import { Component, NgModule, Directive, ElementRef, InjectionToken, ChangeDetectionStrategy, ChangeDetectorRef, Input, Inject, Optional, ComponentFactoryResolver, ViewContainerRef, HostBinding, Self, NgZone, ViewChild, TemplateRef, ContentChildren, EventEmitter, Output, ViewEncapsulation, forwardRef, Injector, ContentChild, Injectable, Pipe, ɵɵdefineInjectable, ɵɵinject, ViewChildren, Host, HostListener, INJECTOR } from '@angular/core';
import { DatePipe, CommonModule, DOCUMENT } from '@angular/common';
import { NgbDate, NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter, NgbCalendar, NgbDatepickerI18n, NgbModule, NgbActiveModal, NgbModalRef, NgbModal, NgbTypeahead, NgbTooltip, NgbDropdown, NgbProgressbarModule, NgbRatingModule, NgbDropdownModule, NgbTooltipModule, NgbTypeaheadModule, NgbAccordion, NgbPanelToggle, NgbPanel, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { PerfectScrollbarComponent, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgControl, FormControl, AbstractControl, ControlContainer, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, ReactiveFormsModule, FormGroup, FormArray } from '@angular/forms';
import { IconsModule, facChevronLeft, facChevronRight } from '@dagility-ui/kit/icons';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fortawesome/angular-fontawesome';
import * as ɵngcc4 from '@dagility-ui/kit/icons';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc6 from 'ngx-perfect-scrollbar';
import * as ɵngcc7 from '@ng-select/ng-select';
import * as ɵngcc8 from '@angular/platform-browser';
import * as ɵngcc9 from '@angular/router';
import * as ɵngcc10 from '@angular/cdk/drag-drop';
import * as ɵngcc11 from '@angular/common/http';

const _c0 = ["input"];
const _c1 = ["controlContainer"];
function ValidationErrorsComponent_ng_container_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c2 = function (a0, a1) { return { $implicit: a0, error: a1 }; };
function ValidationErrorsComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, ValidationErrorsComponent_ng_container_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const errorDirective_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", errorDirective_r2.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, ctx_r1.label, (ctx_r1.formControl == null ? null : ctx_r1.formControl.errors)[errorDirective_r2.valError]));
} }
function ValidationErrorsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ValidationErrorsComponent_ng_container_0_div_1_Template, 2, 5, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.displayedErrors);
} }
function InputComponent_span_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function InputComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, InputComponent_span_0_span_2_Template, 2, 0, "span", 14);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.readonly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
function InputComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("right", ctx_r3.clearable && ctx_r3.copyable ? 180 : ctx_r3.copyable ? 160 : ctx_r3.clearable ? 32 : 12, "px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", (ctx_r3.value || "").length, "/", ctx_r3.maxlength, " ");
} }
function InputComponent_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 17);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r4.icon);
} }
function InputComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function InputComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.handleClearBtn()); });
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("right", ctx_r5.copyable ? 160 : 12, "px");
} }
function InputComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵlistener("click", function InputComponent_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); const _r2 = ɵngcc0.ɵɵreference(4); return ɵngcc0.ɵɵresetView(ctx_r14.copyToClipboard(_r2)); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("right", 0, "px");
    ɵngcc0.ɵɵproperty("openDelay", 400);
} }
function InputComponent_fa_icon_9_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fa-icon", 22);
    ɵngcc0.ɵɵlistener("click", function InputComponent_fa_icon_9_Template_fa_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.togglePassword()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("openDelay", 800);
} }
function InputComponent_fa_icon_10_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fa-icon", 23);
    ɵngcc0.ɵɵlistener("click", function InputComponent_fa_icon_10_Template_fa_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r18.togglePassword()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("openDelay", 800);
} }
function InputComponent_lib_app_warning_message_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-app-warning-message", 24);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r9.warningMessage);
} }
function InputComponent_lib_app_warning_message_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-app-warning-message", 25);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r10.infoMessage)("isInfo", true);
} }
const _c3 = ["*"];
function TextareaComponent_label_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function TextareaComponent_label_0_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fa-icon", 12);
    ɵngcc0.ɵɵlistener("click", function TextareaComponent_label_0_fa_icon_3_Template_fa_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); const _r2 = ɵngcc0.ɵɵreference(5); return ɵngcc0.ɵɵresetView(ctx_r7.copyToClipboard(_r2)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("openDelay", 800);
} }
function TextareaComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, TextareaComponent_label_0_span_2_Template, 2, 0, "span", 9);
    ɵngcc0.ɵɵtemplate(3, TextareaComponent_label_0_fa_icon_3_Template, 1, 1, "fa-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.readonly && !ctx_r0.copyable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.copyable);
} }
function TextareaComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function TextareaComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.handleClearBtn()); });
    ɵngcc0.ɵɵelementStart(1, "span", 14);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd()();
} }
function TextareaComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", +ctx_r4.maxlength - (ctx_r4.value || "").length, " ", (ctx_r4.translatedText == null ? null : ctx_r4.translatedText.CHARACTERS_LEFT) || "characters left", " ");
} }
const _c4 = function (a0) { return { textareaHeight: a0 }; };
const _c5 = ["addTagContainerRef"];
const _c6 = ["dropdown"];
function DropdownComponent_span_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function DropdownComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, DropdownComponent_span_0_span_2_Template, 2, 0, "span", 13);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("label label-", ctx_r0.labelPosition, "");
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
function DropdownComponent_ng_template_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17)(1, "div", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 19);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_ng_template_5_div_3_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const item_r14 = ɵngcc0.ɵɵnextContext().item; const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.addGroup(item_r14[ctx_r16.groupBy])); });
    ɵngcc0.ɵɵelementStart(4, "span", 20);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 21);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_ng_template_5_div_3_Template_div_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r18); const item_r14 = ɵngcc0.ɵɵnextContext().item; const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r19.removeGroup(item_r14[ctx_r19.groupBy])); });
    ɵngcc0.ɵɵelementStart(7, "span", 20);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(9, "div", 22);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_ng_template_5_div_3_Template_div_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r18); const item_r14 = ɵngcc0.ɵɵnextContext().item; const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r21.invertAllInGroup(item_r14[ctx_r21.groupBy])); });
    ɵngcc0.ɵɵelementStart(10, "span", 20);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r15.translatedText == null ? null : ctx_r15.translatedText.SELECT) || "Select", " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((ctx_r15.translatedText == null ? null : ctx_r15.translatedText.ALL) || "All");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((ctx_r15.translatedText == null ? null : ctx_r15.translatedText.NONE) || "None");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((ctx_r15.translatedText == null ? null : ctx_r15.translatedText.INVERT) || "Invert");
} }
function DropdownComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "titlecase");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DropdownComponent_ng_template_5_div_3_Template, 12, 4, "div", 16);
} if (rf & 2) {
    const item_r14 = ctx.item;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, item_r14[ctx_r3.groupBy] || (ctx_r3.translatedText == null ? null : ctx_r3.translatedText.UNNAMED_GROUP) || "Unnamed group"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.multiple && !ctx_r3.disabled);
} }
function DropdownComponent_ng_container_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 26);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_ng_container_6_ng_template_1_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r24.addAll()); });
    ɵngcc0.ɵɵelementStart(4, "span", 20);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 27);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_ng_container_6_ng_template_1_Template_div_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r26.removeAll()); });
    ɵngcc0.ɵɵelementStart(7, "span", 20);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(9, "div", 28);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_ng_container_6_ng_template_1_Template_div_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r27.invertAll()); });
    ɵngcc0.ɵɵelementStart(10, "span", 20);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("size-s", ctx_r23.sizeS);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r23.translatedText == null ? null : ctx_r23.translatedText.SELECT) || "Select", " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((ctx_r23.translatedText == null ? null : ctx_r23.translatedText.ALL) || "All");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((ctx_r23.translatedText == null ? null : ctx_r23.translatedText.NONE) || "None");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate((ctx_r23.translatedText == null ? null : ctx_r23.translatedText.INVERT) || "Invert");
} }
function DropdownComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_ng_container_6_ng_template_1_Template, 12, 6, "ng-template", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DropdownComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DropdownComponent_ng_template_7_ng_template_1_checkbox_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "checkbox", 34);
} if (rf & 2) {
    const item$_r29 = ɵngcc0.ɵɵnextContext(2).item$;
    const ctx_r33 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("size-s", ctx_r33.sizeS);
    ɵngcc0.ɵɵproperty("value", item$_r29.selected);
} }
function DropdownComponent_ng_template_7_ng_template_1_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 35);
} }
const _c7 = function () { return { "margin-left": "10px" }; };
const _c8 = function () { return {}; };
function DropdownComponent_ng_template_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropdownComponent_ng_template_7_ng_template_1_checkbox_0_Template, 1, 3, "checkbox", 31);
    ɵngcc0.ɵɵelementStart(1, "span", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DropdownComponent_ng_template_7_ng_template_1_fa_icon_3_Template, 1, 0, "fa-icon", 33);
} if (rf & 2) {
    const item_r28 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r32 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r32.multiple);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("size-s", ctx_r32.sizeS);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r32.groupBy ? ɵngcc0.ɵɵpureFunction0(9, _c7) : ɵngcc0.ɵɵpureFunction0(10, _c8))("ngbTooltip", item_r28[ctx_r32.labelKey])("tooltipClass", "dropdown-tooltip")("hoverElementSelectorFn", ctx_r32.hoverElementSelectorFn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r28[ctx_r32.labelKey]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r32.disabled && ctx_r32.multiple);
} }
const _c9 = function (a0, a1, a2, a3, a4) { return { item: a0, item$: a1, labelKey: a2, valueKey: a3, multiple: a4 }; };
function DropdownComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropdownComponent_ng_template_7_ng_container_0_Template, 1, 0, "ng-container", 29);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_ng_template_7_ng_template_1_Template, 4, 11, "ng-template", null, 30, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const item_r28 = ctx.item;
    const item$_r29 = ctx.item$;
    const _r31 = ɵngcc0.ɵɵreference(2);
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.optionTemplateRef || _r31)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction5(2, _c9, item_r28, item$_r29, ctx_r5.labelKey, ctx_r5.valueKey, ctx_r5.multiple));
} }
function DropdownComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DropdownComponent_ng_template_8_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 37);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r37 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r40 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("size-s", ctx_r40.sizeS);
    ɵngcc0.ɵɵproperty("ngbTooltip", item_r37[ctx_r40.labelKey])("tooltipClass", "dropdown-tooltip")("textElementSelectorFn", ctx_r40.hoverElementSelectorFn)("hoverElementSelectorFn", ctx_r40.labelHoverElementSelectorFn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r37[ctx_r40.labelKey]);
} }
const _c10 = function (a0, a1, a2) { return { item: a0, labelKey: a1, valueKey: a2 }; };
function DropdownComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropdownComponent_ng_template_8_ng_container_0_Template, 1, 0, "ng-container", 29);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_ng_template_8_ng_template_1_Template, 2, 7, "ng-template", null, 36, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const item_r37 = ctx.item;
    const _r39 = ɵngcc0.ɵɵreference(2);
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.labelTemplateRef || _r39)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c10, item_r37, ctx_r6.labelKey, ctx_r6.valueKey));
} }
const _c11 = function (a0) { return { "selected-counter-disabled": a0 }; };
function DropdownComponent_9_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 40)(1, "span", 41);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const items_r43 = ɵngcc0.ɵɵnextContext().items;
    const ctx_r45 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("size-s", ctx_r45.sizeS);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c11, ctx_r45.disabled));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", ctx_r45.min(items_r43.length, ctx_r45.itemsLength), "/", ctx_r45.itemsLength, " ", (ctx_r45.translatedText == null ? null : ctx_r45.translatedText.SELECTED) || "selected", "");
} }
function DropdownComponent_9_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropdownComponent_9_ng_template_0_div_0_Template, 3, 8, "div", 39);
} if (rf & 2) {
    const ctx_r42 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r42.showCounter);
} }
function DropdownComponent_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropdownComponent_9_ng_template_0_Template, 1, 1, "ng-template", 38);
} }
function DropdownComponent_ng_template_10_ng_template_4_Template(rf, ctx) { }
function DropdownComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span")(1, "span", 42);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DropdownComponent_ng_template_10_ng_template_4_Template, 0, 0, "ng-template", null, 43, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const searchTerm_r47 = ctx.searchTerm;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("size-s", ctx_r8.sizeS);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate((ctx_r8.translatedText == null ? null : ctx_r8.translatedText.ADD_ITEM) || "Add item");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\"", searchTerm_r47, "\"");
} }
function DropdownComponent_ng_container_11_ng_template_1_ng_template_0_Template(rf, ctx) { }
function DropdownComponent_ng_container_11_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DropdownComponent_ng_container_11_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 44);
} if (rf & 2) {
    const ctx_r50 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r50.headerTemplate.template);
} }
function DropdownComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_ng_container_11_ng_template_1_Template, 1, 1, "ng-template", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DropdownComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 45);
    ɵngcc0.ɵɵelement(1, "fa-icon", 46);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("size-s", ctx_r10.sizeS);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.validationError, " ");
} }
function DropdownComponent_lib_app_warning_message_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-app-warning-message", 47);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r11.warningMessage);
} }
function DropdownComponent_lib_app_warning_message_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-app-warning-message", 48);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r12.infoMessage)("isInfo", true);
} }
const _c12 = function (a0, a1, a2, a3, a4, a5, a6, a7, a8) { return { "label-left": a0, "dropdown-multiple": a1, "has-validation-error": a2, searchable: a3, clearable: a4, warning: a5, "show-input": a6, multiline: a7, "size-s": a8 }; };
const _c13 = function (a0) { return { maxlength: a0 }; };
const _c14 = ["perfect-scrollbar-styles", ""];
const _c15 = ["checkbox"];
function CheckboxComponent_label_0_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 8);
} if (rf & 2) {
    const icon_r4 = ctx.ngIf;
    ɵngcc0.ɵɵproperty("icon", icon_r4);
} }
function CheckboxComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 2);
    ɵngcc0.ɵɵlistener("click", function CheckboxComponent_label_0_Template_label_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.preventBubblingFromCheckbox($event)); });
    ɵngcc0.ɵɵelementStart(1, "input", 3, 4);
    ɵngcc0.ɵɵlistener("change", function CheckboxComponent_label_0_Template_input_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.preventCheckboxChangeEvent($event)); })("click", function CheckboxComponent_label_0_Template_input_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.onChange()); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵtemplate(4, CheckboxComponent_label_0_fa_icon_4_Template, 1, 1, "fa-icon", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵprojection(6);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("loading", ctx_r0.loading || ctx_r0.blueCheckEnabled)("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵattribute("data-test-id", ctx_r0.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r0.value)("disabled", ctx_r0.disabled || ctx_r0.loading || ctx_r0.blueCheckEnabled)("indeterminate", ctx_r0.isUndefinedState());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.icon);
} }
const _c16 = function (a0) { return { "btn-primary": a0 }; };
function CheckboxComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function CheckboxComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.onChange()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c16, ctx_r1.value));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, "\n");
} }
function RadioGroupComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 2);
    ɵngcc0.ɵɵelement(1, "input", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", option_r3.value)("name", ctx_r0.name)("formControl", ctx_r0.control);
    ɵngcc0.ɵɵattribute("data-test-id", ctx_r0.testId)("disabled", option_r3.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r3.label, "\n");
} }
function RadioGroupComponent_ng_template_1_Template(rf, ctx) { }
function WarningMessageComponent_ng_template_0_Template(rf, ctx) { }
function WarningMessageComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "fa-icon", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.show);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.text, " ");
} }
function WarningMessageComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r4.show);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.text, " ");
} }
function RadioButtonComponent_ng_content_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "!label"]);
} }
const _c17 = function (a0) { return { disabled: a0 }; };
const _c18 = function (a0, a1) { return { disabled: a0, "margin-icon": a1 }; };
const _c19 = ["dp"];
const _c20 = ["inputEl"];
const _c21 = ["popover"];
const _c22 = ["timePickerPopover"];
const _c23 = ["datepicker"];
const _c24 = ["dateRangePicker"];
const _c25 = ["timepicker"];
const _c26 = ["datepickerButton"];
function DatepickerComponent_label_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function DatepickerComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, DatepickerComponent_label_0_span_2_Template, 2, 0, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
function DatepickerComponent_div_1_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function DatepickerComponent_div_1_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); ɵngcc0.ɵɵnextContext(); const _r13 = ɵngcc0.ɵɵreference(3); const ctx_r18 = ɵngcc0.ɵɵnextContext(); _r13.value = ""; return ɵngcc0.ɵɵresetView(ctx_r18.clearRange()); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 21);
    ɵngcc0.ɵɵelementEnd();
} }
function DatepickerComponent_div_1_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22, 23);
    ɵngcc0.ɵɵlistener("hidden", function DatepickerComponent_div_1_button_11_Template_button_hidden_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r21.onPopoverHidden()); })("shown", function DatepickerComponent_div_1_button_11_Template_button_shown_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r23.onPopoverShown()); });
    ɵngcc0.ɵɵelement(2, "fa-icon", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    const _r10 = ɵngcc0.ɵɵreference(11);
    const _r8 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵproperty("disabled", ctx_r17._disabled)("autoClose", "outside")("container", ctx_r17.container)("popoverTitle", _r10)("ngbPopover", _r8);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r17._disabled);
} }
const _c27 = function (a0) { return { "mr-5px": a0 }; };
function DatepickerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "input", 12, 13);
    ɵngcc0.ɵɵlistener("change", function DatepickerComponent_div_1_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r24.mode === "single" && ctx_r24.onInputChange($event)); })("input", function DatepickerComponent_div_1_Template_input_input_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r26.mode === "range" && ctx_r26.inputRangeChanged($event.target.value)); });
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵtemplate(6, DatepickerComponent_div_1_button_6_Template, 2, 0, "button", 15);
    ɵngcc0.ɵɵelementStart(7, "button", 16, 17);
    ɵngcc0.ɵɵlistener("hidden", function DatepickerComponent_div_1_Template_button_hidden_7_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r27.onPopoverHidden()); })("shown", function DatepickerComponent_div_1_Template_button_shown_7_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r28.onPopoverShown()); });
    ɵngcc0.ɵɵelement(10, "fa-icon", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DatepickerComponent_div_1_button_11_Template, 3, 7, "button", 19);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r13 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("disabled", ctx_r1.disabled)("pristine", ctx_r1.pristine);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r1.placeholder)("readOnly", !!ctx_r1.rangeInputFormatter)("ngClass", (ctx_r1.ngControl == null ? null : ctx_r1.ngControl.valid) ? "ng-valid" : "ng-invalid")("value", ctx_r1.mode === "single" ? ctx_r1.dateString != "" ? ɵngcc0.ɵɵpipeBind2(4, 19, ctx_r1.dateString, ctx_r1.inputDatetimeFormat) : "" : ctx_r1.rangeString)("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵstyleProp("height", ctx_r1.height);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", _r13.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(22, _c27, !ctx_r1.dateWithTime))("autoClose", "outside")("container", ctx_r1.container)("ngbPopover", ctx_r1.mode === "single" ? _r4 : _r6)("animation", false)("placement", ctx_r1.mode === "single" ? "bottom" : "auto");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.dateWithTime);
} }
function DatepickerComponent_div_2_ng_template_1_Template(rf, ctx) { }
function DatepickerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, DatepickerComponent_div_2_ng_template_1_Template, 0, 0, "ng-template", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DatepickerComponent_div_3_ng_template_1_Template(rf, ctx) { }
function DatepickerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtemplate(1, DatepickerComponent_div_3_ng_template_1_Template, 0, 0, "ng-template", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function DatepickerComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-datepicker", 27);
    ɵngcc0.ɵɵlistener("navigate", function DatepickerComponent_ng_template_4_Template_ngb_datepicker_navigate_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r31.handleNavigate($event)); })("ngModelChange", function DatepickerComponent_ng_template_4_Template_ngb_datepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r33.onDateChange($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("startDate", ctx_r5.startDate || ctx_r5.getTodayNgbDate())("navigation", "arrows")("maxDate", !ctx_r5.withoutMaxDate ? ctx_r5.getTodayNgbDate() : null)("ngModel", ctx_r5.datetime);
} }
function DatepickerComponent_ng_template_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-datepicker-range-dialog", 32);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r34 = ɵngcc0.ɵɵreference(1);
    const ctx_r35 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("dp", _r34)("leftTemplate", ctx_r35.leftRangeContent ? ctx_r35.leftRangeContent.templateRef : null)("rightTemplate", ctx_r35.rightRangeContent ? ctx_r35.rightRangeContent.templateRef : null);
} }
function DatepickerComponent_ng_template_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵlistener("mouseenter", function DatepickerComponent_ng_template_6_ng_template_3_Template_div_mouseenter_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r42); const date_r38 = restoredCtx.$implicit; const ctx_r41 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r41.range.hoveredDate = date_r38); })("mouseleave", function DatepickerComponent_ng_template_6_ng_template_3_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r43.range.hoveredDate = null); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r38 = ctx.$implicit;
    const focused_r39 = ctx.focused;
    const selected_r40 = ctx.selected;
    ɵngcc0.ɵɵnextContext();
    const _r34 = ɵngcc0.ɵɵreference(1);
    const ctx_r37 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("text-white", selected_r40)("focused", focused_r39)("range", ctx_r37.range.isRange(date_r38))("from-date", ctx_r37.range.isFrom(date_r38))("to-date", ctx_r37.range.isTo(date_r38))("need-hover", ctx_r37.range.needHover())("outside", ctx_r37.range.isOutside(date_r38, _r34))("faded", ctx_r37.range.isHovered(date_r38) || ctx_r37.range.isInside(date_r38));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", date_r38.day, " ");
} }
function DatepickerComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-datepicker", 28, 29);
    ɵngcc0.ɵɵlistener("dateSelect", function DatepickerComponent_ng_template_6_Template_ngb_datepicker_dateSelect_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r44 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r44.handleDateRangeSelect($event)); });
    ɵngcc0.ɵɵtemplate(2, DatepickerComponent_ng_template_6_ng_template_2_Template, 1, 3, "ng-template", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DatepickerComponent_ng_template_6_ng_template_3_Template, 2, 17, "ng-template", null, 31, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r36 = ɵngcc0.ɵɵreference(4);
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("startDate", ctx_r7.range.fromDate || ctx_r7.getTodayNgbDate())("navigation", "none")("ngModel", ctx_r7.datetime)("dayTemplate", _r36)("displayMonths", 2);
} }
function DatepickerComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 34);
    ɵngcc0.ɵɵlistener("ngModelChange", function DatepickerComponent_ng_template_8_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r46.onTimeChange($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("seconds", ctx_r9.seconds)("meridian", ctx_r9.meridian)("hourStep", ctx_r9.hourStep)("minuteStep", ctx_r9.minuteStep)("secondStep", ctx_r9.secondStep)("ngModel", ctx_r9.datetime);
} }
function DatepickerComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵtext(1, " TIME ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c28 = ["customNavigation"];
const _c29 = ["inputElement"];
function DatepickerAdapterComponent_label_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function DatepickerAdapterComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, DatepickerAdapterComponent_label_0_span_2_Template, 2, 0, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
const _c30 = function (a0) { return { "has-validation-error": a0 }; };
function DatepickerAdapterComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "button", 16);
    ɵngcc0.ɵɵelement(2, "fa-icon", 17);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(12);
    ɵngcc0.ɵɵstyleProp("height", ctx_r4.height);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4._disabled)("ngbPopover", _r6)("autoClose", "outside")("placement", "bottom")("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c30, ctx_r4.validationError || ctx_r4.hasErrors));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r4.icons.faClock);
} }
function DatepickerAdapterComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function DatepickerAdapterComponent_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.getToday()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("size-s", ctx_r5.sizeS)("size-l", ctx_r5.sizeL);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r5.translatedText == null ? null : ctx_r5.translatedText.SELECT_TODAY) || "Select Today", "\n");
} }
function DatepickerAdapterComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DatepickerAdapterComponent_ng_template_11_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.time = $event); })("ngModelChange", function DatepickerAdapterComponent_ng_template_11_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.onTimeChanged($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("meridian", ctx_r7.meridian)("hourStep", ctx_r7.hourStep)("minuteStep", ctx_r7.minuteStep)("secondStep", ctx_r7.secondStep)("ngModel", ctx_r7.time);
} }
function DatepickerAdapterComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20)(1, "lib-datepicker-multi-month-view", 21);
    ɵngcc0.ɵɵlistener("selectDate", function DatepickerAdapterComponent_ng_template_13_Template_lib_datepicker_multi_month_view_selectDate_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); const _r3 = ɵngcc0.ɵɵreference(5); _r3.navigateTo({ year: $event.getFullYear(), month: $event.getMonth() + 1, day: $event.getDate() }); return ɵngcc0.ɵɵresetView(ctx_r18.goToDateAhead()); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const currDate_r17 = ctx.currDate;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("inputDate", currDate_r17);
} }
const _c31 = function (a0, a1) { return { last: a0, penult: a1 }; };
function DatepickerMultiMonthViewComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_div_1_div_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r5.changeYear(ctx_r5.currentDate, -1)); });
    ɵngcc0.ɵɵelement(3, "span", 10);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 11);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_div_1_div_1_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r7.turnMode()); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 12)(7, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_div_1_div_1_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r8.changeYear(ctx_r8.currentDate, +1)); });
    ɵngcc0.ɵɵelement(8, "span", 10);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.currentDate.getFullYear(), " ");
} }
function DatepickerMultiMonthViewComponent_div_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_div_1_div_3_div_1_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const month_r11 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r12.pickMonth(month_r11)); });
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const month_r11 = ctx.$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("selected", ctx_r10.currentDate.getMonth() == month_r11.getMonth());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.transformDate(month_r11, "MMM"), " ");
} }
function DatepickerMultiMonthViewComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, DatepickerMultiMonthViewComponent_div_1_div_3_div_1_Template, 3, 3, "div", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const chunkMonth_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", chunkMonth_r9);
} }
function DatepickerMultiMonthViewComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, DatepickerMultiMonthViewComponent_div_1_div_1_Template, 9, 1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵtemplate(3, DatepickerMultiMonthViewComponent_div_1_div_3_Template, 2, 1, "div", 6);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentDate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.chunkMonths);
} }
function DatepickerMultiMonthViewComponent_ng_template_2_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_ng_template_2_div_11_div_1_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r19); const year_r17 = restoredCtx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r18.pickYear(year_r17)); });
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const year_r17 = ctx.$implicit;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("selected", ctx_r16.currentDate.getFullYear() == year_r17.getFullYear());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r16.transformDate(year_r17, "yyyy"), " ");
} }
function DatepickerMultiMonthViewComponent_ng_template_2_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, DatepickerMultiMonthViewComponent_ng_template_2_div_11_div_1_Template, 3, 3, "div", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const chunkYear_r15 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", chunkYear_r15);
} }
function DatepickerMultiMonthViewComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3)(1, "div", 7)(2, "div", 8)(3, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_ng_template_2_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r20.changeYearsSet(-12)); });
    ɵngcc0.ɵɵelement(4, "span", 10);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(5, "div", 16);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 12)(8, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DatepickerMultiMonthViewComponent_ng_template_2_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r22.changeYearsSet(+12)); });
    ɵngcc0.ɵɵelement(9, "span", 10);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(10, "div", 17);
    ɵngcc0.ɵɵtemplate(11, DatepickerMultiMonthViewComponent_ng_template_2_div_11_Template, 2, 1, "div", 18);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.years[0].getFullYear() + " - " + ctx_r2.years[ctx_r2.years.length - 1].getFullYear(), " ");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.chunkYears);
} }
function DatepickerRangeNavigationComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 0);
} }
function DatepickerRangeNavigationComponent_ng_template_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 0);
} }
function DatepickerRangeNavigationComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DatepickerRangeNavigationComponent_ng_template_3_div_0_Template, 1, 0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DatepickerRangeNavigationComponent_ng_template_3_div_3_Template, 1, 0, "div", 6);
} if (rf & 2) {
    const month_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", i_r2 > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r0.i18n.getMonthFullName(month_r1.number, month_r1.year), " ", ctx_r0.i18n.getYearNumerals(month_r1.year), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r2 !== ctx_r0.months.length - 1);
} }
function DatepickerRangeDialogComponent_div_0_ng_template_1_Template(rf, ctx) { }
function DatepickerRangeDialogComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DatepickerRangeDialogComponent_div_0_ng_template_1_Template, 0, 0, "ng-template", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.leftTemplate);
} }
function DatepickerRangeDialogComponent_ngb_datepicker_month_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngb-datepicker-month", 5);
} if (rf & 2) {
    const month_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("month", month_r4);
} }
function DatepickerRangeDialogComponent_div_5_ng_template_1_Template(rf, ctx) { }
function DatepickerRangeDialogComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DatepickerRangeDialogComponent_div_5_ng_template_1_Template, 0, 0, "ng-template", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.rightTemplate);
} }
function RatingModalComponent_ng_template_10_fa_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 19);
} }
function RatingModalComponent_ng_template_10_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 20);
} }
function RatingModalComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, RatingModalComponent_ng_template_10_fa_icon_0_Template, 1, 0, "fa-icon", 17);
    ɵngcc0.ɵɵtemplate(1, RatingModalComponent_ng_template_10_fa_icon_1_Template, 1, 0, "fa-icon", 18);
} if (rf & 2) {
    const fill_r2 = ctx.fill;
    ɵngcc0.ɵɵproperty("ngIf", fill_r2 === 100);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", fill_r2 < 100);
} }
function RatingModalComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21)(1, "span", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "ngb-progressbar", 23);
    ɵngcc0.ɵɵelementStart(4, "span", 24);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "number");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ratingRowItem_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ratingRowItem_r5.label + (ratingRowItem_r5.label !== "1" ? " stars" : " star"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ratingRowItem_r5.width);
    ɵngcc0.ɵɵproperty("height", ratingRowItem_r5.height)("value", ratingRowItem_r5.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind2(6, 6, ratingRowItem_r5.value, "1.0-1"), " %");
} }
function RatingComponent_div_1_div_2_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 12);
} }
function RatingComponent_div_1_div_2_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 13);
} }
function RatingComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, RatingComponent_div_1_div_2_fa_icon_1_Template, 1, 0, "fa-icon", 10);
    ɵngcc0.ɵɵtemplate(2, RatingComponent_div_1_div_2_fa_icon_2_Template, 1, 0, "fa-icon", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.fullStars);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.emptyStars);
} }
function RatingComponent_div_1_div_3_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 16);
} }
function RatingComponent_div_1_div_3_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 13);
} }
function RatingComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, RatingComponent_div_1_div_3_fa_icon_1_Template, 1, 0, "fa-icon", 14);
    ɵngcc0.ɵɵtemplate(2, RatingComponent_div_1_div_3_fa_icon_2_Template, 1, 0, "fa-icon", 11);
    ɵngcc0.ɵɵelementStart(3, "span", 15);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.myFullStars);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.myEmptyStars);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.myRate, " ");
} }
function RatingComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4, 5);
    ɵngcc0.ɵɵlistener("click", function RatingComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const _r5 = ɵngcc0.ɵɵreference(1); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.editable && ctx_r16.toggleTooltip(_r5)); });
    ɵngcc0.ɵɵtemplate(2, RatingComponent_div_1_div_2_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(3, RatingComponent_div_1_div_3_Template, 5, 3, "div", 6);
    ɵngcc0.ɵɵelementStart(4, "div", 7)(5, "span", 8);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "number");
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵclassProp("cursor-pointer", ctx_r0.editable);
    ɵngcc0.ɵɵproperty("placement", ctx_r0.tooltipPlacement)("ngbTooltip", _r1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.myRate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.myRate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.value !== 0 ? "color-brand" : "color-gray");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(7, 8, ctx_r0.value, "1.1-2"));
} }
function RatingComponent_ng_template_2_ng_template_1_Template(rf, ctx) { }
function RatingComponent_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 20)(2, "button", 21);
    ɵngcc0.ɵɵlistener("click", function RatingComponent_ng_template_2_ng_container_2_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r22.rate()); });
    ɵngcc0.ɵɵelementStart(3, "span", 22);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 23);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r19.translatedText == null ? null : ctx_r19.translatedText.CHANGE_MY_RATE) || "Change my rating", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r19.myRate);
} }
function RatingComponent_ng_template_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20)(1, "button", 21);
    ɵngcc0.ɵɵlistener("click", function RatingComponent_ng_template_2_ng_template_3_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r24.rate()); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r21.translatedText == null ? null : ctx_r21.translatedText.RATE_IT_NOW) || "Rate it now", " ");
} }
function RatingComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, RatingComponent_ng_template_2_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵtemplate(2, RatingComponent_ng_template_2_ng_container_2_Template, 7, 2, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, RatingComponent_ng_template_2_ng_template_3_Template, 3, 1, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r20 = ɵngcc0.ɵɵreference(4);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.myRate)("ngIfElse", _r20);
} }
function RatingComponent_ng_template_4_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 33)(1, "span", 34);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "ngb-progressbar", 35);
    ɵngcc0.ɵɵelementStart(4, "span", 36);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "number");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ratingRowItem_r30 = ctx.$implicit;
    const ctx_r29 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ratingRowItem_r30.label + " " + (ratingRowItem_r30.label !== "1" ? (ctx_r29.translatedText == null ? null : ctx_r29.translatedText.STARS) || "stars" : (ctx_r29.translatedText == null ? null : ctx_r29.translatedText.STAR) || "star"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ratingRowItem_r30.width);
    ɵngcc0.ɵɵproperty("height", ratingRowItem_r30.height)("value", ratingRowItem_r30.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind2(6, 6, ratingRowItem_r30.value, "1.0-1"), " %");
} }
function RatingComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26)(1, "lib-rating", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function RatingComponent_ng_template_4_div_0_Template_lib_rating_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r31.rating.rating = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 28)(3, "span", 29);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 30);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(7, "div", 31);
    ɵngcc0.ɵɵtemplate(8, RatingComponent_ng_template_4_div_0_div_8_Template, 7, 9, "div", 32);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("editable", false)("ngModel", ctx_r26.rating.rating)("max", ctx_r26.max);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r26.rating == null ? null : ctx_r26.rating.ratesCount, " ", (ctx_r26.translatedText == null ? null : ctx_r26.translatedText.USER_RATINGS) || "user ratings", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r26.rating == null ? null : ctx_r26.rating.downloads, " ", (ctx_r26.translatedText == null ? null : ctx_r26.translatedText.DOWNLOADS) || "downloads", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r26.ratingRowsTemplate);
} }
function RatingComponent_ng_template_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵelement(1, "lib-spinner");
    ɵngcc0.ɵɵelementEnd();
} }
function RatingComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, RatingComponent_ng_template_4_div_0_Template, 9, 8, "div", 24);
    ɵngcc0.ɵɵtemplate(1, RatingComponent_ng_template_4_ng_template_1_Template, 2, 0, "ng-template", null, 25, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r27 = ɵngcc0.ɵɵreference(2);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.ratingLoaded)("ngIfElse", _r27);
} }
function TypeaheadComponent_span_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function TypeaheadComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, TypeaheadComponent_span_0_span_2_Template, 2, 0, "span", 5);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.readonly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
const _c40 = ".mandatory[_ngcontent-%COMP%]{color:var(--da-error-base)}.label[_ngcontent-%COMP%]{color:var(--da-title);font-size:11px;margin-bottom:7px}input[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;color:var(--da-primary-text);width:100%}input[_ngcontent-%COMP%]::-moz-placeholder{color:var(--da-disable)}input[_ngcontent-%COMP%]:-ms-input-placeholder{color:var(--da-disable)}input[_ngcontent-%COMP%]::placeholder{color:var(--da-disable)}input[_ngcontent-%COMP%]:focus{outline:none}input[_ngcontent-%COMP%]:focus:not(.invalid):not(:hover):not(:active):not(:-moz-read-only){box-shadow:0 0 0 4px var(--da-brand-20)}input[_ngcontent-%COMP%]:focus:not(.invalid):not(:hover):not(:active):not(:read-only){box-shadow:0 0 0 4px var(--da-brand-20)}input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):hover{border:1px solid var(--da-brand-base)}input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:read-only):hover{border:1px solid var(--da-brand-base)}input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):active, input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):hover{margin:0;width:100%}input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:read-only):active, input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:read-only):hover{margin:0;width:100%}input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):active{border:1px solid var(--da-brand-base)}input[_ngcontent-%COMP%]:not(:disabled):not(.disabled):not(.invalid):not(:read-only):active{border:1px solid var(--da-brand-base)}input.invalid[_ngcontent-%COMP%]{border:1px solid var(--da-error-base)!important}input.disabled[_ngcontent-%COMP%], input[_ngcontent-%COMP%]:disabled{background:rgba(0,0,0,.04);color:var(--da-disable)}input[_ngcontent-%COMP%]:-moz-read-only{cursor:default}input.disabled[_ngcontent-%COMP%], input[_ngcontent-%COMP%]:disabled, input[_ngcontent-%COMP%]:read-only{cursor:default}input.with-icon[_ngcontent-%COMP%]{padding:15px 28px!important}.icon[_ngcontent-%COMP%]{color:var(--da-brand-base);left:.5rem;position:absolute;top:.5rem}.password-toggle[_ngcontent-%COMP%]{cursor:pointer;margin-left:-24px;margin-top:6px}.lib-input--left[_nghost-%COMP%]{align-items:center}.lib-input--left[_nghost-%COMP%]   .input-content[_ngcontent-%COMP%]{flex-grow:1;margin-left:5px}.lib-input--left[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{margin-bottom:0}.size-s[_nghost-%COMP%]  .clear-btn{top:.25rem!important}.size-l[_nghost-%COMP%]  .clear-btn{top:1rem!important}[_nghost-%COMP%]   .clear-btn[_ngcontent-%COMP%]{background:none!important;border:none!important;color:var(--da-secondary-text-and-icons);padding:0!important;position:absolute;right:.5rem;top:.5rem;width:16px}[_nghost-%COMP%]   .clear-btn[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:16px!important}[_nghost-%COMP%]   .clear-btn[_ngcontent-%COMP%]:focus{outline:none!important}.max-length[_ngcontent-%COMP%]{align-items:center;display:flex;height:100%;top:0}.with-max-length[_ngcontent-%COMP%]{padding-right:62px}.with-copyable-length[_ngcontent-%COMP%]{padding-right:40px}.with-copyable-length.with-max-length[_ngcontent-%COMP%]{padding-right:102px}.clearable[_ngcontent-%COMP%]{padding-right:28px}.clearable.with-copyable-length[_ngcontent-%COMP%]:not(.with-max-length){padding-right:68px}.clearable.with-max-length[_ngcontent-%COMP%]:not(.with-copyable-length){padding-right:90px}.clearable.with-copyable-length.with-max-length[_ngcontent-%COMP%]{padding-right:130px}";
const _c41 = ["treelikeDropdown"];
function TreelikeDropdownComponent_span_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function TreelikeDropdownComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, TreelikeDropdownComponent_span_0_span_2_Template, 2, 0, "span", 9);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("label label-", ctx_r0.labelPosition, "");
    ɵngcc0.ɵɵclassProp("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isRequired);
} }
function TreelikeDropdownComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TreelikeDropdownComponent_ng_template_5_ng_template_1_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 18);
} if (rf & 2) {
    const item_r8 = ɵngcc0.ɵɵnextContext(2).item;
    ɵngcc0.ɵɵproperty("icon", item_r8.icon);
} }
function TreelikeDropdownComponent_ng_template_5_ng_template_1_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 18);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("icon", ctx_r13.icons.facChevronRight);
} }
function TreelikeDropdownComponent_ng_template_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function TreelikeDropdownComponent_ng_template_5_ng_template_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const item_r8 = ɵngcc0.ɵɵnextContext().item; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.currentItems.indexOf(item_r8) === 0 && ctx_r15.itemParentMap.get(item_r8.value) ? ctx_r15.goBackToParens(item_r8) : ctx_r15.handleChange(item_r8)); });
    ɵngcc0.ɵɵtemplate(1, TreelikeDropdownComponent_ng_template_5_ng_template_1_fa_icon_1_Template, 1, 1, "fa-icon", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵlistener("click", function TreelikeDropdownComponent_ng_template_5_ng_template_1_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const item_r8 = ɵngcc0.ɵɵnextContext().item; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r18.handleChange(item_r8)); });
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 17);
    ɵngcc0.ɵɵtemplate(6, TreelikeDropdownComponent_ng_template_5_ng_template_1_fa_icon_6_Template, 1, 1, "fa-icon", 14);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r8 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.currentItems.indexOf(item_r8) === 0 && ctx_r11.itemParentMap.get(item_r8.value) || !ctx_r11.itemParentMap.get(item_r8.value) && item_r8.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("size-s", ctx_r11.sizeS);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11.getOptionLabel(item_r8), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r8.children == null ? null : item_r8.children.length);
} }
const _c42 = function (a0) { return { item: a0 }; };
function TreelikeDropdownComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TreelikeDropdownComponent_ng_template_5_ng_container_0_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵtemplate(1, TreelikeDropdownComponent_ng_template_5_ng_template_1_Template, 7, 5, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const item_r8 = ctx.item;
    const _r10 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c42, item_r8));
} }
function TreelikeDropdownComponent_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TreelikeDropdownComponent_ng_template_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r21 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r24 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("size-s", ctx_r24.sizeS);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r24.getLabel(item_r21.value), " ");
} }
function TreelikeDropdownComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TreelikeDropdownComponent_ng_template_6_ng_container_0_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵtemplate(1, TreelikeDropdownComponent_ng_template_6_ng_template_1_Template, 2, 3, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const item_r21 = ctx.item;
    const _r23 = ɵngcc0.ɵɵreference(2);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.labelTemplateRef || _r23)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c42, item_r21));
} }
function TreelikeDropdownComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "fa-icon", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("size-s", ctx_r5.sizeS);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.validationError, " ");
} }
function TreelikeDropdownComponent_lib_app_warning_message_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-app-warning-message", 23);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r6.warningMessage);
} }
const _c43 = function (a0, a1, a2, a3, a4) { return { "label-left": a0, "has-validation-error": a1, clearable: a2, warning: a3, "size-s": a4 }; };
function TreelikeMenuComponent_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} }
function TreelikeMenuComponent_ng_container_6_div_3_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 13);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("icon", ctx_r8.returnIcon);
} }
function TreelikeMenuComponent_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵlistener("click", function TreelikeMenuComponent_ng_container_6_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const itemGroup_r3 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.handleReturnClick(itemGroup_r3)); });
    ɵngcc0.ɵɵtemplate(1, TreelikeMenuComponent_ng_container_6_div_3_fa_icon_1_Template, 1, 1, "fa-icon", 11);
    ɵngcc0.ɵɵelementStart(2, "h3", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    const isFirstGroup_r4 = ctx_r12.first;
    const itemGroup_r3 = ctx_r12.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("ml-3", ctx_r6.isFirstLevel)("first-group", ctx_r6.isFirstLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.isFirstLevel && isFirstGroup_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("ml-4", !ctx_r6.isFirstLevel && !isFirstGroup_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemGroup_r3.label, " ");
} }
function TreelikeMenuComponent_ng_container_6_div_4_ng_container_2_ng_template_1_Template(rf, ctx) { }
const _c44 = function (a0) { return { $implicit: a0 }; };
function TreelikeMenuComponent_ng_container_6_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TreelikeMenuComponent_ng_container_6_div_4_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const groupItem_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", groupItem_r13.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, groupItem_r13));
} }
function TreelikeMenuComponent_ng_container_6_div_4_ng_container_3_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 20);
} if (rf & 2) {
    const groupItem_r13 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("icon", groupItem_r13.icon);
} }
function TreelikeMenuComponent_ng_container_6_div_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TreelikeMenuComponent_ng_container_6_div_4_ng_container_3_fa_icon_1_Template, 1, 1, "fa-icon", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const groupItem_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", groupItem_r13.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", groupItem_r13.label, " ");
} }
function TreelikeMenuComponent_ng_container_6_div_4_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 21);
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("icon", ctx_r16.nextIcon);
} }
function TreelikeMenuComponent_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵlistener("click", function TreelikeMenuComponent_ng_container_6_div_4_Template_div_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const groupItem_r13 = restoredCtx.$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r22.handleItemClick(groupItem_r13, $event)); });
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, TreelikeMenuComponent_ng_container_6_div_4_ng_container_2_Template, 2, 4, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(3, TreelikeMenuComponent_ng_container_6_div_4_ng_container_3_Template, 3, 2, "ng-container", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TreelikeMenuComponent_ng_container_6_div_4_fa_icon_4_Template, 1, 1, "fa-icon", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const groupItem_r13 = ctx.$implicit;
    const isFirstGroup_r4 = ɵngcc0.ɵɵnextContext().first;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", groupItem_r13.hidden ? "d-none" : "d-flex text-left text-start align-items-center")("disabled", groupItem_r13.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", isFirstGroup_r4 && !ctx_r7.isFirstLevel ? "mx-36px" : !ctx_r7.isFirstLevel ? "mx-4" : "mx-3");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", groupItem_r13.template);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !groupItem_r13.template);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", groupItem_r13.children && !groupItem_r13.disabled);
} }
function TreelikeMenuComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TreelikeMenuComponent_ng_container_6_div_1_Template, 1, 0, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtemplate(3, TreelikeMenuComponent_ng_container_6_div_3_Template, 4, 8, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TreelikeMenuComponent_ng_container_6_div_4_Template, 5, 6, "div", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const itemGroup_r3 = ctx.$implicit;
    const isFirstGroup_r4 = ctx.first;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !isFirstGroup_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("return-button", !ctx_r2.isFirstLevel && isFirstGroup_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", itemGroup_r3.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", itemGroup_r3.items);
} }
function SidenavComponent_perfect_scrollbar_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "perfect-scrollbar", 4);
    ɵngcc0.ɵɵelementContainer(1, 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function SidenavComponent_ng_template_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function SidenavComponent_ng_template_1_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r12.handlePinToggle()); });
    ɵngcc0.ɵɵelementStart(1, "button", 19);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 20);
    ɵngcc0.ɵɵelement(3, "use");
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbTooltip", (ctx_r7.mode !== "push" ? "Pin" : "Unpin") + " Side Menu");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("href", "#" + (ctx_r7.mode !== "push" ? "pin" : "unpin"));
} }
function SidenavComponent_ng_template_1_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵlistener("click", function SidenavComponent_ng_template_1_div_9_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r14.handleExpand(true)); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 22);
    ɵngcc0.ɵɵelement(2, "use", 23);
    ɵngcc0.ɵɵelementEnd()();
} }
function SidenavComponent_ng_template_1_ng_container_10_ng_template_1_Template(rf, ctx) { }
const _c45 = function (a0) { return { expanded: a0 }; };
function SidenavComponent_ng_template_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_1_ng_container_10_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.headerTemplate.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c45, ctx_r9.expanded));
} }
function SidenavComponent_ng_template_1_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
} }
function SidenavComponent_ng_template_1_ng_container_12_ng_template_1_Template(rf, ctx) { }
function SidenavComponent_ng_template_1_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_1_ng_container_12_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r11.footerTemplate.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c45, ctx_r11.expanded));
} }
const _c46 = function (a0) { return { $implicit: a0, level: 0 }; };
function SidenavComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 6)(1, "symbol", 7);
    ɵngcc0.ɵɵelement(2, "path", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "symbol", 9);
    ɵngcc0.ɵɵelement(4, "path", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "symbol", 11);
    ɵngcc0.ɵɵelement(6, "path", 12)(7, "path", 13);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(8, SidenavComponent_ng_template_1_div_8_Template, 4, 2, "div", 14);
    ɵngcc0.ɵɵtemplate(9, SidenavComponent_ng_template_1_div_9_Template, 3, 0, "div", 15);
    ɵngcc0.ɵɵtemplate(10, SidenavComponent_ng_template_1_ng_container_10_Template, 2, 4, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(11, SidenavComponent_ng_template_1_ng_template_11_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵtemplate(12, SidenavComponent_ng_template_1_ng_container_12_Template, 2, 4, "ng-container", 16);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.expanded && !ctx_r2.disableCollapseMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.headerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c46, ctx_r2.items));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.footerTemplate);
} }
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_1_ng_template_1_Template(rf, ctx) { }
const _c47 = function (a0, a1, a3, a4) { return { $implicit: a0, i: a1, leaf: true, level: a3, withoutRouterLink: a4 }; };
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r25 = ɵngcc0.ɵɵnextContext().ngIf;
    const index_r23 = ɵngcc0.ɵɵnextContext().index;
    const level_r19 = ɵngcc0.ɵɵnextContext().level;
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c47, menuItem_r25, index_r23, level_r19, menuItem_r25.withoutRouterLink));
} }
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_2_ng_template_1_Template(rf, ctx) { }
const _c48 = function (a0, a1, a3) { return { $implicit: a0, i: a1, leaf: false, level: a3 }; };
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r25 = ɵngcc0.ɵɵnextContext().ngIf;
    const index_r23 = ɵngcc0.ɵɵnextContext().index;
    const level_r19 = ɵngcc0.ɵɵnextContext().level;
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c48, menuItem_r25, index_r23, level_r19));
} }
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 27);
} }
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_3_div_1_Template, 1, 0, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "lib-sidenav-group", 26);
    ɵngcc0.ɵɵlistener("expand", function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_3_Template_lib_sidenav_group_expand_2_listener() { ɵngcc0.ɵɵrestoreView(_r40); const ctx_r39 = ɵngcc0.ɵɵnextContext(4); return ɵngcc0.ɵɵresetView(ctx_r39.handleExpand(true)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r25 = ɵngcc0.ɵɵnextContext().ngIf;
    const index_r23 = ɵngcc0.ɵɵnextContext().index;
    const level_r19 = ɵngcc0.ɵɵnextContext().level;
    const ctx_r28 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", index_r23);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", menuItem_r25)("level", level_r19)("menuTemplate", _r3)("expanded", ctx_r28.expanded);
} }
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_4_ng_template_1_Template(rf, ctx) { }
const _c49 = function (a0, a1) { return { $implicit: a0, level: a1 }; };
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_4_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r25 = ɵngcc0.ɵɵnextContext().ngIf;
    const level_r19 = ɵngcc0.ɵɵnextContext(2).level;
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c49, menuItem_r25.children, level_r19 + 1));
} }
function SidenavComponent_ng_template_3_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_1_Template, 2, 7, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(2, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_2_Template, 2, 6, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(3, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_3_Template, 3, 5, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(4, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_ng_container_4_Template, 2, 5, "ng-container", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r25 = ctx.ngIf;
    const ctx_r24 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r25.routerLink || menuItem_r25.withoutRouterLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r25.children);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r25.items);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r25.children && ctx_r24.expanded);
} }
function SidenavComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_3_ng_container_0_ng_container_1_Template, 5, 4, "ng-container", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.isSidenavItem(item_r22));
} }
function SidenavComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SidenavComponent_ng_template_3_ng_container_0_Template, 2, 1, "ng-container", 24);
} if (rf & 2) {
    const items_r18 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngForOf", items_r18);
} }
function SidenavComponent_ng_template_5_ng_container_0_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 33);
} if (rf & 2) {
    const menuItem_r53 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r54 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("width", menuItem_r53.icon[1][0], "px")("height", menuItem_r53.icon[1][1], "px");
    ɵngcc0.ɵɵclassProp("sidenav-item--preview", !ctx_r54.expanded);
    ɵngcc0.ɵɵproperty("icon", menuItem_r53.icon[0]);
} }
function SidenavComponent_ng_template_5_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "uppercase");
    ɵngcc0.ɵɵpipe(3, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menuItem_r53 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r55 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("sidenav-item--preview", !ctx_r55.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind3(3, 5, menuItem_r53.title, 0, 2)), " ");
} }
function SidenavComponent_ng_template_5_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menuItem_r53 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", menuItem_r53.title, " ");
} }
function SidenavComponent_ng_template_5_ng_container_0_ng_container_5_ng_template_1_Template(rf, ctx) { }
const _c50 = function (a0, a1) { return { expanded: a0, item: a1 }; };
function SidenavComponent_ng_template_5_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_5_ng_container_0_ng_container_5_ng_template_1_Template, 0, 0, "ng-template", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r53 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r57 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r57.itemPostfixTemplate.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c50, ctx_r57.expanded, menuItem_r53));
} }
function SidenavComponent_ng_template_5_ng_container_0_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 35);
} if (rf & 2) {
    const menuItem_r53 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵproperty("icon", menuItem_r53.isCollapsed === false ? "chevron-right" : "chevron-down");
} }
const _c51 = function (a0) { return { exact: a0 }; };
function SidenavComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r67 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 28);
    ɵngcc0.ɵɵlistener("click", function SidenavComponent_ng_template_5_ng_container_0_Template_a_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r67); const menuItem_r53 = restoredCtx.ngIf; const ctx_r66 = ɵngcc0.ɵɵnextContext(); const leaf_r49 = ctx_r66.leaf; const i_r48 = ctx_r66.i; const ctx_r65 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(leaf_r49 ? ctx_r65.handleSideNavItemClicked(menuItem_r53) : ctx_r65.handleSideNavItemGroupClicked(menuItem_r53, menuItem_r53.id ? menuItem_r53.id : i_r48, $event)); });
    ɵngcc0.ɵɵtemplate(2, SidenavComponent_ng_template_5_ng_container_0_fa_icon_2_Template, 1, 7, "fa-icon", 29);
    ɵngcc0.ɵɵtemplate(3, SidenavComponent_ng_template_5_ng_container_0_div_3_Template, 4, 9, "div", 30);
    ɵngcc0.ɵɵtemplate(4, SidenavComponent_ng_template_5_ng_container_0_div_4_Template, 2, 1, "div", 31);
    ɵngcc0.ɵɵtemplate(5, SidenavComponent_ng_template_5_ng_container_0_ng_container_5_Template, 2, 5, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(6, SidenavComponent_ng_template_5_ng_container_0_fa_icon_6_Template, 1, 1, "fa-icon", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r53 = ctx.ngIf;
    const ctx_r68 = ɵngcc0.ɵɵnextContext();
    const level_r50 = ctx_r68.level;
    const withoutRouterLink_r51 = ctx_r68.withoutRouterLink;
    const leaf_r49 = ctx_r68.leaf;
    const ctx_r52 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("padding-left", ctx_r52.expanded ? 16 + 24 * (level_r50 || 0) : 16, "px");
    ɵngcc0.ɵɵclassProp("sidenav-item--compact", !ctx_r52.expanded)("sidenav-item-without-children", !(menuItem_r53.children == null ? null : menuItem_r53.children.length));
    ɵngcc0.ɵɵproperty("hoverElementSelectorFn", ctx_r52.hoverElementSelectorFn)("textElementSelectorFn", ctx_r52.textElementSelectorFn)("overflowEnabled", ctx_r52.expanded)("id", menuItem_r53.id ? menuItem_r53.id : menuItem_r53.title)("routerLink", !withoutRouterLink_r51 ? menuItem_r53.routerLink ? menuItem_r53.routerLink : (menuItem_r53.children == null ? null : menuItem_r53.children.length) ? menuItem_r53.children[0].routerLink : null : null)("routerLinkActive", !withoutRouterLink_r51 ? "sidenav-item--active" : "")("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction1(23, _c51, !!ctx_r52.exactLinkActive))("ngbTooltip", menuItem_r53.title)("tooltipClass", ctx_r52.expanded ? "sidenav-expanded-tooltip" : "sidenav-tooltip")("openDelay", 200);
    ɵngcc0.ɵɵattribute("sidenav-parent", menuItem_r53.sidenavParent ? menuItem_r53.sidenavParent : null)("sidenav-parent-id", menuItem_r53.sidenavParentId ? menuItem_r53.sidenavParentId : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r53.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !menuItem_r53.icon && !ctx_r52.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r52.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r52.itemPostfixTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !leaf_r49 && ctx_r52.expanded && (menuItem_r53.children == null ? null : menuItem_r53.children.length));
} }
function SidenavComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SidenavComponent_ng_template_5_ng_container_0_Template, 7, 25, "ng-container", 16);
} if (rf & 2) {
    const item_r47 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.isSidenavItem(item_r47));
} }
function SidenavGroupComponent_h3_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.item.title);
} }
function SidenavGroupComponent_ng_container_1_lib_search_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-search", 8);
    ɵngcc0.ɵɵlistener("searchText", function SidenavGroupComponent_ng_container_1_lib_search_1_Template_lib_search_searchText_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r8.handleSearch($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("value", ctx_r5.value);
} }
function SidenavGroupComponent_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function SidenavGroupComponent_ng_container_1_ng_template_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r10.handleSearchClick()); });
    ɵngcc0.ɵɵelement(1, "fa-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} }
function SidenavGroupComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavGroupComponent_ng_container_1_lib_search_1_Template, 1, 1, "lib-search", 6);
    ɵngcc0.ɵɵtemplate(2, SidenavGroupComponent_ng_container_1_ng_template_2_Template, 2, 0, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.expanded)("ngIfElse", _r6);
} }
function SidenavGroupComponent_ng_template_3_Template(rf, ctx) { }
function SidenavGroupComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.expanded ? "No items found" : "", " ");
} }
const _c52 = [[["lib-sidenav"]], [["lib-sidenav-content"]]];
const _c53 = ["lib-sidenav", "lib-sidenav-content"];
const _c54 = ["tableRef"];
function DataGridComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DataGridComponent_ng_container_4_ng_template_2_th_1_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 15);
} }
function DataGridComponent_ng_container_4_ng_template_2_th_1_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 16);
} if (rf & 2) {
    const s_r11 = ctx.ngIf;
    ɵngcc0.ɵɵpropertyInterpolate("icon", s_r11 === "ASC" ? "chevron-up" : "chevron-down");
} }
const _c55 = function (a0) { return { "sort-field": a0 }; };
function DataGridComponent_ng_container_4_ng_template_2_th_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "th", 11);
    ɵngcc0.ɵɵlistener("click", function DataGridComponent_ng_container_4_ng_template_2_th_1_Template_th_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const c_r8 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r12.changeSort(c_r8.sortingField)); });
    ɵngcc0.ɵɵelementStart(1, "span", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, DataGridComponent_ng_container_4_ng_template_2_th_1_fa_icon_3_Template, 1, 0, "fa-icon", 13);
    ɵngcc0.ɵɵtemplate(4, DataGridComponent_ng_container_4_ng_template_2_th_1_fa_icon_4_Template, 1, 1, "fa-icon", 14);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const c_r8 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵstyleProp("width", c_r8.width);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c55, c_r8.sortingField));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", c_r8.title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", c_r8.sortingField && (!ctx_r7.pageable || !ctx_r7.pageable.sorted(c_r8.sortingField)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.pageable && ctx_r7.pageable.sorted(c_r8.sortingField));
} }
function DataGridComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 9);
    ɵngcc0.ɵɵtemplate(1, DataGridComponent_ng_container_4_ng_template_2_th_1_Template, 5, 8, "th", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.gridColumns);
} }
function DataGridComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DataGridComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(2, DataGridComponent_ng_container_4_ng_template_2_Template, 2, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate ? ctx_r1.headerTemplate.template : _r5);
} }
function DataGridComponent_tr_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DataGridComponent_tr_6_ng_template_2_td_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r20 = ctx.$implicit;
    const item_r14 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵstyleProp("width", c_r20.width);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r14[c_r20.field], " ");
} }
function DataGridComponent_tr_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DataGridComponent_tr_6_ng_template_2_td_0_Template, 2, 3, "td", 20);
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r18.gridColumns);
} }
const _c56 = function (a0, a1, a2) { return { item: a0, items: a1, index: a2 }; };
function DataGridComponent_tr_6_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 17);
    ɵngcc0.ɵɵlistener("click", function DataGridComponent_tr_6_Template_tr_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const item_r14 = restoredCtx.$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r22.handleRowClick(item_r14)); })("dblclick", function DataGridComponent_tr_6_Template_tr_dblclick_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const item_r14 = restoredCtx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r24.handleDoubleClick(item_r14)); });
    ɵngcc0.ɵɵtemplate(1, DataGridComponent_tr_6_ng_container_1_Template, 1, 0, "ng-container", 18);
    ɵngcc0.ɵɵtemplate(2, DataGridComponent_tr_6_ng_template_2_Template, 1, 1, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const i_r15 = ctx.index;
    const _r17 = ɵngcc0.ɵɵreference(3);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.rowTemplate ? ctx_r2.rowTemplate.template : _r17)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c56, item_r14, ctx_r2.dataSource, i_r15));
} }
function DataGridComponent_lib_pagination_7_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-pagination", 21);
    ɵngcc0.ɵɵlistener("pagerdata", function DataGridComponent_lib_pagination_7_Template_lib_pagination_pagerdata_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r25.onPageChange($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("metaData", ctx_r3.pagination)("placement", ctx_r3.placement)("pageSizeContainer", ctx_r3.pageSizeContainer)("sortOptions", ctx_r3.sortOptions)("noDataText", ctx_r3.noDataText)("translatedText", ctx_r3.translatedText);
} }
function PaginationComponent_div_3_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_div_3_button_7_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const option_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r6.changeMessage(option_r5)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    ɵngcc0.ɵɵstyleProp("font-size", "0.7rem !important")("height", "25px !important")("padding", "0 12px !important");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r5, " ");
} }
function PaginationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 9)(4, "button", 10);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵtemplate(7, PaginationComponent_div_3_button_7_Template, 2, 7, "button", 12);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(8, "span", 8);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate((ctx_r0.translatedText == null ? null : ctx_r0.translatedText.SHOW) || "Show");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placement", ctx_r0.placement)("container", ctx_r0.pageSizeContainer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("font-size", "0.7rem !important")("height", "25px !important")("padding", "0 10px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.perPageCount, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.sortOptions);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate((ctx_r0.translatedText == null ? null : ctx_r0.translatedText.ENTRIES) || "entries");
} }
function PaginationComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate7("", (ctx_r1.translatedText == null ? null : ctx_r1.translatedText.SHOWING) || "Showing", " ", ctx_r1.pager.startIndex, " ", (ctx_r1.translatedText == null ? null : ctx_r1.translatedText.TO) || "to", " ", ctx_r1.pager.endIndex, " ", (ctx_r1.translatedText == null ? null : ctx_r1.translatedText.OF) || "of", " ", ctx_r1.totalCount, " ", (ctx_r1.translatedText == null ? null : ctx_r1.translatedText.ENTRIES) || "entries", "");
} }
function PaginationComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.noDataText);
} }
function PaginationComponent_nav_8_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 24)(1, "fa-icon", 25);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_span_1_Template_fa_icon_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r15.setPage(1)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c17, ctx_r8.pager.currentPage === 1));
} }
function PaginationComponent_nav_8_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 26);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c17, ctx_r9.pager.currentPage === 1));
} }
const _c57 = function (a0) { return { active: a0 }; };
function PaginationComponent_nav_8_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li")(1, "a", 30);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_ul_5_li_1_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r21); const page_r19 = restoredCtx.$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r20.setPage(page_r19)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const page_r19 = ctx.$implicit;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c57, ctx_r17.pager.currentPage === page_r19));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(page_r19);
} }
function PaginationComponent_nav_8_ul_5_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 31);
    ɵngcc0.ɵɵtext(1, " ... ");
    ɵngcc0.ɵɵelementEnd();
} }
function PaginationComponent_nav_8_ul_5_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 27);
    ɵngcc0.ɵɵtemplate(1, PaginationComponent_nav_8_ul_5_li_1_Template, 3, 4, "li", 28);
    ɵngcc0.ɵɵtemplate(2, PaginationComponent_nav_8_ul_5_li_2_Template, 2, 0, "li", 29);
    ɵngcc0.ɵɵelementStart(3, "li")(4, "a", 30);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_ul_5_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r22.setPage(ctx_r22.pager.totalPages)); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.getVisiblePages());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.isEndOfList());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c57, ctx_r10.pager.currentPage === ctx_r10.pager.totalPages));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.pager.totalPages, " ");
} }
function PaginationComponent_nav_8_ul_6_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li")(1, "a", 30);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_ul_6_li_1_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r27); const page_r25 = restoredCtx.$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r26.setPage(page_r25)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const page_r25 = ctx.$implicit;
    const ctx_r24 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c57, ctx_r24.pager.currentPage === page_r25));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(page_r25);
} }
function PaginationComponent_nav_8_ul_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 27);
    ɵngcc0.ɵɵtemplate(1, PaginationComponent_nav_8_ul_6_li_1_Template, 3, 4, "li", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.pager.pages);
} }
function PaginationComponent_nav_8_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 32);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c17, ctx_r12.pager.currentPage === ctx_r12.pager.totalPages));
} }
function PaginationComponent_nav_8_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 33)(1, "fa-icon", 34);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_span_10_Template_fa_icon_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r28.setPage(ctx_r28.pager.totalPages)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c17, ctx_r13.pager.currentPage === ctx_r13.pager.totalPages));
} }
function PaginationComponent_nav_8_span_11_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span")(1, "lib-input", 35);
    ɵngcc0.ɵɵlistener("keypress", function PaginationComponent_nav_8_span_11_Template_lib_input_keypress_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r30.validateJumpValue($event)); })("keyup", function PaginationComponent_nav_8_span_11_Template_lib_input_keyup_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r32.onJumpValueChange($event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "button", 36);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_span_11_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r33.jump()); });
    ɵngcc0.ɵɵelement(3, "em", 37);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", (ctx_r14.translatedText == null ? null : ctx_r14.translatedText.JUMP_TO) || "Jump to ...")("value", ctx_r14.jumpValue);
} }
function PaginationComponent_nav_8_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 14);
    ɵngcc0.ɵɵtemplate(1, PaginationComponent_nav_8_span_1_Template, 2, 3, "span", 15);
    ɵngcc0.ɵɵtemplate(2, PaginationComponent_nav_8_span_2_Template, 1, 3, "span", 16);
    ɵngcc0.ɵɵelementStart(3, "span", 17)(4, "fa-icon", 18);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_Template_fa_icon_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r34.setPage(ctx_r34.pager.currentPage - 1)); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(5, PaginationComponent_nav_8_ul_5_Template, 6, 6, "ul", 19);
    ɵngcc0.ɵɵtemplate(6, PaginationComponent_nav_8_ul_6_Template, 2, 1, "ul", 19);
    ɵngcc0.ɵɵelementStart(7, "span", 20)(8, "fa-icon", 21);
    ɵngcc0.ɵɵlistener("click", function PaginationComponent_nav_8_Template_fa_icon_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r36.setPage(ctx_r36.pager.currentPage + 1)); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(9, PaginationComponent_nav_8_span_9_Template, 1, 3, "span", 22);
    ɵngcc0.ɵɵtemplate(10, PaginationComponent_nav_8_span_10_Template, 2, 3, "span", 23);
    ɵngcc0.ɵɵtemplate(11, PaginationComponent_nav_8_span_11_Template, 4, 2, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isDiscrete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isDiscrete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c17, ctx_r3.pager.currentPage === 1));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.pager.pages && ctx_r3.isDiscrete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.pager.pages && !ctx_r3.isDiscrete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c17, ctx_r3.pager.currentPage === ctx_r3.pager.totalPages));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isDiscrete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isDiscrete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isDiscrete);
} }
function ModalConfirmComponent_h2_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
    ɵngcc0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, ctx_r5.message.additionalTitleHtml, "html"), ɵngcc0.ɵɵsanitizeHtml);
} }
function ModalConfirmComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 10);
    ɵngcc0.ɵɵtemplate(1, ModalConfirmComponent_h2_1_span_1_Template, 2, 4, "span", 11);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.message.additionalTitleHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.message.title);
} }
function ModalConfirmComponent_ng_container_5_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.message == null ? null : ctx_r6.message.content);
} }
function ModalConfirmComponent_ng_container_5_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.message == null ? null : ctx_r7.message.description, " ");
} }
function ModalConfirmComponent_ng_container_5_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.message == null ? null : ctx_r8.message.warningMessage, " ");
} }
function ModalConfirmComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵtemplate(2, ModalConfirmComponent_ng_container_5_p_2_Template, 2, 1, "p", 4);
    ɵngcc0.ɵɵtemplate(3, ModalConfirmComponent_ng_container_5_p_3_Template, 2, 1, "p", 14);
    ɵngcc0.ɵɵtemplate(4, ModalConfirmComponent_ng_container_5_p_4_Template, 4, 1, "p", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.message.content);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.message.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.message.warningMessage);
} }
function ModalConfirmComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function ModalConfirmComponent_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.cancel()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.cancelBtnDisable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.closeButtonText, " ");
} }
function ModalConfirmComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 19);
    ɵngcc0.ɵɵlistener("click", function ModalConfirmComponent_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.confirmAdditional()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.additionalButtonText, " ");
} }
function ModalConfirmComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function ModalConfirmComponent_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.confirm()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("btnWithLoader", ctx_r4.confirmButtonLoading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.confirmButtonText, " ");
} }
function ModalWarningComponent_div_0_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 10);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r6.message.image, ɵngcc0.ɵɵsanitizeUrl);
} }
function ModalWarningComponent_div_0_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 11);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("color", ctx_r7.message.imageColor)("font-size", ctx_r7.message.imageFontSize);
    ɵngcc0.ɵɵproperty("icon", ctx_r7.message.image);
} }
function ModalWarningComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, ModalWarningComponent_div_0_img_1_Template, 1, 1, "img", 8);
    ɵngcc0.ɵɵtemplate(2, ModalWarningComponent_div_0_fa_icon_2_Template, 1, 5, "fa-icon", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.checkImageType(ctx_r0.message.image) === "url");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.checkImageType(ctx_r0.message.image) === "icon");
} }
function ModalWarningComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("mt-40px", !ctx_r1.message.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.message.title, "\n");
} }
function ModalWarningComponent_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.message == null ? null : ctx_r2.message.description, "\n");
} }
function ModalWarningComponent_div_3_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 17);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("color", ctx_r8.message.iconColor)("font-size", ctx_r8.message.iconFontSize);
    ɵngcc0.ɵɵproperty("icon", ctx_r8.message.icon);
} }
function ModalWarningComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, ModalWarningComponent_div_3_fa_icon_1_Template, 1, 5, "fa-icon", 15);
    ɵngcc0.ɵɵelementStart(2, "p", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.message.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.message == null ? null : ctx_r3.message.content);
} }
function ModalWarningComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function ModalWarningComponent_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.cancel()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngbTooltip", ctx_r4.cancelBtnTooltip)("disabled", ctx_r4.cancelBtnDisable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.closeButtonText, " ");
} }
function ModalWarningComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 19);
    ɵngcc0.ɵɵlistener("click", function ModalWarningComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.confirm()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("btnWithLoader", ctx_r5.confirmButtonLoading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.confirmButtonText, " ");
} }
function StreamWrapperComponent_ng_container_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function StreamWrapperComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, StreamWrapperComponent_ng_container_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.cssClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.loader ? ctx_r4.loader.template : _r1);
} }
function StreamWrapperComponent_ng_container_0_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c58 = function (a0) { return { data: a0 }; };
function StreamWrapperComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StreamWrapperComponent_ng_container_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dataStream_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.content.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c58, dataStream_r3.value));
} }
function StreamWrapperComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 9);
    ɵngcc0.ɵɵlistener("click", function StreamWrapperComponent_ng_container_0_div_3_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r10.handleReload()); });
    ɵngcc0.ɵɵtext(4, "Reload");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const dataStream_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.errorCssClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.isBoolean(dataStream_r3.error) ? ctx_r6.errorText : dataStream_r3.error || ctx_r6.errorText, " ");
} }
function StreamWrapperComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StreamWrapperComponent_ng_container_0_div_1_Template, 2, 2, "div", 2);
    ɵngcc0.ɵɵtemplate(2, StreamWrapperComponent_ng_container_0_ng_container_2_Template, 2, 4, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, StreamWrapperComponent_ng_container_0_div_3_Template, 5, 2, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dataStream_r3 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dataStream_r3.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dataStream_r3.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dataStream_r3.error);
} }
function StreamWrapperComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-spinner");
} }
function TriggerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1, "ON");
    ɵngcc0.ɵɵelementEnd();
} }
function TriggerComponent_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 10);
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("font-size", 14, "px");
} }
function TriggerComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtext(1, "OFF");
    ɵngcc0.ɵɵelementEnd();
} }
function TriggerComponent_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 12);
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("font-size", 14, "px");
} }
const _c59 = function (a0, a1) { return { "checked": a0, "disabled": a1 }; };
function SideMenuComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    ɵngcc0.ɵɵlistener("click", function SideMenuComponent_div_0_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.handleOverlay(true)); });
    ɵngcc0.ɵɵelementEnd()();
} }
function SideMenuComponent_2_ng_template_0_Template(rf, ctx) { }
function SideMenuComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SideMenuComponent_2_ng_template_0_Template, 0, 0, "ng-template", 8);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.sideMenuHeaderDirective.template);
} }
function SideMenuComponent_lib_search_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-search", 9);
    ɵngcc0.ɵɵlistener("searchText", function SideMenuComponent_lib_search_3_Template_lib_search_searchText_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.search($event)); });
    ɵngcc0.ɵɵelementEnd();
} }
function SideMenuComponent_perfect_scrollbar_4_ng_template_1_Template(rf, ctx) { }
const _c60 = function (a0, a1, a2) { return { $implicit: a0, menuClicked: a1, template: a2 }; };
function SideMenuComponent_perfect_scrollbar_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "perfect-scrollbar", 10);
    ɵngcc0.ɵɵtemplate(1, SideMenuComponent_perfect_scrollbar_4_ng_template_1_Template, 0, 0, "ng-template", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassProp("has-search", ctx_r3.hasSearch)("height-unset", ctx_r3.sideMenuFooterDirective);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(6, _c60, ctx_r3.items, ctx_r3.sideMenuClicked, ctx_r3.sideMenuItemTemplate.template));
} }
function SideMenuComponent_5_ng_template_0_Template(rf, ctx) { }
function SideMenuComponent_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SideMenuComponent_5_ng_template_0_Template, 0, 0, "ng-template", 8);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.sideMenuFooterDirective.template);
} }
function SideMenuComponent_ng_template_6_ng_container_0_ng_template_2_Template(rf, ctx) { }
function SideMenuComponent_ng_template_6_ng_container_0_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 16);
} if (rf & 2) {
    const menuItem_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("chevron-icon chevron-icon--", menuItem_r18.opened ? "down" : "right", "");
    ɵngcc0.ɵɵpropertyInterpolate("icon", menuItem_r18.opened ? "chevron-down" : "chevron-right");
} }
function SideMenuComponent_ng_template_6_ng_container_0_div_4_1_ng_template_0_Template(rf, ctx) { }
function SideMenuComponent_ng_template_6_ng_container_0_div_4_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SideMenuComponent_ng_template_6_ng_container_0_div_4_1_ng_template_0_Template, 0, 0, "ng-template", 11);
} if (rf & 2) {
    const menuItem_r18 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    const _r5 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c60, menuItem_r18.children, ctx_r23.sideSubMenuClicked, ctx_r23.sideMenuChildItemTemplate.template));
} }
function SideMenuComponent_ng_template_6_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, SideMenuComponent_ng_template_6_ng_container_0_div_4_1_Template, 1, 6, null, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.sideMenuChildItemTemplate);
} }
function SideMenuComponent_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵlistener("click", function SideMenuComponent_ng_template_6_ng_container_0_Template_div_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r27); const menuItem_r18 = restoredCtx.$implicit; const menuClicked_r15 = ɵngcc0.ɵɵnextContext().menuClicked; const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r26.handleClick(menuItem_r18, menuClicked_r15, $event)); });
    ɵngcc0.ɵɵtemplate(2, SideMenuComponent_ng_template_6_ng_container_0_ng_template_2_Template, 0, 0, "ng-template", 11);
    ɵngcc0.ɵɵtemplate(3, SideMenuComponent_ng_template_6_ng_container_0_fa_icon_3_Template, 1, 4, "fa-icon", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, SideMenuComponent_ng_template_6_ng_container_0_div_4_Template, 2, 1, "div", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r18 = ctx.$implicit;
    const template_r16 = ɵngcc0.ɵɵnextContext().template;
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("side-menu-item-parent", menuItem_r18.children == null ? null : menuItem_r18.children.length)("active", !(menuItem_r18.children == null ? null : menuItem_r18.children.length) && menuItem_r18 === ctx_r17.activeMenu);
    ɵngcc0.ɵɵproperty("routerLink", (menuItem_r18.children == null ? null : menuItem_r18.children.length) ? null : menuItem_r18.routerLink)("routerLinkActive", menuItem_r18.routerLink ? "active" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", template_r16)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(10, _c44, menuItem_r18));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r18.children == null ? null : menuItem_r18.children.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menuItem_r18.opened && (menuItem_r18.children == null ? null : menuItem_r18.children.length));
} }
function SideMenuComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SideMenuComponent_ng_template_6_ng_container_0_Template, 5, 12, "ng-container", 12);
} if (rf & 2) {
    const menuItems_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngForOf", menuItems_r14);
} }
const _c61 = ["container"];
const _c62 = ["actions"];
const _c63 = ["libScroller", ""];
function ScrollerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3, 4)(2, "div", 5)(3, "fa-icon", 6);
    ɵngcc0.ɵɵlistener("click", function ScrollerComponent_div_3_Template_fa_icon_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.shift(-ctx_r3.scrollStep)); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 7)(5, "fa-icon", 8);
    ɵngcc0.ɵɵlistener("click", function ScrollerComponent_div_3_Template_fa_icon_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.shift(ctx_r5.scrollStep)); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("--size", ctx_r1.libScrollerSize + "px");
} }
function TagComponent_fa_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 4);
} }
function TagComponent_fa_icon_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fa-icon", 5);
    ɵngcc0.ɵɵlistener("click", function TagComponent_fa_icon_5_Template_fa_icon_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.handleRemove($event)); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c64 = [[["", "left-content", ""]]];
const _c65 = ["[left-content]"];
const _c66 = ["sort-column", ""];
function InsightCardComponent_ng_container_3_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.unit);
} }
function InsightCardComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, InsightCardComponent_ng_container_3_span_3_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.value, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.unit);
} }
function InsightCardComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵelement(1, "lib-loader", 7);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "\u00A0");
    ɵngcc0.ɵɵelementEnd()();
} }
function CardComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate.template);
} }
function CardComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 1);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate.template);
} }
const _c67 = ["containerEl"];
function SplitButtonComponent_button_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c68 = function (a0, a1, a2, a3, a4) { return { "btn-primary": a0, "btn-secondary": a1, "btn-link py-0": a2, "size-s": a3, "size-l": a4 }; };
const _c69 = function (a0, a1) { return { item: a0, items: a1 }; };
function SplitButtonComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function SplitButtonComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.itemClick.emit(ctx_r6.items[0])); });
    ɵngcc0.ɵɵtemplate(1, SplitButtonComponent_button_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(4, _c68, ctx_r1.isPrimary && !ctx_r1.isLink, !ctx_r1.isPrimary && !ctx_r1.isLink, ctx_r1.isLink, ctx_r1.sizeS, ctx_r1.sizeL))("disabled", ctx_r1.items[0].disabled || ctx_r1.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate || _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(10, _c69, ctx_r1.items[0], ctx_r1.items));
} }
function SplitButtonComponent_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r11.buttonText);
} }
function SplitButtonComponent_div_3_fa_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 12);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r12.buttonIcon);
} }
function SplitButtonComponent_div_3_li_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function SplitButtonComponent_div_3_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 16);
    ɵngcc0.ɵɵlistener("click", function SplitButtonComponent_div_3_li_10_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const item_r14 = restoredCtx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r16.handleClick(item_r14)); });
    ɵngcc0.ɵɵtemplate(1, SplitButtonComponent_div_3_li_10_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵclassProp("disabled", !!item_r14.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r13.itemTemplate || _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(4, _c69, item_r14, ctx_r13.items));
} }
const _c70 = function (a0, a1, a2, a3, a4, a5) { return { "btn-primary": a0, "btn-secondary": a1, "btn-link py-0": a2, "size-s": a3, "size-l": a4, "btn-icon": a5 }; };
function SplitButtonComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6, 7);
    ɵngcc0.ɵɵlistener("openChange", function SplitButtonComponent_div_3_Template_div_openChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const _r8 = ɵngcc0.ɵɵreference(1); const _r9 = ɵngcc0.ɵɵreference(2); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r18.handleOpen(_r8, _r9)); });
    ɵngcc0.ɵɵelementStart(3, "button", 8, 9);
    ɵngcc0.ɵɵlistener("click", function SplitButtonComponent_div_3_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r19); const _r10 = ɵngcc0.ɵɵreference(4); return ɵngcc0.ɵɵresetView(_r10.blur()); });
    ɵngcc0.ɵɵtemplate(5, SplitButtonComponent_div_3_span_5_Template, 2, 1, "span", 10);
    ɵngcc0.ɵɵtemplate(6, SplitButtonComponent_div_3_fa_icon_6_Template, 1, 1, "fa-icon", 11);
    ɵngcc0.ɵɵelement(7, "fa-icon", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ul", 13);
    ɵngcc0.ɵɵprojection(9);
    ɵngcc0.ɵɵtemplate(10, SplitButtonComponent_div_3_li_10_Template, 2, 7, "li", 14);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r9 = ɵngcc0.ɵɵreference(2);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("placement", ctx_r2.placement)("container", ctx_r2.container);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.items || !ctx_r2.items.length || ctx_r2.disabled)("ngClass", ɵngcc0.ɵɵpureFunction6(10, _c70, ctx_r2.isPrimary && !ctx_r2.isLink, !ctx_r2.isPrimary && !ctx_r2.isLink, ctx_r2.isLink, ctx_r2.sizeS, ctx_r2.sizeL, ctx_r2.isIcon));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.buttonText && !ctx_r2.isIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.buttonIcon && !ctx_r2.isIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("chevron-icon-along", ctx_r2.isIcon);
    ɵngcc0.ɵɵproperty("icon", ctx_r2.isIcon ? ctx_r2.buttonIcon : _r9.isOpen() ? "chevron-up" : "chevron-down");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.items);
} }
function SplitButtonComponent_ng_template_4_fa_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 18);
} if (rf & 2) {
    const item_r21 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵproperty("icon", item_r21.icon);
} }
function SplitButtonComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SplitButtonComponent_ng_template_4_fa_icon_0_Template, 1, 1, "fa-icon", 17);
    ɵngcc0.ɵɵtext(1);
} if (rf & 2) {
    const item_r21 = ctx.item;
    ɵngcc0.ɵɵproperty("ngIf", item_r21.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r21.label, "\n");
} }
function NavbarMenuComponent_ng_container_1_ng_template_1_Template(rf, ctx) { }
function NavbarMenuComponent_ng_container_1_li_3_ng_template_1_Template(rf, ctx) { }
function NavbarMenuComponent_ng_container_1_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_container_1_li_3_ng_template_1_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵpropertyInterpolate("id", i_r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c44, item_r9));
} }
function NavbarMenuComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementStart(2, "ul", 6);
    ɵngcc0.ɵɵtemplate(3, NavbarMenuComponent_ng_container_1_li_3_Template, 2, 5, "li", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c44, ctx_r0.menuItems));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.menuItems);
} }
function NavbarMenuComponent_ng_template_2_ng_container_0_ng_template_1_Template(rf, ctx) { }
function NavbarMenuComponent_ng_template_2_ng_container_0_li_3_ng_template_1_Template(rf, ctx) { }
function NavbarMenuComponent_ng_template_2_ng_container_0_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_template_2_ng_container_0_li_3_ng_template_1_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const k_r17 = ctx.index;
    ɵngcc0.ɵɵnextContext(3);
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵpropertyInterpolate("id", k_r17);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c44, item_r16));
} }
function NavbarMenuComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_template_2_ng_container_0_ng_template_1_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementStart(2, "ul", 6);
    ɵngcc0.ɵɵtemplate(3, NavbarMenuComponent_ng_template_2_ng_container_0_li_3_Template, 2, 5, "li", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const items_r13 = ctx.ngIf;
    ɵngcc0.ɵɵnextContext(2);
    const _r5 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c44, items_r13));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", items_r13);
} }
function NavbarMenuComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavbarMenuComponent_ng_template_2_ng_container_0_Template, 4, 5, "ng-container", 9);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r2.menuItems$));
} }
function NavbarMenuComponent_ng_template_4_a_0_div_2_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 18);
} if (rf & 2) {
    const item_r19 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("icon", item_r19.icon);
} }
function NavbarMenuComponent_ng_template_4_a_0_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
    ɵngcc0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const item_r19 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, item_r19.image, "html"), ɵngcc0.ɵɵsanitizeHtml);
} }
function NavbarMenuComponent_ng_template_4_a_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_template_4_a_0_div_2_fa_icon_1_Template, 1, 1, "fa-icon", 16);
    ɵngcc0.ɵɵtemplate(2, NavbarMenuComponent_ng_template_4_a_0_div_2_span_2_Template, 2, 4, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r19 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵstyleProp("height", 18, "px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r19.icon && !item_r19.image);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r19.image && !item_r19.icon);
} }
const _c71 = function (a0) { return { "link-without-pic": a0 }; };
const _c72 = function () { return ["active"]; };
const _c73 = function (a0) { return [a0]; };
function NavbarMenuComponent_ng_template_4_a_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 11)(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, NavbarMenuComponent_ng_template_4_a_0_div_2_Template, 3, 4, "div", 13);
    ɵngcc0.ɵɵelementStart(3, "div", 14)(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const item_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c71, !item_r19.image && !item_r19.icon))("routerLinkActive", ɵngcc0.ɵɵpureFunction0(7, _c72))("routerLink", ɵngcc0.ɵɵpureFunction1(8, _c73, item_r19.routerLink));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r19.icon || item_r19.image);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r19.label, " ");
} }
function NavbarMenuComponent_ng_template_4_2_ng_template_0_Template(rf, ctx) { }
function NavbarMenuComponent_ng_template_4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavbarMenuComponent_ng_template_4_2_ng_template_0_Template, 0, 0, "ng-template", 5);
} if (rf & 2) {
    const item_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r21.navbarMenuSpecialItemsDirective.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, item_r19));
} }
function NavbarMenuComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavbarMenuComponent_ng_template_4_a_0_Template, 6, 10, "a", 10);
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵtemplate(2, NavbarMenuComponent_ng_template_4_2_Template, 1, 4, null, 9);
    ɵngcc0.ɵɵpipe(3, "async");
} if (rf & 2) {
    const item_r19 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngIf", !item_r19.specialItem && (item_r19.active$ ? ɵngcc0.ɵɵpipeBind1(1, 2, item_r19.active$) : true));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r19.specialItem && (item_r19.active$ ? ɵngcc0.ɵɵpipeBind1(3, 4, item_r19.active$) : true));
} }
function NavbarMenuComponent_ng_template_6_div_0_ng_container_3_a_1_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 29);
} if (rf & 2) {
    const menu_r34 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵstyleProp("height", 16, "px");
    ɵngcc0.ɵɵproperty("icon", menu_r34.icon);
} }
function NavbarMenuComponent_ng_template_6_div_0_ng_container_3_a_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 30);
    ɵngcc0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const menu_r34 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵstyleProp("margin-right", 12, "px")("height", 16, "px");
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 5, menu_r34.image, "html"), ɵngcc0.ɵɵsanitizeHtml);
} }
function NavbarMenuComponent_ng_template_6_div_0_ng_container_3_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 26);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_template_6_div_0_ng_container_3_a_1_fa_icon_1_Template, 1, 3, "fa-icon", 27);
    ɵngcc0.ɵɵtemplate(2, NavbarMenuComponent_ng_template_6_div_0_ng_container_3_a_1_span_2_Template, 2, 8, "span", 28);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const menu_r34 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", menu_r34.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menu_r34.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menu_r34.image && !menu_r34.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", menu_r34.label, " ");
} }
function NavbarMenuComponent_ng_template_6_div_0_ng_container_3_3_ng_template_0_Template(rf, ctx) { }
function NavbarMenuComponent_ng_template_6_div_0_ng_container_3_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavbarMenuComponent_ng_template_6_div_0_ng_container_3_3_ng_template_0_Template, 0, 0, "ng-template", 5);
} if (rf & 2) {
    const menu_r34 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r36 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r36.navbarMenuSpecialItemsDirective.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, menu_r34));
} }
function NavbarMenuComponent_ng_template_6_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_template_6_div_0_ng_container_3_a_1_Template, 5, 4, "a", 25);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, NavbarMenuComponent_ng_template_6_div_0_ng_container_3_3_Template, 1, 4, null, 9);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menu_r34 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !menu_r34.specialItem && (menu_r34.active$ ? ɵngcc0.ɵɵpipeBind1(2, 2, menu_r34.active$) : true));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", menu_r34.specialItem && (menu_r34.active$ ? ɵngcc0.ɵɵpipeBind1(4, 4, menu_r34.active$) : true));
} }
function NavbarMenuComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "a", 22);
    ɵngcc0.ɵɵelementStart(2, "div", 23);
    ɵngcc0.ɵɵtemplate(3, NavbarMenuComponent_ng_template_6_div_0_ng_container_3_Template, 5, 6, "ng-container", 24);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const items_r31 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", items_r31);
} }
function NavbarMenuComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavbarMenuComponent_ng_template_6_div_0_Template, 4, 1, "div", 20);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.collapsed);
} }
function ContextMenuComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.buttonTemplate.template);
} }
function ContextMenuComponent_a_5_fa_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 10);
} if (rf & 2) {
    const menu_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("icon", menu_r3.icon);
} }
function ContextMenuComponent_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵlistener("click", function ContextMenuComponent_a_5_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const menu_r3 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.itemClicked.emit(menu_r3)); });
    ɵngcc0.ɵɵtemplate(1, ContextMenuComponent_a_5_fa_icon_1_Template, 1, 1, "fa-icon", 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const menu_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("href", menu_r3.link ? menu_r3.link : null, ɵngcc0.ɵɵsanitizeUrl)("routerLink", menu_r3.routerLink ? menu_r3.routerLink : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", menu_r3.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", menu_r3.name, " ");
} }
function ContextMenuComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.contextSpecialItemsTemplate.template);
} }
const _c74 = ["btnWithLoader", ""];
function ButtonWithLoaderComponent_ng_container_0_ng_template_1_Template(rf, ctx) { }
function ButtonWithLoaderComponent_ng_container_0_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.loadingText);
} }
function ButtonWithLoaderComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ButtonWithLoaderComponent_ng_container_0_ng_template_2_div_0_Template, 3, 1, "div", 3);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.loading);
} }
function ButtonWithLoaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ButtonWithLoaderComponent_ng_container_0_ng_template_1_Template, 0, 0, "ng-template", 1);
    ɵngcc0.ɵɵtemplate(2, ButtonWithLoaderComponent_ng_container_0_ng_template_2_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.loaderTemplate)("ngIfElse", _r2)("ngTemplateOutlet", ctx_r0.loaderTemplate);
} }
const _c75 = ["tabHeaderTmpl"];
const _c76 = ["tabSet"];
function NavComponent_ng_container_4_ng_container_1_a_1_ng_template_1_Template(rf, ctx) { }
function NavComponent_ng_container_4_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 15);
    ɵngcc0.ɵɵlistener("click", function NavComponent_ng_container_4_ng_container_1_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r14.onNavItemClick(navItem_r4)); });
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_ng_container_1_a_1_ng_template_1_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r8 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
} }
function NavComponent_ng_container_4_ng_container_1_a_2_ng_template_2_Template(rf, ctx) { }
function NavComponent_ng_container_4_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17, 18);
    ɵngcc0.ɵɵlistener("click", function NavComponent_ng_container_4_ng_container_1_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r19.onNavItemClick(navItem_r4)); });
    ɵngcc0.ɵɵtemplate(2, NavComponent_ng_container_4_ng_container_1_a_2_ng_template_2_Template, 0, 0, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r17 = ɵngcc0.ɵɵreference(1);
    const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const _r8 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵclassProp("active", _r17.isActive);
    ɵngcc0.ɵɵproperty("routerLink", navItem_r4.navItemLink);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
} }
function NavComponent_ng_container_4_ng_container_1_lib_context_menu_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", navItem_r4.navItemName, " ");
} }
function NavComponent_ng_container_4_ng_container_1_lib_context_menu_3_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-context-menu", 19);
    ɵngcc0.ɵɵlistener("itemClicked", function NavComponent_ng_container_4_ng_container_1_lib_context_menu_3_Template_lib_context_menu_itemClicked_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r25.onNavItemClick($event)); })("click", function NavComponent_ng_container_4_ng_container_1_lib_context_menu_3_Template_lib_context_menu_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r27.onNavItemClick(navItem_r4)); });
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_ng_container_1_lib_context_menu_3_ng_template_1_Template, 2, 1, "ng-template", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("placement", "bottom-left")("menuItems", navItem_r4.navItemContextMenuItems);
} }
function NavComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_ng_container_1_a_1_Template, 2, 1, "a", 12);
    ɵngcc0.ɵɵtemplate(2, NavComponent_ng_container_4_ng_container_1_a_2_Template, 3, 4, "a", 13);
    ɵngcc0.ɵɵtemplate(3, NavComponent_ng_container_4_ng_container_1_lib_context_menu_3_Template, 2, 2, "lib-context-menu", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !navItem_r4.navItemLink && !navItem_r4.navItemContextMenuItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", navItem_r4.navItemLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !navItem_r4.navItemLink && navItem_r4.navItemContextMenuItems);
} }
function NavComponent_ng_container_4_a_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NavComponent_ng_container_4_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 22);
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_a_2_ng_container_1_Template, 1, 0, "ng-container", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", navItem_r4.navItemHeaderTemplate);
} }
function NavComponent_ng_container_4_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NavComponent_ng_container_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavComponent_ng_container_4_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 23);
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", navItem_r4.template);
} }
function NavComponent_ng_container_4_ng_template_4_ng_container_0_ng_template_1_Template(rf, ctx) { }
function NavComponent_ng_container_4_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_ng_template_4_ng_container_0_ng_template_1_Template, 0, 0, "ng-template", 26);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r35 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r35.tabHeaderTmpl)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, navItem_r4));
} }
function NavComponent_ng_container_4_ng_template_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const navItem_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵtextInterpolate(navItem_r4.navItemName);
} }
function NavComponent_ng_container_4_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavComponent_ng_container_4_ng_template_4_ng_container_0_Template, 2, 4, "ng-container", 24);
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_ng_template_4_ng_template_1_Template, 1, 1, "ng-template", null, 25, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r36 = ɵngcc0.ɵɵreference(2);
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.tabHeaderTmpl)("ngIfElse", _r36);
} }
function NavComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 7);
    ɵngcc0.ɵɵtemplate(1, NavComponent_ng_container_4_ng_container_1_Template, 4, 3, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(2, NavComponent_ng_container_4_a_2_Template, 2, 1, "a", 9);
    ɵngcc0.ɵɵtemplate(3, NavComponent_ng_container_4_ng_template_3_Template, 1, 1, "ng-template", 10);
    ɵngcc0.ɵɵtemplate(4, NavComponent_ng_container_4_ng_template_4_Template, 3, 2, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const navItem_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngbNavItem", navItem_r4.navItemId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !navItem_r4.hidden && !navItem_r4.navItemHeaderTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", navItem_r4.navItemHeaderTemplate);
} }
function NavComponent_ng_template_6_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 28);
    ɵngcc0.ɵɵlistener("click", function NavComponent_ng_template_6_span_0_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r44); const item_r42 = restoredCtx.$implicit; const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r43.selectById(item_r42.id)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r42 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("routerLink", item_r42.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r42.name, " ");
} }
function NavComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NavComponent_ng_template_6_span_0_Template, 2, 2, "span", 27);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.hiddenItems);
} }
function ToastrComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ToastrComponent_button_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.onClose()); });
    ɵngcc0.ɵɵelementStart(1, "span", 11);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd()();
} }
function ToastrComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "fa-icon", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", "toastr-icon-" + ctx_r1.toastType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("icon", ctx_r1.messageIcon);
} }
const _c77 = function (a0) { return { "toastr-title-notification": a0 }; };
function ToastrComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c77, ctx_r2.isNotification));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.title, " ");
} }
function ToastrComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainer(1, 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(7);
    const _r6 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.htmlBodyContent ? _r4 : _r6);
} }
function ToastrComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r5.getMessage(), ɵngcc0.ɵɵsanitizeHtml);
} }
function ToastrComponent_ng_template_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 18);
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.bodyTemplate.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, ctx_r14.message));
} }
function ToastrComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, ToastrComponent_ng_template_8_ng_container_2_Template, 1, 4, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ctx_r7.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.getMessage(), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.bodyTemplate);
} }
function ToastrComponent_ng_template_10_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 18);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.footerTemplate.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, ctx_r15.message));
} }
function ToastrComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ToastrComponent_ng_template_10_ng_container_0_Template, 1, 4, "ng-container", 17);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.footerTemplate);
} }
function ToastrComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    ɵngcc0.ɵɵlistener("click", function ToastrComponent_ng_template_12_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.onClose()); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r11.closeButtonText);
} }
function CardWithStatusComponent_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r0.status.icon);
} }
function CardWithStatusComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5)(2, "div", 6);
    ɵngcc0.ɵɵlistener("click", function CardWithStatusComponent_ng_container_7_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.expanded = !ctx_r2.expanded); });
    ɵngcc0.ɵɵelement(3, "fa-icon", 7);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelementContainer(6, 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("border-bottom", !!ctx_r1.expanded);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("expanded", !!ctx_r1.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.cardExpandedTemplate.expandedLabel, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("@expand", !!ctx_r1.expanded ? "expanded" : "collapsed");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.cardExpandedTemplate.template);
} }
const _c78 = function (a0) { return { width: a0 }; };
function SlideSelectorComponent_nav_0_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 3);
    ɵngcc0.ɵɵlistener("click", function SlideSelectorComponent_nav_0_a_1_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const i_r3 = restoredCtx.index; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r4.changeView(i_r3)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("switch-active-item", ctx_r1.viewSelector === i_r3);
    ɵngcc0.ɵɵproperty("ngbTooltip", item_r2.title)("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c78, item_r2.widthPercent + "%"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2.title, " ");
} }
const _c79 = function (a0, a1) { return { width: a0, left: a1 }; };
function SlideSelectorComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nav");
    ɵngcc0.ɵɵtemplate(1, SlideSelectorComponent_nav_0_a_1_Template, 2, 7, "a", 1);
    ɵngcc0.ɵɵelement(2, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.itemsVm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(2, _c79, "calc(" + ctx_r0.itemsVm[ctx_r0.viewSelector].widthPercent + "%" + " + 2px)", ctx_r0.itemsVm[ctx_r0.viewSelector].leftPositionPercent + "%"));
} }
function ModalWithOptionsComponent_h2_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
    ɵngcc0.ɵɵpipe(1, "safeHtml");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 1, ctx_r5.message.additionalTitleHtml, "html"), ɵngcc0.ɵɵsanitizeHtml);
} }
function ModalWithOptionsComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 11);
    ɵngcc0.ɵɵtemplate(1, ModalWithOptionsComponent_h2_1_span_1_Template, 2, 4, "span", 12);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.message.additionalTitleHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.message.title);
} }
function ModalWithOptionsComponent_ng_container_6_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.message.content);
} }
function ModalWithOptionsComponent_ng_container_6_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.message.description, " ");
} }
function ModalWithOptionsComponent_ng_container_6_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵelement(1, "fa-icon", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.message.warningMessage, " ");
} }
function ModalWithOptionsComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ModalWithOptionsComponent_ng_container_6_p_1_Template, 2, 1, "p", 5);
    ɵngcc0.ɵɵtemplate(2, ModalWithOptionsComponent_ng_container_6_p_2_Template, 2, 1, "p", 14);
    ɵngcc0.ɵɵtemplate(3, ModalWithOptionsComponent_ng_container_6_p_3_Template, 4, 1, "p", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.message.content);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.message.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.message.warningMessage);
} }
function ModalWithOptionsComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "lib-radio-button", 18);
    ɵngcc0.ɵɵlistener("click", function ModalWithOptionsComponent_div_8_Template_lib_radio_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const i_r10 = restoredCtx.index; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.switchRadioButton(i_r10)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const radio_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const last_r11 = ctx.last;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("mb-16px", !last_r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", ctx_r2.selectedRadioButton == i_r10)("label", radio_r9.buttonText);
} }
function ModalWithOptionsComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 19);
    ɵngcc0.ɵɵlistener("click", function ModalWithOptionsComponent_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r14.cancel()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.closeButtonText, " ");
} }
function ModalWithOptionsComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function ModalWithOptionsComponent_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.confirm()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("btnWithLoader", ctx_r4.confirmButtonLoading)("disabled", ctx_r4.selectedRadioButton === null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.confirmButtonText, " ");
} }
const _c80 = ".modal-header[_ngcontent-%COMP%]{border:none;color:var(--da-title)}.modal-header[_ngcontent-%COMP%]   button.close[_ngcontent-%COMP%]{color:var(--da-popup-icon-close-color);font-size:30px;font-weight:300;line-height:1rem}.modal-body[_ngcontent-%COMP%]{font-size:12px;white-space:pre-line}.modal-body[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--da-popup-icon-warning-color);font-size:14px;margin:0 4px}.modal-body[_ngcontent-%COMP%]   .text-description[_ngcontent-%COMP%]{color:#bebebe;font-size:10px}.modal-body[_ngcontent-%COMP%]   .message-with-warning[_ngcontent-%COMP%]{margin-left:5px}.modal-body[_ngcontent-%COMP%]   .warning-icon[_ngcontent-%COMP%]{color:var(--da-error-base);font-size:16px!important}.modal-footer[_ngcontent-%COMP%]{border:none;display:flex}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:11px;height:28px;line-height:14px;margin-left:1rem}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:not(.additional-button){min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;width:88px}";
function BreadcrumbComponent__svg_svg_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 2)(1, "symbol", 3);
    ɵngcc0.ɵɵelement(2, "path", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "symbol", 5);
    ɵngcc0.ɵɵelement(4, "path", 6);
    ɵngcc0.ɵɵelementEnd()();
} }
function BreadcrumbComponent_ng_container_1_a_2__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 16);
    ɵngcc0.ɵɵelement(1, "use", 17);
    ɵngcc0.ɵɵelementEnd();
} }
function BreadcrumbComponent_ng_container_1_a_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BreadcrumbComponent_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9, 10);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbComponent_ng_container_1_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const item_r2 = ɵngcc0.ɵɵnextContext().$implicit; return ɵngcc0.ɵɵresetView(item_r2.breadcrumbClick == null ? null : item_r2.breadcrumbClick.emit($event)); });
    ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_ng_container_1_a_2__svg_svg_2_Template, 2, 0, "svg", 11);
    ɵngcc0.ɵɵelementStart(3, "span", 12);
    ɵngcc0.ɵɵtemplate(4, BreadcrumbComponent_ng_container_1_a_2_ng_container_4_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(5, "svg", 14);
    ɵngcc0.ɵɵelement(6, "use", 15);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(1);
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const first_r3 = ctx_r13.first;
    const item_r2 = ctx_r13.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("breadcrumb-arrow-item-first", first_r3)("fake", item_r2.fake)("active", ctx_r4.isActive(_r7, item_r2));
    ɵngcc0.ɵɵproperty("routerLink", ctx_r4.getUrl(item_r2));
    ɵngcc0.ɵɵattribute("tabindex", ctx_r4.isActive(_r7, item_r2) ? -1 : undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !first_r3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r2.template);
} }
function BreadcrumbComponent_ng_container_1_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BreadcrumbComponent_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18, 10);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbComponent_ng_container_1_ng_template_3_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const item_r2 = ɵngcc0.ɵɵnextContext().$implicit; return ɵngcc0.ɵɵresetView(item_r2.breadcrumbClick == null ? null : item_r2.breadcrumbClick.emit($event)); });
    ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_ng_container_1_ng_template_3_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r14 = ɵngcc0.ɵɵreference(1);
    const item_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r6.isActive(_r14, item_r2))("fake", item_r2.fake);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r6.getUrl(item_r2));
    ɵngcc0.ɵɵattribute("tabindex", ctx_r6.isActive(_r14, item_r2) ? -1 : undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r2.template);
} }
function BreadcrumbComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0)(1);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_ng_container_1_a_2_Template, 7, 10, "a", 7);
    ɵngcc0.ɵɵtemplate(3, BreadcrumbComponent_ng_container_1_ng_template_3_Template, 3, 7, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(4);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.mode === "arrow")("ngIfElse", _r5);
} }
function WaitingLoaderComponent__svg_g_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "g")(1, "circle", 1);
    ɵngcc0.ɵɵelement(2, "animate", 2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const circle_r1 = ctx.$implicit;
    const first_r2 = ctx.first;
    ɵngcc0.ɵɵattribute("transform", circle_r1.transform);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("fill-opacity", first_r2 ? 1 : 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", circle_r1.values);
} }
export * from '@dagility-ui/kit/icons';
import { faExclamationCircle, faCalendar, faClock } from '@fortawesome/free-solid-svg-icons';
import { fromEvent, BehaviorSubject, Subject, concat, of, EMPTY, merge, noop, combineLatest, identity, Subscription, Observable, timer } from 'rxjs';
import { shareReplay, delay, startWith, concatMap, tap, catchError, takeUntil, debounceTime, distinctUntilChanged, map, filter, switchMap, take, mapTo, pairwise, share } from 'rxjs/operators';
import PerfectScrollbar from 'perfect-scrollbar';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { __awaiter } from 'tslib';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpParams, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { trigger, state, style, transition, animate } from '@angular/animations';

class SpinnerComponent {
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["lib-spinner"]], hostAttrs: [1, "d-inline-block"], decls: 3, vars: 0, consts: [[1, "bounce1"], [1, "bounce2"], [1, "bounce3"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0)(1, "div", 1)(2, "div", 2);
    } }, styles: ["[_nghost-%COMP%], [_nghost-%COMP%]   div[_ngcontent-%COMP%]{height:18px}[_nghost-%COMP%]   div[_ngcontent-%COMP%]{-webkit-animation:sk-bouncedelay 1.4s ease-in-out infinite both;animation:sk-bouncedelay 1.4s ease-in-out infinite both;background-color:var(--da-title);border-radius:100%;display:inline-block;margin-left:3px;width:18px}[_nghost-%COMP%]   div[_ngcontent-%COMP%]:first-child{margin-left:0}[_nghost-%COMP%]   .bounce1[_ngcontent-%COMP%]{-webkit-animation-delay:-.32s;animation-delay:-.32s}[_nghost-%COMP%]   .bounce2[_ngcontent-%COMP%]{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{ selector: 'lib-spinner', template: `
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    `, host: {
                    class: 'd-inline-block'
                }, styles: [":host,:host div{height:18px}:host div{-webkit-animation:sk-bouncedelay 1.4s ease-in-out infinite both;animation:sk-bouncedelay 1.4s ease-in-out infinite both;background-color:var(--da-title);border-radius:100%;display:inline-block;margin-left:3px;width:18px}:host div:first-child{margin-left:0}:host .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}:host .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}"] }]
    }], null, null); })();

class ProgressSpinnerComponent {
}
ProgressSpinnerComponent.ɵfac = function ProgressSpinnerComponent_Factory(t) { return new (t || ProgressSpinnerComponent)(); };
ProgressSpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressSpinnerComponent, selectors: [["lib-progress-spinner"]], decls: 1, vars: 0, consts: [[1, "indeterminate"]], template: function ProgressSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, styles: ["[_nghost-%COMP%]{background:none;background-clip:padding-box;border-radius:2px;display:block;height:2px;overflow:hidden;position:fixed;top:0;width:100%;z-index:1000}  #spinner.backdrop{background:none!important;height:2px!important;opacity:1!important}.indeterminate[_ngcontent-%COMP%]{background:#24abe2}.indeterminate[_ngcontent-%COMP%]:after, .indeterminate[_ngcontent-%COMP%]:before{background-color:inherit;bottom:0;content:\"\";left:0;position:absolute;top:0;will-change:left,right}.indeterminate[_ngcontent-%COMP%]:before{-webkit-animation:indeterminate 3.1s cubic-bezier(.65,.815,.735,.395) infinite;animation:indeterminate 3.1s cubic-bezier(.65,.815,.735,.395) infinite}.indeterminate[_ngcontent-%COMP%]:after{-webkit-animation:indeterminate-short 3.1s cubic-bezier(.165,.84,.44,1) infinite;-webkit-animation-delay:1.25s;animation:indeterminate-short 3.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.25s}@-webkit-keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@-webkit-keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressSpinnerComponent, [{
        type: Component,
        args: [{ selector: 'lib-progress-spinner', template: `<div class="indeterminate"></div>`, styles: [":host{background:none;background-clip:padding-box;border-radius:2px;display:block;height:2px;overflow:hidden;position:fixed;top:0;width:100%;z-index:1000}::ng-deep #spinner.backdrop{background:none!important;height:2px!important;opacity:1!important}.indeterminate{background:#24abe2}.indeterminate:after,.indeterminate:before{background-color:inherit;bottom:0;content:\"\";left:0;position:absolute;top:0;will-change:left,right}.indeterminate:before{-webkit-animation:indeterminate 3.1s cubic-bezier(.65,.815,.735,.395) infinite;animation:indeterminate 3.1s cubic-bezier(.65,.815,.735,.395) infinite}.indeterminate:after{-webkit-animation:indeterminate-short 3.1s cubic-bezier(.165,.84,.44,1) infinite;-webkit-animation-delay:1.25s;animation:indeterminate-short 3.1s cubic-bezier(.165,.84,.44,1) infinite;animation-delay:1.25s}@-webkit-keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}to{left:100%;right:-90%}}@-webkit-keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}"] }]
    }], null, null); })();

class SpinnerModule {
}
SpinnerModule.ɵfac = function SpinnerModule_Factory(t) { return new (t || SpinnerModule)(); };
SpinnerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SpinnerModule });
SpinnerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerModule, [{
        type: NgModule,
        args: [{
                declarations: [SpinnerComponent, ProgressSpinnerComponent],
                exports: [SpinnerComponent, ProgressSpinnerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SpinnerModule, { declarations: [SpinnerComponent, ProgressSpinnerComponent], exports: [SpinnerComponent, ProgressSpinnerComponent] }); })();

class FormSubmitDirective {
    constructor(host) {
        this.host = host;
        this.submit$ = fromEvent(this.element, 'submit').pipe(shareReplay(1));
    }
    get element() {
        return this.host.nativeElement;
    }
}
FormSubmitDirective.ɵfac = function FormSubmitDirective_Factory(t) { return new (t || FormSubmitDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FormSubmitDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FormSubmitDirective, selectors: [["form"]] });
FormSubmitDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormSubmitDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: 'form'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

const ɵ0 = () => 'This field is required', ɵ1 = () => 'Invalid range', ɵ2 = ({ requiredLength, actualLength }) => `Must be at least ${requiredLength} characters long`, ɵ3 = ({ requiredLength, actualLength }) => `Must be max ${requiredLength} characters long`, ɵ4 = () => 'Duplicated field', ɵ5 = ({ min, actual }) => `Must be greater than ${min}`, ɵ6 = ({ requiredPattern, actualValue }) => `The field doesn't match requested format ${requiredPattern}`, ɵ7 = ({ required, received }) => `Expected ${required}, but got ${received}`, ɵ8 = (text) => text, ɵ9 = ({ value, customTextFn = null }) => customTextFn
    ? customTextFn(value)
    : `The field shouldn't equal ${value}`, ɵ10 = () => 'Email is not valid', ɵ11 = ({ controlLabel = 'This field' }) => `${controlLabel} cannot contain trailing or leading spaces`;
const defaultErrors = {
    required: ɵ0,
    range: ɵ1,
    minlength: ɵ2,
    maxlength: ɵ3,
    duplicate: ɵ4,
    min: ɵ5,
    pattern: ɵ6,
    typingError: ɵ7,
    customText: ɵ8,
    notEqual: ɵ9,
    email: ɵ10,
    leadingTrailingSpaces: ɵ11
};
function isErrorState(control, form) {
    const isSubmitted = form && form.submitted;
    return !!(control &&
        control.invalid &&
        (control.dirty || control.touched || isSubmitted));
}
const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
    providedIn: 'root',
    factory: () => defaultErrors
});

const toDropDownItem = item => {
    if (item && item.includes(':')) {
        const pair = item.split(':');
        return { label: pair[1], value: item };
    }
    return { label: item, value: item };
};
const toDropDownItemFromIPluginService = item => ({
    label: item.service,
    value: item.pluginName + ':' + item.service
});
const capitalizeLabel = (label) => {
    label = label.toLowerCase();
    label = label
        .replace(/\b(\w)/g, s => s.toUpperCase())
        .replace(/_\w/g, s => s.toUpperCase())
        .replace(/_/g, ' ');
    return label;
};
const toDropDownItemCapitalizedLabel = item => ({ label: capitalizeLabel(item), value: item });
function sortObjectArrayByKey(array, key, asc = true) {
    array.sort((a, b) => {
        const aKey = a[key];
        const bKey = b[key];
        let result = null;
        if (typeof aKey === 'string' && typeof bKey === 'string') {
            result =
                aKey.toLowerCase() < bKey.toLowerCase()
                    ? asc
                        ? -1
                        : 1
                    : asc
                        ? 1
                        : -1;
        }
        else {
            result = aKey < bKey ? (asc ? -1 : 1) : asc ? 1 : -1;
        }
        return result;
    });
    return array;
}
function observeProperty(target, key) {
    const subject = new BehaviorSubject(target[key]);
    Object.defineProperty(target, key, {
        get() {
            return subject.getValue();
        },
        set(newValue) {
            if (newValue !== subject.getValue()) {
                subject.next(newValue);
            }
        }
    });
    return subject.asObservable();
}
function writeContents(blob, fileName) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
}
function toHttpParams(obj) {
    const returns = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const v = obj[key];
            if (v) {
                returns[key] = v.toString();
            }
        }
    }
    return returns;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function generateUUID() {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' &&
        typeof performance.now === 'function') {
        d += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line: no-bitwise
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // tslint:disable-next-line: no-bitwise
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}
function collectAllParentRouteParams(currentSnapshot) {
    const params = {};
    (function mergeParamsFromSnapshot(snapshot) {
        Object.assign(params, snapshot.params);
        if (snapshot.parent) {
            mergeParamsFromSnapshot(snapshot.parent);
        }
    })(currentSnapshot);
    return params;
}
function toJSONBlob(object) {
    return new Blob([JSON.stringify(object, undefined, 2)], {
        type: 'application/json'
    });
}
function loadFile(accept) {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = accept;
        input.multiple = false;
        input.onchange = () => resolve(input.files);
        input.onerror = () => reject();
        input.click();
    });
}
function readFileToObject(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            try {
                const obj = JSON.parse(reader.result);
                resolve(obj);
            }
            catch (e) {
                reject('Invalid data format');
            }
        };
        reader.onerror = () => reject();
        reader.readAsText(file);
    });
}
function polling(delayTime, fn) {
    const subject$ = new Subject();
    return subject$.pipe(delay(delayTime), startWith(0), concatMap(fn), tap(() => subject$.next()));
}
function liftToObsWithStatus(observable) {
    return concat(of({ type: 'start' }), observable.pipe(catchError(() => of({ type: 'error' }))));
}
function coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}
function lightOrDark(color) {
    let r, g, b, hsp;
    if (color.match(/^rgb/)) {
        const [R, G, B] = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = R;
        g = G;
        b = B;
    }
    else {
        const colorNumber = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        // tslint:disable-next-line:no-bitwise
        r = colorNumber >> 16;
        // tslint:disable-next-line:no-bitwise
        g = (colorNumber >> 8) & 255;
        // tslint:disable-next-line:no-bitwise
        b = colorNumber & 255;
    }
    hsp = Math.sqrt(0.299 * Math.pow(r, 2) + 0.587 * Math.pow(g, 2) + 0.114 * Math.pow(b, 2));
    if (hsp > 127.5) {
        return '#000';
    }
    else {
        return '#fff';
    }
}
function focusNativeElement(element, focused = true, preventScroll = false) {
    if (focused) {
        element.focus({ preventScroll });
        return;
    }
    element.blur();
}
function onVisible(element, callback) {
    new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                callback(element);
                observer.disconnect();
            }
        });
    }).observe(element);
}

class ErrorMessageComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.icons = {
            faExclamationCircle
        };
        this.show = false;
    }
    set message(value) {
        this.text = value;
        this.show = coerceBooleanProperty(value);
        if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
        }
    }
}
ErrorMessageComponent.ɵfac = function ErrorMessageComponent_Factory(t) { return new (t || ErrorMessageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ErrorMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ErrorMessageComponent, selectors: [["lib-error-message"]], hostAttrs: [1, "error-message"], inputs: { message: "message" }, decls: 2, vars: 2, consts: [[1, "error-message-container", 3, "hidden"]], template: function ErrorMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.show);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.text, "\n");
    } }, styles: [".error-message-container[_ngcontent-%COMP%]{color:var(--da-error-base);font-size:10px;font-style:italic;line-height:14px;margin-bottom:3px;margin-top:3px}"], changeDetection: 0 });
ErrorMessageComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
ErrorMessageComponent.propDecorators = {
    message: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorMessageComponent, [{
        type: Component,
        args: [{ selector: 'lib-error-message', template: "<div class=\"error-message-container\" [hidden]=\"!show\">\n    {{text}}\n</div>\n", changeDetection: ChangeDetectionStrategy.OnPush, host: { class: 'error-message' }, styles: [".error-message-container{color:var(--da-error-base);font-size:10px;font-style:italic;line-height:14px;margin-bottom:3px;margin-top:3px}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { message: [{
            type: Input
        }] }); })();

class ErrorControlDirective {
    constructor(
    // tslint:disable-next-line:variable-name
    _errors, form, resolver, ngControl, containerRef, cdr) {
        this._errors = _errors;
        this.form = form;
        this.resolver = resolver;
        this.ngControl = ngControl;
        this.containerRef = containerRef;
        this.cdr = cdr;
        this.customErrors = {};
        this.showError = true;
        this.destroy$ = new Subject();
        this.errors = this._errors;
        this.submit$ = this.form ? this.form.submit$ : EMPTY;
    }
    get container() {
        return (this.ngControl.valueAccessor['controlContainerRef'] ||
            this.containerRef);
    }
    ngOnInit() {
        var _a;
        const control = (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control;
        if (control) {
            merge(control.valueChanges, control.statusChanges, this.submit$)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                const controlErrors = control.errors;
                if (isErrorState(control) && controlErrors) {
                    const key = Object.keys(controlErrors)[0];
                    const getError = this.errors[key];
                    if (!getError && !this.customErrors[key]) {
                        console.warn(`Missing default error message for '${key}' error key`);
                        return;
                    }
                    const text = this.customErrors[key] ||
                        getError(controlErrors[key]);
                    if (this.showError) {
                        this.setError(text);
                    }
                    else {
                        this.hasErrors = text != null;
                    }
                }
                else {
                    if (this.errorContainerRef) {
                        this.setError(null);
                    }
                    else {
                        this.hasErrors = false;
                    }
                }
                this.cdr.detectChanges();
            });
        }
    }
    setError(text) {
        if (!this.errorContainerRef) {
            const component = this.resolver.resolveComponentFactory(ErrorMessageComponent);
            this.errorContainerRef = this.container.createComponent(component);
        }
        this.errorContainerRef.instance.message = text;
        this.hasErrors = text !== null;
        //        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
ErrorControlDirective.ɵfac = function ErrorControlDirective_Factory(t) { return new (t || ErrorControlDirective)(ɵngcc0.ɵɵdirectiveInject(FORM_ERRORS), ɵngcc0.ɵɵdirectiveInject(FormSubmitDirective, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ErrorControlDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ErrorControlDirective, selectors: [["", "formControl", ""], ["", "formControlName", ""]], hostVars: 2, hostBindings: function ErrorControlDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("invalid", ctx.hasErrors);
    } }, inputs: { customErrors: "customErrors", showError: "showError", formControlName: "formControlName" } });
ErrorControlDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [FORM_ERRORS,] }] },
    { type: FormSubmitDirective, decorators: [{ type: Optional }] },
    { type: ComponentFactoryResolver },
    { type: NgControl, decorators: [{ type: Optional }] },
    { type: ViewContainerRef },
    { type: ChangeDetectorRef }
];
ErrorControlDirective.propDecorators = {
    customErrors: [{ type: Input }],
    formControlName: [{ type: Input }],
    showError: [{ type: Input }],
    hasErrors: [{ type: HostBinding, args: ['class.invalid',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorControlDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: '[formControl], [formControlName]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [FORM_ERRORS]
            }] }, { type: FormSubmitDirective, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { customErrors: [{
            type: Input
        }], showError: [{
            type: Input
        }], hasErrors: [{
            type: HostBinding,
            args: ['class.invalid']
        }], formControlName: [{
            type: Input
        }] }); })();

// tslint:disable-next-line:directive-class-suffix
class BaseFormControl {
    constructor(errorControlDirective, ngControl, form, cdr, zone) {
        this.errorControlDirective = errorControlDirective;
        this.ngControl = ngControl;
        this.form = form;
        this.cdr = cdr;
        this.zone = zone;
        this.readonly = false;
        this.isRequired = false;
        this.destroy$ = new Subject();
        this.onChange = (_) => { };
        this.onTouched = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    get warning() {
        return this.warningMessage;
    }
    get info() {
        return this.infoMessage;
    }
    get hasErrors() {
        return this.errorControlDirective ? this.errorControlDirective.hasErrors : false;
    }
    get control() {
        return this.ngControl ? this.ngControl.control : new FormControl();
    }
    ngOnInit() {
        this.checkRequired();
        if (this.ngControl) {
            this.ngControl.control.statusChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.checkRequired());
        }
        if (this.form && this.form.submit$) {
            this.form.submit$.pipe(takeUntil(this.destroy$)).subscribe(() => this.cdr.markForCheck());
        }
    }
    checkRequired() {
        if (this.ngControl) {
            const validator = this.ngControl.control.validator;
            if (validator) {
                const validationErrors = this.ngControl.control.validator({});
                this.isRequired = !!(validationErrors && validationErrors.required);
            }
            else {
                this.isRequired = false;
            }
        }
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
}
BaseFormControl.ɵfac = function BaseFormControl_Factory(t) { return new (t || BaseFormControl)(ɵngcc0.ɵɵdirectiveInject(ErrorControlDirective, 10), ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(FormSubmitDirective, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
BaseFormControl.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BaseFormControl, viewQuery: function BaseFormControl_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.controlContainerRef = _t.first);
    } }, inputs: { readonly: "readonly", value: "value", label: "label", warningMessage: "warningMessage", infoMessage: "infoMessage" } });
BaseFormControl.ctorParameters = () => [
    { type: ErrorControlDirective, decorators: [{ type: Inject, args: [ErrorControlDirective,] }, { type: Self }, { type: Optional }] },
    { type: NgControl, decorators: [{ type: Inject, args: [NgControl,] }, { type: Self }, { type: Optional }] },
    { type: FormSubmitDirective, decorators: [{ type: Inject, args: [FormSubmitDirective,] }, { type: Optional }] },
    { type: ChangeDetectorRef },
    { type: NgZone }
];
BaseFormControl.propDecorators = {
    label: [{ type: Input }],
    warningMessage: [{ type: Input }],
    infoMessage: [{ type: Input }],
    value: [{ type: Input }],
    readonly: [{ type: Input }],
    input: [{ type: ViewChild, args: ['input', { static: true },] }],
    controlContainerRef: [{ type: ViewChild, args: ['controlContainer', { read: ViewContainerRef, static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseFormControl, [{
        type: Directive
    }], function () { return [{ type: ErrorControlDirective, decorators: [{
                type: Inject,
                args: [ErrorControlDirective]
            }, {
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc1.NgControl, decorators: [{
                type: Inject,
                args: [NgControl]
            }, {
                type: Self
            }, {
                type: Optional
            }] }, { type: FormSubmitDirective, decorators: [{
                type: Inject,
                args: [FormSubmitDirective]
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { readonly: [{
            type: Input
        }], value: [{
            type: Input
        }], label: [{
            type: Input
        }], warningMessage: [{
            type: Input
        }], infoMessage: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }], controlContainerRef: [{
            type: ViewChild,
            args: ['controlContainer', { read: ViewContainerRef, static: true }]
        }] }); })();

class ValidationErrorDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
ValidationErrorDirective.ɵfac = function ValidationErrorDirective_Factory(t) { return new (t || ValidationErrorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ValidationErrorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ValidationErrorDirective, selectors: [["ng-template", "valError", ""]], inputs: { valError: "valError" } });
ValidationErrorDirective.ctorParameters = () => [
    { type: TemplateRef }
];
ValidationErrorDirective.propDecorators = {
    valError: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationErrorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line
                selector: 'ng-template[valError]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { valError: [{
            type: Input
        }] }); })();

class ValidationErrorsComponent {
    constructor(controlContainer) {
        this.controlContainer = controlContainer;
        this.icons = {
            faExclamationCircle
        };
    }
    get hasDisplayableError() {
        return (isErrorState(this.formControl) &&
            this.formControl.validator &&
            Object.keys(this.formControl.errors || []).some(type => this.errorsDirective.some(errorDirective => errorDirective.valError === type)));
    }
    get displayedErrors() {
        return this.errorsDirective.filter(errorDirective => this.formControl.hasError(errorDirective.valError));
    }
    get isNgControl() {
        return this.control instanceof NgControl;
    }
    get isBaseControl() {
        return this.control instanceof BaseFormControl;
    }
    get isHTMLInputElement() {
        return this.control instanceof HTMLInputElement;
    }
    get isAbstractControl() {
        return this.control instanceof AbstractControl;
    }
    get formControl() {
        if (this.isNgControl) {
            return this.control.control;
        }
        else if (this.isBaseControl) {
            return this.control.ngControl.control;
        }
        else if (this.isHTMLInputElement) {
            const name = this
                .control.attributes.getNamedItem('formControlName').value;
            return this.getControlByName(name);
        }
        else if (this.isAbstractControl) {
            return this.control;
        }
        else {
            return this.getControlByName(this.control);
        }
    }
    getControlByName(name) {
        var _a;
        const control = (_a = this.controlContainer) === null || _a === void 0 ? void 0 : _a.control;
        return control === null || control === void 0 ? void 0 : control.controls[name];
    }
}
ValidationErrorsComponent.ɵfac = function ValidationErrorsComponent_Factory(t) { return new (t || ValidationErrorsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ControlContainer, 8)); };
ValidationErrorsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ValidationErrorsComponent, selectors: [["lib-validation-errors"]], contentQueries: function ValidationErrorsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ValidationErrorDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.errorsDirective = _t);
    } }, inputs: { control: "control", label: "label" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "error-message-container mb-3", 4, "ngFor", "ngForOf"], [1, "error-message-container", "mb-3"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function ValidationErrorsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ValidationErrorsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasDisplayableError);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], styles: [".error-message-container[_ngcontent-%COMP%]{color:var(--da-error-base);margin-top:7px}"] });
ValidationErrorsComponent.ctorParameters = () => [
    { type: ControlContainer, decorators: [{ type: Optional }] }
];
ValidationErrorsComponent.propDecorators = {
    control: [{ type: Input }],
    label: [{ type: Input }],
    errorsDirective: [{ type: ContentChildren, args: [ValidationErrorDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationErrorsComponent, [{
        type: Component,
        args: [{ selector: 'lib-validation-errors', template: "<ng-container *ngIf=\"hasDisplayableError\">\n    <div *ngFor=\"let errorDirective of displayedErrors\" class=\"error-message-container mb-3\">\n        <ng-container *ngTemplateOutlet=\"errorDirective!.templateRef; context: {\n      $implicit: label,\n      error: formControl?.errors![errorDirective.valError]\n    }\"></ng-container>\n    </div>\n</ng-container>\n", styles: [".error-message-container{color:var(--da-error-base);margin-top:7px}"] }]
    }], function () { return [{ type: ɵngcc1.ControlContainer, decorators: [{
                type: Optional
            }] }]; }, { control: [{
            type: Input
        }], label: [{
            type: Input
        }], errorsDirective: [{
            type: ContentChildren,
            args: [ValidationErrorDirective]
        }] }); })();

class InputComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.isPasswordVisible = false;
        this.type = 'text';
        this.labelPosition = 'top';
        this.copyable = false;
        this.lockByFocus = false;
        this.checked = false;
        this.passwordPreview = false;
        this.strictNumberValidation = false;
        this.clear = new EventEmitter();
        this.controlValueChange = new EventEmitter();
        this.blur = new EventEmitter();
    }
    set setDisable(value) {
        this.setDisabledState(value);
    }
    get isValidate() {
        return this.type === 'number' && this.strictNumberValidation;
    }
    get cssClass() {
        return `lib-input d-flex ${this.labelPosition === 'left' ? 'flex-row' : 'flex-column'} lib-input--${this.labelPosition}`;
    }
    ngOnChanges(changes) {
        if (this.input) {
            const props = ['type', 'min', 'max', 'id', 'name'];
            props.forEach(prop => {
                if (changes[prop]) {
                    this.input.nativeElement[prop] = this[prop];
                }
            });
        }
    }
    ngAfterViewInit() {
        this.toggleReadonly(true);
    }
    handleInput(event) {
        this.value = event.target.value;
        this.onChange(event.target.value);
        this.controlValueChange.emit(event);
    }
    toggleReadonly(lock) {
        if (this.readonly || !this.lockByFocus) {
            return;
        }
        this.input.nativeElement.readOnly = lock;
    }
    setDisabledState(isDisabled) {
        this.input.nativeElement.disabled = isDisabled;
        this.readonly = isDisabled;
    }
    copyToClipboard(inputElement) {
        this.input.nativeElement.disabled = false;
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.input.nativeElement.disabled = this.readonly;
    }
    togglePassword() {
        this.type = this.type === 'password' ? 'text' : 'password';
        this.isPasswordVisible = !this.isPasswordVisible;
    }
    validate(type, event) {
        if (!this.isValidate) {
            return;
        }
        const validateFns = {
            keydown: this.handleKeydown,
            paste: this.handlePaste
        };
        validateFns[type](event);
    }
    handleKeydown(event) {
        var _a;
        const code = (_a = event === null || event === void 0 ? void 0 : event.code) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
        const codePieces = [
            'minus',
            'numpadsubtract',
            'period',
            'comma',
            'numpaddecimal',
            'numpadadd',
            'slash',
            'keye',
            'equal'
        ];
        if (codePieces.includes(code)) {
            event.preventDefault();
        }
    }
    handlePaste(event) {
        let paste = (event.clipboardData || window.clipboardData).getData('text');
        paste = paste.toUpperCase();
        const value = parseInt(paste);
        const reg = new RegExp('^[0-9]{0,100}$');
        if (!reg.test(paste) || !value || isNaN(event.target.value)) {
            event.preventDefault();
        }
    }
    handleClearBtn() {
        this.clear.emit();
        this.value = '';
    }
}
InputComponent.ɵfac = /*@__PURE__*/ function () { let ɵInputComponent_BaseFactory; return function InputComponent_Factory(t) { return (ɵInputComponent_BaseFactory || (ɵInputComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(InputComponent)))(t || InputComponent); }; }();
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["lib-input"]], hostAttrs: [1, "lib-input"], hostVars: 2, hostBindings: function InputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.cssClass);
    } }, inputs: { type: "type", labelPosition: "labelPosition", copyable: "copyable", lockByFocus: "lockByFocus", checked: "checked", passwordPreview: "passwordPreview", strictNumberValidation: "strictNumberValidation", setDisable: "setDisable", value: "value", min: "min", max: "max", maxlength: "maxlength", placeholder: "placeholder", clearable: "clearable", name: "name", id: "id", icon: "icon" }, outputs: { clear: "clear", controlValueChange: "controlValueChange", blur: "blur" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3, decls: 13, vars: 30, consts: [["class", "label text-truncate", 3, "disabled", 4, "ngIf"], [1, "position-relative", "input-content"], ["controlContainer", ""], [3, "value", "readonly", "checked", "type", "input", "focus", "blur", "keydown", "paste"], ["input", ""], ["class", "info2 secondary-text-and-icons max-length position-absolute", 3, "right", 4, "ngIf"], ["class", "icon", 3, "icon", 4, "ngIf"], ["class", "clear-btn", 3, "right", "click", 4, "ngIf"], ["class", "position-absolute max-length btn btn-link cursor-pointer", "ngbTooltip", "Copy to clipboard", "placement", "top", 3, "right", "openDelay", "click", 4, "ngIf"], ["icon", "eyeOff", "class", "position-absolute password-toggle", "ngbTooltip", "Show", "placement", "top", 3, "openDelay", "click", 4, "ngIf"], ["icon", "facEyeOpen", "class", "position-absolute password-toggle", "ngbTooltip", "Hide", "placement", "top", 3, "openDelay", "click", 4, "ngIf"], [3, "message", 4, "ngIf"], [3, "message", "isInfo", 4, "ngIf"], [1, "label", "text-truncate"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "info2", "secondary-text-and-icons", "max-length", "position-absolute"], [1, "icon", 3, "icon"], [1, "clear-btn", 3, "click"], ["aria-hidden", "true", 1, "icon"], ["ngbTooltip", "Copy to clipboard", "placement", "top", 1, "position-absolute", "max-length", "btn", "btn-link", "cursor-pointer", 3, "openDelay", "click"], ["icon", "facClone", 1, "fa", "color-brand", "font-14px"], ["icon", "eyeOff", "ngbTooltip", "Show", "placement", "top", 1, "position-absolute", "password-toggle", 3, "openDelay", "click"], ["icon", "facEyeOpen", "ngbTooltip", "Hide", "placement", "top", 1, "position-absolute", "password-toggle", 3, "openDelay", "click"], [3, "message"], [3, "message", "isInfo"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, InputComponent_span_0_Template, 4, 4, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2)(3, "input", 3, 4);
        ɵngcc0.ɵɵlistener("input", function InputComponent_Template_input_input_3_listener($event) { return ctx.handleInput($event); })("focus", function InputComponent_Template_input_focus_3_listener() { return ctx.toggleReadonly(false); })("blur", function InputComponent_Template_input_blur_3_listener($event) { ctx.onTouched(); ctx.toggleReadonly(true); return ctx.blur.emit($event); })("keydown", function InputComponent_Template_input_keydown_3_listener($event) { return ctx.validate("keydown", $event); })("paste", function InputComponent_Template_input_paste_3_listener($event) { return ctx.validate("paste", $event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, InputComponent_div_5_Template, 2, 4, "div", 5);
        ɵngcc0.ɵɵtemplate(6, InputComponent_fa_icon_6_Template, 1, 1, "fa-icon", 6);
        ɵngcc0.ɵɵtemplate(7, InputComponent_button_7_Template, 3, 2, "button", 7);
        ɵngcc0.ɵɵtemplate(8, InputComponent_div_8_Template, 2, 3, "div", 8);
        ɵngcc0.ɵɵtemplate(9, InputComponent_fa_icon_9_Template, 1, 1, "fa-icon", 9);
        ɵngcc0.ɵɵtemplate(10, InputComponent_fa_icon_10_Template, 1, 1, "fa-icon", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, InputComponent_lib_app_warning_message_11_Template, 1, 1, "lib-app-warning-message", 11);
        ɵngcc0.ɵɵtemplate(12, InputComponent_lib_app_warning_message_12_Template, 1, 2, "lib-app-warning-message", 12);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("disabled", ctx.readonly)("invalid", ctx.hasErrors)("warning", ctx.warning)("with-icon", ctx.icon)("clearable", ctx.clearable)("with-max-length", ctx.maxlength)("with-copyable-length", ctx.copyable);
        ɵngcc0.ɵɵproperty("value", ctx.value === undefined || ctx.value === null ? "" : ctx.value)("readonly", ctx.readonly)("checked", ctx.type === "radio" && ctx.checked)("type", ctx.type);
        ɵngcc0.ɵɵattribute("placeholder", ctx.placeholder)("maxlength", ctx.maxlength)("data-test-id", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxlength);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.readonly && ctx.clearable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.copyable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "password" && ctx.passwordPreview);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isPasswordVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.warning);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.info);
    } }, dependencies: function () { return [ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc5.NgbTooltip, WarningMessageComponent]; }, styles: [_c40] });
InputComponent.propDecorators = {
    type: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    value: [{ type: Input }],
    maxlength: [{ type: Input }],
    labelPosition: [{ type: Input }],
    placeholder: [{ type: Input }],
    clearable: [{ type: Input }],
    copyable: [{ type: Input }],
    setDisable: [{ type: Input }],
    lockByFocus: [{ type: Input }],
    name: [{ type: Input }],
    checked: [{ type: Input }],
    id: [{ type: Input }],
    passwordPreview: [{ type: Input }],
    strictNumberValidation: [{ type: Input }],
    icon: [{ type: Input }],
    clear: [{ type: Output }],
    controlValueChange: [{ type: Output }],
    blur: [{ type: Output }],
    cssClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{ selector: 'lib-input', template: "<span *ngIf=\"label\" class=\"label text-truncate\" [class.disabled]=\"readonly\">\n    {{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n    <ng-content></ng-content>\n</span>\n<div #controlContainer class=\"position-relative input-content\">\n    <!--    #controlContainer and #input are necessary for base form control-->\n    <input\n        #input\n        [value]=\"value === undefined || value === null ? '' : value\"\n        [attr.placeholder]=\"placeholder\"\n        [class.disabled]=\"readonly\"\n        [class.invalid]=\"hasErrors\"\n        [class.warning]=\"warning\"\n        [class.with-icon]=\"icon\"\n        [class.clearable]=\"clearable\"\n        [class.with-max-length]=\"maxlength\"\n        [class.with-copyable-length]=\"copyable\"\n        [readonly]=\"readonly\"\n        [attr.maxlength]=\"maxlength\"\n        [checked]=\"type === 'radio' && checked\"\n        [type]=\"type\"\n        [attr.data-test-id]=\"id\"\n        (input)=\"handleInput($event)\"\n        (focus)=\"toggleReadonly(false)\"\n        (blur)=\"onTouched(); toggleReadonly(true); blur.emit($event)\"\n        (keydown)=\"validate('keydown', $event)\"\n        (paste)=\"validate('paste', $event)\"\n    />\n    <div\n        *ngIf=\"maxlength\"\n        class=\"info2 secondary-text-and-icons max-length position-absolute\"\n        [style.right.px]=\"clearable && copyable ? 180 : copyable ? 160 : clearable ? 32 : 12\"\n    >\n        {{ (this.value || '').length }}/{{ this.maxlength }}\n    </div>\n    <fa-icon *ngIf=\"icon\" class=\"icon\" [icon]=\"icon\"></fa-icon>\n\n    <button *ngIf=\"!readonly && clearable\" [style.right.px]=\"copyable ? 160 : 12\" class=\"clear-btn\" (click)=\"handleClearBtn()\">\n        <span aria-hidden=\"true\" class=\"icon\">&times;</span>\n    </button>\n\n    <div\n        *ngIf=\"copyable\"\n        [style.right.px]=\"0\"\n        class=\"position-absolute max-length btn btn-link cursor-pointer\"\n        [openDelay]=\"400\"\n        ngbTooltip=\"Copy to clipboard\"\n        placement=\"top\"\n        (click)=\"copyToClipboard(input)\"\n    >\n        <fa-icon\n            icon=\"facClone\"\n            class=\"fa color-brand font-14px\"\n        ></fa-icon>\n    </div>\n\n    <fa-icon\n        *ngIf=\"type === 'password' && passwordPreview\"\n        icon=\"eyeOff\"\n        class=\"position-absolute password-toggle\"\n        ngbTooltip=\"Show\"\n        (click)=\"togglePassword()\"\n        [openDelay]=\"800\"\n        placement=\"top\"\n    ></fa-icon>\n    <fa-icon\n        *ngIf=\"isPasswordVisible\"\n        icon=\"facEyeOpen\"\n        class=\"position-absolute password-toggle\"\n        ngbTooltip=\"Hide\"\n        (click)=\"togglePassword()\"\n        [openDelay]=\"800\"\n        placement=\"top\"\n    ></fa-icon>\n</div>\n<lib-app-warning-message *ngIf=\"warning\" [message]=\"warningMessage\"></lib-app-warning-message>\n<lib-app-warning-message *ngIf=\"info\" [message]=\"infoMessage\" [isInfo]=\"true\"></lib-app-warning-message>\n", host: { class: 'lib-input' }, styles: [".mandatory{color:var(--da-error-base)}.label{color:var(--da-title);font-size:11px;margin-bottom:7px}input{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;color:var(--da-primary-text);width:100%}input::-moz-placeholder{color:var(--da-disable)}input:-ms-input-placeholder{color:var(--da-disable)}input::placeholder{color:var(--da-disable)}input:focus{outline:none}input:focus:not(.invalid):not(:hover):not(:active):not(:-moz-read-only){box-shadow:0 0 0 4px var(--da-brand-20)}input:focus:not(.invalid):not(:hover):not(:active):not(:read-only){box-shadow:0 0 0 4px var(--da-brand-20)}input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):hover{border:1px solid var(--da-brand-base)}input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):hover{border:1px solid var(--da-brand-base)}input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):active,input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):hover{margin:0;width:100%}input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):active,input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):hover{margin:0;width:100%}input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):active{border:1px solid var(--da-brand-base)}input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):active{border:1px solid var(--da-brand-base)}input.invalid{border:1px solid var(--da-error-base)!important}input.disabled,input:disabled{background:rgba(0,0,0,.04);color:var(--da-disable)}input:-moz-read-only{cursor:default}input.disabled,input:disabled,input:read-only{cursor:default}input.with-icon{padding:15px 28px!important}.icon{color:var(--da-brand-base);left:.5rem;position:absolute;top:.5rem}.password-toggle{cursor:pointer;margin-left:-24px;margin-top:6px}:host.lib-input--left{align-items:center}:host.lib-input--left .input-content{flex-grow:1;margin-left:5px}:host.lib-input--left .label{margin-bottom:0}:host.size-s::ng-deep .clear-btn{top:.25rem!important}:host.size-l::ng-deep .clear-btn{top:1rem!important}:host .clear-btn{background:none!important;border:none!important;color:var(--da-secondary-text-and-icons);padding:0!important;position:absolute;right:.5rem;top:.5rem;width:16px}:host .clear-btn .icon{font-size:16px!important}:host .clear-btn:focus{outline:none!important}.max-length{align-items:center;display:flex;height:100%;top:0}.with-max-length{padding-right:62px}.with-copyable-length{padding-right:40px}.with-copyable-length.with-max-length{padding-right:102px}.clearable{padding-right:28px}.clearable.with-copyable-length:not(.with-max-length){padding-right:68px}.clearable.with-max-length:not(.with-copyable-length){padding-right:90px}.clearable.with-copyable-length.with-max-length{padding-right:130px}"] }]
    }], null, { type: [{
            type: Input
        }], labelPosition: [{
            type: Input
        }], copyable: [{
            type: Input
        }], lockByFocus: [{
            type: Input
        }], checked: [{
            type: Input
        }], passwordPreview: [{
            type: Input
        }], strictNumberValidation: [{
            type: Input
        }], clear: [{
            type: Output
        }], controlValueChange: [{
            type: Output
        }], blur: [{
            type: Output
        }], setDisable: [{
            type: Input
        }], cssClass: [{
            type: HostBinding,
            args: ['class']
        }], value: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], clearable: [{
            type: Input
        }], name: [{
            type: Input
        }], id: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

class TextareaComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.id = 'textarea';
        this.copyable = false;
        this.labelPosition = 'top';
        this.resize = true;
        this.resizeMode = 'none';
        this.customHeight = false;
    }
    set setDisable(value) {
        this.setDisabledState(value);
    }
    get isLabelPositionLeft() {
        return this.labelPosition === 'left';
    }
    updateTextAreaValueAndSize() {
        this.input.nativeElement.style.height = 'auto';
        this.input.nativeElement.style.height =
            this.input.nativeElement.scrollHeight + 'px';
        this.perfectScrollbar.directiveRef.update();
    }
    handleInput(value) {
        this.value = value;
        this.onChange(value);
        this.updateTextAreaValueAndSize();
    }
    setDisabledState(isDisabled) {
        this.input.nativeElement.disabled = isDisabled;
        this.readonly = isDisabled;
    }
    copyToClipboard(inputElement) {
        this.input.nativeElement.disabled = false;
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.input.nativeElement.disabled = this.readonly;
    }
    handleClearBtn() {
        this.value = '';
        this.onChange('');
        setTimeout(() => this.updateTextAreaValueAndSize());
    }
    ngAfterViewInit() {
        const input = this.input.nativeElement;
        const updateStyles = () => {
            input.style.overflow = 'auto';
            input.style.height = input.scrollHeight + 'px';
            input.style.overflow = 'hidden';
            input.parentElement.style.height = input.offsetHeight + 'px';
        };
        if (input.offsetParent) {
            updateStyles();
        }
        else {
            onVisible(input, elem => updateStyles());
        }
    }
}
TextareaComponent.ɵfac = /*@__PURE__*/ function () { let ɵTextareaComponent_BaseFactory; return function TextareaComponent_Factory(t) { return (ɵTextareaComponent_BaseFactory || (ɵTextareaComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TextareaComponent)))(t || TextareaComponent); }; }();
TextareaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["lib-textarea"]], viewQuery: function TextareaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(PerfectScrollbarComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.perfectScrollbar = _t.first);
    } }, hostAttrs: [1, "d-flex", "flex-column", "textarea"], hostVars: 2, hostBindings: function TextareaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("label-left", ctx.isLabelPositionLeft);
    } }, inputs: { id: "id", copyable: "copyable", labelPosition: "labelPosition", resize: "resize", resizeMode: "resizeMode", customHeight: "customHeight", setDisable: "setDisable", placeholder: "placeholder", maxlength: "maxlength", translatedText: "translatedText" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 19, consts: [["class", "label body2 min-width-fit-content", 3, "disabled", 4, "ngIf"], [1, "w-100", "position-relative"], [1, "textarea-wrapper"], ["controlContainer", ""], [1, "textarea-input", 3, "readOnly", "ngClass", "value", "input", "blur"], ["input", ""], ["class", "clear-btn", 3, "click", 4, "ngIf"], ["class", "info2 secondary-text-and-icons mt-2px", 4, "ngIf"], [1, "label", "body2", "min-width-fit-content"], ["class", "mandatory", 4, "ngIf"], ["icon", "facClone", "class", "fa font-12px copy-icon ml-5px", "ngbTooltip", "Copy to clipboard", "placement", "top", 3, "openDelay", "click", 4, "ngIf"], [1, "mandatory"], ["icon", "facClone", "ngbTooltip", "Copy to clipboard", "placement", "top", 1, "fa", "font-12px", "copy-icon", "ml-5px", 3, "openDelay", "click"], [1, "clear-btn", 3, "click"], ["aria-hidden", "true", 1, "icon"], [1, "info2", "secondary-text-and-icons", "mt-2px"]], template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TextareaComponent_label_0_Template, 4, 5, "label", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "perfect-scrollbar", 2, 3)(4, "textarea", 4, 5);
        ɵngcc0.ɵɵlistener("input", function TextareaComponent_Template_textarea_input_4_listener($event) { return ctx.handleInput($event.target.value); })("blur", function TextareaComponent_Template_textarea_blur_4_listener() { return ctx.onTouched(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(6, TextareaComponent_button_6_Template, 3, 0, "button", 6);
        ɵngcc0.ɵɵtemplate(7, TextareaComponent_div_7_Template, 2, 2, "div", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("textarea-wrapper--readonly", ctx.readonly)("invalid", ctx.hasErrors);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("resize", ctx.resize ? "both" : ctx.resizeMode);
        ɵngcc0.ɵɵclassProp("invalid", ctx.hasErrors);
        ɵngcc0.ɵɵproperty("readOnly", ctx.readonly)("ngClass", ɵngcc0.ɵɵpureFunction1(17, _c4, ctx.customHeight))("value", ctx.value);
        ɵngcc0.ɵɵattribute("data-test-id", ctx.id)("placeholder", ctx.placeholder)("maxlength", ctx.maxlength);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.readonly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.maxlength && !ctx.hasErrors);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc6.PerfectScrollbarComponent, ɵngcc5.NgbTooltip], styles: ["[_nghost-%COMP%]   .clear-btn[_ngcontent-%COMP%]{background:none!important;border:none!important;color:var(--da-secondary-text-and-icons);padding:0!important;position:absolute;right:.5rem;top:0;width:16px}[_nghost-%COMP%]   .clear-btn[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:16px!important}[_nghost-%COMP%]   .clear-btn[_ngcontent-%COMP%]:focus{outline:none!important}.label-left[_nghost-%COMP%]{flex-direction:row!important}.label-left[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{margin-right:.5rem;margin-top:.5rem}.label[_ngcontent-%COMP%]{font-size:11px}.label[_ngcontent-%COMP%], .label.disabled[_ngcontent-%COMP%]{color:var(--da-title)}.mandatory[_ngcontent-%COMP%]{color:var(--da-error-base)}.copy-icon[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons);cursor:pointer;font-size:14px}.copy-icon[_ngcontent-%COMP%]:hover{color:var(--da-brand-base)}.textarea-wrapper[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;box-sizing:border-box;color:var(--da-primary-text);display:block;outline:none!important;padding:.375rem .75rem;width:100%}.textarea-wrapper.textarea-input[_ngcontent-%COMP%], textarea.textarea-input[_ngcontent-%COMP%]{padding-right:24px!important}.textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):focus, .textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):focus-within, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):focus, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):focus-within{box-shadow:0 0 0 4px var(--da-brand-20)}.textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly).invalid, .textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):active, .textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):hover, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly).invalid, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):active, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):hover{margin:0;width:100%}.textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):active, .textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):hover, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):active, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly):hover{border:1px solid var(--da-brand-base);box-shadow:none}.textarea-wrapper.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly).invalid, textarea.textarea-wrapper[_ngcontent-%COMP%]:not(.textarea-wrapper--readonly).invalid{border:1px solid var(--da-error-base)!important;box-shadow:none!important}.textarea-wrapper.textarea-wrapper--readonly[_ngcontent-%COMP%], textarea.textarea-wrapper--readonly[_ngcontent-%COMP%]{cursor:default}.textarea-wrapper[_ngcontent-%COMP%]:disabled, textarea[_ngcontent-%COMP%]:disabled{background:rgba(0,0,0,.04);color:var(--da-disable);cursor:default}.textarea-wrapper[_ngcontent-%COMP%]{padding:0}textarea[_ngcontent-%COMP%]{border:0!important}textarea[_ngcontent-%COMP%]::-moz-placeholder{color:var(--da-disable)}textarea[_ngcontent-%COMP%]:-ms-input-placeholder{color:var(--da-disable)}textarea[_ngcontent-%COMP%]::placeholder{color:var(--da-disable)}.textareaHeight[_ngcontent-%COMP%]{height:94px}"] });
TextareaComponent.propDecorators = {
    placeholder: [{ type: Input }],
    maxlength: [{ type: Input }],
    id: [{ type: Input }],
    copyable: [{ type: Input }],
    labelPosition: [{ type: Input }],
    resize: [{ type: Input }],
    resizeMode: [{ type: Input }],
    setDisable: [{ type: Input }],
    customHeight: [{ type: Input }],
    translatedText: [{ type: Input }],
    perfectScrollbar: [{ type: ViewChild, args: [PerfectScrollbarComponent,] }],
    isLabelPositionLeft: [{ type: HostBinding, args: ['class.label-left',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{ selector: 'lib-textarea', template: "<label\n    class=\"label body2 min-width-fit-content\"\n    *ngIf=\"label\"\n    [class.disabled]=\"readonly && !copyable\"\n>\n    {{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n    <fa-icon\n        *ngIf=\"copyable\"\n        icon=\"facClone\"\n        class=\"fa font-12px copy-icon ml-5px\"\n        ngbTooltip=\"Copy to clipboard\"\n        (click)=\"copyToClipboard(input)\"\n        [openDelay]=\"800\"\n        placement=\"top\"\n    ></fa-icon>\n</label>\n\n<div class=\"w-100 position-relative\">\n    <!--    #controlContainer and #input are necessary for base form control-->\n    <perfect-scrollbar\n        class=\"textarea-wrapper\"\n        [class.textarea-wrapper--readonly]=\"readonly\"\n        [class.invalid]=\"hasErrors\"\n        #controlContainer\n    >\n        <textarea\n            #input\n            class=\"textarea-input\"\n            [readOnly]=\"readonly\"\n            [attr.data-test-id]=\"id\"\n            [style.resize]=\"resize ? 'both' : resizeMode\"\n            [ngClass]=\"{ textareaHeight: customHeight }\"\n            [value]=\"value\"\n            (input)=\"handleInput($event.target.value)\"\n            (blur)=\"onTouched()\"\n            [attr.placeholder]=\"placeholder\"\n            [class.invalid]=\"hasErrors\"\n            [attr.maxlength]=\"maxlength\"\n        ></textarea>\n    </perfect-scrollbar>\n\n    <button *ngIf=\"!readonly\" class=\"clear-btn\" (click)=\"handleClearBtn()\">\n        <span aria-hidden=\"true\" class=\"icon\">&times;</span>\n    </button>\n\n    <div\n        *ngIf=\"maxlength && !hasErrors\"\n        class=\"info2 secondary-text-and-icons mt-2px\"\n    >\n        {{ +this.maxlength - (this.value || \"\").length }}\n        {{ translatedText?.CHARACTERS_LEFT || \"characters left\" }}\n    </div>\n</div>\n", host: {
                    class: 'd-flex flex-column textarea'
                }, styles: [":host .clear-btn{background:none!important;border:none!important;color:var(--da-secondary-text-and-icons);padding:0!important;position:absolute;right:.5rem;top:0;width:16px}:host .clear-btn .icon{font-size:16px!important}:host .clear-btn:focus{outline:none!important}:host.label-left{flex-direction:row!important}:host.label-left .label{margin-right:.5rem;margin-top:.5rem}.label{font-size:11px}.label,.label.disabled{color:var(--da-title)}.mandatory{color:var(--da-error-base)}.copy-icon{color:var(--da-secondary-text-and-icons);cursor:pointer;font-size:14px}.copy-icon:hover{color:var(--da-brand-base)}.textarea-wrapper,textarea{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;box-sizing:border-box;color:var(--da-primary-text);display:block;outline:none!important;padding:.375rem .75rem;width:100%}.textarea-wrapper.textarea-input,textarea.textarea-input{padding-right:24px!important}.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly):focus,.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly):focus-within,textarea.textarea-wrapper:not(.textarea-wrapper--readonly):focus,textarea.textarea-wrapper:not(.textarea-wrapper--readonly):focus-within{box-shadow:0 0 0 4px var(--da-brand-20)}.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly).invalid,.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly):active,.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly):hover,textarea.textarea-wrapper:not(.textarea-wrapper--readonly).invalid,textarea.textarea-wrapper:not(.textarea-wrapper--readonly):active,textarea.textarea-wrapper:not(.textarea-wrapper--readonly):hover{margin:0;width:100%}.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly):active,.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly):hover,textarea.textarea-wrapper:not(.textarea-wrapper--readonly):active,textarea.textarea-wrapper:not(.textarea-wrapper--readonly):hover{border:1px solid var(--da-brand-base);box-shadow:none}.textarea-wrapper.textarea-wrapper:not(.textarea-wrapper--readonly).invalid,textarea.textarea-wrapper:not(.textarea-wrapper--readonly).invalid{border:1px solid var(--da-error-base)!important;box-shadow:none!important}.textarea-wrapper.textarea-wrapper--readonly,textarea.textarea-wrapper--readonly{cursor:default}.textarea-wrapper:disabled,textarea:disabled{background:rgba(0,0,0,.04);color:var(--da-disable);cursor:default}.textarea-wrapper{padding:0}textarea{border:0!important}textarea::-moz-placeholder{color:var(--da-disable)}textarea:-ms-input-placeholder{color:var(--da-disable)}textarea::placeholder{color:var(--da-disable)}.textareaHeight{height:94px}"] }]
    }], null, { id: [{
            type: Input
        }], copyable: [{
            type: Input
        }], labelPosition: [{
            type: Input
        }], resize: [{
            type: Input
        }], resizeMode: [{
            type: Input
        }], customHeight: [{
            type: Input
        }], setDisable: [{
            type: Input
        }], isLabelPositionLeft: [{
            type: HostBinding,
            args: ['class.label-left']
        }], placeholder: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], translatedText: [{
            type: Input
        }], perfectScrollbar: [{
            type: ViewChild,
            args: [PerfectScrollbarComponent]
        }] }); })();

class DropdownHeaderTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
DropdownHeaderTemplateDirective.ɵfac = function DropdownHeaderTemplateDirective_Factory(t) { return new (t || DropdownHeaderTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
DropdownHeaderTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DropdownHeaderTemplateDirective, selectors: [["", "libDropdownHeaderTemplate", ""]] });
DropdownHeaderTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownHeaderTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[libDropdownHeaderTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class DropdownComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.labelPosition = 'top';
        this.multiple = false;
        this.searchable = true;
        this.clearable = true;
        this.placeholder = 'Select Option';
        this.notFoundText = 'No items found';
        this.appendTo = 'body';
        this.truncate = true;
        this.dropdownPosition = 'auto';
        this.id = 'select';
        this.items = [];
        this.valueKey = 'value';
        this.labelKey = 'label';
        this.labelRemovable = false;
        this.addTag = false;
        this.multiline = false;
        this.ngSelectItemsFilter = true;
        this.showInput = false;
        this.editableSearchTerm = false;
        this.isItemsLinked = false;
        this.clearSearchOnAdd = false;
        this.searchTermOnly = false;
        this.virtualScroll = false;
        this.disableFilterOnSelect = false;
        /*
         * flag to skip inner setting of dropdown value when clicking on header operation
         */
        this.onlyEmitHeaderOperationTypeChange = false;
        this.valueChange = new EventEmitter();
        this.change = new EventEmitter();
        this.searchTerm = new EventEmitter();
        this.add = new EventEmitter();
        this.remove = new EventEmitter();
        this.filter = new EventEmitter();
        this.scroll = new EventEmitter();
        this.close = new EventEmitter();
        this.clear = new EventEmitter();
        this.navigate = new EventEmitter();
        this.multipleHeaderClicked = new EventEmitter();
        this.multipleHeaderOperation = new EventEmitter();
        this.typeahead$ = new Subject();
        this.afterOnInit = false;
        this.disabled = false;
        this.sizeS = false;
        this.showCounter = true;
        this.min = Math.min;
        this.changedByUser = false;
        this.parentElements = [];
        this.addTagFnImpl = (value) => {
            let result = {};
            result[this.valueKey] = value;
            result[this.labelKey] = value;
            const item = this.items.find(el => el[this.valueKey] === result[this.valueKey]);
            result = !item ? result : null;
            return result;
        };
    }
    set setDisable(value) {
        this.setDisabledState(value);
    }
    get itemsLength() {
        return this.items
            ? this.totalItemsLength
                ? this.totalItemsLength
                : this.items.length
            : 0;
    }
    ngOnChanges(changes) {
        var _a;
        (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.update();
        if (changes.addTag || changes.addTagFunction) {
            this.updateTagFn();
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.sizeS = this.dropdownEl.nativeElement.parentNode.classList.contains('size-s');
        if (this.isObjectsArray(this.value)) {
            this.value = this.value.map((el) => el[this.valueKey]);
        }
        if (this.ngSelectItemsFilter && typeof this.filter === 'function') {
            this.ngSelectItemsFilter = false;
        }
        this.typeahead$
            .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this.destroy$))
            .subscribe((str) => {
            this.filter.emit(str || '');
            this._filterValue = str;
            setTimeout(() => { var _a; return (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.update(); });
        });
        this.afterOnInit = true;
        this.updateTagFn();
    }
    updateTagFn() {
        if (this.addTag) {
            this.addTagFn = this.addTagFunction || this.addTagFnImpl;
        }
        else {
            this.addTagFn = null;
        }
    }
    hoverElementSelectorFn(el) {
        return el.parentElement;
    }
    labelHoverElementSelectorFn(el) {
        return el.parentElement.parentElement.parentElement;
    }
    ngAfterViewInit() {
        var _a;
        this.headerTemplate = (_a = this.headerTemplates) === null || _a === void 0 ? void 0 : _a.first;
    }
    addParentsEventListener(ngSelect) {
        this.scrollFn = () => {
            if (ngSelect.isOpen) {
                ngSelect.close();
                this.removeParentsEventListener();
            }
        };
        this.parentElements = [];
        let parentElement = this.dropdownEl.nativeElement.parentElement;
        do {
            this.parentElements.push(parentElement);
            parentElement.addEventListener('scroll', this.scrollFn);
            parentElement = parentElement.parentElement;
        } while (parentElement);
    }
    removeParentsEventListener() {
        this.parentElements.forEach(element => {
            element.removeEventListener('scroll', this.scrollFn);
        });
    }
    onOpen() {
        this.ngSelect.classes =
            'dropdown-select ' +
                (this.disabled ? 'dropdown-select--disabled' : '');
        this.showCounter = this.multiple && this.disabled;
        setTimeout(() => {
            var _a, _b;
            this.perfectScrollbar = new PerfectScrollbar((_b = (_a = this.ngSelect) === null || _a === void 0 ? void 0 : _a.dropdownPanel) === null || _b === void 0 ? void 0 : _b.contentElementRef.nativeElement.parentNode, {
                wheelPropagation: true
            });
            const ngSelect = this.ngSelect;
            this.addParentsEventListener(ngSelect);
        });
    }
    onSelect(param) {
        var _a;
        this.changedByUser = true;
        if (this.ngControl) {
            // Disabling filter is necessary to preserve the previous state in components where filtering uses id
            // but not the items
            const selected = this.multiple && !this.disableFilterOnSelect
                ? (_a = this.items) === null || _a === void 0 ? void 0 : _a.filter(el => param.includes(el[this.valueKey])) : param;
            this.onChange(selected);
            this.onTouched();
        }
        this.valueChange.emit(param);
    }
    writeValue(value) {
        const changed = this.changedByUser || value !== this.value;
        if (this.isObjectsArray(value) && this.afterOnInit) {
            this.value = value.map((el) => el[this.valueKey]);
        }
        else {
            this.value = value;
        }
        if (this.editableSearchTerm && changed) {
            setTimeout(() => {
                this.ngSelect['_setSearchTermFromItems']();
                this.ngSelect['_cd'].markForCheck();
            });
        }
        this.changedByUser = false;
    }
    handleChange(value) {
        if (this.truncate) {
            const selectContainer = this.selectControlEl.nativeElement.querySelector('.ng-value-container');
            if (selectContainer) {
                setTimeout(() => {
                    if (selectContainer.offsetWidth <
                        selectContainer.scrollWidth) {
                        selectContainer.title = Array.from(selectContainer.children)
                            .slice(1)
                            .map(x => x.textContent)
                            .filter(Boolean)
                            .join(', ');
                    }
                    else {
                        selectContainer.title = '';
                    }
                });
            }
        }
        this.change.emit(value);
    }
    handleSearch(value) {
        this.searchTerm.emit(this.searchTermOnly ? value.term : value);
        setTimeout(() => { var _a; return (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.update(); });
    }
    handleNavigate(value) {
        this.navigate.emit(value);
    }
    handleAdd(value) {
        this.add.emit(value);
    }
    handleRemove(value) {
        this.remove.emit(value);
    }
    isObjectsArray(arg) {
        return (Array.isArray(arg) &&
            typeof arg[0] === 'object' &&
            [null, undefined].indexOf(arg[0]) < 0);
    }
    emitMultipleHeaderClicked(newObjects, operation) {
        if (this.onlyEmitHeaderOperationTypeChange) {
            this.multipleHeaderOperation.emit(operation);
            return;
        }
        if (this.ngControl) {
            this.ngControl.control.setValue(this.value);
        }
        this.valueChange.emit(this.value);
        this.change.emit(newObjects);
        this.multipleHeaderClicked.emit(newObjects);
        this.multipleHeaderOperation.emit(operation);
    }
    addAll() {
        if (!this.onlyEmitHeaderOperationTypeChange) {
            this.checkItemsWithAddTag();
            this.value = [
                ...this.items.map((obj) => {
                    return obj[this.valueKey];
                })
            ];
        }
        this.emitMultipleHeaderClicked(this.items, 'ALL');
    }
    addGroup(group) {
        const valuesToAdd = this.items
            .filter(item => item[this.groupBy] === group)
            .map((obj) => obj[this.valueKey]);
        this.value = this.items
            .filter(item => (this.value || []).includes(item[this.valueKey]) ||
            valuesToAdd.includes(item[this.valueKey]))
            .map((obj) => obj[this.valueKey]);
        this.updateValue();
    }
    removeGroup(group) {
        this.value = (this.value || []).filter(value => {
            const item = this.items.find(elem => elem[this.valueKey] === value);
            return item[this.groupBy] !== group;
        });
        this.updateValue();
    }
    invertAllInGroup(group) {
        const allValuesInGroup = this.items
            .filter(item => item[this.groupBy] === group)
            .map((obj) => obj[this.valueKey]);
        const selectedValuesInGroup = (this.value || []).filter(value => allValuesInGroup.includes(value));
        const valuesToAdd = allValuesInGroup.filter(value => !selectedValuesInGroup.includes(value));
        this.value = this.items
            .filter(item => {
            const value = item[this.valueKey];
            return (valuesToAdd.includes(value) ||
                ((this.value || []).includes(value) &&
                    !selectedValuesInGroup.includes(value)));
        })
            .map((obj) => obj[this.valueKey]);
        this.updateValue();
    }
    removeAll() {
        if (!this.onlyEmitHeaderOperationTypeChange) {
            this.checkItemsWithAddTag();
            this.value = [];
        }
        this.emitMultipleHeaderClicked([], 'NONE');
    }
    invertAll() {
        if (this.onlyEmitHeaderOperationTypeChange) {
            this.multipleHeaderOperation.emit('INV');
            return;
        }
        this.checkItemsWithAddTag();
        const invertValue = this.items.filter(i => !this.value.includes(i[this.valueKey]));
        this.value = [
            ...invertValue.map((obj) => {
                return obj[this.valueKey];
            })
        ];
        this.emitMultipleHeaderClicked(invertValue, 'INV');
    }
    checkItemsWithAddTag() {
        var _a, _b, _c, _d;
        if (this.addTag &&
            ((_a = this.items) === null || _a === void 0 ? void 0 : _a.length) !== ((_d = (_c = (_b = this.ngSelect) === null || _b === void 0 ? void 0 : _b.itemsList) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length)) {
            this.items = this.ngSelect.itemsList.items.map(item => item.value);
        }
    }
    onScroll() {
        this.scroll.emit();
    }
    onScrollToEnd(value) {
        this.scroll.emit(value);
    }
    onClose() {
        var _a;
        this.showCounter = true;
        this.removeParentsEventListener();
        (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.destroy();
        if (typeof this.validation === 'function') {
            this.validationError = this.validation(this.value);
        }
        if (this._filterValue) {
            this._filterValue = '';
            this.filter.emit(this._filterValue);
        }
        this.close.emit(this.value);
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    updateValue() {
        var _a;
        (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control.setValue(this.value);
        this.valueChange.emit(this.value);
        const selectedItems = this.items.filter(item => this.value.includes(item[this.valueKey]));
        this.change.emit(selectedItems);
    }
    ngOnDestroy() {
        this.removeParentsEventListener();
    }
}
DropdownComponent.ɵfac = /*@__PURE__*/ function () { let ɵDropdownComponent_BaseFactory; return function DropdownComponent_Factory(t) { return (ɵDropdownComponent_BaseFactory || (ɵDropdownComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DropdownComponent)))(t || DropdownComponent); }; }();
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["lib-dropdown"]], contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DropdownHeaderTemplateDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplates = _t);
    } }, viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgSelectComponent, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(NgSelectComponent, 7);
        ɵngcc0.ɵɵviewQuery(_c5, 5, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c6, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectControlEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngSelect = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.addTagContainerRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownEl = _t.first);
    } }, hostAttrs: [1, "dropdown"], inputs: { labelPosition: "labelPosition", multiple: "multiple", searchable: "searchable", clearable: "clearable", placeholder: "placeholder", notFoundText: "notFoundText", appendTo: "appendTo", truncate: "truncate", dropdownPosition: "dropdownPosition", id: "id", items: "items", valueKey: "valueKey", labelKey: "labelKey", labelRemovable: "labelRemovable", addTag: "addTag", multiline: "multiline", ngSelectItemsFilter: "ngSelectItemsFilter", showInput: "showInput", editableSearchTerm: "editableSearchTerm", isItemsLinked: "isItemsLinked", clearSearchOnAdd: "clearSearchOnAdd", searchTermOnly: "searchTermOnly", virtualScroll: "virtualScroll", disableFilterOnSelect: "disableFilterOnSelect", onlyEmitHeaderOperationTypeChange: "onlyEmitHeaderOperationTypeChange", setDisable: "setDisable", width: "width", minWidth: "minWidth", maxWidth: "maxWidth", maxLength: "maxLength", label: "label", loading: "loading", typeahead: "typeahead", validation: "validation", addTagFunction: "addTagFunction", optionTemplateRef: "optionTemplateRef", labelTemplateRef: "labelTemplateRef", addTagTemplateRef: "addTagTemplateRef", searchFn: "searchFn", groupBy: "groupBy", totalItemsLength: "totalItemsLength", translatedText: "translatedText" }, outputs: { valueChange: "valueChange", change: "change", searchTerm: "searchTerm", add: "add", remove: "remove", filter: "filter", scroll: "scroll", close: "close", clear: "clear", navigate: "navigate", multipleHeaderClicked: "multipleHeaderClicked", multipleHeaderOperation: "multipleHeaderOperation" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3, decls: 15, vars: 55, consts: [[3, "class", "disabled", 4, "ngIf"], ["perfect-scrollbar-styles", "", 1, "dropdown", 3, "ngClass"], ["dropdown", ""], [1, "dropdown-select", 3, "bindValue", "bindLabel", "placeholder", "notFoundText", "disabled", "items", "virtualScroll", "multiple", "closeOnSelect", "ngModel", "clearSearchOnAdd", "typeahead", "loading", "clearable", "appendTo", "dropdownPosition", "addTag", "searchFn", "editableSearchTerm", "groupBy", "inputAttrs", "ngModelChange", "open", "change", "add", "remove", "blur", "scroll", "search", "scrollToEnd", "close", "clear"], ["controlContainer", ""], ["ng-optgroup-tmp", ""], [4, "ngIf"], ["ng-option-tmp", ""], ["ng-label-tmp", ""], ["ng-tag-tmp", ""], ["class", "validation-error", 3, "size-s", 4, "ngIf"], [3, "message", 4, "ngIf"], [3, "message", "isInfo", 4, "ngIf"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], ["data-test-id", "group-title", 1, "internal-header"], ["class", "d-flex", 4, "ngIf"], [1, "d-flex"], [1, "multiple-header-border", "border-left-0"], ["data-test-id", "add-group-btn", 1, "multiple-header-border", "multiple-header-btn", 3, "click"], [1, "text"], ["data-test-id", "remove-group-btn", 1, "multiple-header-border", "multiple-header-btn", 3, "click"], ["data-test-id", "invert-group-btn", 1, "multiple-header-border", "multiple-header-btn", 3, "click"], ["ng-header-tmp", ""], [1, "d-flex", "multiple-header"], [1, "ml-1", "multiple-header-border"], ["data-test-id", "add-all-btn", 1, "multiple-header-border", "multiple-header-btn", 3, "click"], ["data-test-id", "remove-all-btn", 1, "multiple-header-border", "multiple-header-btn", 3, "click"], ["data-test-id", "invert-all-btn", 1, "multiple-header-border", "multiple-header-btn", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultOptionTemplate", ""], ["class", "option-checkbox", 3, "size-s", "value", 4, "ngIf"], ["triggers", "manual", "libTooltipWhenOverflow", "", "container", "body", 1, "option-label", "text-truncate", 3, "ngStyle", "ngbTooltip", "tooltipClass", "hoverElementSelectorFn"], ["class", "font-16px", "icon", "simpleCheck", 4, "ngIf"], [1, "option-checkbox", 3, "value"], ["icon", "simpleCheck", 1, "font-16px"], ["defaultLabelTemplate", ""], ["triggers", "manual", "libTooltipWhenOverflow", "", "placement", "top-left", "container", "body", 1, "value-label", 3, "ngbTooltip", "tooltipClass", "textElementSelectorFn", "hoverElementSelectorFn"], ["ng-multi-label-tmp", ""], ["class", "multiple-label-container", 3, "size-s", 4, "ngIf"], [1, "multiple-label-container"], [1, "selected-counter", "text-truncate", 3, "ngClass"], [1, "ng-tag-label"], ["addTagContainerRef", ""], [3, "ngTemplateOutlet"], [1, "validation-error"], ["icon", "facExclamationCircle", 1, "fa"], [3, "message"], [3, "message", "isInfo"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DropdownComponent_span_0_Template, 4, 7, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2)(3, "ng-select", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DropdownComponent_Template_ng_select_ngModelChange_3_listener($event) { return ctx.value = $event; })("open", function DropdownComponent_Template_ng_select_open_3_listener() { return ctx.onOpen(); })("ngModelChange", function DropdownComponent_Template_ng_select_ngModelChange_3_listener($event) { return ctx.onSelect($event); })("change", function DropdownComponent_Template_ng_select_change_3_listener($event) { return ctx.handleChange($event); })("add", function DropdownComponent_Template_ng_select_add_3_listener($event) { return ctx.handleAdd($event); })("remove", function DropdownComponent_Template_ng_select_remove_3_listener($event) { return ctx.handleRemove($event); })("blur", function DropdownComponent_Template_ng_select_blur_3_listener() { return ctx.onTouched(); })("scroll", function DropdownComponent_Template_ng_select_scroll_3_listener($event) { return ctx.onScrollToEnd($event); })("search", function DropdownComponent_Template_ng_select_search_3_listener($event) { return ctx.handleSearch($event); })("scrollToEnd", function DropdownComponent_Template_ng_select_scrollToEnd_3_listener() { return ctx.onScroll(); })("close", function DropdownComponent_Template_ng_select_close_3_listener() { return ctx.onClose(); })("clear", function DropdownComponent_Template_ng_select_clear_3_listener() { return ctx.clear.emit(); });
        ɵngcc0.ɵɵtemplate(5, DropdownComponent_ng_template_5_Template, 4, 4, "ng-template", 5);
        ɵngcc0.ɵɵtemplate(6, DropdownComponent_ng_container_6_Template, 2, 0, "ng-container", 6);
        ɵngcc0.ɵɵtemplate(7, DropdownComponent_ng_template_7_Template, 3, 8, "ng-template", 7);
        ɵngcc0.ɵɵtemplate(8, DropdownComponent_ng_template_8_Template, 3, 6, "ng-template", 8);
        ɵngcc0.ɵɵtemplate(9, DropdownComponent_9_Template, 1, 0, null, 6);
        ɵngcc0.ɵɵtemplate(10, DropdownComponent_ng_template_10_Template, 6, 4, "ng-template", 9);
        ɵngcc0.ɵɵtemplate(11, DropdownComponent_ng_container_11_Template, 2, 0, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DropdownComponent_div_12_Template, 3, 3, "div", 10);
        ɵngcc0.ɵɵtemplate(13, DropdownComponent_lib_app_warning_message_13_Template, 1, 1, "lib-app-warning-message", 11);
        ɵngcc0.ɵɵtemplate(14, DropdownComponent_lib_app_warning_message_14_Template, 1, 2, "lib-app-warning-message", 12);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunctionV(43, _c12, [ctx.labelPosition === "left", ctx.multiple, ctx.validationError || ctx.hasErrors, ctx.searchable, ctx.clearable, ctx.warning, ctx.showInput || ctx.addTag, ctx.multiline, ctx.sizeS]));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("min-width", ctx.minWidth, "px")("max-width", ctx.maxWidth, "px")("width", ctx.width, "px")("max-height", ctx.height * 2, "px");
        ɵngcc0.ɵɵclassProp("select--append-to", !!ctx.appendTo)("truncated", ctx.truncate);
        ɵngcc0.ɵɵproperty("bindValue", ctx.valueKey)("bindLabel", ctx.labelKey)("placeholder", ctx.multiple ? "0/" + ctx.itemsLength : ctx.placeholder)("notFoundText", ctx.notFoundText)("disabled", !ctx.multiple && ctx.disabled)("items", ctx.items)("virtualScroll", ctx.virtualScroll)("multiple", ctx.multiple)("closeOnSelect", !ctx.multiple)("ngModel", ctx.value)("clearSearchOnAdd", ctx.clearSearchOnAdd)("typeahead", ctx.ngSelectItemsFilter ? null : ctx.typeahead$)("loading", ctx.loading)("clearable", ctx.clearable)("appendTo", ctx.appendTo)("dropdownPosition", ctx.dropdownPosition)("addTag", ctx.addTagFn)("searchFn", ctx.searchFn)("editableSearchTerm", ctx.editableSearchTerm)("groupBy", ctx.groupBy)("inputAttrs", ɵngcc0.ɵɵpureFunction1(53, _c13, (ctx.maxLength == null ? null : ctx.maxLength.toString()) || null));
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null)("data-test-id", ctx.id);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiple && !ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiple);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.validationError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.warning);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.info);
    } }, dependencies: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgStyle, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc7.NgSelectComponent, ɵngcc7.ɵg, ɵngcc7.ɵf, ɵngcc7.ɵh, ɵngcc7.ɵi, ɵngcc7.ɵj, ɵngcc7.ɵo, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc5.NgbTooltip, TooltipWhenOverflowDirective, WarningMessageComponent, PerfectScrollbarStylesComponent, CheckboxComponent, ɵngcc2.TitleCasePipe]; }, styles: [".size-l[_nghost-%COMP%]     .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important}[_nghost-%COMP%]     .ng-select-disabled .ng-arrow:before{content:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23BDBCBC%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")!important}  .dropdown-tooltip{top:-10px!important}.label[_ngcontent-%COMP%]{color:var(--da-title);display:block;font-size:11px}.label.label-left[_ngcontent-%COMP%]{line-height:28px;margin-right:7px}.label.label-top[_ngcontent-%COMP%]{margin-bottom:7px}.label.disabled[_ngcontent-%COMP%]{color:var(--da-title)}.label[_ngcontent-%COMP%]   .mandatory[_ngcontent-%COMP%]{color:var(--da-error-base)}.internal-header[_ngcontent-%COMP%]{color:var(--da-title);font-weight:700}.multiple-header[_ngcontent-%COMP%]{font-size:14px;line-height:18px}.multiple-header-border[_ngcontent-%COMP%]{border:4px solid transparent}.multiple-header-btn[_ngcontent-%COMP%]{color:var(--da-brand-base);cursor:pointer;margin:0 -.2rem;padding:0 .25rem}.multiple-header-btn[_ngcontent-%COMP%]:focus{border:4px solid var(--da-brand-20);border-radius:4px}.multiple-header-btn[_ngcontent-%COMP%]:active   .text[_ngcontent-%COMP%], .multiple-header-btn[_ngcontent-%COMP%]:hover   .text[_ngcontent-%COMP%]{-webkit-text-decoration-line:underline;text-decoration-line:underline}.multiple-header-btn[_ngcontent-%COMP%]:not(:last-child):after{-webkit-text-decoration-line:none!important;color:var(--da-title);content:\"/\";margin-left:.25rem;text-decoration-line:none!important}.label-left[_ngcontent-%COMP%], .option-label[_ngcontent-%COMP%]{display:inline-block}.option-label[_ngcontent-%COMP%]{color:var(--da-primary-text)} .ng-dropdown-panel .ng-dropdown-panel-items{width:inherit} .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .option-label{overflow:hidden;text-overflow:ellipsis;width:100%}.option-checkbox[_ngcontent-%COMP%]{float:left}[_nghost-%COMP%]  .dropdown{cursor:pointer!important}[_nghost-%COMP%]  .dropdown .dropdown-select{height:inherit}[_nghost-%COMP%]  .dropdown .ng-select-container{background:var(--da-cards-and-blocks);cursor:pointer!important}[_nghost-%COMP%]  .dropdown .ng-select-container *{color:var(--da-primary-text)}[_nghost-%COMP%]  .dropdown .ng-input>input{cursor:text!important}[_nghost-%COMP%]  .dropdown .ng-select-opened .ng-arrow-wrapper{transform:rotate(180deg)}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:not(:hover):not(:active){border-radius:4px;box-shadow:0 0 0 4px var(--da-brand-20)}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:not(:hover):not(:active) .ng-select-container{border:1px solid var(--da-border-and-dividers)!important}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-arrow-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-value{margin-top:-3px!important}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container{border:1px solid var(--da-brand-base)!important;height:100%!important;margin:0!important;width:100%!important}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper{padding-right:--2px}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-arrow-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-value, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-arrow-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-value{margin-top:0!important}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled) .ng-placeholder{color:var(--da-disable)!important}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled):active .ng-select-container, [_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled):hover .ng-select-container{border:1px solid var(--da-brand-base)!important;margin:0!important;width:100%!important}[_nghost-%COMP%]  .dropdown:not(.has-validation-error) .dropdown-select.ng-select-disabled .ng-input>input{color:var(--da-disable)!important}[_nghost-%COMP%]  .dropdown.has-validation-error .ng-select-container{border:1px solid var(--da-error-base)!important}[_nghost-%COMP%]  .dropdown .ng-value-container{display:flex!important;height:inherit;overflow:auto}[_nghost-%COMP%]  .dropdown .ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{box-shadow:none;outline:none}[_nghost-%COMP%]  .dropdown .ng-select-single .ng-select-container{padding-left:8px}[_nghost-%COMP%]  .dropdown .ng-select-disabled .ng-select-container{background-color:rgba(0,0,0,.04)}[_nghost-%COMP%]  .dropdown .ng-select-disabled .ng-select-container .ng-placeholder, [_nghost-%COMP%]  .dropdown .ng-select-disabled .ng-select-container .option-label, [_nghost-%COMP%]  .dropdown .ng-select-disabled .ng-select-container .value-label{color:var(--da-disable)}[_nghost-%COMP%]  .dropdown .ng-select-container{border:1px solid var(--da-border-and-dividers);border-radius:4px;height:inherit!important;min-height:auto!important;padding:0 8px 0 0}[_nghost-%COMP%]  .dropdown .ng-select-container .ng-clear, [_nghost-%COMP%]  .dropdown .ng-select-container .ng-clear-wrapper:hover .ng-clear{color:var(--da-disable)!important;font-size:16px!important}[_nghost-%COMP%]  .dropdown .ng-select-container .ng-arrow-wrapper{height:24px;padding:0;width:24px}[_nghost-%COMP%]  .dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow{height:16px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:16px}[_nghost-%COMP%]  .dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;-webkit-mask-size:contain;background:var(--da-brand-base);color:var(--da-brand-base);content:\"\";display:inline-block;height:14px;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;mask-size:contain;width:14px}[_nghost-%COMP%]  .dropdown .ng-select-container .ng-input{display:none!important;left:-3px!important;top:auto!important}[_nghost-%COMP%]  .dropdown .ng-dropdown-panel{border:var(--da-dropdown-border);border-radius:var(--da-dropdown-border-radius);box-shadow:var(--da-dropdown-box-shadow)}[_nghost-%COMP%]  .dropdown .ng-dropdown-panel .ng-option{color:var(--da-primary-text);cursor:pointer;padding:12px 19px;white-space:inherit}[_nghost-%COMP%]  .dropdown .ng-dropdown-panel .ng-option-selected{background-color:var(--da-cards-and-blocks)}[_nghost-%COMP%]  .dropdown .ng-dropdown-panel .ng-option-selected.ng-option-marked{color:var(--da-brand-base)}[_nghost-%COMP%]  .dropdown .ng-dropdown-panel .ng-option-marked{background-color:var(--da-background);color:var(--da-brand-base)}[_nghost-%COMP%]  .dropdown.label-left{float:right}[_nghost-%COMP%]  .dropdown .icons{cursor:pointer}[_nghost-%COMP%]  .dropdown .icons, [_nghost-%COMP%]  .dropdown .icons:hover{color:var(--da-secondary-text-and-icons)}[_nghost-%COMP%]  .dropdown-multiple:not(.has-validation-error) .ng-select-focused:not(:hover):not(:active) .ng-value-container .ng-placeholder{margin-top:-3px}[_nghost-%COMP%]  .dropdown-multiple .ng-select-container{padding-left:8px}[_nghost-%COMP%]  .dropdown-multiple .ng-select-container .ng-value-container{display:inline-flex!important;flex-direction:row;height:100%;overflow:hidden;padding-left:0;padding-top:0}[_nghost-%COMP%]  .dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container{align-items:center;display:inline-flex;flex-direction:row;height:100%;overflow:hidden}[_nghost-%COMP%]  .dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .perfect-scrollbar{max-height:24px;padding-right:.25rem}[_nghost-%COMP%]  .dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .ng-value{background-color:var(--da-background);border:none;border-radius:4px;color:var(--da-primary-text);margin-bottom:1px;margin-top:1px;padding:2px 6px}[_nghost-%COMP%]  .dropdown-multiple .ng-dropdown-panel .ng-option-marked, [_nghost-%COMP%]  .dropdown-multiple .ng-dropdown-panel .ng-option-marked.ng-option-selected{color:var(--da-primary-text)}[_nghost-%COMP%]  .dropdown-multiple.multiline .ng-select-container .ng-value-container .multiple-label-container, [_nghost-%COMP%]  .dropdown-multiple.show-input.multiline .ng-select-container .ng-value-container .multiple-label-container{max-width:100%}[_nghost-%COMP%]  .dropdown-multiple.show-input .ng-select-container .ng-value-container .multiple-label-container{max-width:60%}[_nghost-%COMP%]  .dropdown-multiple.show-input .ng-select-container .ng-value-container .ng-input{display:block!important;min-width:30%;padding-bottom:0!important}[_nghost-%COMP%]  .clearable .ng-clear-wrapper{align-items:center;display:flex;justify-content:center}[_nghost-%COMP%]  .searchable .ng-select-container .ng-clear-wrapper{height:20px;width:17px}[_nghost-%COMP%]  .searchable .ng-select-container .ng-clear-wrapper .ng-clear{font-size:18px}[_nghost-%COMP%]  .searchable .ng-select-container .ng-input{display:block!important}[_nghost-%COMP%]  .has-validation-error .ng-select-container{border-color:var(--da-error-base)}.validation-error[_ngcontent-%COMP%]{color:var(--da-error-base);font-size:10px;margin-top:5px;position:absolute}.validation-error[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{cursor:pointer;font-size:14px!important;margin-right:7px}[_nghost-%COMP%]   .truncated[_ngcontent-%COMP%]     .ng-value-container{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[_nghost-%COMP%]   .truncated[_ngcontent-%COMP%]     .ng-value{display:inline}[_nghost-%COMP%]     .ng-select-multiple[disabled] .ng-clear-wrapper, [_nghost-%COMP%]     .ng-select-multiple[disabled] input, [_nghost-%COMP%]     .select--append-to .ng-dropdown-panel{display:none}  .dropdown-select--disabled .ng-dropdown-header,   .dropdown-select--disabled .ng-option,   .dropdown-select--disabled .option-checkbox{display:none!important;pointer-events:none}  .dropdown-select--disabled.ng-dropdown-panel .ng-dropdown-panel-items .ng-option-marked{background:none!important}  .dropdown-select--disabled .ng-option-selected{display:flex!important}.selected-counter[_ngcontent-%COMP%]{color:var(--da-brand-base)!important}.selected-counter-disabled[_ngcontent-%COMP%]{color:var(--da-disable)!important}.multiple-header-border[_ngcontent-%COMP%]{font-weight:500}"] });
DropdownComponent.propDecorators = {
    width: [{ type: Input }],
    minWidth: [{ type: Input }],
    maxWidth: [{ type: Input }],
    maxLength: [{ type: Input }],
    label: [{ type: Input }],
    labelPosition: [{ type: Input }],
    multiple: [{ type: Input }],
    searchable: [{ type: Input }],
    clearable: [{ type: Input }],
    loading: [{ type: Input }],
    placeholder: [{ type: Input }],
    notFoundText: [{ type: Input }],
    typeahead: [{ type: Input }],
    appendTo: [{ type: Input }],
    truncate: [{ type: Input }],
    dropdownPosition: [{ type: Input }],
    id: [{ type: Input }],
    items: [{ type: Input }],
    validation: [{ type: Input }],
    valueKey: [{ type: Input }],
    labelKey: [{ type: Input }],
    labelRemovable: [{ type: Input }],
    addTag: [{ type: Input }],
    multiline: [{ type: Input }],
    ngSelectItemsFilter: [{ type: Input }],
    showInput: [{ type: Input }],
    addTagFunction: [{ type: Input }],
    optionTemplateRef: [{ type: Input }],
    labelTemplateRef: [{ type: Input }],
    addTagTemplateRef: [{ type: Input }],
    searchFn: [{ type: Input }],
    editableSearchTerm: [{ type: Input }],
    isItemsLinked: [{ type: Input }],
    clearSearchOnAdd: [{ type: Input }],
    searchTermOnly: [{ type: Input }],
    setDisable: [{ type: Input }],
    groupBy: [{ type: Input }],
    virtualScroll: [{ type: Input }],
    disableFilterOnSelect: [{ type: Input }],
    totalItemsLength: [{ type: Input }],
    onlyEmitHeaderOperationTypeChange: [{ type: Input }],
    translatedText: [{ type: Input }],
    valueChange: [{ type: Output }],
    change: [{ type: Output }],
    searchTerm: [{ type: Output }],
    add: [{ type: Output }],
    remove: [{ type: Output }],
    filter: [{ type: Output }],
    scroll: [{ type: Output }],
    close: [{ type: Output }],
    clear: [{ type: Output }],
    navigate: [{ type: Output }],
    multipleHeaderClicked: [{ type: Output }],
    multipleHeaderOperation: [{ type: Output }],
    selectControlEl: [{ type: ViewChild, args: [NgSelectComponent, { read: ElementRef, static: true },] }],
    ngSelect: [{ type: ViewChild, args: [NgSelectComponent, { static: true },] }],
    addTagContainerRef: [{ type: ViewChild, args: ['addTagContainerRef', { read: ViewContainerRef },] }],
    dropdownEl: [{ type: ViewChild, args: ['dropdown', { static: true, read: ElementRef },] }],
    headerTemplates: [{ type: ContentChildren, args: [DropdownHeaderTemplateDirective, { descendants: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{ selector: 'lib-dropdown', template: "<span\n    *ngIf=\"label\"\n    class=\"label label-{{ labelPosition }}\"\n    [class.disabled]=\"disabled\"\n    >{{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n    <ng-content></ng-content>\n</span>\n<div\n    perfect-scrollbar-styles\n    #dropdown\n    class=\"dropdown\"\n    [ngClass]=\"{\n        'label-left': labelPosition === 'left',\n        'dropdown-multiple': multiple,\n        'has-validation-error': validationError || hasErrors,\n        searchable: searchable,\n        clearable: clearable,\n        warning: warning,\n        'show-input': showInput || addTag,\n        multiline: multiline,\n        'size-s': sizeS\n    }\"\n>\n    <!--    #controlContainer is necessary for base form control-->\n    <ng-select\n        class=\"dropdown-select\"\n        #controlContainer\n        [class.select--append-to]=\"!!appendTo\"\n        [bindValue]=\"valueKey\"\n        [bindLabel]=\"labelKey\"\n        [placeholder]=\"multiple ? '0/' + itemsLength : placeholder\"\n        [notFoundText]=\"notFoundText\"\n        [disabled]=\"!multiple && disabled\"\n        [attr.disabled]=\"disabled || null\"\n        [style.minWidth.px]=\"minWidth\"\n        [style.maxWidth.px]=\"maxWidth\"\n        [style.width.px]=\"width\"\n        [items]=\"items\"\n        [virtualScroll]=\"virtualScroll\"\n        [multiple]=\"multiple\"\n        [closeOnSelect]=\"!multiple\"\n        [(ngModel)]=\"value\"\n        [clearSearchOnAdd]=\"clearSearchOnAdd\"\n        [typeahead]=\"ngSelectItemsFilter ? null : typeahead$\"\n        [loading]=\"loading\"\n        [clearable]=\"clearable\"\n        [appendTo]=\"appendTo\"\n        [dropdownPosition]=\"dropdownPosition\"\n        [addTag]=\"addTagFn\"\n        [searchFn]=\"searchFn\"\n        [editableSearchTerm]=\"editableSearchTerm\"\n        [style.maxHeight.px]=\"height * 2\"\n        [class.truncated]=\"truncate\"\n        [groupBy]=\"groupBy\"\n        (open)=\"onOpen()\"\n        (ngModelChange)=\"onSelect($event)\"\n        (change)=\"handleChange($event)\"\n        (add)=\"handleAdd($event)\"\n        (remove)=\"handleRemove($event)\"\n        (blur)=\"onTouched()\"\n        (scroll)=\"onScrollToEnd($event)\"\n        (search)=\"handleSearch($event)\"\n        (scrollToEnd)=\"onScroll()\"\n        (close)=\"onClose()\"\n        (clear)=\"clear.emit()\"\n        [attr.data-test-id]=\"id\"\n        [inputAttrs]=\"{ maxlength: maxLength?.toString() || null }\"\n    >\n        <ng-template let-item=\"item\" ng-optgroup-tmp>\n            <span class=\"internal-header\" data-test-id=\"group-title\">\n                {{\n                    item[groupBy] ||\n                        translatedText?.UNNAMED_GROUP ||\n                        \"Unnamed group\" | titlecase\n                }}\n            </span>\n            <div *ngIf=\"multiple && !disabled\" class=\"d-flex\">\n                <div class=\"multiple-header-border border-left-0\">\n                    {{ translatedText?.SELECT || \"Select\" }}\n                </div>\n                <div\n                    class=\"multiple-header-border multiple-header-btn\"\n                    data-test-id=\"add-group-btn\"\n                    (click)=\"addGroup(item[groupBy])\"\n                >\n                        <span class=\"text\">{{\n                            translatedText?.ALL || \"All\"\n                            }}</span>\n                </div>\n                <div\n                    class=\"multiple-header-border multiple-header-btn\"\n                    data-test-id=\"remove-group-btn\"\n                    (click)=\"removeGroup(item[groupBy])\"\n                >\n                        <span class=\"text\">{{\n                            translatedText?.NONE || \"None\"\n                            }}</span>\n                </div>\n                <div\n                    class=\"multiple-header-border multiple-header-btn\"\n                    data-test-id=\"invert-group-btn\"\n                    (click)=\"invertAllInGroup(item[groupBy])\"\n                >\n                        <span class=\"text\">{{\n                            translatedText?.INVERT || \"Invert\"\n                            }}</span>\n                </div>\n            </div>\n        </ng-template>\n\n        <ng-container *ngIf=\"multiple && !headerTemplate\">\n            <ng-template ng-header-tmp>\n                <div class=\"d-flex multiple-header\" [class.size-s]=\"sizeS\">\n                    <div class=\"ml-1 multiple-header-border\">\n                        {{ translatedText?.SELECT || \"Select\" }}\n                    </div>\n                    <div\n                        class=\"multiple-header-border multiple-header-btn\"\n                        data-test-id=\"add-all-btn\"\n                        (click)=\"addAll()\"\n                    >\n                        <span class=\"text\">{{\n                            translatedText?.ALL || \"All\"\n                        }}</span>\n                    </div>\n                    <div\n                        class=\"multiple-header-border multiple-header-btn\"\n                        data-test-id=\"remove-all-btn\"\n                        (click)=\"removeAll()\"\n                    >\n                        <span class=\"text\">{{\n                            translatedText?.NONE || \"None\"\n                        }}</span>\n                    </div>\n                    <div\n                        class=\"multiple-header-border multiple-header-btn\"\n                        data-test-id=\"invert-all-btn\"\n                        (click)=\"invertAll()\"\n                    >\n                        <span class=\"text\">{{\n                            translatedText?.INVERT || \"Invert\"\n                        }}</span>\n                    </div>\n                </div>\n            </ng-template>\n        </ng-container>\n\n        <ng-template ng-option-tmp let-item=\"item\" let-item$=\"item$\">\n            <ng-container\n                *ngTemplateOutlet=\"\n                    optionTemplateRef || defaultOptionTemplate;\n                    context: {\n                        item: item,\n                        item$: item$,\n                        labelKey: labelKey,\n                        valueKey: valueKey,\n                        multiple: multiple\n                    }\n                \"\n            ></ng-container>\n            <ng-template #defaultOptionTemplate>\n                <checkbox\n                    *ngIf=\"multiple\"\n                    class=\"option-checkbox\"\n                    [class.size-s]=\"sizeS\"\n                    [value]=\"item$.selected\"\n                ></checkbox>\n                <span\n                    [ngStyle]=\"groupBy ? { 'margin-left': '10px' } : {}\"\n                    class=\"option-label text-truncate\"\n                    [class.size-s]=\"sizeS\"\n                    [ngbTooltip]=\"item[labelKey]\"\n                    triggers=\"manual\"\n                    libTooltipWhenOverflow\n                    container=\"body\"\n                    [tooltipClass]=\"'dropdown-tooltip'\"\n                    [hoverElementSelectorFn]=\"hoverElementSelectorFn\"\n                    >{{ item[labelKey] }}</span\n                >\n                <fa-icon\n                    *ngIf=\"disabled && multiple\"\n                    class=\"font-16px\"\n                    icon=\"simpleCheck\"\n                ></fa-icon>\n            </ng-template>\n        </ng-template>\n\n        <ng-template ng-label-tmp let-item=\"item\">\n            <ng-container\n                *ngTemplateOutlet=\"\n                    labelTemplateRef || defaultLabelTemplate;\n                    context: {\n                        item: item,\n                        labelKey: labelKey,\n                        valueKey: valueKey\n                    }\n                \"\n            ></ng-container>\n\n            <ng-template #defaultLabelTemplate>\n                <span\n                    class=\"value-label\"\n                    [class.size-s]=\"sizeS\"\n                    [ngbTooltip]=\"item[labelKey]\"\n                    triggers=\"manual\"\n                    libTooltipWhenOverflow\n                    [tooltipClass]=\"'dropdown-tooltip'\"\n                    [textElementSelectorFn]=\"hoverElementSelectorFn\"\n                    [hoverElementSelectorFn]=\"labelHoverElementSelectorFn\"\n                    placement=\"top-left\"\n                    container=\"body\"\n                    >{{ item[labelKey] }}</span\n                >\n            </ng-template>\n        </ng-template>\n\n        <ng-template\n            *ngIf=\"multiple\"\n            ng-multi-label-tmp\n            let-items=\"items\"\n            let-clear=\"clear\"\n        >\n            <div\n                *ngIf=\"showCounter\"\n                class=\"multiple-label-container\"\n                [class.size-s]=\"sizeS\"\n            >\n                <span\n                    class=\"selected-counter text-truncate\"\n                    [ngClass]=\"{ 'selected-counter-disabled': disabled }\"\n                    >{{ min(items.length, itemsLength) }}/{{ itemsLength }}\n                    {{ translatedText?.SELECTED || \"selected\" }}</span\n                >\n            </div>\n        </ng-template>\n\n        <ng-template ng-tag-tmp let-searchTerm=\"searchTerm\">\n            <span\n                ><span class=\"ng-tag-label\" [class.size-s]=\"sizeS\">{{\n                    translatedText?.ADD_ITEM || \"Add item\"\n                }}</span\n                >\"{{ searchTerm }}\"</span\n            >\n            <ng-template #addTagContainerRef></ng-template>\n        </ng-template>\n\n        <ng-container *ngIf=\"headerTemplate\">\n            <ng-template ng-header-tmp>\n                <ng-template\n                    [ngTemplateOutlet]=\"headerTemplate.template\"\n                ></ng-template>\n            </ng-template>\n        </ng-container>\n    </ng-select>\n    <div\n        *ngIf=\"validationError\"\n        class=\"validation-error\"\n        [class.size-s]=\"sizeS\"\n    >\n        <fa-icon class=\"fa\" icon=\"facExclamationCircle\"></fa-icon>\n        {{ validationError }}\n    </div>\n\n    <lib-app-warning-message\n        *ngIf=\"warning\"\n        [message]=\"warningMessage\"\n    ></lib-app-warning-message>\n\n    <lib-app-warning-message\n        *ngIf=\"info\"\n        [message]=\"infoMessage\"\n        [isInfo]=\"true\"\n    ></lib-app-warning-message>\n</div>\n", host: { class: 'dropdown' }, styles: [":host.size-l ::ng-deep .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important}:host ::ng-deep .ng-select-disabled .ng-arrow:before{content:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23BDBCBC%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")!important}::ng-deep .dropdown-tooltip{top:-10px!important}.label{color:var(--da-title);display:block;font-size:11px}.label.label-left{line-height:28px;margin-right:7px}.label.label-top{margin-bottom:7px}.label.disabled{color:var(--da-title)}.label .mandatory{color:var(--da-error-base)}.internal-header{color:var(--da-title);font-weight:700}.multiple-header{font-size:14px;line-height:18px}.multiple-header-border{border:4px solid transparent}.multiple-header-btn{color:var(--da-brand-base);cursor:pointer;margin:0 -.2rem;padding:0 .25rem}.multiple-header-btn:focus{border:4px solid var(--da-brand-20);border-radius:4px}.multiple-header-btn:active .text,.multiple-header-btn:hover .text{-webkit-text-decoration-line:underline;text-decoration-line:underline}.multiple-header-btn:not(:last-child):after{-webkit-text-decoration-line:none!important;color:var(--da-title);content:\"/\";margin-left:.25rem;text-decoration-line:none!important}.label-left,.option-label{display:inline-block}.option-label{color:var(--da-primary-text)}::ng-deep.ng-dropdown-panel .ng-dropdown-panel-items{width:inherit}::ng-deep.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .option-label{overflow:hidden;text-overflow:ellipsis;width:100%}.option-checkbox{float:left}:host::ng-deep .dropdown{cursor:pointer!important}:host::ng-deep .dropdown .dropdown-select{height:inherit}:host::ng-deep .dropdown .ng-select-container{background:var(--da-cards-and-blocks);cursor:pointer!important}:host::ng-deep .dropdown .ng-select-container *{color:var(--da-primary-text)}:host::ng-deep .dropdown .ng-input>input{cursor:text!important}:host::ng-deep .dropdown .ng-select-opened .ng-arrow-wrapper{transform:rotate(180deg)}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:not(:hover):not(:active){border-radius:4px;box-shadow:0 0 0 4px var(--da-brand-20)}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:not(:hover):not(:active) .ng-select-container{border:1px solid var(--da-border-and-dividers)!important}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-arrow-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-clear-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-value{margin-top:-3px!important}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container{border:1px solid var(--da-brand-base)!important;height:100%!important;margin:0!important;width:100%!important}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper{padding-right:--2px}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-arrow-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-value,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-arrow-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-value{margin-top:0!important}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled) .ng-placeholder{color:var(--da-disable)!important}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled):active .ng-select-container,:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select:not(.ng-select-disabled):hover .ng-select-container{border:1px solid var(--da-brand-base)!important;margin:0!important;width:100%!important}:host::ng-deep .dropdown:not(.has-validation-error) .dropdown-select.ng-select-disabled .ng-input>input{color:var(--da-disable)!important}:host::ng-deep .dropdown.has-validation-error .ng-select-container{border:1px solid var(--da-error-base)!important}:host::ng-deep .dropdown .ng-value-container{display:flex!important;height:inherit;overflow:auto}:host::ng-deep .dropdown .ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{box-shadow:none;outline:none}:host::ng-deep .dropdown .ng-select-single .ng-select-container{padding-left:8px}:host::ng-deep .dropdown .ng-select-disabled .ng-select-container{background-color:rgba(0,0,0,.04)}:host::ng-deep .dropdown .ng-select-disabled .ng-select-container .ng-placeholder,:host::ng-deep .dropdown .ng-select-disabled .ng-select-container .option-label,:host::ng-deep .dropdown .ng-select-disabled .ng-select-container .value-label{color:var(--da-disable)}:host::ng-deep .dropdown .ng-select-container{border:1px solid var(--da-border-and-dividers);border-radius:4px;height:inherit!important;min-height:auto!important;padding:0 8px 0 0}:host::ng-deep .dropdown .ng-select-container .ng-clear,:host::ng-deep .dropdown .ng-select-container .ng-clear-wrapper:hover .ng-clear{color:var(--da-disable)!important;font-size:16px!important}:host::ng-deep .dropdown .ng-select-container .ng-arrow-wrapper{height:24px;padding:0;width:24px}:host::ng-deep .dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow{height:16px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:16px}:host::ng-deep .dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;-webkit-mask-size:contain;background:var(--da-brand-base);color:var(--da-brand-base);content:\"\";display:inline-block;height:14px;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;mask-size:contain;width:14px}:host::ng-deep .dropdown .ng-select-container .ng-input{display:none!important;left:-3px!important;top:auto!important}:host::ng-deep .dropdown .ng-dropdown-panel{border:var(--da-dropdown-border);border-radius:var(--da-dropdown-border-radius);box-shadow:var(--da-dropdown-box-shadow)}:host::ng-deep .dropdown .ng-dropdown-panel .ng-option{color:var(--da-primary-text);cursor:pointer;padding:12px 19px;white-space:inherit}:host::ng-deep .dropdown .ng-dropdown-panel .ng-option-selected{background-color:var(--da-cards-and-blocks)}:host::ng-deep .dropdown .ng-dropdown-panel .ng-option-selected.ng-option-marked{color:var(--da-brand-base)}:host::ng-deep .dropdown .ng-dropdown-panel .ng-option-marked{background-color:var(--da-background);color:var(--da-brand-base)}:host::ng-deep .dropdown.label-left{float:right}:host::ng-deep .dropdown .icons{cursor:pointer}:host::ng-deep .dropdown .icons,:host::ng-deep .dropdown .icons:hover{color:var(--da-secondary-text-and-icons)}:host::ng-deep .dropdown-multiple:not(.has-validation-error) .ng-select-focused:not(:hover):not(:active) .ng-value-container .ng-placeholder{margin-top:-3px}:host::ng-deep .dropdown-multiple .ng-select-container{padding-left:8px}:host::ng-deep .dropdown-multiple .ng-select-container .ng-value-container{display:inline-flex!important;flex-direction:row;height:100%;overflow:hidden;padding-left:0;padding-top:0}:host::ng-deep .dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container{align-items:center;display:inline-flex;flex-direction:row;height:100%;overflow:hidden}:host::ng-deep .dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .perfect-scrollbar{max-height:24px;padding-right:.25rem}:host::ng-deep .dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .ng-value{background-color:var(--da-background);border:none;border-radius:4px;color:var(--da-primary-text);margin-bottom:1px;margin-top:1px;padding:2px 6px}:host::ng-deep .dropdown-multiple .ng-dropdown-panel .ng-option-marked,:host::ng-deep .dropdown-multiple .ng-dropdown-panel .ng-option-marked.ng-option-selected{color:var(--da-primary-text)}:host::ng-deep .dropdown-multiple.multiline .ng-select-container .ng-value-container .multiple-label-container,:host::ng-deep .dropdown-multiple.show-input.multiline .ng-select-container .ng-value-container .multiple-label-container{max-width:100%}:host::ng-deep .dropdown-multiple.show-input .ng-select-container .ng-value-container .multiple-label-container{max-width:60%}:host::ng-deep .dropdown-multiple.show-input .ng-select-container .ng-value-container .ng-input{display:block!important;min-width:30%;padding-bottom:0!important}:host::ng-deep .clearable .ng-clear-wrapper{align-items:center;display:flex;justify-content:center}:host::ng-deep .searchable .ng-select-container .ng-clear-wrapper{height:20px;width:17px}:host::ng-deep .searchable .ng-select-container .ng-clear-wrapper .ng-clear{font-size:18px}:host::ng-deep .searchable .ng-select-container .ng-input{display:block!important}:host::ng-deep .has-validation-error .ng-select-container{border-color:var(--da-error-base)}.validation-error{color:var(--da-error-base);font-size:10px;margin-top:5px;position:absolute}.validation-error .fa{cursor:pointer;font-size:14px!important;margin-right:7px}:host .truncated ::ng-deep .ng-value-container{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .truncated ::ng-deep .ng-value{display:inline}:host ::ng-deep .ng-select-multiple[disabled] .ng-clear-wrapper,:host ::ng-deep .ng-select-multiple[disabled] input,:host ::ng-deep .select--append-to .ng-dropdown-panel{display:none}::ng-deep .dropdown-select--disabled .ng-dropdown-header,::ng-deep .dropdown-select--disabled .ng-option,::ng-deep .dropdown-select--disabled .option-checkbox{display:none!important;pointer-events:none}::ng-deep .dropdown-select--disabled.ng-dropdown-panel .ng-dropdown-panel-items .ng-option-marked{background:none!important}::ng-deep .dropdown-select--disabled .ng-option-selected{display:flex!important}.selected-counter{color:var(--da-brand-base)!important}.selected-counter-disabled{color:var(--da-disable)!important}.multiple-header-border{font-weight:500}"] }]
    }], null, { labelPosition: [{
            type: Input
        }], multiple: [{
            type: Input
        }], searchable: [{
            type: Input
        }], clearable: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], notFoundText: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], truncate: [{
            type: Input
        }], dropdownPosition: [{
            type: Input
        }], id: [{
            type: Input
        }], items: [{
            type: Input
        }], valueKey: [{
            type: Input
        }], labelKey: [{
            type: Input
        }], labelRemovable: [{
            type: Input
        }], addTag: [{
            type: Input
        }], multiline: [{
            type: Input
        }], ngSelectItemsFilter: [{
            type: Input
        }], showInput: [{
            type: Input
        }], editableSearchTerm: [{
            type: Input
        }], isItemsLinked: [{
            type: Input
        }], clearSearchOnAdd: [{
            type: Input
        }], searchTermOnly: [{
            type: Input
        }], virtualScroll: [{
            type: Input
        }], disableFilterOnSelect: [{
            type: Input
        }], onlyEmitHeaderOperationTypeChange: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], change: [{
            type: Output
        }], searchTerm: [{
            type: Output
        }], add: [{
            type: Output
        }], remove: [{
            type: Output
        }], filter: [{
            type: Output
        }], scroll: [{
            type: Output
        }], close: [{
            type: Output
        }], clear: [{
            type: Output
        }], navigate: [{
            type: Output
        }], multipleHeaderClicked: [{
            type: Output
        }], multipleHeaderOperation: [{
            type: Output
        }], setDisable: [{
            type: Input
        }], width: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], label: [{
            type: Input
        }], loading: [{
            type: Input
        }], typeahead: [{
            type: Input
        }], validation: [{
            type: Input
        }], addTagFunction: [{
            type: Input
        }], optionTemplateRef: [{
            type: Input
        }], labelTemplateRef: [{
            type: Input
        }], addTagTemplateRef: [{
            type: Input
        }], searchFn: [{
            type: Input
        }], groupBy: [{
            type: Input
        }], totalItemsLength: [{
            type: Input
        }], translatedText: [{
            type: Input
        }], selectControlEl: [{
            type: ViewChild,
            args: [NgSelectComponent, { read: ElementRef, static: true }]
        }], ngSelect: [{
            type: ViewChild,
            args: [NgSelectComponent, { static: true }]
        }], addTagContainerRef: [{
            type: ViewChild,
            args: ['addTagContainerRef', { read: ViewContainerRef }]
        }], dropdownEl: [{
            type: ViewChild,
            args: ['dropdown', { static: true, read: ElementRef }]
        }], headerTemplates: [{
            type: ContentChildren,
            args: [DropdownHeaderTemplateDirective, { descendants: true }]
        }] }); })();
class PerfectScrollbarStylesComponent {
}
PerfectScrollbarStylesComponent.ɵfac = function PerfectScrollbarStylesComponent_Factory(t) { return new (t || PerfectScrollbarStylesComponent)(); };
PerfectScrollbarStylesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PerfectScrollbarStylesComponent, selectors: [["", "perfect-scrollbar-styles", ""]], attrs: _c14, ngContentSelectors: _c3, decls: 1, vars: 0, template: function PerfectScrollbarStylesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [".ps{-ms-overflow-style:none;-ms-touch-action:auto;overflow:hidden!important;overflow-anchor:none;touch-action:auto}.ps__rail-x{bottom:0;height:15px}.ps__rail-x,.ps__rail-y{-webkit-transition:background-color .2s linear,opacity .2s linear;display:none;opacity:0;position:absolute;transition:background-color .2s linear,opacity .2s linear}.ps__rail-y{right:0;width:15px}.ps--active-x>.ps__rail-x,.ps--active-y>.ps__rail-y{background-color:transparent;display:block}.ps--focus>.ps__rail-x,.ps--focus>.ps__rail-y,.ps--scrolling-x>.ps__rail-x,.ps--scrolling-y>.ps__rail-y,.ps:hover>.ps__rail-x,.ps:hover>.ps__rail-y{opacity:.6}.ps .ps__rail-x.ps--clicking,.ps .ps__rail-x:focus,.ps .ps__rail-x:hover,.ps .ps__rail-y.ps--clicking,.ps .ps__rail-y:focus,.ps .ps__rail-y:hover{background-color:#eee;opacity:.9}.ps__thumb-x{-webkit-transition:background-color .2s linear,height .2s ease-in-out;bottom:2px;height:6px;transition:background-color .2s linear,height .2s ease-in-out}.ps__thumb-x,.ps__thumb-y{background-color:#aaa;border-radius:6px;position:absolute}.ps__thumb-y{-webkit-transition:background-color .2s linear,width .2s ease-in-out;right:2px;transition:background-color .2s linear,width .2s ease-in-out;width:6px}.ps__rail-x.ps--clicking .ps__thumb-x,.ps__rail-x:focus>.ps__thumb-x,.ps__rail-x:hover>.ps__thumb-x{background-color:#999;height:11px}.ps__rail-y.ps--clicking .ps__thumb-y,.ps__rail-y:focus>.ps__thumb-y,.ps__rail-y:hover>.ps__thumb-y{background-color:#999;width:11px}@supports (-ms-overflow-style:none){.ps{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps{overflow:auto!important}}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PerfectScrollbarStylesComponent, [{
        type: Component,
        args: [{ selector: '[perfect-scrollbar-styles]', template: '<ng-content></ng-content>', encapsulation: ViewEncapsulation.None, styles: [".ps{-ms-overflow-style:none;-ms-touch-action:auto;overflow:hidden!important;overflow-anchor:none;touch-action:auto}.ps__rail-x{bottom:0;height:15px}.ps__rail-x,.ps__rail-y{-webkit-transition:background-color .2s linear,opacity .2s linear;display:none;opacity:0;position:absolute;transition:background-color .2s linear,opacity .2s linear}.ps__rail-y{right:0;width:15px}.ps--active-x>.ps__rail-x,.ps--active-y>.ps__rail-y{background-color:transparent;display:block}.ps--focus>.ps__rail-x,.ps--focus>.ps__rail-y,.ps--scrolling-x>.ps__rail-x,.ps--scrolling-y>.ps__rail-y,.ps:hover>.ps__rail-x,.ps:hover>.ps__rail-y{opacity:.6}.ps .ps__rail-x.ps--clicking,.ps .ps__rail-x:focus,.ps .ps__rail-x:hover,.ps .ps__rail-y.ps--clicking,.ps .ps__rail-y:focus,.ps .ps__rail-y:hover{background-color:#eee;opacity:.9}.ps__thumb-x{-webkit-transition:background-color .2s linear,height .2s ease-in-out;bottom:2px;height:6px;transition:background-color .2s linear,height .2s ease-in-out}.ps__thumb-x,.ps__thumb-y{background-color:#aaa;border-radius:6px;position:absolute}.ps__thumb-y{-webkit-transition:background-color .2s linear,width .2s ease-in-out;right:2px;transition:background-color .2s linear,width .2s ease-in-out;width:6px}.ps__rail-x.ps--clicking .ps__thumb-x,.ps__rail-x:focus>.ps__thumb-x,.ps__rail-x:hover>.ps__thumb-x{background-color:#999;height:11px}.ps__rail-y.ps--clicking .ps__thumb-y,.ps__rail-y:focus>.ps__thumb-y,.ps__rail-y:hover>.ps__thumb-y{background-color:#999;width:11px}@supports (-ms-overflow-style:none){.ps{overflow:auto!important}}@media (-ms-high-contrast:none),screen and (-ms-high-contrast:active){.ps{overflow:auto!important}}"] }]
    }], null, null); })();

class CheckboxComponent {
    constructor() {
        this.preventDefault = false;
        this.undefinedState = false;
        this.buttonView = false;
        /** @deprecated: use {@link appearance} instead*/
        this.blueCheck = false;
        this.appearance = 'filled';
        this.id = 'checkbox';
        this.loading = false;
        this.change = new EventEmitter();
    }
    get icon() {
        if (this.value) {
            return 'facBuildSuccess';
        }
        if (this.isUndefinedState()) {
            return 'minus';
        }
        return null;
    }
    get checkboxAppearance() {
        if (this.blueCheckEnabled) {
            return 'unbordered';
        }
        if (!this.isUndefinedState() && !this.value) {
            return 'border';
        }
        if (this.loading) {
            return 'unbordered';
        }
        return this.appearance;
    }
    get blueCheckEnabled() {
        return this.blueCheck && this.value && this.disabled;
    }
    onChange() {
        if (this.disabled) {
            return;
        }
        if (!this.preventDefault) {
            if (!this.undefinedState) {
                this.value = !this.value;
            }
            else {
                if (this.value === undefined) {
                    this.value = true;
                }
                else if (this.value === true) {
                    this.value = false;
                }
                else {
                    this.value = undefined;
                }
            }
        }
        if (this.onTouchedCb) {
            this.onTouchedCb();
        }
        if (this.onChangeCb) {
            this.onChangeCb(this.value);
        }
        this.change.emit(this.value);
    }
    registerOnChange(fn) {
        this.onChangeCb = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCb = fn;
    }
    writeValue(obj) {
        this.value = _.clone(obj);
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    isUndefinedState() {
        if (!this.undefinedState) {
            return false;
        }
        return this.value === undefined;
    }
    /*
     *  Prevent click events that come from the `<label/>` element from bubbling. This prevents the
     *  click handler on the host from triggering twice when clicking on the `<label/>` element. After
     *  the click event on the `<label/>` propagates, the browsers dispatches click on the associated
     *  `<input/>`. By preventing clicks on the label by bubbling, we ensure only one click event
     *  bubbles when the label is clicked.
     */
    preventBubblingFromCheckbox(event) {
        if (!!event.target &&
            !this.checkbox.nativeElement.contains(event.target)) {
            event.stopPropagation();
        }
    }
    /*
     * We always have to stop propagation on the change event.
     * Otherwise the change event, from the input element, will bubble up and
     * emit its event object to the `change` output.
     */
    preventCheckboxChangeEvent(event) {
        event.stopPropagation();
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["checkbox"]], viewQuery: function CheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c15, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
    } }, hostAttrs: [1, "lib-checkbox"], hostVars: 1, hostBindings: function CheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-appearance", ctx.checkboxAppearance);
    } }, inputs: { preventDefault: "preventDefault", undefinedState: "undefinedState", buttonView: "buttonView", blueCheck: "blueCheck", appearance: "appearance", id: "id", loading: "loading", value: "value", disabled: "disabled", label: "label" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxComponent),
                multi: true
            }
        ])], ngContentSelectors: _c3, decls: 2, vars: 2, consts: [["class", "checkbox-item", 3, "loading", "disabled", "click", 4, "ngIf"], ["class", "button-item btn btn-outline-secondary", 3, "ngClass", "click", 4, "ngIf"], [1, "checkbox-item", 3, "click"], ["type", "checkbox", 1, "native-checkbox", 3, "checked", "disabled", "indeterminate", "change", "click"], ["checkbox", ""], [1, "checkbox-item__icon", "mr-2"], ["class", "icon", 3, "icon", 4, "ngIf"], [1, "checkbox-item__label"], [1, "icon", 3, "icon"], [1, "button-item", "btn", "btn-outline-secondary", 3, "ngClass", "click"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CheckboxComponent_label_0_Template, 7, 9, "label", 0);
        ɵngcc0.ɵɵtemplate(1, CheckboxComponent_button_1_Template, 2, 4, "button", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.buttonView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonView);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: [".checkbox-item[_ngcontent-%COMP%]{--checkbox-border:var(--da-border-and-dividers);align-items:center;cursor:pointer;display:flex;height:inherit;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.button-item[_ngcontent-%COMP%]{border-color:var(--da-color-border-3);box-shadow:none;color:var(--da-title);font-size:11px;padding:1px 6px}.button-item.btn-primary[_ngcontent-%COMP%]{color:var(--da-white)}.button-item[_ngcontent-%COMP%]:hover{background:none}.button-item.btn-primary[_ngcontent-%COMP%]:hover, .button-item[_ngcontent-%COMP%]:active{background-color:var(--da-brand-base)!important;box-shadow:none!important}.checkbox-item__icon[_ngcontent-%COMP%]{align-items:center;background:var(--da-checkbox-background);border-radius:var(--checkbox-border-radius,4px);display:inline-flex;font-size:16px;height:16px;justify-content:center;line-height:normal;position:relative;width:16px}.checkbox-item__icon[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%], [_nghost-%COMP%]  .checkbox-item__icon svg path{color:var(--da-checkbox-icon)!important}[data-appearance=filled][_nghost-%COMP%]   .checkbox-item[_ngcontent-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:checked + .checkbox-item__icon[_ngcontent-%COMP%], [data-appearance=filled][_nghost-%COMP%]   .checkbox-item[_ngcontent-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:indeterminate + .checkbox-item__icon[_ngcontent-%COMP%]{--da-checkbox-background:var(--da-brand-base);--da-checkbox-icon:var(--da-white)}[data-appearance=filled][_nghost-%COMP%]   .checkbox-item[_ngcontent-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:checked:disabled + .checkbox-item__icon[_ngcontent-%COMP%], [data-appearance=filled][_nghost-%COMP%]   .checkbox-item[_ngcontent-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:indeterminate:disabled + .checkbox-item__icon[_ngcontent-%COMP%]{--da-checkbox-background:var(--da-brand-disabled)}[data-appearance=filled][_nghost-%COMP%]   .checkbox-item[_ngcontent-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:checked:enabled:not(:focus):hover + .checkbox-item__icon[_ngcontent-%COMP%], [data-appearance=filled][_nghost-%COMP%]   .checkbox-item[_ngcontent-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:indeterminate:enabled:not(:focus):hover + .checkbox-item__icon[_ngcontent-%COMP%]{--da-checkbox-background:var(--da-brand-hover)}[data-appearance=border][_nghost-%COMP%], [data-appearance=unbordered][_nghost-%COMP%]{--da-checkbox-icon:var(--da-brand-base)}[data-appearance=border][_nghost-%COMP%]   .checkbox-item__icon[_ngcontent-%COMP%]:after{border:1px solid var(--da-border-and-dividers);border-radius:var(--checkbox-border-radius,4px);content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}[data-appearance=border][_nghost-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:enabled:not(:focus):hover + .checkbox-item__icon[_ngcontent-%COMP%]:after{border-color:var(--da-brand-base)}[data-appearance=border][_nghost-%COMP%]   .native-checkbox[_ngcontent-%COMP%]:disabled + .checkbox-item__icon[_ngcontent-%COMP%]{--da-checkbox-background:rgba(0,0,0,0.0392156862745098)}.checkbox-item.loading[_ngcontent-%COMP%]   .checkbox-item__label[_ngcontent-%COMP%], .native-checkbox[_ngcontent-%COMP%]:disabled ~ .checkbox-item__label[_ngcontent-%COMP%]{color:var(--da-disable)}.checkbox-item.disabled[_ngcontent-%COMP%], .checkbox-item.loading[_ngcontent-%COMP%]{cursor:auto}.checkbox-item[_ngcontent-%COMP%]:not(.loading)   .native-checkbox[_ngcontent-%COMP%]:disabled + .checkbox-item__icon[_ngcontent-%COMP%]{--da-checkbox-icon:var(--da-disable)}.size-s[_nghost-%COMP%]   .checkbox-item__icon[_ngcontent-%COMP%]{font-size:18px;height:18px;width:18px}.native-checkbox[_ngcontent-%COMP%]:enabled:focus + .checkbox-item__icon[_ngcontent-%COMP%]{box-shadow:0 0 0 4px var(--da-brand-20)}.native-checkbox[_ngcontent-%COMP%]{-moz-appearance:none;-webkit-appearance:none;appearance:none}"] });
CheckboxComponent.propDecorators = {
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    preventDefault: [{ type: Input }],
    undefinedState: [{ type: Input }],
    buttonView: [{ type: Input }],
    label: [{ type: Input }],
    blueCheck: [{ type: Input }],
    appearance: [{ type: Input }],
    id: [{ type: Input }],
    loading: [{ type: Input }],
    change: [{ type: Output }],
    checkbox: [{ type: ViewChild, args: ['checkbox',] }],
    checkboxAppearance: [{ type: HostBinding, args: ['attr.data-appearance',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{ selector: 'checkbox', template: "<label\n    *ngIf=\"!buttonView\"\n    class=\"checkbox-item\"\n    [class.loading]=\"loading || blueCheckEnabled\"\n    [class.disabled]=\"disabled\"\n    [attr.data-test-id]=\"id\"\n    (click)=\"preventBubblingFromCheckbox($event)\"\n>\n    <input\n        #checkbox\n        class=\"native-checkbox\"\n        type=\"checkbox\"\n        [checked]=\"value\"\n        [disabled]=\"disabled || loading || blueCheckEnabled\"\n        [indeterminate]=\"isUndefinedState()\"\n        (change)=\"preventCheckboxChangeEvent($event)\"\n        (click)=\"onChange()\"\n    />\n    <div class=\"checkbox-item__icon mr-2\">\n        <fa-icon class=\"icon\" *ngIf=\"icon as icon\" [icon]=\"icon\"></fa-icon>\n    </div>\n    <div class=\"checkbox-item__label\"><ng-content></ng-content></div>\n</label>\n\n<button\n    class=\"button-item btn btn-outline-secondary\"\n    *ngIf=\"buttonView\"\n    [ngClass]=\"{ 'btn-primary': value }\"\n    (click)=\"onChange()\"\n>\n    {{ label }}\n</button>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxComponent),
                        multi: true
                    }
                ], host: { class: 'lib-checkbox' }, styles: [".checkbox-item{--checkbox-border:var(--da-border-and-dividers);align-items:center;cursor:pointer;display:flex;height:inherit;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.button-item{border-color:var(--da-color-border-3);box-shadow:none;color:var(--da-title);font-size:11px;padding:1px 6px}.button-item.btn-primary{color:var(--da-white)}.button-item:hover{background:none}.button-item.btn-primary:hover,.button-item:active{background-color:var(--da-brand-base)!important;box-shadow:none!important}.checkbox-item__icon{align-items:center;background:var(--da-checkbox-background);border-radius:var(--checkbox-border-radius,4px);display:inline-flex;font-size:16px;height:16px;justify-content:center;line-height:normal;position:relative;width:16px}.checkbox-item__icon .icon,:host::ng-deep .checkbox-item__icon svg path{color:var(--da-checkbox-icon)!important}:host[data-appearance=filled] .checkbox-item .native-checkbox:checked+.checkbox-item__icon,:host[data-appearance=filled] .checkbox-item .native-checkbox:indeterminate+.checkbox-item__icon{--da-checkbox-background:var(--da-brand-base);--da-checkbox-icon:var(--da-white)}:host[data-appearance=filled] .checkbox-item .native-checkbox:checked:disabled+.checkbox-item__icon,:host[data-appearance=filled] .checkbox-item .native-checkbox:indeterminate:disabled+.checkbox-item__icon{--da-checkbox-background:var(--da-brand-disabled)}:host[data-appearance=filled] .checkbox-item .native-checkbox:checked:enabled:not(:focus):hover+.checkbox-item__icon,:host[data-appearance=filled] .checkbox-item .native-checkbox:indeterminate:enabled:not(:focus):hover+.checkbox-item__icon{--da-checkbox-background:var(--da-brand-hover)}:host[data-appearance=border],:host[data-appearance=unbordered]{--da-checkbox-icon:var(--da-brand-base)}:host[data-appearance=border] .checkbox-item__icon:after{border:1px solid var(--da-border-and-dividers);border-radius:var(--checkbox-border-radius,4px);content:\"\";height:100%;left:0;position:absolute;top:0;width:100%}:host[data-appearance=border] .native-checkbox:enabled:not(:focus):hover+.checkbox-item__icon:after{border-color:var(--da-brand-base)}:host[data-appearance=border] .native-checkbox:disabled+.checkbox-item__icon{--da-checkbox-background:rgba(0,0,0,0.0392156862745098)}.checkbox-item.loading .checkbox-item__label,.native-checkbox:disabled~.checkbox-item__label{color:var(--da-disable)}.checkbox-item.disabled,.checkbox-item.loading{cursor:auto}.checkbox-item:not(.loading) .native-checkbox:disabled+.checkbox-item__icon{--da-checkbox-icon:var(--da-disable)}:host.size-s .checkbox-item__icon{font-size:18px;height:18px;width:18px}.native-checkbox:enabled:focus+.checkbox-item__icon{box-shadow:0 0 0 4px var(--da-brand-20)}.native-checkbox{-moz-appearance:none;-webkit-appearance:none;appearance:none}"] }]
    }], function () { return []; }, { preventDefault: [{
            type: Input
        }], undefinedState: [{
            type: Input
        }], buttonView: [{
            type: Input
        }], blueCheck: [{
            type: Input
        }], appearance: [{
            type: Input
        }], id: [{
            type: Input
        }], loading: [{
            type: Input
        }], change: [{
            type: Output
        }], checkboxAppearance: [{
            type: HostBinding,
            args: ['attr.data-appearance']
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }], checkbox: [{
            type: ViewChild,
            args: ['checkbox']
        }] }); })();

let id = 1;
class RadioGroupComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.id = 'radiogroup';
        this.name = `radio-group_` + id++;
        this.testId = 'radio';
    }
}
RadioGroupComponent.ɵfac = /*@__PURE__*/ function () { let ɵRadioGroupComponent_BaseFactory; return function RadioGroupComponent_Factory(t) { return (ɵRadioGroupComponent_BaseFactory || (ɵRadioGroupComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(RadioGroupComponent)))(t || RadioGroupComponent); }; }();
RadioGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioGroupComponent, selectors: [["lib-radio-group"]], inputs: { id: "id", testId: "testId", options: "options" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["class", "d-flex a-align-center", 4, "ngFor", "ngForOf"], ["controlContainer", ""], [1, "d-flex", "a-align-center"], ["type", "radio", 1, "mr-1", 3, "value", "name", "formControl"]], template: function RadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RadioGroupComponent_label_0_Template, 3, 6, "label", 0);
        ɵngcc0.ɵɵtemplate(1, RadioGroupComponent_ng_template_1_Template, 0, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.options);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc1.DefaultValueAccessor, ɵngcc1.RadioControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlDirective, ErrorControlDirective], encapsulation: 2 });
RadioGroupComponent.propDecorators = {
    id: [{ type: Input }],
    options: [{ type: Input }],
    testId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'lib-radio-group',
                template: "<label *ngFor=\"let option of options\" class=\"d-flex a-align-center\">\n    <input type=\"radio\" [attr.data-test-id]=\"testId\" class=\"mr-1\" [value]=\"option.value\" [name]=\"name\" [attr.disabled]=\"option.disabled\" [formControl]=\"control\"> {{ option.label }}\n</label>\n<ng-template #controlContainer></ng-template>\n"
            }]
    }], null, { id: [{
            type: Input
        }], testId: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();

class FormDirtyDirective {
    constructor(formSubmit) {
        this.formSubmit = formSubmit;
        this.listenFromSubmitEvent = true;
    }
    ngOnInit() {
        if (this.form) {
            this.setOriginalValue();
            this.subscription$ = this.form.valueChanges
                .pipe(map(currentValue => this.isEqual(this.originalValue, this.takeModelSnapshot(currentValue))))
                .subscribe(equals => {
                if (equals) {
                    this.form.markAsPristine();
                }
                else {
                    this.form.markAsDirty();
                }
            });
            if (this.listenFromSubmitEvent) {
                this.subscription$.add(this.formSubmit.submit$.pipe(filter(() => this.form.valid)).subscribe(() => this.reset()));
            }
        }
    }
    setOriginalValue() {
        this.originalValue = this.takeModelSnapshot(this.form.value);
    }
    reset() {
        this.setOriginalValue();
        this.form.markAsPristine();
    }
    takeModelSnapshot(model) {
        return JSON.stringify(model);
    }
    isEqual(a, b) {
        return a === b;
    }
    ngOnDestroy() {
        if (this.subscription$) {
            this.subscription$.unsubscribe();
        }
    }
}
FormDirtyDirective.ɵfac = function FormDirtyDirective_Factory(t) { return new (t || FormDirtyDirective)(ɵngcc0.ɵɵdirectiveInject(FormSubmitDirective, 2)); };
FormDirtyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FormDirtyDirective, selectors: [["form", "formGroup", "", 9, "not-check-dirty"]], inputs: { listenFromSubmitEvent: "listenFromSubmitEvent", form: ["formGroup", "form"] }, exportAs: ["formDirty"] });
FormDirtyDirective.ctorParameters = () => [
    { type: FormSubmitDirective, decorators: [{ type: Self }] }
];
FormDirtyDirective.propDecorators = {
    form: [{ type: Input, args: ['formGroup',] }],
    listenFromSubmitEvent: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormDirtyDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: 'form[formGroup]:not(.not-check-dirty)',
                exportAs: 'formDirty'
            }]
    }], function () { return [{ type: FormSubmitDirective, decorators: [{
                type: Self
            }] }]; }, { listenFromSubmitEvent: [{
            type: Input
        }], form: [{
            type: Input,
            args: ['formGroup']
        }] }); })();

class WarningMessageComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.isInfo = false;
        this.show = false;
    }
    set message(value) {
        this.text = value;
        this.show = coerceBooleanProperty(value);
        if (!this.cdr['destroyed']) {
            this.cdr.detectChanges();
        }
    }
}
WarningMessageComponent.ɵfac = function WarningMessageComponent_Factory(t) { return new (t || WarningMessageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
WarningMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WarningMessageComponent, selectors: [["lib-app-warning-message"]], inputs: { isInfo: "isInfo", message: "message" }, decls: 5, vars: 1, consts: [[3, "ngTemplateOutlet"], ["info", ""], ["warning", ""], [1, "info-message-container", "body3", 3, "hidden"], ["icon", "facInfoCircle", 1, "mr-5px", "font-12px"], [1, "warning-message-container", 3, "hidden"]], template: function WarningMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, WarningMessageComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, WarningMessageComponent_ng_template_1_Template, 3, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, WarningMessageComponent_ng_template_3_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.isInfo ? _r1 : _r3);
    } }, dependencies: [ɵngcc2.NgTemplateOutlet, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: [".warning-message-container[_ngcontent-%COMP%]{color:var(--da-color-2-normal);margin-top:7px}.info-message-container[_ngcontent-%COMP%]{color:var(--da-primary-text);margin-top:7px}.info-message-container[_ngcontent-%COMP%]     svg{stroke:var(--da-brand-base)!important}"], changeDetection: 0 });
WarningMessageComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
WarningMessageComponent.propDecorators = {
    message: [{ type: Input }],
    isInfo: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WarningMessageComponent, [{
        type: Component,
        args: [{ selector: 'lib-app-warning-message', template: "<ng-template [ngTemplateOutlet]=\"isInfo ? info : warning\"></ng-template>\n\n<ng-template #info>\n    <div class=\"info-message-container body3\" [hidden]=\"!show\">\n        <fa-icon icon=\"facInfoCircle\" class=\"mr-5px font-12px\"></fa-icon>\n        {{ text }}\n    </div>\n</ng-template>\n\n<ng-template #warning>\n    <div class=\"warning-message-container\" [hidden]=\"!show\">\n        {{ text }}\n    </div>\n</ng-template>\n\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [".warning-message-container{color:var(--da-color-2-normal);margin-top:7px}.info-message-container{color:var(--da-primary-text);margin-top:7px}.info-message-container ::ng-deep svg{stroke:var(--da-brand-base)!important}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { isInfo: [{
            type: Input
        }], message: [{
            type: Input
        }] }); })();

class DropdownAddTagValidatorDirective {
    constructor(dropdown) {
        this.dropdown = dropdown;
        this.errorMessage = '';
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        var _a;
        this.control = new FormControl('', this.validator);
        this.control.statusChanges
            .pipe(delay(0), takeUntil(this.destroy$))
            .subscribe(status => {
            var _a;
            if (status === 'INVALID') {
                if (!this.errorElement) {
                    this.errorElement = document.createElement('div');
                    this.errorElement.className = 'color-red mt-2';
                    this.errorElement.textContent =
                        this.errorMessage || 'Add tag error';
                }
                if (this.dropdown.addTagContainerRef) {
                    this.dropdown.addTagContainerRef.element.nativeElement.parentElement.appendChild(this.errorElement);
                }
            }
            else if ((_a = this.errorElement) === null || _a === void 0 ? void 0 : _a.parentElement) {
                this.errorElement.parentElement.removeChild(this.errorElement);
                this.errorElement = null;
            }
        });
        (_a = this.dropdown.ngSelect) === null || _a === void 0 ? void 0 : _a.searchEvent.pipe(takeUntil(this.destroy$)).subscribe(({ term }) => {
            this.control.setValue(term);
        });
        const addTagFunction = this.dropdown.addTagFunction || this.dropdown.addTagFnImpl;
        const control = this.control;
        this.dropdown.addTagFn = this.dropdown.addTag
            ? function () {
                if (control.valid) {
                    return addTagFunction.apply(this, arguments);
                }
                else {
                    return Promise.resolve(null);
                }
            }
            : undefined;
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
}
DropdownAddTagValidatorDirective.ɵfac = function DropdownAddTagValidatorDirective_Factory(t) { return new (t || DropdownAddTagValidatorDirective)(ɵngcc0.ɵɵdirectiveInject(DropdownComponent)); };
DropdownAddTagValidatorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DropdownAddTagValidatorDirective, selectors: [["lib-dropdown", "libDropdownAddTagValidator", ""]], inputs: { errorMessage: ["libDropdownAddTagErrorMessage", "errorMessage"], validator: ["libDropdownAddTagValidator", "validator"] } });
DropdownAddTagValidatorDirective.ctorParameters = () => [
    { type: DropdownComponent }
];
DropdownAddTagValidatorDirective.propDecorators = {
    validator: [{ type: Input, args: ['libDropdownAddTagValidator',] }],
    errorMessage: [{ type: Input, args: ['libDropdownAddTagErrorMessage',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownAddTagValidatorDirective, [{
        type: Directive,
        args: [{
                selector: 'lib-dropdown[libDropdownAddTagValidator]'
            }]
    }], function () { return [{ type: DropdownComponent }]; }, { errorMessage: [{
            type: Input,
            args: ['libDropdownAddTagErrorMessage']
        }], validator: [{
            type: Input,
            args: ['libDropdownAddTagValidator']
        }] }); })();

let id$1 = 1;
class RadioButtonComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.id = name + `${id$1++}`;
        this.checked = false;
        this.preventDefault = false;
        this.noLabelMargin = false;
        this.change = new EventEmitter();
        this.testId = 'radio';
    }
    set disabled(value) {
        this.setDisabledState(value);
    }
    handleChange() {
        if (this.disabledState || this.preventDefault) {
            return;
        }
        this.onTouched();
        this.onChange(this.value);
        this.change.emit(this.value);
    }
    writeValue(obj) { }
    setDisabledState(isDisabled) {
        this.disabledState = isDisabled;
    }
}
RadioButtonComponent.ɵfac = /*@__PURE__*/ function () { let ɵRadioButtonComponent_BaseFactory; return function RadioButtonComponent_Factory(t) { return (ɵRadioButtonComponent_BaseFactory || (ɵRadioButtonComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(RadioButtonComponent)))(t || RadioButtonComponent); }; }();
RadioButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["lib-radio-button"]], hostAttrs: [1, "lib-radio-button"], inputs: { id: "id", checked: "checked", preventDefault: "preventDefault", noLabelMargin: "noLabelMargin", testId: "testId", disabled: "disabled", name: "name" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c3, decls: 6, vars: 16, consts: [[1, "radio-button-item", 3, "ngClass"], ["type", "radio", 3, "id", "value", "checked", "name", "disabled", "input"], ["controlContainer", ""], [3, "ngClass", "for"], [4, "ngIf"]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("input", function RadioButtonComponent_Template_input_input_1_listener() { return ctx.handleChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtemplate(4, RadioButtonComponent_ng_content_4_Template, 1, 0, "ng-content", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c17, ctx.disabledState));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.id)("value", ctx.value)("checked", ctx.checked)("name", ctx.name)("disabled", ctx.disabledState);
        ɵngcc0.ɵɵattribute("data-test-id", ctx.testId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c18, ctx.disabledState, !ctx.noLabelMargin))("for", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf], styles: [".radio-button-item[_ngcontent-%COMP%]{cursor:pointer;display:flex;height:inherit;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.radio-button-item[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{display:none}.radio-button-item[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;align-items:center;cursor:pointer;display:inline-flex;justify-content:center;margin-bottom:0;margin-right:0;position:relative;user-select:none}.radio-button-item[_ngcontent-%COMP%]   label.margin-icon[_ngcontent-%COMP%]:before{margin-right:7px}.radio-button-item[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:before{background:var(--da-checkbox-background);border:1px solid var(--da-border-and-dividers);border-radius:8px;content:\" \";height:16px;min-width:16px;width:16px}.radio-button-item[_ngcontent-%COMP%]   label.disabled[_ngcontent-%COMP%]{color:var(--da-disable)}.radio-button-item[_ngcontent-%COMP%]   label.disabled[_ngcontent-%COMP%]:before{background:var(--da-checkbox-blackout)}.radio-button-item[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:before{background:var(--da-white);border:6.4px solid var(--da-brand-base);border-radius:8px;height:16px;min-width:16px;width:16px}.radio-button-item[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:not(.disabled):hover:before{border-color:var(--da-brand-hover)}.radio-button-item.disabled[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:before{background:var(--da-radio-disable);border-color:var(--da-checkbox-background-disabled);border-radius:8px;height:16px;min-width:16px;width:16px}.radio-button-item[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]:not(.disabled):hover:before{border-color:var(--da-brand-base)}"] });
RadioButtonComponent.propDecorators = {
    id: [{ type: Input }],
    name: [{ type: Input }],
    checked: [{ type: Input }],
    preventDefault: [{ type: Input }],
    disabled: [{ type: Input }],
    noLabelMargin: [{ type: Input }],
    change: [{ type: Output }],
    testId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{ selector: 'lib-radio-button', template: "<div class=\"radio-button-item\" [ngClass]=\"{ disabled: disabledState }\">\n    <!--    #controlContainer is necessary for base form control-->\n    <input #controlContainer [id]=\"id\" type=\"radio\" [attr.data-test-id]=\"testId\" [value]=\"value\" [checked]=\"checked\" [name]=\"name\" [disabled]=\"disabledState\" (input)=\"handleChange()\"/>\n    <label [ngClass]=\"{ disabled: disabledState, 'margin-icon': !noLabelMargin }\" [for]=\"id\"><ng-content *ngIf=\"!label\"></ng-content>{{label}}</label>\n</div>\n", host: { class: 'lib-radio-button' }, styles: [".radio-button-item{cursor:pointer;display:flex;height:inherit;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.radio-button-item input[type=radio]{display:none}.radio-button-item label{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;align-items:center;cursor:pointer;display:inline-flex;justify-content:center;margin-bottom:0;margin-right:0;position:relative;user-select:none}.radio-button-item label.margin-icon:before{margin-right:7px}.radio-button-item label:before{background:var(--da-checkbox-background);border:1px solid var(--da-border-and-dividers);border-radius:8px;content:\" \";height:16px;min-width:16px;width:16px}.radio-button-item label.disabled{color:var(--da-disable)}.radio-button-item label.disabled:before{background:var(--da-checkbox-blackout)}.radio-button-item input[type=radio]:checked+label:before{background:var(--da-white);border:6.4px solid var(--da-brand-base);border-radius:8px;height:16px;min-width:16px;width:16px}.radio-button-item input[type=radio]:checked+label:not(.disabled):hover:before{border-color:var(--da-brand-hover)}.radio-button-item.disabled input[type=radio]:checked+label:before{background:var(--da-radio-disable);border-color:var(--da-checkbox-background-disabled);border-radius:8px;height:16px;min-width:16px;width:16px}.radio-button-item label:not(.disabled):hover:before{border-color:var(--da-brand-base)}"] }]
    }], null, { id: [{
            type: Input
        }], checked: [{
            type: Input
        }], preventDefault: [{
            type: Input
        }], noLabelMargin: [{
            type: Input
        }], change: [{
            type: Output
        }], testId: [{
            type: Input
        }], disabled: [{
            type: Input
        }], name: [{
            type: Input
        }] }); })();

class OutsideClickDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.clickedOutside = new EventEmitter();
        this.disabledValue = false;
    }
    get disabled() {
        return this.disabledValue;
    }
    set disabled(value) {
        this.disabledValue = value;
    }
    onClick(event) {
        if (this.disabled || !event.target) {
            return;
        }
        // if modal has vertical scrollbar
        if (event.target.offsetWidth < event.offsetX + 25) {
            return;
        }
        // if clicked on context help
        if (event.target.closest('.context-help-wrap')) {
            return;
        }
        // if context help exist
        const contextHelpEls = document.getElementsByClassName('context-help-wrap');
        Object.entries(contextHelpEls).forEach((entry) => {
            const contextHelpEl = entry[1];
            contextHelpEl.parentNode.removeChild(contextHelpEl);
        });
        const eventClassList = event.target.classList;
        const foundBodyItem = eventClassList
            ? eventClassList.value.search('ng-option') !== -1
            : false;
        // .ng-dropdown-panel-items  is necessary for a situation when there is a dropdown,
        // since the dropdown will be attached to the body and this event will emit
        if (!this.elementRef.nativeElement.contains(event.target) &&
            !foundBodyItem &&
            !document.body.querySelector('.ng-dropdown-panel-items') &&
            !document.body.querySelector('.completion-wrapper') &&
            !document.body.querySelector('.edgeops-toast__content') &&
            !document.body.querySelector('.repository-existing-modal') &&
            !document.body.querySelector('.reject-approval-modal') &&
            !document.body.querySelector('.import-confirm-modal')) {
            this.clickedOutside.emit();
        }
    }
}
OutsideClickDirective.ɵfac = function OutsideClickDirective_Factory(t) { return new (t || OutsideClickDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
OutsideClickDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: OutsideClickDirective, selectors: [["", "libOutsideClick", ""]], hostBindings: function OutsideClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function OutsideClickDirective_mousedown_HostBindingHandler($event) { return ctx.onClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, outputs: { clickedOutside: "clickedOutside" } });
OutsideClickDirective.ctorParameters = () => [
    { type: ElementRef }
];
OutsideClickDirective.propDecorators = {
    clickedOutside: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OutsideClickDirective, [{
        type: Directive,
        args: [{
                selector: '[libOutsideClick]',
                host: {
                    '(document:mousedown)': 'onClick($event)'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { clickedOutside: [{
            type: Output
        }] }); })();

class DateTimeModel {
    constructor(init) {
        Object.assign(this, init);
    }
    static fromLocalString(dateString) {
        let date;
        if (typeof dateString === 'string' &&
            dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const [year, month, day] = dateString.split('-');
            date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
        }
        else {
            date = new Date(dateString);
        }
        const isValidDate = !isNaN(date.valueOf());
        if (!date || !isValidDate) {
            return null;
        }
        return new DateTimeModel({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            second: date.getSeconds(),
            timeZoneOffset: date.getTimezoneOffset()
        });
    }
    isInteger(value) {
        return (typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value);
    }
    toString() {
        if (this.isInteger(this.year) &&
            this.isInteger(this.month) &&
            this.isInteger(this.day)) {
            const year = this.year.toString().padStart(2, '0');
            const month = this.month.toString().padStart(2, '0');
            const day = this.day.toString().padStart(2, '0');
            if (!this.hour) {
                this.hour = 0;
            }
            if (!this.minute) {
                this.minute = 0;
            }
            if (!this.second) {
                this.second = 0;
            }
            if (!this.timeZoneOffset) {
                this.timeZoneOffset = new Date().getTimezoneOffset();
            }
            const hour = this.hour.toString().padStart(2, '0');
            const minute = this.minute.toString().padStart(2, '0');
            const second = this.second.toString().padStart(2, '0');
            const tzo = -this.timeZoneOffset;
            const dif = tzo >= 0 ? '+' : '-', pad = function (num) {
                const norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };
            return `${pad(year)}-${pad(month)}-${pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
        }
        return null;
    }
}

const defaultPlaceholder = String('Select Date');
// tslint:disable-next-line:directive-selector
class DatepickerLeftRangeContentDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
DatepickerLeftRangeContentDirective.ɵfac = function DatepickerLeftRangeContentDirective_Factory(t) { return new (t || DatepickerLeftRangeContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
DatepickerLeftRangeContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DatepickerLeftRangeContentDirective, selectors: [["ng-template", "dpLeftRangeContent", ""]] });
DatepickerLeftRangeContentDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerLeftRangeContentDirective, [{
        type: Directive,
        args: [{ selector: 'ng-template[dpLeftRangeContent]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
// tslint:disable-next-line:directive-selector
class DatepickerRightRangeContentDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
DatepickerRightRangeContentDirective.ɵfac = function DatepickerRightRangeContentDirective_Factory(t) { return new (t || DatepickerRightRangeContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
DatepickerRightRangeContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DatepickerRightRangeContentDirective, selectors: [["ng-template", "dpRightRangeContent", ""]] });
DatepickerRightRangeContentDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerRightRangeContentDirective, [{
        type: Directive,
        args: [{ selector: 'ng-template[dpRightRangeContent]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class DatepickerComponent {
    constructor(inj, elRef, ngbDateAdapter, formatter, calendar, zone) {
        this.inj = inj;
        this.elRef = elRef;
        this.ngbDateAdapter = ngbDateAdapter;
        this.formatter = formatter;
        this.calendar = calendar;
        this.zone = zone;
        this.inputDatetimeFormat = 'yyyy-M-d H:mm';
        this.hourStep = 1;
        this.minuteStep = 5;
        this.secondStep = 30;
        this.seconds = false;
        this.labelPosition = 'top';
        this.placeholder = defaultPlaceholder;
        this.isRequired = false;
        this.disabled = false;
        this.height = '32px';
        this.meridian = false;
        this.dateWithTime = false;
        // tslint:disable-next-line:variable-name
        this._disabled = true;
        this.container = 'body';
        this.mode = 'single';
        this.withoutMaxDate = false;
        this.valueChange = new EventEmitter();
        this.selectedDaysCount = 0;
        this.datetime = new DateTimeModel();
        this.onTouched = noop;
        this.onChange = noop;
        this.destroy$ = new Subject();
        this.pristine = true;
        this.range = {
            fromDate: null,
            toDate: null,
            hoveredDate: null,
            isRange(date) {
                return (date.equals(this.fromDate) ||
                    (this.toDate && date.equals(this.toDate)) ||
                    this.isInside(date) ||
                    this.isHovered(date));
            },
            needHover() {
                return this.fromDate && !this.toDate;
            },
            isOutside(date, dp) {
                const firstMonth = dp.model.months[0].firstDate.month;
                const month = date.month;
                if (firstMonth === 12) {
                    return month > 1 && month < 12;
                }
                return month < firstMonth || month > firstMonth + 1;
            },
            isFrom(date) {
                return date.equals(this.fromDate);
            },
            isTo(date) {
                return this.toDate && date.equals(this.toDate);
            },
            isInside(date) {
                return (this.toDate &&
                    date.after(this.fromDate) &&
                    date.before(this.toDate));
            },
            isHovered(date) {
                return (this.fromDate &&
                    !this.toDate &&
                    this.hoveredDate &&
                    date.after(this.fromDate) &&
                    date.before(this.hoveredDate));
            },
            onDateSelection(date) {
                if (!this.fromDate && !this.toDate) {
                    this.fromDate = date;
                }
                else if (this.fromDate &&
                    !this.toDate &&
                    date &&
                    date.after(this.fromDate)) {
                    this.toDate = date;
                }
                else {
                    this.toDate = null;
                    this.fromDate = date;
                }
            },
            defaultInputFormatter: (fromDate, toDate) => {
                const from = fromDate ? this.formatter.format(fromDate) : '';
                const to = toDate ? this.formatter.format(toDate) : '';
                return !from && !to ? '' : `${from} - ${to}`;
            }
        };
    }
    get cssClass() {
        return `d-flex ${this.labelPosition === 'left' ? 'flex-row' : 'flex-column'} lib-datepicker--${this.labelPosition}`;
    }
    static addBackdrop(isSizeS) {
        const backdropTarget = document.body;
        if (backdropTarget && backdropTarget.lastChild) {
            const itemToAdd = document.createElement('div');
            itemToAdd.id = 'popover-backdrop';
            itemToAdd.classList.add('overlay-backdrop', 'backdrop-showing');
            backdropTarget.appendChild(itemToAdd);
        }
        const popup = document.body
            .getElementsByClassName('datepicker-popover')
            .item(0);
        if (!popup) {
            return;
        }
        const boundingClientRect = popup.getBoundingClientRect();
        const padding = 8;
        window.innerWidth - boundingClientRect.left <= 250 ||
            window.innerWidth - boundingClientRect.left - padding <=
                boundingClientRect.width
            ? popup.classList.add('small-screen')
            : popup.classList.remove('small-screen');
        isSizeS
            ? popup.classList.add('size-s')
            : popup.classList.remove('size-s');
    }
    static removeBackdrop() {
        const backdrop = document.getElementById('popover-backdrop');
        if (backdrop) {
            backdrop.remove();
        }
    }
    ngOnInit() {
        if (this.mode === 'range' && this.placeholder === defaultPlaceholder) {
            this.placeholder = 'Select a Range';
        }
        this.closeOnEvents(['wheel']);
        setTimeout(() => {
            this.ngControl = this.inj.get(NgControl);
            if (!this.isRequired) {
                this.checkRequired();
            }
            if (this.ngControl && this.ngControl.control) {
                this.ngControl.control.statusChanges
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(() => this.checkRequired());
            }
        });
    }
    ngOnChanges(changes) {
        if (this.datepickerButton) {
            const props = ['id'];
            props.forEach(prop => {
                if (changes[prop]) {
                    this.datepickerButton.nativeElement[prop] = this[prop];
                }
            });
        }
    }
    checkRequired() {
        if (this.ngControl && this.ngControl.control) {
            const validator = this.ngControl.control.validator;
            if (validator) {
                const validationErrors = validator({});
                this.isRequired = !!(validationErrors && validationErrors.required);
            }
            else {
                this.isRequired = false;
            }
        }
    }
    closeOnEvents(events) {
        if (events && events.length > 0) {
            this.zone.runOutsideAngular(() => {
                const eventStreams$ = [];
                events.forEach(event => {
                    eventStreams$.push(fromEvent(document, event));
                    eventStreams$.push(fromEvent(window, event));
                });
                combineLatest(eventStreams$)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(() => {
                    if ((this.popover && this.popover.isOpen()) ||
                        (this.timePickerPopover &&
                            this.timePickerPopover.isOpen())) {
                        this.zone.run(() => this.closeDialog());
                    }
                });
            });
        }
    }
    onPopoverHidden() {
        this.handleToggleBackdrop(false);
    }
    onPopoverShown() {
        this.handleToggleBackdrop(true);
    }
    handleToggleBackdrop(open) {
        if (open) {
            const isSizeS = this.elRef.nativeElement.classList.contains('size-s');
            DatepickerComponent.addBackdrop(isSizeS);
            if (this.mode === 'single') {
                this.setCurrentDate();
            }
        }
        else {
            DatepickerComponent.removeBackdrop();
            if (this.mode === 'single') {
                this.startDate = null;
            }
        }
    }
    handleNavigate(event) {
        const { month, year } = event.next;
        if (this.datetime.month !== month || this.datetime.year !== year) {
            this.setDayClasses(this.getWeeks(this.getPopup()), false);
            return;
        }
        this.setCurrentDate();
    }
    closeDialog() {
        if (this.popover && this.popover.isOpen()) {
            this.popover.close();
            this.handleToggleBackdrop(false);
        }
        else if (this.timePickerPopover && this.timePickerPopover.isOpen()) {
            this.timePickerPopover.close();
            this.handleToggleBackdrop(false);
        }
    }
    setDayClasses(weeks, add = true) {
        for (let i = 0; i < (weeks === null || weeks === void 0 ? void 0 : weeks.length); i++) {
            const week = weeks.item(i);
            if (week.classList.contains('ngb-dp-weekdays')) {
                continue;
            }
            const days = week.children;
            for (let j = 0; j < days.length; j++) {
                const day = days.item(j).children[0];
                if (day.classList.contains('outside')) {
                    continue;
                }
                if (+day.innerHTML === this.datetime.day) {
                    add
                        ? day.classList.add('bg-primary', 'text-white')
                        : day.classList.remove('bg-primary', 'text-white');
                    return;
                }
            }
        }
    }
    getPopup() {
        return document.body
            .getElementsByClassName('datepicker-popover')
            .item(0);
    }
    getWeeks(popup) {
        var _a, _b;
        return (_b = (_a = popup === null || popup === void 0 ? void 0 : popup.getElementsByTagName('ngb-datepicker-month')) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.children;
    }
    setCurrentDate() {
        const date = new Date(this.dateString || Date.now());
        this.monthName = date.toLocaleString('en-us', {
            month: 'long'
        });
        this.startDate = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        };
        setTimeout(() => {
            var _a;
            const popup = this.getPopup();
            const ngbDpMonthName = (_a = popup === null || popup === void 0 ? void 0 : popup.querySelector('div.ngb-dp-month-name')) === null || _a === void 0 ? void 0 : _a.innerHTML;
            if (!ngbDpMonthName) {
                return;
            }
            const yearIndex = ngbDpMonthName.search(/[0-9]+/);
            const month = ngbDpMonthName.substring(1, yearIndex - 1);
            const year = ngbDpMonthName.substring(yearIndex, ngbDpMonthName.length - 1);
            if (+year < this.datetime.year || this.monthName !== month) {
                return;
            }
            const weeks = this.getWeeks(popup);
            this.setDayClasses(weeks);
        });
    }
    getTodayNgbDate() {
        const nowDate = new Date();
        return {
            day: nowDate.getDate(),
            month: nowDate.getMonth() + 1,
            year: nowDate.getFullYear()
        };
    }
    onInputChange($event) {
        const value = $event.target.value;
        const dt = DateTimeModel.fromLocalString(value);
        this.pristine = false;
        if (dt) {
            this.datetime = dt;
            this.setDateStringModel();
            this._disabled = false;
        }
        else if (value.trim() === '') {
            this.datetime = new DateTimeModel();
            this.dateString = '';
            this.onChange(this.dateString);
        }
        else {
            this.onChange(value);
        }
    }
    onDateChange($event) {
        if (!$event) {
            return;
        }
        this.pristine = false;
        if (this.mode === 'single') {
            this.setDayClasses(this.getWeeks(this.getPopup()), false);
            const renderDelay = 50;
            setTimeout(() => {
                this.closeDialog();
            }, renderDelay);
        }
        setTimeout(() => {
            if ($event.year) {
                $event = `${$event.year}-${$event.month}-${$event.day}`;
            }
            const date = DateTimeModel.fromLocalString($event);
            if (!date) {
                return;
            }
            if (!this.datetime) {
                this.datetime = date;
            }
            this.datetime.year = date.year;
            this.datetime.month = date.month;
            this.datetime.day = date.day;
            this.valueChange.emit(this.datetime.toString());
            this.setDateStringModel();
            this._disabled = false;
        });
    }
    onTimeChange($event) {
        this.datetime.hour = $event.hour;
        this.datetime.minute = $event.minute;
        this.datetime.second = $event.second;
        this.valueChange.emit(this.datetime.toString());
        this.setDateStringModel();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(newModel) {
        if (this.mode === 'range' || this.mode === 'inline-range') {
            newModel = newModel;
            this.range.fromDate = (newModel === null || newModel === void 0 ? void 0 : newModel.startDate) ? this.ngbDateAdapter.fromModel(new Date(newModel.startDate))
                : null;
            this.range.toDate = (newModel === null || newModel === void 0 ? void 0 : newModel.endDate) ? this.ngbDateAdapter.fromModel(new Date(newModel.endDate))
                : null;
            this.updateRangeStr();
            return;
        }
        if (newModel) {
            this.datetime = Object.assign(this.datetime, DateTimeModel.fromLocalString(newModel));
            this.dateString = newModel;
            this.setDateStringModel();
            if (this.mode === 'inline-single') {
                this.setCurrentDate();
            }
        }
        else {
            this.datetime = new DateTimeModel();
        }
    }
    setDateStringModel() {
        this.dateString = this.datetime.toString();
        this.onChange(this.dateString);
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    handleDateRangeSelect(event) {
        this.range.onDateSelection(event);
        this.updateRange();
        this.updateRangeStr();
        if (!this.range.fromDate || !this.range.toDate) {
            return;
        }
        const renderDelay = 50;
        setTimeout(() => {
            this.closeDialog();
        }, renderDelay);
    }
    updateRange() {
        const { fromDate, toDate } = this.range;
        this.onChange({
            startDate: fromDate ? this.ngbDateAdapter.toModel(fromDate) : null,
            endDate: toDate ? this.ngbDateAdapter.toModel(toDate) : null
        });
    }
    validate(control) {
        if (this.mode === 'single' || this.mode === 'inline-single') {
            return null;
        }
        const value = control.value;
        return !value ||
            (!value.startDate &&
                !value.endDate &&
                !this.inputEl.nativeElement.value) ||
            (value.startDate &&
                value.endDate &&
                value.startDate < value.endDate)
            ? null
            : {
                range: true
            };
    }
    inputRangeChanged(input) {
        const parts = (input || '').split(' - ');
        if (parts.length !== 2) {
            this.range.fromDate = this.range.toDate = null;
        }
        else {
            const [fromDateStr, toDateStr] = parts;
            this.range.fromDate = this.convertToNgbDate(fromDateStr);
            this.range.toDate = this.convertToNgbDate(toDateStr);
        }
        this.updateRange();
    }
    convertToNgbDate(date) {
        const parsed = this.formatter.parse(date);
        return parsed && this.calendar.isValid(NgbDate.from(parsed))
            ? NgbDate.from(parsed)
            : null;
    }
    updateRangeStr() {
        const { fromDate, toDate } = this.range;
        this.selectedDaysCount =
            fromDate && toDate
                ? diffNgbDateStruct(fromDate, toDate)
                : fromDate
                    ? 1
                    : 0;
        const formatter = this.rangeInputFormatter || this.range.defaultInputFormatter;
        this.rangeString = formatter(fromDate, toDate);
    }
    clearRange() {
        this.dateString = '';
        if (this.mode === 'range' || this.mode === 'inline-range') {
            this.rangeString = '';
            this.inputRangeChanged('');
        }
        else {
            this.onChange(this.dateString);
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.handleToggleBackdrop(false);
    }
}
DatepickerComponent.ɵfac = function DatepickerComponent_Factory(t) { return new (t || DatepickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbDateAdapter), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbDateParserFormatter), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbCalendar), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
DatepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["lib-datepicker"]], contentQueries: function DatepickerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DatepickerLeftRangeContentDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DatepickerRightRangeContentDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.leftRangeContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rightRangeContent = _t.first);
    } }, viewQuery: function DatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c19, 5);
        ɵngcc0.ɵɵviewQuery(_c20, 5);
        ɵngcc0.ɵɵviewQuery(_c21, 5);
        ɵngcc0.ɵɵviewQuery(_c22, 5);
        ɵngcc0.ɵɵviewQuery(_c23, 5);
        ɵngcc0.ɵɵviewQuery(_c24, 5);
        ɵngcc0.ɵɵviewQuery(_c25, 5);
        ɵngcc0.ɵɵviewQuery(_c26, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dp = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.timePickerPopover = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepickerElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dateRangePickerElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.timePickerElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepickerButton = _t.first);
    } }, hostAttrs: [1, "lib-datepicker"], hostVars: 2, hostBindings: function DatepickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.cssClass);
    } }, inputs: { inputDatetimeFormat: "inputDatetimeFormat", hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", seconds: "seconds", labelPosition: "labelPosition", placeholder: "placeholder", isRequired: "isRequired", disabled: "disabled", height: "height", meridian: "meridian", dateWithTime: "dateWithTime", _disabled: "_disabled", container: "container", mode: "mode", withoutMaxDate: "withoutMaxDate", dateString: "dateString", id: "id", label: "label", rangeInputFormatter: "rangeInputFormatter", model: ["ngModel", "model"] }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DatepickerComponent),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: DatepickerComponent,
                multi: true
            },
            {
                provide: NgbDateAdapter,
                useClass: NgbDateNativeAdapter
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 4, consts: [["class", "label", 3, "disabled", 4, "ngIf"], ["class", "datepicker-wrapper", 4, "ngIf"], ["class", "datepicker-popover", 4, "ngIf"], ["datepicker", ""], ["dateRangePicker", ""], ["timepicker", ""], ["timepickerPopoverTitle", ""], [1, "label"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "datepicker-wrapper"], [1, "input-group", "custom-datepicker-group"], [1, "form-control", "control", 3, "placeholder", "readOnly", "ngClass", "value", "disabled", "change", "input"], ["inputEl", ""], [1, "input-group-append"], ["class", "btn btn-link", 3, "click", 4, "ngIf"], ["type", "button", "popoverClass", "datepicker-popover", 1, "btn", "btn-link", "control", "mt-auto", "mb-auto", 3, "ngClass", "autoClose", "container", "ngbPopover", "animation", "placement", "hidden", "shown"], ["datepickerButton", "", "popover", "ngbPopover"], ["icon", "calendar", 1, "fa", "icons", "font-13px"], ["class", "btn btn-link control my-auto", "type", "button", "popoverClass", "timepicker-popover", 3, "disabled", "autoClose", "container", "popoverTitle", "ngbPopover", "hidden", "shown", 4, "ngIf"], [1, "btn", "btn-link", 3, "click"], ["icon", "times", 1, "fa", "icons", "font-13px"], ["type", "button", "popoverClass", "timepicker-popover", 1, "btn", "btn-link", "control", "my-auto", 3, "disabled", "autoClose", "container", "popoverTitle", "ngbPopover", "hidden", "shown"], ["timePickerPopover", "ngbPopover"], ["icon", "clock", 1, "fa", "icons", "icon-clock", "font-12px"], [1, "datepicker-popover"], [3, "ngTemplateOutlet"], [3, "startDate", "navigation", "maxDate", "ngModel", "navigate", "ngModelChange"], [1, "date-range-picker-popup", 3, "startDate", "navigation", "ngModel", "dayTemplate", "displayMonths", "dateSelect"], ["dp", ""], ["ngbDatepickerContent", ""], ["dayTmpl", ""], [1, "d-flex", 3, "dp", "leftTemplate", "rightTemplate"], [1, "custom-day", 3, "mouseenter", "mouseleave"], [3, "seconds", "meridian", "hourStep", "minuteStep", "secondStep", "ngModel", "ngModelChange"], [1, "timepicker-popover-title"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DatepickerComponent_label_0_Template, 3, 4, "label", 0);
        ɵngcc0.ɵɵtemplate(1, DatepickerComponent_div_1_Template, 12, 24, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DatepickerComponent_div_2_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DatepickerComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, DatepickerComponent_ng_template_4_Template, 1, 4, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, DatepickerComponent_ng_template_6_Template, 5, 5, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, DatepickerComponent_ng_template_8_Template, 1, 6, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, DatepickerComponent_ng_template_10_Template, 2, 0, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode !== "inline-range" && ctx.mode !== "inline-single");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode === "inline-range");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode === "inline-single");
    } }, dependencies: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.NgbDatepicker, ɵngcc5.NgbDatepickerContent, ɵngcc5.NgbPopover, ɵngcc5.NgbTimepicker, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, DatepickerRangeDialogComponent, ɵngcc2.DatePipe]; }, styles: ["@charset \"UTF-8\";.form-control[_ngcontent-%COMP%]:focus{border-color:initial;box-shadow:none;outline:0!important}.control[_ngcontent-%COMP%]{font-weight:400;height:calc(100% - 2px)!important;line-height:15px}.label[_ngcontent-%COMP%]{color:var(--da-title);display:block;font-size:11px;margin-bottom:7px}.label.disabled[_ngcontent-%COMP%], .label[_ngcontent-%COMP%]   .mandatory[_ngcontent-%COMP%]{color:var(--da-disable)}.lib-datepicker--left[_nghost-%COMP%]{align-items:center}.lib-datepicker--left[_nghost-%COMP%]   .input-group[_ngcontent-%COMP%]{flex-grow:1;margin-left:5px}.lib-datepicker--left[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{margin-bottom:0}.input-group-append[_ngcontent-%COMP%]{height:inherit!important}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{box-shadow:none;height:calc(100% - 2px)!important;z-index:0!important}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:hover{background:none}.mandatory[_ngcontent-%COMP%]{color:var(--da-error-base)!important}.custom-datepicker-group[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;color:#515151;flex-wrap:nowrap!important}.custom-datepicker-group[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{color:var(--da-brand-base)}.custom-datepicker-group[_ngcontent-%COMP%]   .icons.disabled[_ngcontent-%COMP%]{color:var(--da-disable)}.custom-datepicker-group[_ngcontent-%COMP%]   .icon-clock[_ngcontent-%COMP%]{margin-top:-2px}.custom-datepicker-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0 5px!important}.custom-datepicker-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);border:0!important;color:var(--da-primary-text);margin-top:1px}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within{border:4px solid var(--da-brand-20);width:calc(100% + 3px)}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within   .form-control[_ngcontent-%COMP%]{margin-right:-3px;padding-bottom:0;padding-left:9px;padding-top:0}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within   .input-group-append[_ngcontent-%COMP%]{margin-top:-3px}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active, [_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover{border:1px solid var(--da-brand-base);width:100%}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active   .form-control[_ngcontent-%COMP%], [_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover   .form-control[_ngcontent-%COMP%]{margin-right:0;padding:6px 12px}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active   .input-group-append[_ngcontent-%COMP%], [_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover   .input-group-append[_ngcontent-%COMP%]{margin-top:0}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group.disabled[_ngcontent-%COMP%]{background:rgba(0,0,0,.04);border-color:var(--da-border-and-dividers);color:var(--da-disable)}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], [_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]{background:none;border:0!important;color:var(--da-disable)}[_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%], [_nghost-%COMP%]:not(.ng-invalid)   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{color:var(--da-disable);cursor:default}.ng-invalid[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.pristine){border-color:var(--da-error-base)!important}.ng-invalid[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.pristine)   .icons[_ngcontent-%COMP%]{color:var(--da-error-base)}.timepicker-popover-title[_ngcontent-%COMP%]{color:var(--da-title);font-size:12px;text-align:center!important}  .small-screen{left:-50px!important}  .small-screen .arrow{left:72%!important}  .datepicker-popover.popover,   .timepicker-popover.popover{background:var(--da-cards-and-blocks)}  .timepicker-popover .popover-header{border-bottom-color:var(--da-border-and-dividers);color:var(--da-title)}  .timepicker-popover .form-control,   .timepicker-popover .popover-header{background:var(--da-background)}  .timepicker-popover .form-control{color:var(--da-primary-text)}  .datepicker-popover{border-radius:4px;box-shadow:var(--da-soft-default-shadow);max-width:none}  .datepicker-popover .arrow{display:none}  .datepicker-popover .ngb-dp-month-name,   .datepicker-popover ngb-datepicker{font-size:14px!important;line-height:18px!important}  .datepicker-popover.size-s *{font-size:12px!important;line-height:16px!important}  .datepicker-popover.size-s .ngb-dp-week .ngb-dp-day,   .datepicker-popover.size-s .ngb-dp-week .ngb-dp-weekday{height:32px!important;width:32px!important}  .datepicker-popover ngb-datepicker{border-color:var(--da-border-and-dividers);border-radius:2px}  .datepicker-popover .ngb-dp-day{outline:none}  .datepicker-popover .ngb-dp-day>.text-white,   .datepicker-popover .ngb-dp-day>.text-white:hover{background:var(--da-brand-base)!important}  .datepicker-popover .btn-link:hover{background:none!important}  .datepicker-popover .ngb-dp-month-name{align-items:center;color:var(--da-title);cursor:pointer;display:flex;flex-direction:row;font-size:13px;font-weight:600;height:2em;line-height:18px}  .datepicker-popover .ngb-dp-weekdays{background:var(--da-table-header)}  .datepicker-popover .ngb-dp-weekdays .ngb-dp-weekday{align-items:center;color:var(--da-primary-text);display:flex;flex-direction:row;font-size:11px;font-style:normal;justify-content:center;line-height:15px;text-align:center;text-transform:uppercase}  .datepicker-popover .ngb-tp-chevron:before{border:none!important;content:\"\uF107\";font:normal normal normal 18px/1 FontAwesome,sans-serif;transform:rotate(180deg);vertical-align:0!important}  .datepicker-popover .ngb-tp-chevron.bottom:before{top:.1em;transform:rotate(1turn)}  .datepicker-popover .ngb-dp-arrow{color:var(--da-primary-text);font-size:12px}  .datepicker-popover .ngb-dp-arrow button.ngb-dp-arrow-btn{display:flex;flex-direction:row;height:calc(100% - 4px)!important;margin:0 8px 0 auto;padding:0!important}  .datepicker-popover .ngb-dp-arrow button.ngb-dp-arrow-btn .ngb-dp-navigation-chevron{color:var(--da-brand-base);font-size:10px}  .datepicker-popover .ngb-dp-arrow button.ngb-dp-arrow-btn .ngb-dp-arrow-btn:focus{outline:none!important}  .datepicker-popover .ngb-dp-arrow.right .ngb-dp-arrow-btn{margin:0 auto 0 8px}  .datepicker-popover .ngb-dp-week .ngb-dp-day,   .datepicker-popover .ngb-dp-week .ngb-dp-weekday{height:40px!important;width:40px!important}  .datepicker-popover .ngb-dp-week .ngb-dp-day *,   .datepicker-popover .ngb-dp-week .ngb-dp-weekday *{color:var(--da-primary-text)}  .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light,   .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light{align-items:center;display:flex;font-weight:400!important;height:inherit;justify-content:center;width:auto}  .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light:hover:not(.outside),   .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light:hover:not(.outside){color:var(--da-brand-base)!important}  .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light.outside,   .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light:hover,   .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light.outside,   .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light:hover{background:var(--da-cards-and-blocks)!important}  .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light.active:not(.outside),   .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light.active:not(.outside){background:var(--da-brand-base)!important;color:#fff!important}  .datepicker-popover .selected{background:var(--da-brand-base);color:var(--da-cards-and-blocks)!important}  .datepicker-popover .popover-body{padding:0}  .datepicker-popover .ngb-dp-header,   .datepicker-popover ngb-datepicker{border:none}  .datepicker-popover .ngb-dp-header,   .datepicker-popover .ngb-dp-weekdays{background:var(--da-table-header)}  .datepicker-popover .ngb-dp-navigation-chevron{margin-top:5px}  .datepicker-popover .ngb-dp-header{line-height:16px!important;padding-top:.25rem}  .datepicker-popover .ngb-dp-header .ngb-dp-month-name{color:var(--da-title);font-weight:400}  .datepicker-popover .ngb-dp-week{padding:0 8px!important}  .datepicker-popover .ngb-dp-week:last-child{margin-bottom:8px}  .datepicker-popover .date-range-picker-popup .ngb-dp-week{padding:0 16px!important}  .datepicker-popover .date-range-picker-popup .ngb-dp-weekdays{margin-bottom:8px}  .datepicker-popover .ngb-tp{padding:.5rem .75rem}  .datepicker-popover .btn-light:hover{background-color:var(--da-cards-and-blocks);border-color:var(--da-cards-and-blocks);border-radius:.25rem;color:var(--da-primary-text);font-weight:600}  .datepicker-popover .custom-day{align-items:center;background:transparent;border-radius:.25rem;display:flex;height:inherit;justify-content:center;text-align:center;width:auto}  .datepicker-popover .custom-day.focused{background-color:var(--da-background)}  .datepicker-popover .custom-day.outside{background:var(--da-cards-and-blocks)!important;color:var(--da-disable)!important}  .datepicker-popover .custom-day.range.from-date,   .datepicker-popover .custom-day.range.to-date{background-color:var(--da-brand-base);color:#fff}  .datepicker-popover .custom-day.range.from-date{border-radius:4px 0 0 4px}  .datepicker-popover .custom-day.range.to-date{border-radius:0 4px 4px 0}  .datepicker-popover .custom-day.has-from-date:hover{color:var(--da-brand-base)}  .datepicker-popover .custom-day.need-hover:not(.outside):hover{background:var(--da-cards-and-blocks);border:1px solid var(--da-brand-base);color:var(--da-brand-base)}  .datepicker-popover .custom-day.faded{background:var(--da-brand-12);border-radius:0;color:var(--da-brand-base)}  .datepicker-popover .custom-day.faded:hover{background:var(--da-cards-and-blocks);border:1px solid var(--da-brand-base);border-radius:4px;color:var(--da-brand-base)}  .datepicker-popover .custom-day.from-date,   .datepicker-popover .custom-day.to-date{position:relative}  .datepicker-popover .custom-day.from-date:before,   .datepicker-popover .custom-day.to-date:before{background:var(--da-brand-hover);bottom:0;content:\"\";position:absolute;top:0;width:4px;z-index:-1}  .datepicker-popover .custom-day.from-date:before{right:0}  .datepicker-popover .custom-day.to:before{left:0}@media (max-width:600px){  .datepicker-popover{left:-50px!important}  .datepicker-popover .arrow{left:72%!important}  .timepicker-popover{left:-50px!important}  .timepicker-popover .arrow{left:80%!important}  .date-range-picker-popup{max-width:280px;overflow-x:auto}}"] });
DatepickerComponent.ctorParameters = () => [
    { type: Injector },
    { type: ElementRef },
    { type: NgbDateAdapter },
    { type: NgbDateParserFormatter },
    { type: NgbCalendar },
    { type: NgZone }
];
DatepickerComponent.propDecorators = {
    dp: [{ type: ViewChild, args: ['dp',] }],
    inputEl: [{ type: ViewChild, args: ['inputEl',] }],
    popover: [{ type: ViewChild, args: ['popover',] }],
    timePickerPopover: [{ type: ViewChild, args: ['timePickerPopover',] }],
    datepickerElementRef: [{ type: ViewChild, args: ['datepicker',] }],
    dateRangePickerElementRef: [{ type: ViewChild, args: ['dateRangePicker',] }],
    timePickerElementRef: [{ type: ViewChild, args: ['timepicker',] }],
    datepickerButton: [{ type: ViewChild, args: ['datepickerButton', { static: true },] }],
    id: [{ type: Input }],
    dateString: [{ type: Input }],
    inputDatetimeFormat: [{ type: Input }],
    hourStep: [{ type: Input }],
    minuteStep: [{ type: Input }],
    secondStep: [{ type: Input }],
    seconds: [{ type: Input }],
    label: [{ type: Input }],
    labelPosition: [{ type: Input }],
    placeholder: [{ type: Input }],
    isRequired: [{ type: Input }],
    disabled: [{ type: Input }],
    height: [{ type: Input }],
    meridian: [{ type: Input }],
    dateWithTime: [{ type: Input }],
    _disabled: [{ type: Input }],
    container: [{ type: Input }],
    mode: [{ type: Input }],
    rangeInputFormatter: [{ type: Input }],
    withoutMaxDate: [{ type: Input }],
    model: [{ type: Input, args: ['ngModel',] }],
    leftRangeContent: [{ type: ContentChild, args: [DatepickerLeftRangeContentDirective,] }],
    rightRangeContent: [{ type: ContentChild, args: [DatepickerRightRangeContentDirective,] }],
    cssClass: [{ type: HostBinding, args: ['class',] }],
    valueChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{ selector: 'lib-datepicker', template: "<label *ngIf=\"label\" class=\"label\" [class.disabled]=\"disabled\"\n    >{{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n</label>\n<div class=\"datepicker-wrapper\" *ngIf=\"mode !== 'inline-range' && mode !== 'inline-single'\">\n    <div\n        class=\"input-group custom-datepicker-group\"\n        [class.disabled]=\"disabled\"\n        [class.pristine]=\"pristine\"\n    >\n        <input\n            #inputEl\n            [placeholder]=\"placeholder\"\n            [readOnly]=\"!!rangeInputFormatter\"\n            [ngClass]=\"ngControl?.valid ? 'ng-valid' : 'ng-invalid'\"\n            class=\"form-control control\"\n            [value]=\"\n                mode === 'single'\n                    ? dateString != ''\n                        ? (dateString | date: inputDatetimeFormat)\n                        : ''\n                    : rangeString\n            \"\n            (change)=\"mode === 'single' && onInputChange($event)\"\n            (input)=\"\n                mode === 'range' && inputRangeChanged($any($event.target).value)\n            \"\n            [disabled]=\"disabled\"\n        />\n        <div class=\"input-group-append\" [style.height]=\"height\">\n            <button\n                *ngIf=\"inputEl.value\"\n                class=\"btn btn-link\"\n                (click)=\"inputEl.value = ''; clearRange()\"\n            >\n                <fa-icon class=\"fa icons font-13px\" icon=\"times\"></fa-icon>\n            </button>\n            <button\n                #datepickerButton\n                class=\"btn btn-link control mt-auto mb-auto\"\n                [ngClass]=\"{ 'mr-5px': !dateWithTime }\"\n                type=\"button\"\n                #popover=\"ngbPopover\"\n                [autoClose]=\"'outside'\"\n                [container]=\"container\"\n                popoverClass=\"datepicker-popover\"\n                [ngbPopover]=\"mode === 'single' ? datepicker : dateRangePicker\"\n                [animation]=\"false\"\n                [placement]=\"mode === 'single' ? 'bottom' : 'auto'\"\n                (hidden)=\"onPopoverHidden()\"\n                (shown)=\"onPopoverShown()\"\n            >\n                <fa-icon class=\"fa icons font-13px\" icon=\"calendar\"></fa-icon>\n            </button>\n            <button\n                *ngIf=\"dateWithTime\"\n                class=\"btn btn-link control my-auto\"\n                type=\"button\"\n                [disabled]=\"_disabled\"\n                #timePickerPopover=\"ngbPopover\"\n                popoverClass=\"timepicker-popover\"\n                [autoClose]=\"'outside'\"\n                [container]=\"container\"\n                [popoverTitle]=\"timepickerPopoverTitle\"\n                [ngbPopover]=\"timepicker\"\n                (hidden)=\"onPopoverHidden()\"\n                (shown)=\"onPopoverShown()\"\n            >\n                <fa-icon\n                    class=\"fa icons icon-clock font-12px\"\n                    icon=\"clock\"\n                    [class.disabled]=\"_disabled\"\n                ></fa-icon>\n            </button>\n        </div>\n    </div>\n</div>\n\n<div *ngIf=\"mode ==='inline-range'\" class=\"datepicker-popover\">\n    <ng-template [ngTemplateOutlet]=\"dateRangePicker\"></ng-template>\n</div>\n<div *ngIf=\"mode ==='inline-single'\" class=\"datepicker-popover\">\n    <ng-template [ngTemplateOutlet]=\"datepicker\"></ng-template>\n</div>\n<ng-template #datepicker>\n    <ngb-datepicker\n        [startDate]=\"this.startDate || getTodayNgbDate()\"\n        [navigation]=\"'arrows'\"\n        [maxDate]=\"!withoutMaxDate ? getTodayNgbDate() : null\"\n        [ngModel]=\"datetime\"\n        (navigate)=\"handleNavigate($event)\"\n        (ngModelChange)=\"onDateChange($event)\"\n    >\n    </ngb-datepicker>\n</ng-template>\n<ng-template #dateRangePicker>\n    <ngb-datepicker\n        #dp\n        class=\"date-range-picker-popup\"\n        [startDate]=\"range.fromDate || getTodayNgbDate()\"\n        [navigation]=\"'none'\"\n        [ngModel]=\"datetime\"\n        [dayTemplate]=\"dayTmpl\"\n        [displayMonths]=\"2\"\n        (dateSelect)=\"handleDateRangeSelect($event)\"\n    >\n        <ng-template ngbDatepickerContent>\n            <lib-datepicker-range-dialog\n                [dp]=\"dp\"\n                class=\"d-flex\"\n                [leftTemplate]=\"\n                    leftRangeContent ? leftRangeContent.templateRef : null\n                \"\n                [rightTemplate]=\"\n                    rightRangeContent ? rightRangeContent.templateRef : null\n                \"\n            ></lib-datepicker-range-dialog>\n        </ng-template>\n    </ngb-datepicker>\n    <ng-template\n        #dayTmpl\n        let-date\n        let-focused=\"focused\"\n        let-selected=\"selected\"\n    >\n        <div\n            class=\"custom-day\"\n            [class.text-white]=\"selected\"\n            [class.focused]=\"focused\"\n            [class.range]=\"range.isRange(date)\"\n            [class.from-date]=\"range.isFrom(date)\"\n            [class.to-date]=\"range.isTo(date)\"\n            [class.need-hover]=\"range.needHover()\"\n            [class.outside]=\"range.isOutside(date, dp)\"\n            [class.faded]=\"range.isHovered(date) || range.isInside(date)\"\n            (mouseenter)=\"range.hoveredDate = date\"\n            (mouseleave)=\"range.hoveredDate = null\"\n        >\n            {{ date.day }}\n        </div>\n    </ng-template>\n</ng-template>\n\n<ng-template #timepicker>\n    <ngb-timepicker\n        [seconds]=\"seconds\"\n        [meridian]=\"meridian\"\n        [hourStep]=\"hourStep\"\n        [minuteStep]=\"minuteStep\"\n        [secondStep]=\"secondStep\"\n        [ngModel]=\"datetime\"\n        (ngModelChange)=\"onTimeChange($event)\"\n    >\n    </ngb-timepicker>\n</ng-template>\n\n<ng-template #timepickerPopoverTitle>\n    <div class=\"timepicker-popover-title\">\n        TIME\n    </div>\n</ng-template>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DatepickerComponent),
                        multi: true
                    },
                    {
                        provide: NG_VALIDATORS,
                        useExisting: DatepickerComponent,
                        multi: true
                    },
                    {
                        provide: NgbDateAdapter,
                        useClass: NgbDateNativeAdapter
                    }
                ], host: { class: 'lib-datepicker' }, styles: ["@charset \"UTF-8\";.form-control:focus{border-color:initial;box-shadow:none;outline:0!important}.control{font-weight:400;height:calc(100% - 2px)!important;line-height:15px}.label{color:var(--da-title);display:block;font-size:11px;margin-bottom:7px}.label.disabled,.label .mandatory{color:var(--da-disable)}:host.lib-datepicker--left{align-items:center}:host.lib-datepicker--left .input-group{flex-grow:1;margin-left:5px}:host.lib-datepicker--left .label{margin-bottom:0}.input-group-append{height:inherit!important}.input-group-append .btn{box-shadow:none;height:calc(100% - 2px)!important;z-index:0!important}.input-group-append .btn:hover{background:none}.mandatory{color:var(--da-error-base)!important}.custom-datepicker-group{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;color:#515151;flex-wrap:nowrap!important}.custom-datepicker-group .icons{color:var(--da-brand-base)}.custom-datepicker-group .icons.disabled{color:var(--da-disable)}.custom-datepicker-group .icon-clock{margin-top:-2px}.custom-datepicker-group button{padding:0 5px!important}.custom-datepicker-group .form-control{background:var(--da-cards-and-blocks);border:0!important;color:var(--da-primary-text);margin-top:1px}:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):focus-within{border:4px solid var(--da-brand-20);width:calc(100% + 3px)}:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):focus-within .form-control{margin-right:-3px;padding-bottom:0;padding-left:9px;padding-top:0}:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):focus-within .input-group-append{margin-top:-3px}:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):active,:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):hover{border:1px solid var(--da-brand-base);width:100%}:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):active .form-control,:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):hover .form-control{margin-right:0;padding:6px 12px}:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):active .input-group-append,:host:not(.ng-invalid) .custom-datepicker-group:not(.disabled):hover .input-group-append{margin-top:0}:host:not(.ng-invalid) .custom-datepicker-group.disabled{background:rgba(0,0,0,.04);border-color:var(--da-border-and-dividers);color:var(--da-disable)}:host:not(.ng-invalid) .custom-datepicker-group.disabled .form-control,:host:not(.ng-invalid) .custom-datepicker-group.disabled .input-group-append{background:none;border:0!important;color:var(--da-disable)}:host:not(.ng-invalid) .custom-datepicker-group.disabled .form-control .icons,:host:not(.ng-invalid) .custom-datepicker-group.disabled .input-group-append .icons{color:var(--da-disable);cursor:default}:host.ng-invalid .custom-datepicker-group:not(.pristine){border-color:var(--da-error-base)!important}:host.ng-invalid .custom-datepicker-group:not(.pristine) .icons{color:var(--da-error-base)}.timepicker-popover-title{color:var(--da-title);font-size:12px;text-align:center!important}::ng-deep .small-screen{left:-50px!important}::ng-deep .small-screen .arrow{left:72%!important}::ng-deep .datepicker-popover.popover,::ng-deep .timepicker-popover.popover{background:var(--da-cards-and-blocks)}::ng-deep .timepicker-popover .popover-header{border-bottom-color:var(--da-border-and-dividers);color:var(--da-title)}::ng-deep .timepicker-popover .form-control,::ng-deep .timepicker-popover .popover-header{background:var(--da-background)}::ng-deep .timepicker-popover .form-control{color:var(--da-primary-text)}::ng-deep .datepicker-popover{border-radius:4px;box-shadow:var(--da-soft-default-shadow);max-width:none}::ng-deep .datepicker-popover .arrow{display:none}::ng-deep .datepicker-popover .ngb-dp-month-name,::ng-deep .datepicker-popover ngb-datepicker{font-size:14px!important;line-height:18px!important}::ng-deep .datepicker-popover.size-s *{font-size:12px!important;line-height:16px!important}::ng-deep .datepicker-popover.size-s .ngb-dp-week .ngb-dp-day,::ng-deep .datepicker-popover.size-s .ngb-dp-week .ngb-dp-weekday{height:32px!important;width:32px!important}::ng-deep .datepicker-popover ngb-datepicker{border-color:var(--da-border-and-dividers);border-radius:2px}::ng-deep .datepicker-popover .ngb-dp-day{outline:none}::ng-deep .datepicker-popover .ngb-dp-day>.text-white,::ng-deep .datepicker-popover .ngb-dp-day>.text-white:hover{background:var(--da-brand-base)!important}::ng-deep .datepicker-popover .btn-link:hover{background:none!important}::ng-deep .datepicker-popover .ngb-dp-month-name{align-items:center;color:var(--da-title);cursor:pointer;display:flex;flex-direction:row;font-size:13px;font-weight:600;height:2em;line-height:18px}::ng-deep .datepicker-popover .ngb-dp-weekdays{background:var(--da-table-header)}::ng-deep .datepicker-popover .ngb-dp-weekdays .ngb-dp-weekday{align-items:center;color:var(--da-primary-text);display:flex;flex-direction:row;font-size:11px;font-style:normal;justify-content:center;line-height:15px;text-align:center;text-transform:uppercase}::ng-deep .datepicker-popover .ngb-tp-chevron:before{border:none!important;content:\"\uF107\";font:normal normal normal 18px/1 FontAwesome,sans-serif;transform:rotate(180deg);vertical-align:0!important}::ng-deep .datepicker-popover .ngb-tp-chevron.bottom:before{top:.1em;transform:rotate(1turn)}::ng-deep .datepicker-popover .ngb-dp-arrow{color:var(--da-primary-text);font-size:12px}::ng-deep .datepicker-popover .ngb-dp-arrow button.ngb-dp-arrow-btn{display:flex;flex-direction:row;height:calc(100% - 4px)!important;margin:0 8px 0 auto;padding:0!important}::ng-deep .datepicker-popover .ngb-dp-arrow button.ngb-dp-arrow-btn .ngb-dp-navigation-chevron{color:var(--da-brand-base);font-size:10px}::ng-deep .datepicker-popover .ngb-dp-arrow button.ngb-dp-arrow-btn .ngb-dp-arrow-btn:focus{outline:none!important}::ng-deep .datepicker-popover .ngb-dp-arrow.right .ngb-dp-arrow-btn{margin:0 auto 0 8px}::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day,::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday{height:40px!important;width:40px!important}::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day *,::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday *{color:var(--da-primary-text)}::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light,::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light{align-items:center;display:flex;font-weight:400!important;height:inherit;justify-content:center;width:auto}::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light:hover:not(.outside),::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light:hover:not(.outside){color:var(--da-brand-base)!important}::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light.outside,::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light:hover,::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light.outside,::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light:hover{background:var(--da-cards-and-blocks)!important}::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-day .btn-light.active:not(.outside),::ng-deep .datepicker-popover .ngb-dp-week .ngb-dp-weekday .btn-light.active:not(.outside){background:var(--da-brand-base)!important;color:#fff!important}::ng-deep .datepicker-popover .selected{background:var(--da-brand-base);color:var(--da-cards-and-blocks)!important}::ng-deep .datepicker-popover .popover-body{padding:0}::ng-deep .datepicker-popover .ngb-dp-header,::ng-deep .datepicker-popover ngb-datepicker{border:none}::ng-deep .datepicker-popover .ngb-dp-header,::ng-deep .datepicker-popover .ngb-dp-weekdays{background:var(--da-table-header)}::ng-deep .datepicker-popover .ngb-dp-navigation-chevron{margin-top:5px}::ng-deep .datepicker-popover .ngb-dp-header{line-height:16px!important;padding-top:.25rem}::ng-deep .datepicker-popover .ngb-dp-header .ngb-dp-month-name{color:var(--da-title);font-weight:400}::ng-deep .datepicker-popover .ngb-dp-week{padding:0 8px!important}::ng-deep .datepicker-popover .ngb-dp-week:last-child{margin-bottom:8px}::ng-deep .datepicker-popover .date-range-picker-popup .ngb-dp-week{padding:0 16px!important}::ng-deep .datepicker-popover .date-range-picker-popup .ngb-dp-weekdays{margin-bottom:8px}::ng-deep .datepicker-popover .ngb-tp{padding:.5rem .75rem}::ng-deep .datepicker-popover .btn-light:hover{background-color:var(--da-cards-and-blocks);border-color:var(--da-cards-and-blocks);border-radius:.25rem;color:var(--da-primary-text);font-weight:600}::ng-deep .datepicker-popover .custom-day{align-items:center;background:transparent;border-radius:.25rem;display:flex;height:inherit;justify-content:center;text-align:center;width:auto}::ng-deep .datepicker-popover .custom-day.focused{background-color:var(--da-background)}::ng-deep .datepicker-popover .custom-day.outside{background:var(--da-cards-and-blocks)!important;color:var(--da-disable)!important}::ng-deep .datepicker-popover .custom-day.range.from-date,::ng-deep .datepicker-popover .custom-day.range.to-date{background-color:var(--da-brand-base);color:#fff}::ng-deep .datepicker-popover .custom-day.range.from-date{border-radius:4px 0 0 4px}::ng-deep .datepicker-popover .custom-day.range.to-date{border-radius:0 4px 4px 0}::ng-deep .datepicker-popover .custom-day.has-from-date:hover{color:var(--da-brand-base)}::ng-deep .datepicker-popover .custom-day.need-hover:not(.outside):hover{background:var(--da-cards-and-blocks);border:1px solid var(--da-brand-base);color:var(--da-brand-base)}::ng-deep .datepicker-popover .custom-day.faded{background:var(--da-brand-12);border-radius:0;color:var(--da-brand-base)}::ng-deep .datepicker-popover .custom-day.faded:hover{background:var(--da-cards-and-blocks);border:1px solid var(--da-brand-base);border-radius:4px;color:var(--da-brand-base)}::ng-deep .datepicker-popover .custom-day.from-date,::ng-deep .datepicker-popover .custom-day.to-date{position:relative}::ng-deep .datepicker-popover .custom-day.from-date:before,::ng-deep .datepicker-popover .custom-day.to-date:before{background:var(--da-brand-hover);bottom:0;content:\"\";position:absolute;top:0;width:4px;z-index:-1}::ng-deep .datepicker-popover .custom-day.from-date:before{right:0}::ng-deep .datepicker-popover .custom-day.to:before{left:0}@media (max-width:600px){::ng-deep .datepicker-popover{left:-50px!important}::ng-deep .datepicker-popover .arrow{left:72%!important}::ng-deep .timepicker-popover{left:-50px!important}::ng-deep .timepicker-popover .arrow{left:80%!important}::ng-deep .date-range-picker-popup{max-width:280px;overflow-x:auto}}"] }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ElementRef }, { type: ɵngcc5.NgbDateAdapter }, { type: ɵngcc5.NgbDateParserFormatter }, { type: ɵngcc5.NgbCalendar }, { type: ɵngcc0.NgZone }]; }, { inputDatetimeFormat: [{
            type: Input
        }], hourStep: [{
            type: Input
        }], minuteStep: [{
            type: Input
        }], secondStep: [{
            type: Input
        }], seconds: [{
            type: Input
        }], labelPosition: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], isRequired: [{
            type: Input
        }], disabled: [{
            type: Input
        }], height: [{
            type: Input
        }], meridian: [{
            type: Input
        }], dateWithTime: [{
            type: Input
        }], _disabled: [{
            type: Input
        }], container: [{
            type: Input
        }], mode: [{
            type: Input
        }], withoutMaxDate: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], cssClass: [{
            type: HostBinding,
            args: ['class']
        }], dateString: [{
            type: Input
        }], dp: [{
            type: ViewChild,
            args: ['dp']
        }], inputEl: [{
            type: ViewChild,
            args: ['inputEl']
        }], popover: [{
            type: ViewChild,
            args: ['popover']
        }], timePickerPopover: [{
            type: ViewChild,
            args: ['timePickerPopover']
        }], datepickerElementRef: [{
            type: ViewChild,
            args: ['datepicker']
        }], dateRangePickerElementRef: [{
            type: ViewChild,
            args: ['dateRangePicker']
        }], timePickerElementRef: [{
            type: ViewChild,
            args: ['timepicker']
        }], datepickerButton: [{
            type: ViewChild,
            args: ['datepickerButton', { static: true }]
        }], id: [{
            type: Input
        }], label: [{
            type: Input
        }], rangeInputFormatter: [{
            type: Input
        }], model: [{
            type: Input,
            args: ['ngModel']
        }], leftRangeContent: [{
            type: ContentChild,
            args: [DatepickerLeftRangeContentDirective]
        }], rightRangeContent: [{
            type: ContentChild,
            args: [DatepickerRightRangeContentDirective]
        }] }); })();
function diffNgbDateStruct(from, to) {
    const fromDate = new Date(from.year, from.month - 1, from.day);
    const toDate = new Date(to.year, to.month - 1, to.day);
    return (Math.round((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1);
}

class DatepickerAdapterComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.labelPosition = 'top';
        this.placeholder = 'Select Date';
        this.hideTodayButton = false;
        this.dateWithTime = false;
        this.disabled = false;
        this.seconds = false;
        this.meridian = false;
        this.hourStep = 1;
        this.minuteStep = 1;
        this.secondStep = 1;
        this.withoutMaxDate = false;
        this.valueChanges = new EventEmitter();
        this.change = new EventEmitter();
        // tslint:disable-next-line:variable-name
        this._disabled = true;
        this.icons = {
            faCalendar: faCalendar,
            faClock: faClock
        };
        this.time = {
            hour: 13,
            minute: 0,
            second: 0
        };
        this.isCustomNavigation = false;
        this.openCustomNavigation = () => {
            this.isCustomNavigation = true;
            const currentDate = this.model ? this.model : new Date();
            this.template = this.customNavigationTmpl.createEmbeddedView({
                $implicit: '',
                currDate: currentDate
            });
            this.template.detectChanges();
            this.root = this.template.rootNodes[0];
            this.monthElem.parentNode.appendChild(this.root);
        };
    }
    get cssClass() {
        return `d-flex ${this.labelPosition === 'left' ? 'flex-row' : 'flex-column'} lib-datepicker-adapter--${this.labelPosition}`;
    }
    ngOnInit() {
        super.ngOnInit();
        setTimeout(() => {
            this.sizeS = this.input.nativeElement.parentNode.parentNode.classList.contains('size-s');
            this.sizeL = this.input.nativeElement.parentNode.parentNode.classList.contains('size-l');
        });
    }
    ngDoCheck() {
        if (this.template) {
            this.template.detectChanges();
        }
    }
    getTodayNgbDate() {
        const nowDate = new Date();
        return {
            day: nowDate.getDate(),
            month: nowDate.getMonth() + 1,
            year: nowDate.getFullYear()
        };
    }
    getToday() {
        this.model = new Date();
        this.dateChangedHandler();
    }
    dateChangedHandler() {
        if (typeof this.model === 'string') {
            return;
        }
        if (typeof this.validation === 'function') {
            this.validationError = this.validation(this.value);
        }
        if (this.ngControl) {
            this.onChange(this.model);
            this.onTouched();
        }
        this.valueChanges.emit(this.model);
        this.change.emit(this.model);
        this._disabled = false;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    toggle(d) {
        d.toggle();
        if (d._cRef && d._cRef.location) {
            this.monthElem = d._cRef.location.nativeElement.querySelector('.ngb-dp-month-name');
            this.monthElem.addEventListener('click', this.openCustomNavigation);
        }
    }
    onDatePickerClosed() {
        this.isCustomNavigation = false;
        this.destroyClick();
        this.destroyCustomNavigation();
    }
    onTimeChanged($event) {
        const hour = $event.hour;
        const minute = $event.minute;
        const second = $event.second;
        this.model.setHours(hour);
        this.model.setMinutes(minute);
        this.model.setSeconds(second);
        this.setInputValue(hour, minute);
        this.valueChanges.emit(this.model);
    }
    setInputValue(hour, minute) {
        if (!this.model) {
            return;
        }
        const year = this.model.getFullYear();
        const month = this.model.getMonth() < 9
            ? '0' + (this.model.getMonth() + 1).toString()
            : (this.model.getMonth() + 1).toString();
        const day = this.model.getDate() < 10
            ? '0' + this.model.getDate()
            : this.model.getDate();
        const newHour = hour < 10 ? '0' + hour : hour;
        const newMinute = minute < 10 ? '0' + minute : minute;
        this.input.nativeElement['value'] =
            year + '-' + month + '-' + day + ', ' + newHour + ':' + newMinute;
    }
    destroyClick() {
        if (!this.monthElem) {
            return;
        }
        this.monthElem.removeEventListener('click', this.openCustomNavigation);
        this.monthElem = null;
    }
    destroyCustomNavigation() {
        if (!this.template) {
            return;
        }
        this.template.destroy();
        this.template = null;
        this.root.parentNode.removeChild(this.root);
    }
    goToDateAhead() {
        this.isCustomNavigation = false;
        this.destroyCustomNavigation();
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.destroyClick();
        this.destroyCustomNavigation();
    }
}
DatepickerAdapterComponent.ɵfac = /*@__PURE__*/ function () { let ɵDatepickerAdapterComponent_BaseFactory; return function DatepickerAdapterComponent_Factory(t) { return (ɵDatepickerAdapterComponent_BaseFactory || (ɵDatepickerAdapterComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DatepickerAdapterComponent)))(t || DatepickerAdapterComponent); }; }();
DatepickerAdapterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerAdapterComponent, selectors: [["lib-datepicker-adapter"]], viewQuery: function DatepickerAdapterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c28, 5);
        ɵngcc0.ɵɵviewQuery(_c29, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customNavigationTmpl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostAttrs: [1, "datepicker-adapter"], hostVars: 2, hostBindings: function DatepickerAdapterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.cssClass);
    } }, inputs: { labelPosition: "labelPosition", placeholder: "placeholder", hideTodayButton: "hideTodayButton", dateWithTime: "dateWithTime", disabled: "disabled", seconds: "seconds", meridian: "meridian", hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", withoutMaxDate: "withoutMaxDate", label: "label", height: "height", width: "width", validation: "validation", id: "id", translatedText: "translatedText" }, outputs: { valueChanges: "valueChanges", change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 31, consts: [["class", "label", 3, "disabled", 4, "ngIf"], [1, "input-group", "custom-datepicker-group"], ["controlContainer", ""], ["name", "d2", "ngbDatepicker", "", 1, "form-control", "control", "py-2", "border-right-0", "border", 3, "id", "disabled", "ngClass", "maxDate", "autocomplete", "placeholder", "navigation", "ngModel", "ngModelChange", "closed"], ["inputElement", "", "d2", "ngbDatepicker"], [1, "input-group-append", 3, "ngClass"], ["type", "button", 1, "btn", "btn-link", "control", 3, "id", "disabled", "ngClass", "click"], ["icon", "calendar", 1, "fa", "icons", "font-13px"], ["class", "input-group-append last", 3, "height", 4, "ngIf"], ["class", "btn btn-sm btn-secondary mt-15px control", 3, "size-s", "size-l", "click", 4, "ngIf"], ["timepicker", ""], ["customNavigation", ""], [1, "label"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [1, "input-group-append", "last"], ["type", "button", "popoverClass", "timepicker-popover", 1, "btn", "btn-link", "control", 3, "disabled", "ngbPopover", "autoClose", "placement", "ngClass"], [3, "icon"], [1, "btn", "btn-sm", "btn-secondary", "mt-15px", "control", 3, "click"], [3, "meridian", "hourStep", "minuteStep", "secondStep", "ngModel", "ngModelChange"], [1, "custom-navigation", "w-100", "h-100"], [3, "inputDate", "selectDate"]], template: function DatepickerAdapterComponent_Template(rf, ctx) { if (rf & 1) {
        const _r20 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵtemplate(0, DatepickerAdapterComponent_label_0_Template, 3, 4, "label", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2)(3, "input", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DatepickerAdapterComponent_Template_input_ngModelChange_3_listener($event) { return ctx.model = $event; })("ngModelChange", function DatepickerAdapterComponent_Template_input_ngModelChange_3_listener() { return ctx.dateChangedHandler(); })("closed", function DatepickerAdapterComponent_Template_input_closed_3_listener() { return ctx.onDatePickerClosed(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5)(7, "button", 6);
        ɵngcc0.ɵɵlistener("click", function DatepickerAdapterComponent_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r20); const _r3 = ɵngcc0.ɵɵreference(5); return ɵngcc0.ɵɵresetView(ctx.toggle(_r3)); });
        ɵngcc0.ɵɵelement(8, "fa-icon", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(9, DatepickerAdapterComponent_div_9_Template, 3, 10, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, DatepickerAdapterComponent_button_10_Template, 2, 5, "button", 9);
        ɵngcc0.ɵɵtemplate(11, DatepickerAdapterComponent_ng_template_11_Template, 1, 5, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, DatepickerAdapterComponent_ng_template_13_Template, 2, 1, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("hide-month-picker", ctx.isCustomNavigation);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("height", ctx.height)("width", ctx.width);
        ɵngcc0.ɵɵproperty("id", ctx.id)("disabled", ctx.disabled)("ngClass", ɵngcc0.ɵɵpureFunction1(24, _c30, ctx.validationError || ctx.hasErrors))("maxDate", !ctx.withoutMaxDate ? ctx.getTodayNgbDate() : null)("autocomplete", "off")("placeholder", ctx.placeholder)("navigation", "arrows")("ngModel", ctx.model);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleProp("height", ctx.height);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(26, _c31, !ctx.dateWithTime, ctx.dateWithTime));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id + "_calendar");
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("ngClass", ɵngcc0.ɵɵpureFunction1(29, _c30, ctx.validationError || ctx.hasErrors));
        ɵngcc0.ɵɵattribute("data-test-id", ctx.id + "_calendar");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dateWithTime);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideTodayButton);
    } }, dependencies: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc5.NgbInputDatepicker, ɵngcc5.NgbPopover, ɵngcc5.NgbTimepicker, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, DatepickerMultiMonthViewComponent]; }, styles: [".form-control[_ngcontent-%COMP%]:focus{border-color:initial;box-shadow:none;outline:0!important}.control[_ngcontent-%COMP%]{font-size:14px;font-weight:400;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;line-height:16px}.label[_ngcontent-%COMP%]{color:var(--da-title);display:block;font-size:11px;margin-bottom:8px}.label.disabled[_ngcontent-%COMP%]{color:var(--da-disable)}.label[_ngcontent-%COMP%]   .mandatory[_ngcontent-%COMP%]{color:var(--da-error-base)}.has-validation-error[_ngcontent-%COMP%]{border-color:var(--da-error-base)}.custom-navigation[_ngcontent-%COMP%]{left:0;position:absolute;top:0;z-index:99}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks)}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-day .btn-light, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-month-name{font-size:14px!important;line-height:18px!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .month-content .item, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .years-content .item{font-size:14px;line-height:18px}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-day .btn-light{height:inherit;width:inherit}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-day, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-weekday{height:40px!important;width:40px!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-week{padding:0 8px!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-week:last-child{padding:0 8px 8px!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);border-color:var(--da-border-and-dividers)!important;height:calc(100% - 2px)!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within{border:4px solid var(--da-brand-20);width:calc(100% + 3px)}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within   .form-control[_ngcontent-%COMP%]{border:0!important;margin-right:-3px;padding-left:9px}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within     .dropdown-menu{left:-3px!important;top:3px!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover{border-radius:4px}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active   .form-control[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within   .form-control[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover   .form-control[_ngcontent-%COMP%]{border:0!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active   .input-group-append[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):focus-within   .input-group-append[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover   .input-group-append[_ngcontent-%COMP%]{border:0!important;height:100%!important;margin-top:-1px}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover{border:1px solid var(--da-brand-base);width:100%}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active     .dropdown-menu, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover     .dropdown-menu{left:3px!important;top:3px!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active   .form-control[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover   .form-control[_ngcontent-%COMP%]{margin-right:0;padding-left:12px}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):active     .dropdown-menu, [_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]:not(.disabled):hover     .dropdown-menu{left:0!important;top:6px!important}[_nghost-%COMP%]   .custom-datepicker-group.disabled[_ngcontent-%COMP%]{background:rgba(0,0,0,.04);border-color:var(--da-border-and-dividers);color:var(--da-disable)}[_nghost-%COMP%]   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]{border:0!important;color:var(--da-disable)}[_nghost-%COMP%]   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%], [_nghost-%COMP%]   .custom-datepicker-group.disabled[_ngcontent-%COMP%]   .input-group-append[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{color:var(--da-disable);cursor:default}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]   .penult[_ngcontent-%COMP%]{border:1px solid var(--da-border-and-dividers);border-bottom-left-radius:0;border-left:none;border-right:none;border-top-left-radius:0;height:inherit}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]   .last[_ngcontent-%COMP%]{align-items:center;border:1px solid var(--da-border-and-dividers);border-bottom-right-radius:.25rem!important;border-left:none;border-top-right-radius:.25rem!important;display:flex;height:inherit}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .ngb-dp-month-name{align-items:center;color:var(--da-title);cursor:pointer;display:flex;flex-direction:row;font-size:14px;height:2em;line-height:18px;text-transform:uppercase}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .ngb-dp-weekdays .ngb-dp-weekday{align-items:center;color:var(--da-primary-text);display:flex;flex-direction:row;font-style:normal;justify-content:center;text-align:center;text-transform:uppercase}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .ngb-dp-arrow{color:var(--da-border-and-dividers);font-size:10px;height:2em!important}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .ngb-dp-arrow .ngb-dp-arrow-btn{display:flex;flex-direction:row}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .ngb-dp-arrow .ngb-dp-arrow-btn .ngb-dp-navigation-chevron{color:var(--da-brand-base);font-size:10px}[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]   .selected[_ngcontent-%COMP%]{background:var(--da-brand-base);color:#fff!important}.size-s[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-day .btn-light, .size-s[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-month-name{font-size:12px!important;line-height:16px!important}.size-s[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .month-content .item, .size-s[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .years-content .item{font-size:12px;height:32px;line-height:16px;width:32px}.size-s[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-day, .size-s[_nghost-%COMP%]   .custom-datepicker-group[_ngcontent-%COMP%]     .dropdown-menu .ngb-dp-weekday{height:32px!important;width:32px!important}.lib-datepicker-adapter--left[_nghost-%COMP%]{align-items:center}.lib-datepicker-adapter--left[_nghost-%COMP%]   .input-group[_ngcontent-%COMP%]{flex-grow:1;margin-left:5px}.lib-datepicker-adapter--left[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{margin-bottom:0}.input-group-append[_ngcontent-%COMP%]{height:calc(100% - 2px)!important}.input-group-append[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{color:var(--da-base-brand)}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{box-shadow:none;z-index:0!important}.input-group-append[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:hover{background:none}  .dropdown-menu{border-color:var(--da-border-and-dividers);border-radius:4px;box-shadow:var(--da-soft-default-shadow);min-width:auto}  .dropdown-menu .ngb-dp-header .ngb-dp-arrow .ngb-dp-arrow-btn{height:calc(100% - 2px)!important;margin:0 8px 0 auto;padding:0!important}  .dropdown-menu .ngb-dp-header .ngb-dp-arrow .ngb-dp-arrow-btn:focus{outline:none!important}  .dropdown-menu .ngb-dp-week .ngb-dp-day *{color:var(--da-primary-text)}  .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light{align-items:center;display:flex;font-size:14px!important;font-weight:400!important;justify-content:center;line-height:18px!important}  .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light:hover:not(.outside){color:var(--da-brand-base)!important}  .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light.outside,   .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light:hover{background:var(--da-cards-and-blocks)!important}  .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light.active:not(.outside){background:var(--da-brand-base)!important;color:#fff!important}  .dropdown-menu .ngb-dp-arrow.right .ngb-dp-arrow-btn{margin:0 auto 0 8px}  .dropdown-menu .ngb-dp-header{line-height:16px!important;padding-top:.25rem}  .dropdown-menu .ngb-dp-header,   .dropdown-menu .ngb-dp-weekdays{background:var(--da-table-header)}  .dropdown-menu .ngb-dp-weekdays{margin-bottom:8px}.hide-month-picker[_ngcontent-%COMP%]     .ngb-dp-content.ngb-dp-months{display:none}@media (max-width:600px){[_nghost-%COMP%]     .datepicker-with-label .dropdown-menu{left:-55px}[_nghost-%COMP%]     .dropdown-menu, [_nghost-%COMP%]     .timepicker-popover{left:-15px!important}}"] });
DatepickerAdapterComponent.propDecorators = {
    customNavigationTmpl: [{ type: ViewChild, args: ['customNavigation',] }],
    input: [{ type: ViewChild, args: ['inputElement',] }],
    label: [{ type: Input }],
    labelPosition: [{ type: Input }],
    placeholder: [{ type: Input }],
    height: [{ type: Input }],
    width: [{ type: Input }],
    hideTodayButton: [{ type: Input }],
    validation: [{ type: Input }],
    dateWithTime: [{ type: Input }],
    disabled: [{ type: Input }],
    id: [{ type: Input }],
    seconds: [{ type: Input }],
    meridian: [{ type: Input }],
    hourStep: [{ type: Input }],
    minuteStep: [{ type: Input }],
    secondStep: [{ type: Input }],
    withoutMaxDate: [{ type: Input }],
    translatedText: [{ type: Input }],
    valueChanges: [{ type: Output }],
    change: [{ type: Output }],
    cssClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerAdapterComponent, [{
        type: Component,
        args: [{ selector: 'lib-datepicker-adapter', template: "<label *ngIf=\"label\" class=\"label\" [class.disabled]=\"disabled\"\n    >{{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n</label>\n<div\n    #controlContainer\n    class=\"input-group custom-datepicker-group\"\n    [class.hide-month-picker]=\"isCustomNavigation\"\n>\n    <input\n        [style.height]=\"height\"\n        [style.width]=\"width\"\n        #inputElement\n        name=\"d2\"\n        [id]=\"id\"\n        [disabled]=\"disabled\"\n        class=\"form-control control py-2 border-right-0 border\"\n        [ngClass]=\"{ 'has-validation-error': validationError || hasErrors }\"\n        [maxDate]=\"!withoutMaxDate ? getTodayNgbDate() : null\"\n        [autocomplete]=\"'off'\"\n        [placeholder]=\"placeholder\"\n        [navigation]=\"'arrows'\"\n        [(ngModel)]=\"model\"\n        #d2=\"ngbDatepicker\"\n        ngbDatepicker\n        (ngModelChange)=\"dateChangedHandler()\"\n        (closed)=\"onDatePickerClosed()\"\n    />\n    <div\n        class=\"input-group-append\"\n        [ngClass]=\"{ last: !dateWithTime, penult: dateWithTime }\"\n        [style.height]=\"height\"\n    >\n        <button\n            class=\"btn btn-link control\"\n            type=\"button\"\n            id=\"{{ id + '_calendar' }}\"\n            attr.data-test-id=\"{{ id + '_calendar' }}\"\n            [disabled]=\"disabled\"\n            (click)=\"toggle(d2)\"\n            [ngClass]=\"{ 'has-validation-error': validationError || hasErrors }\"\n        >\n            <fa-icon class=\"fa icons font-13px\" icon=\"calendar\"></fa-icon>\n        </button>\n    </div>\n    <div\n        *ngIf=\"dateWithTime\"\n        class=\"input-group-append last\"\n        [style.height]=\"height\"\n    >\n        <button\n            class=\"btn btn-link control\"\n            type=\"button\"\n            [disabled]=\"_disabled\"\n            [ngbPopover]=\"timepicker\"\n            popoverClass=\"timepicker-popover\"\n            [autoClose]=\"'outside'\"\n            [placement]=\"'bottom'\"\n            [ngClass]=\"{ 'has-validation-error': validationError || hasErrors }\"\n        >\n            <fa-icon [icon]=\"icons.faClock\"></fa-icon>\n        </button>\n    </div>\n</div>\n\n<button\n    *ngIf=\"!hideTodayButton\"\n    class=\"btn btn-sm btn-secondary mt-15px control\"\n    [class.size-s]=\"sizeS\"\n    [class.size-l]=\"sizeL\"\n    (click)=\"getToday()\"\n>\n    {{ translatedText?.SELECT_TODAY || 'Select Today' }}\n</button>\n\n<ng-template #timepicker>\n    <ngb-timepicker\n        [meridian]=\"meridian\"\n        [hourStep]=\"hourStep\"\n        [minuteStep]=\"minuteStep\"\n        [secondStep]=\"secondStep\"\n        [(ngModel)]=\"time\"\n        (ngModelChange)=\"onTimeChanged($event)\"\n    >\n    </ngb-timepicker>\n</ng-template>\n\n<ng-template #customNavigation let-param let-currDate=\"currDate\">\n    <div class=\"custom-navigation w-100 h-100\">\n        <lib-datepicker-multi-month-view\n            [inputDate]=\"currDate\"\n            (selectDate)=\"\n                d2.navigateTo({\n                    year: $event.getFullYear(),\n                    month: $event.getMonth() + 1,\n                    day: $event.getDate()\n                });\n                goToDateAhead()\n            \"\n        >\n        </lib-datepicker-multi-month-view>\n    </div>\n</ng-template>\n", providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }], host: { class: 'datepicker-adapter' }, styles: [".form-control:focus{border-color:initial;box-shadow:none;outline:0!important}.control{font-size:14px;font-weight:400;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;line-height:16px}.label{color:var(--da-title);display:block;font-size:11px;margin-bottom:8px}.label.disabled{color:var(--da-disable)}.label .mandatory{color:var(--da-error-base)}.has-validation-error{border-color:var(--da-error-base)}.custom-navigation{left:0;position:absolute;top:0;z-index:99}:host .custom-datepicker-group{background:var(--da-cards-and-blocks)}:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-day .btn-light,:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-month-name{font-size:14px!important;line-height:18px!important}:host .custom-datepicker-group ::ng-deep .dropdown-menu .month-content .item,:host .custom-datepicker-group ::ng-deep .dropdown-menu .years-content .item{font-size:14px;line-height:18px}:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-day .btn-light{height:inherit;width:inherit}:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-day,:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-weekday{height:40px!important;width:40px!important}:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-week{padding:0 8px!important}:host .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-week:last-child{padding:0 8px 8px!important}:host .custom-datepicker-group .form-control{background:var(--da-cards-and-blocks);border-color:var(--da-border-and-dividers)!important;height:calc(100% - 2px)!important}:host .custom-datepicker-group:not(.disabled):focus-within{border:4px solid var(--da-brand-20);width:calc(100% + 3px)}:host .custom-datepicker-group:not(.disabled):focus-within .form-control{border:0!important;margin-right:-3px;padding-left:9px}:host .custom-datepicker-group:not(.disabled):focus-within ::ng-deep .dropdown-menu{left:-3px!important;top:3px!important}:host .custom-datepicker-group:not(.disabled):active,:host .custom-datepicker-group:not(.disabled):focus-within,:host .custom-datepicker-group:not(.disabled):hover{border-radius:4px}:host .custom-datepicker-group:not(.disabled):active .form-control,:host .custom-datepicker-group:not(.disabled):focus-within .form-control,:host .custom-datepicker-group:not(.disabled):hover .form-control{border:0!important}:host .custom-datepicker-group:not(.disabled):active .input-group-append,:host .custom-datepicker-group:not(.disabled):focus-within .input-group-append,:host .custom-datepicker-group:not(.disabled):hover .input-group-append{border:0!important;height:100%!important;margin-top:-1px}:host .custom-datepicker-group:not(.disabled):active,:host .custom-datepicker-group:not(.disabled):hover{border:1px solid var(--da-brand-base);width:100%}:host .custom-datepicker-group:not(.disabled):active ::ng-deep .dropdown-menu,:host .custom-datepicker-group:not(.disabled):hover ::ng-deep .dropdown-menu{left:3px!important;top:3px!important}:host .custom-datepicker-group:not(.disabled):active .form-control,:host .custom-datepicker-group:not(.disabled):hover .form-control{margin-right:0;padding-left:12px}:host .custom-datepicker-group:not(.disabled):active ::ng-deep .dropdown-menu,:host .custom-datepicker-group:not(.disabled):hover ::ng-deep .dropdown-menu{left:0!important;top:6px!important}:host .custom-datepicker-group.disabled{background:rgba(0,0,0,.04);border-color:var(--da-border-and-dividers);color:var(--da-disable)}:host .custom-datepicker-group.disabled .form-control,:host .custom-datepicker-group.disabled .input-group-append{border:0!important;color:var(--da-disable)}:host .custom-datepicker-group.disabled .form-control .icons,:host .custom-datepicker-group.disabled .input-group-append .icons{color:var(--da-disable);cursor:default}:host .custom-datepicker-group .penult{border:1px solid var(--da-border-and-dividers);border-bottom-left-radius:0;border-left:none;border-right:none;border-top-left-radius:0;height:inherit}:host .custom-datepicker-group .last{align-items:center;border:1px solid var(--da-border-and-dividers);border-bottom-right-radius:.25rem!important;border-left:none;border-top-right-radius:.25rem!important;display:flex;height:inherit}:host .custom-datepicker-group ::ng-deep .ngb-dp-month-name{align-items:center;color:var(--da-title);cursor:pointer;display:flex;flex-direction:row;font-size:14px;height:2em;line-height:18px;text-transform:uppercase}:host .custom-datepicker-group ::ng-deep .ngb-dp-weekdays .ngb-dp-weekday{align-items:center;color:var(--da-primary-text);display:flex;flex-direction:row;font-style:normal;justify-content:center;text-align:center;text-transform:uppercase}:host .custom-datepicker-group ::ng-deep .ngb-dp-arrow{color:var(--da-border-and-dividers);font-size:10px;height:2em!important}:host .custom-datepicker-group ::ng-deep .ngb-dp-arrow .ngb-dp-arrow-btn{display:flex;flex-direction:row}:host .custom-datepicker-group ::ng-deep .ngb-dp-arrow .ngb-dp-arrow-btn .ngb-dp-navigation-chevron{color:var(--da-brand-base);font-size:10px}:host .custom-datepicker-group .selected{background:var(--da-brand-base);color:#fff!important}:host.size-s .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-day .btn-light,:host.size-s .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-month-name{font-size:12px!important;line-height:16px!important}:host.size-s .custom-datepicker-group ::ng-deep .dropdown-menu .month-content .item,:host.size-s .custom-datepicker-group ::ng-deep .dropdown-menu .years-content .item{font-size:12px;height:32px;line-height:16px;width:32px}:host.size-s .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-day,:host.size-s .custom-datepicker-group ::ng-deep .dropdown-menu .ngb-dp-weekday{height:32px!important;width:32px!important}:host.lib-datepicker-adapter--left{align-items:center}:host.lib-datepicker-adapter--left .input-group{flex-grow:1;margin-left:5px}:host.lib-datepicker-adapter--left .label{margin-bottom:0}.input-group-append{height:calc(100% - 2px)!important}.input-group-append .icons{color:var(--da-base-brand)}.input-group-append .btn{box-shadow:none;z-index:0!important}.input-group-append .btn:hover{background:none}::ng-deep .dropdown-menu{border-color:var(--da-border-and-dividers);border-radius:4px;box-shadow:var(--da-soft-default-shadow);min-width:auto}::ng-deep .dropdown-menu .ngb-dp-header .ngb-dp-arrow .ngb-dp-arrow-btn{height:calc(100% - 2px)!important;margin:0 8px 0 auto;padding:0!important}::ng-deep .dropdown-menu .ngb-dp-header .ngb-dp-arrow .ngb-dp-arrow-btn:focus{outline:none!important}::ng-deep .dropdown-menu .ngb-dp-week .ngb-dp-day *{color:var(--da-primary-text)}::ng-deep .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light{align-items:center;display:flex;font-size:14px!important;font-weight:400!important;justify-content:center;line-height:18px!important}::ng-deep .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light:hover:not(.outside){color:var(--da-brand-base)!important}::ng-deep .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light.outside,::ng-deep .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light:hover{background:var(--da-cards-and-blocks)!important}::ng-deep .dropdown-menu .ngb-dp-week .ngb-dp-day .btn-light.active:not(.outside){background:var(--da-brand-base)!important;color:#fff!important}::ng-deep .dropdown-menu .ngb-dp-arrow.right .ngb-dp-arrow-btn{margin:0 auto 0 8px}::ng-deep .dropdown-menu .ngb-dp-header{line-height:16px!important;padding-top:.25rem}::ng-deep .dropdown-menu .ngb-dp-header,::ng-deep .dropdown-menu .ngb-dp-weekdays{background:var(--da-table-header)}::ng-deep .dropdown-menu .ngb-dp-weekdays{margin-bottom:8px}.hide-month-picker ::ng-deep .ngb-dp-content.ngb-dp-months{display:none}@media (max-width:600px){:host ::ng-deep .datepicker-with-label .dropdown-menu{left:-55px}:host ::ng-deep .dropdown-menu,:host ::ng-deep .timepicker-popover{left:-15px!important}}"] }]
    }], null, { labelPosition: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], hideTodayButton: [{
            type: Input
        }], dateWithTime: [{
            type: Input
        }], disabled: [{
            type: Input
        }], seconds: [{
            type: Input
        }], meridian: [{
            type: Input
        }], hourStep: [{
            type: Input
        }], minuteStep: [{
            type: Input
        }], secondStep: [{
            type: Input
        }], withoutMaxDate: [{
            type: Input
        }], valueChanges: [{
            type: Output
        }], change: [{
            type: Output
        }], cssClass: [{
            type: HostBinding,
            args: ['class']
        }], customNavigationTmpl: [{
            type: ViewChild,
            args: ['customNavigation']
        }], input: [{
            type: ViewChild,
            args: ['inputElement']
        }], label: [{
            type: Input
        }], height: [{
            type: Input
        }], width: [{
            type: Input
        }], validation: [{
            type: Input
        }], id: [{
            type: Input
        }], translatedText: [{
            type: Input
        }] }); })();

class DatepickerMultiMonthViewComponent {
    constructor(datePipe) {
        this.datePipe = datePipe;
        this.selectDate = new EventEmitter();
        this.rowCount = 3;
        this.yearsMode = false;
    }
    ngOnInit() {
        this.currentDate = this.inputDate;
        this.chunkMonths = this.getChunks(this.getMonths(this.currentDate), 12 / this.rowCount);
        this.years = this.getYears(new Date(2010, 1, 1, 0, 0, 0, 0));
        this.chunkYears = this.getChunks(this.years, 12 / this.rowCount);
    }
    getMonths(date) {
        if (!date) {
            return;
        }
        const months = [];
        for (let i = 0; i < 12; i++) {
            const month = new Date(date.getFullYear(), i, 1, 0, 0, 0, 0);
            months.push(month);
        }
        return months;
    }
    getYears(date) {
        const years = [];
        for (let i = 0; i < 12; i++) {
            const year = new Date(date.getFullYear() + i, date.getMonth(), 1, 0, 0, 0, 0);
            years.push(year);
        }
        return years;
    }
    transformDate(date, format) {
        return this.datePipe.transform(date, format);
    }
    pickMonth(month) {
        this.currentDate.setMonth(month.getMonth());
        this.selectDate.emit(this.currentDate);
    }
    pickYear(year) {
        this.currentDate.setFullYear(year.getFullYear());
        this.yearsMode = false;
    }
    changeYear(date, inc) {
        date.setFullYear(date.getFullYear() + inc);
    }
    changeYearsSet(increment) {
        this.years = this.getYears(new Date(this.years[0].getFullYear() + increment, 1, 1, 0, 0, 0, 0));
        this.chunkYears = this.getChunks(this.years, 12 / this.rowCount);
    }
    getChunks(array, size) {
        if (!(array === null || array === void 0 ? void 0 : array.length)) {
            return;
        }
        const results = [];
        const source = [...array];
        while (source.length) {
            results.push(source.splice(0, size));
        }
        return results;
    }
    turnMode() {
        this.yearsMode = !this.yearsMode;
    }
}
DatepickerMultiMonthViewComponent.ɵfac = function DatepickerMultiMonthViewComponent_Factory(t) { return new (t || DatepickerMultiMonthViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DatePipe)); };
DatepickerMultiMonthViewComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerMultiMonthViewComponent, selectors: [["lib-datepicker-multi-month-view"]], inputs: { inputDate: "inputDate" }, outputs: { selectDate: "selectDate" }, features: [ɵngcc0.ɵɵProvidersFeature([DatePipe])], decls: 4, vars: 2, consts: [[1, "width-fit-content", "h-100"], ["class", "d-flex flex-column w-100 h-100", 4, "ngIf", "ngIfElse"], ["yearsTemplate", ""], [1, "d-flex", "flex-column", "w-100", "h-100"], ["class", "ngb-dp-header bg-light w-100 d-flex d-inline-flex align-items-center", 4, "ngIf"], [1, "flex-1", "p-5px", "month-content"], ["class", "row no-gutters d-flex d-inline-flex flex-nowrap align-items-center", 4, "ngFor", "ngForOf"], [1, "ngb-dp-header", "bg-light", "w-100", "d-flex", "d-inline-flex", "align-items-center"], [1, "ngb-dp-arrow"], [1, "btn", "ngb-dp-arrow-btn", 3, "click"], [1, "ngb-dp-navigation-chevron"], [1, "ngb-dp-month-name", 3, "click"], [1, "ngb-dp-arrow", "right"], [1, "row", "no-gutters", "d-flex", "d-inline-flex", "flex-nowrap", "align-items-center"], ["class", "col-3 item d-flex d-inline-flex align-items-center justify-content-center month", 3, "selected", "click", 4, "ngFor", "ngForOf"], [1, "col-3", "item", "d-flex", "d-inline-flex", "align-items-center", "justify-content-center", "month", 3, "click"], [1, "ngb-dp-month-name", "header-cursor"], [1, "w-100", "flex-1", "p-5px", "years-content"], ["class", "row no-gutters w-100 d-flex d-inline-flex flex-nowrap align-items-center", 4, "ngFor", "ngForOf"], [1, "row", "no-gutters", "w-100", "d-flex", "d-inline-flex", "flex-nowrap", "align-items-center"], ["class", "col-3 item d-flex d-inline-flex align-items-center justify-content-center year", 3, "selected", "click", 4, "ngFor", "ngForOf"], [1, "col-3", "item", "d-flex", "d-inline-flex", "align-items-center", "justify-content-center", "year", 3, "click"]], template: function DatepickerMultiMonthViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DatepickerMultiMonthViewComponent_div_1_Template, 4, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, DatepickerMultiMonthViewComponent_ng_template_2_Template, 12, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.yearsMode)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf], styles: [".item[_ngcontent-%COMP%]:active, .selected[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);color:var(--da-brand-base)}.item[_ngcontent-%COMP%]{border-radius:2px;color:var(--da-primary-text);cursor:pointer;font-size:11px;height:30%;line-height:15px}.item[_ngcontent-%COMP%]:hover{background:var(--da-background);color:var(--da-title)}.month-content[_ngcontent-%COMP%], .years-content[_ngcontent-%COMP%]{background:var(--da-cards-and-blocks);border-radius:0 0 4px 4px;box-shadow:0 5px 6px rgba(0,0,0,.2),0 3px 16px rgba(0,0,0,.12),0 9px 12px rgba(0,0,0,.14);height:150px}.month-content[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%], .month-content[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%], .years-content[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%], .years-content[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]{height:40px;width:40px}.month-content[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%]:hover, .month-content[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]:hover, .years-content[_ngcontent-%COMP%]   .month[_ngcontent-%COMP%]:hover, .years-content[_ngcontent-%COMP%]   .year[_ngcontent-%COMP%]:hover{background:var(--da-brand-base);color:#fff}.header-cursor[_ngcontent-%COMP%]{cursor:default!important}"] });
DatepickerMultiMonthViewComponent.ctorParameters = () => [
    { type: DatePipe }
];
DatepickerMultiMonthViewComponent.propDecorators = {
    inputDate: [{ type: Input }],
    selectDate: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerMultiMonthViewComponent, [{
        type: Component,
        args: [{ selector: 'lib-datepicker-multi-month-view', template: "<div class=\"width-fit-content h-100\">\n    <div\n        *ngIf=\"!yearsMode; else yearsTemplate\"\n        class=\"d-flex flex-column w-100 h-100\"\n    >\n        <div\n            *ngIf=\"currentDate\"\n            class=\"ngb-dp-header bg-light w-100 d-flex d-inline-flex align-items-center\"\n        >\n            <div class=\"ngb-dp-arrow\">\n                <button\n                    class=\"btn ngb-dp-arrow-btn\"\n                    (click)=\"changeYear(currentDate, -1)\"\n                >\n                    <span class=\"ngb-dp-navigation-chevron\"></span>\n                </button>\n            </div>\n            <div class=\"ngb-dp-month-name\" (click)=\"turnMode()\">\n                {{ currentDate.getFullYear() }}\n            </div>\n            <div class=\"ngb-dp-arrow right\">\n                <button\n                    class=\"btn ngb-dp-arrow-btn\"\n                    (click)=\"changeYear(currentDate, +1)\"\n                >\n                    <span class=\"ngb-dp-navigation-chevron\"></span>\n                </button>\n            </div>\n        </div>\n\n        <div class=\"flex-1 p-5px month-content\">\n            <div\n                *ngFor=\"let chunkMonth of chunkMonths\"\n                class=\"row no-gutters d-flex d-inline-flex flex-nowrap align-items-center\"\n            >\n                <div\n                    *ngFor=\"let month of chunkMonth\"\n                    class=\"col-3 item d-flex d-inline-flex align-items-center justify-content-center month\"\n                    [class.selected]=\"\n                        currentDate.getMonth() == month.getMonth()\n                    \"\n                    (click)=\"pickMonth(month)\"\n                >\n                    <div>\n                        {{ transformDate(month, \"MMM\") }}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<ng-template #yearsTemplate>\n    <div class=\"d-flex flex-column w-100 h-100\">\n        <div\n            class=\"ngb-dp-header bg-light w-100 d-flex d-inline-flex align-items-center\"\n        >\n            <div class=\"ngb-dp-arrow\">\n                <button\n                    class=\"btn ngb-dp-arrow-btn\"\n                    (click)=\"changeYearsSet(-12)\"\n                >\n                    <span class=\"ngb-dp-navigation-chevron\"></span>\n                </button>\n            </div>\n            <div class=\"ngb-dp-month-name header-cursor\">\n                {{\n                    years[0].getFullYear() +\n                        \" - \" +\n                        years[years.length - 1].getFullYear()\n                }}\n            </div>\n            <div class=\"ngb-dp-arrow right\">\n                <button\n                    class=\"btn ngb-dp-arrow-btn\"\n                    (click)=\"changeYearsSet(+12)\"\n                >\n                    <span class=\"ngb-dp-navigation-chevron\"></span>\n                </button>\n            </div>\n        </div>\n\n        <div class=\"w-100 flex-1 p-5px years-content\">\n            <div\n                *ngFor=\"let chunkYear of chunkYears\"\n                class=\"row no-gutters w-100 d-flex d-inline-flex flex-nowrap align-items-center\"\n            >\n                <div\n                    *ngFor=\"let year of chunkYear\"\n                    class=\"col-3 item d-flex d-inline-flex align-items-center justify-content-center year\"\n                    [class.selected]=\"\n                        currentDate.getFullYear() == year.getFullYear()\n                    \"\n                    (click)=\"pickYear(year)\"\n                >\n                    <div>\n                        {{ transformDate(year, \"yyyy\") }}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-template>\n", providers: [DatePipe], styles: [".item:active,.selected{background:var(--da-cards-and-blocks);color:var(--da-brand-base)}.item{border-radius:2px;color:var(--da-primary-text);cursor:pointer;font-size:11px;height:30%;line-height:15px}.item:hover{background:var(--da-background);color:var(--da-title)}.month-content,.years-content{background:var(--da-cards-and-blocks);border-radius:0 0 4px 4px;box-shadow:0 5px 6px rgba(0,0,0,.2),0 3px 16px rgba(0,0,0,.12),0 9px 12px rgba(0,0,0,.14);height:150px}.month-content .month,.month-content .year,.years-content .month,.years-content .year{height:40px;width:40px}.month-content .month:hover,.month-content .year:hover,.years-content .month:hover,.years-content .year:hover{background:var(--da-brand-base);color:#fff}.header-cursor{cursor:default!important}"] }]
    }], function () { return [{ type: ɵngcc2.DatePipe }]; }, { selectDate: [{
            type: Output
        }], inputDate: [{
            type: Input
        }] }); })();

var NavigationEvent;
(function (NavigationEvent) {
    NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
    NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
})(NavigationEvent || (NavigationEvent = {}));
class DatepickerRangeNavigationComponent {
    constructor(i18n) {
        this.i18n = i18n;
        this.navigation = NavigationEvent;
        this.months = [];
        this.navigate = new EventEmitter();
        this.select = new EventEmitter();
    }
    onClickPrev(event) {
        event.currentTarget.focus();
        this.navigate.emit(this.navigation.PREV);
    }
    onClickNext(event) {
        event.currentTarget.focus();
        this.navigate.emit(this.navigation.NEXT);
    }
}
DatepickerRangeNavigationComponent.ɵfac = function DatepickerRangeNavigationComponent_Factory(t) { return new (t || DatepickerRangeNavigationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbDatepickerI18n)); };
DatepickerRangeNavigationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerRangeNavigationComponent, selectors: [["lib-datepicker-range-navigation"]], inputs: { months: "months", date: "date", disabled: "disabled", showSelect: "showSelect", prevDisabled: "prevDisabled", nextDisabled: "nextDisabled", selectBoxes: "selectBoxes" }, outputs: { navigate: "navigate", select: "select" }, decls: 7, vars: 3, consts: function () { let i18n_32; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_ngb_datepicker_previous_month$$FESM2015_DAGILITY_UI_KIT_JS_33 = goog.getMsg("Previous month");
        i18n_32 = MSG_EXTERNAL_ngb_datepicker_previous_month$$FESM2015_DAGILITY_UI_KIT_JS_33;
    }
    else {
        i18n_32 = $localize `:@@ngb.datepicker.previous-month␟c3b08b07b5ab98e7cdcf18df39355690ab7d3884␟8586908745456864217:Previous month`;
    } let i18n_34; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_ngb_datepicker_previous_month$$FESM2015_DAGILITY_UI_KIT_JS_35 = goog.getMsg("Previous month");
        i18n_34 = MSG_EXTERNAL_ngb_datepicker_previous_month$$FESM2015_DAGILITY_UI_KIT_JS_35;
    }
    else {
        i18n_34 = $localize `:@@ngb.datepicker.previous-month␟c3b08b07b5ab98e7cdcf18df39355690ab7d3884␟8586908745456864217:Previous month`;
    } let i18n_36; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_ngb_datepicker_next_month$$FESM2015_DAGILITY_UI_KIT_JS_37 = goog.getMsg("Next month");
        i18n_36 = MSG_EXTERNAL_ngb_datepicker_next_month$$FESM2015_DAGILITY_UI_KIT_JS_37;
    }
    else {
        i18n_36 = $localize `:@@ngb.datepicker.next-month␟4bd046985cfe13040d5ef0cd881edce0968a111a␟3628374603023447227:Next month`;
    } let i18n_38; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_ngb_datepicker_next_month$$FESM2015_DAGILITY_UI_KIT_JS_39 = goog.getMsg("Next month");
        i18n_38 = MSG_EXTERNAL_ngb_datepicker_next_month$$FESM2015_DAGILITY_UI_KIT_JS_39;
    }
    else {
        i18n_38 = $localize `:@@ngb.datepicker.next-month␟4bd046985cfe13040d5ef0cd881edce0968a111a␟3628374603023447227:Next month`;
    } return [[1, "ngb-dp-arrow"], ["type", "button", "aria-label", i18n_32, "title", i18n_34, 1, "btn", "btn-link", "ngb-dp-arrow-btn", 3, "disabled", "click"], [1, "ngb-dp-navigation-chevron"], ["ngFor", "", 3, "ngForOf"], [1, "ngb-dp-arrow", "right"], ["type", "button", "aria-label", i18n_36, "title", i18n_38, 1, "btn", "btn-link", "ngb-dp-arrow-btn", 3, "disabled", "click"], ["class", "ngb-dp-arrow", 4, "ngIf"], [1, "ngb-dp-month-name"]]; }, template: function DatepickerRangeNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function DatepickerRangeNavigationComponent_Template_button_click_1_listener($event) { return ctx.onClickPrev($event); });
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(3, DatepickerRangeNavigationComponent_ng_template_3_Template, 4, 4, "ng-template", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4)(5, "button", 5);
        ɵngcc0.ɵɵlistener("click", function DatepickerRangeNavigationComponent_Template_button_click_5_listener($event) { return ctx.onClickNext($event); });
        ɵngcc0.ɵɵelement(6, "span", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.prevDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.months);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.nextDisabled);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf], styles: ["[_nghost-%COMP%]{background:var(--da-table-header)}.ngb-dp-navigation-chevron[_ngcontent-%COMP%]{border-style:solid;border-width:.2em .2em 0 0;display:inline-block;height:.75em;margin-left:.25em;margin-right:.15em;transform:rotate(-135deg);width:.75em}.ngb-dp-arrow[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;height:2rem;margin:0;padding-left:0;padding-right:0;width:2rem}.ngb-dp-arrow.right[_ngcontent-%COMP%]{justify-content:flex-end}.ngb-dp-arrow.right[_ngcontent-%COMP%]   .ngb-dp-navigation-chevron[_ngcontent-%COMP%]{margin-left:.15em;margin-right:.25em;transform:rotate(45deg)}.ngb-dp-arrow-btn[_ngcontent-%COMP%]{background-color:transparent;border:none;margin:0 .5rem;padding:0 .25rem;z-index:1}.ngb-dp-arrow-btn[_ngcontent-%COMP%]:focus{outline-style:auto;outline-width:1px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ngb-dp-arrow-btn[_ngcontent-%COMP%]:focus{outline-style:solid}}.ngb-dp-month-name[_ngcontent-%COMP%]{font-size:14px;font-weight:400;height:2rem;line-height:18px;text-align:center}.ngb-dp-navigation-select[_ngcontent-%COMP%]{display:flex;flex:1 1 9rem}"] });
DatepickerRangeNavigationComponent.ctorParameters = () => [
    { type: NgbDatepickerI18n }
];
DatepickerRangeNavigationComponent.propDecorators = {
    date: [{ type: Input }],
    disabled: [{ type: Input }],
    months: [{ type: Input }],
    showSelect: [{ type: Input }],
    prevDisabled: [{ type: Input }],
    nextDisabled: [{ type: Input }],
    selectBoxes: [{ type: Input }],
    navigate: [{ type: Output }],
    select: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerRangeNavigationComponent, [{
        type: Component,
        args: [{ selector: 'lib-datepicker-range-navigation', template: "<div class=\"ngb-dp-arrow\">\n    <button type=\"button\" class=\"btn btn-link ngb-dp-arrow-btn\" (click)=\"onClickPrev($event)\" [disabled]=\"prevDisabled\"\n            i18n-aria-label=\"@@ngb.datepicker.previous-month\" aria-label=\"Previous month\"\n            i18n-title=\"@@ngb.datepicker.previous-month\" title=\"Previous month\">\n        <span class=\"ngb-dp-navigation-chevron\"></span>\n    </button>\n</div>\n<ng-template ngFor let-month [ngForOf]=\"months\" let-i=\"index\">\n    <div class=\"ngb-dp-arrow\" *ngIf=\"i > 0\"></div>\n    <div class=\"ngb-dp-month-name\">\n        {{ i18n.getMonthFullName(month.number, month.year) }} {{ i18n.getYearNumerals(month.year) }}\n    </div>\n    <div class=\"ngb-dp-arrow\" *ngIf=\"i !== months.length - 1\"></div>\n</ng-template>\n<div class=\"ngb-dp-arrow right\">\n    <button type=\"button\" class=\"btn btn-link ngb-dp-arrow-btn\" (click)=\"onClickNext($event)\" [disabled]=\"nextDisabled\"\n            i18n-aria-label=\"@@ngb.datepicker.next-month\" aria-label=\"Next month\"\n            i18n-title=\"@@ngb.datepicker.next-month\" title=\"Next month\">\n        <span class=\"ngb-dp-navigation-chevron\"></span>\n    </button>\n</div>\n", styles: [":host{background:var(--da-table-header)}.ngb-dp-navigation-chevron{border-style:solid;border-width:.2em .2em 0 0;display:inline-block;height:.75em;margin-left:.25em;margin-right:.15em;transform:rotate(-135deg);width:.75em}.ngb-dp-arrow{display:flex;flex:1 1 auto;height:2rem;margin:0;padding-left:0;padding-right:0;width:2rem}.ngb-dp-arrow.right{justify-content:flex-end}.ngb-dp-arrow.right .ngb-dp-navigation-chevron{margin-left:.15em;margin-right:.25em;transform:rotate(45deg)}.ngb-dp-arrow-btn{background-color:transparent;border:none;margin:0 .5rem;padding:0 .25rem;z-index:1}.ngb-dp-arrow-btn:focus{outline-style:auto;outline-width:1px}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ngb-dp-arrow-btn:focus{outline-style:solid}}.ngb-dp-month-name{font-size:14px;font-weight:400;height:2rem;line-height:18px;text-align:center}.ngb-dp-navigation-select{display:flex;flex:1 1 9rem}"] }]
    }], function () { return [{ type: ɵngcc5.NgbDatepickerI18n }]; }, { months: [{
            type: Input
        }], navigate: [{
            type: Output
        }], select: [{
            type: Output
        }], date: [{
            type: Input
        }], disabled: [{
            type: Input
        }], showSelect: [{
            type: Input
        }], prevDisabled: [{
            type: Input
        }], nextDisabled: [{
            type: Input
        }], selectBoxes: [{
            type: Input
        }] }); })();

class DatepickerRangeDialogComponent {
}
DatepickerRangeDialogComponent.ɵfac = function DatepickerRangeDialogComponent_Factory(t) { return new (t || DatepickerRangeDialogComponent)(); };
DatepickerRangeDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerRangeDialogComponent, selectors: [["lib-datepicker-range-dialog"]], inputs: { dp: "dp", leftTemplate: "leftTemplate", rightTemplate: "rightTemplate" }, decls: 6, vars: 10, consts: [[4, "ngIf"], [1, "d-flex", "align-items-center", 3, "date", "months", "disabled", "showSelect", "prevDisabled", "nextDisabled", "selectBoxes", "navigate", "select"], [1, "d-flex"], [3, "month", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], [3, "month"]], template: function DatepickerRangeDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DatepickerRangeDialogComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div")(2, "lib-datepicker-range-navigation", 1);
        ɵngcc0.ɵɵlistener("navigate", function DatepickerRangeDialogComponent_Template_lib_datepicker_range_navigation_navigate_2_listener($event) { return ctx.dp.onNavigateEvent($event); })("select", function DatepickerRangeDialogComponent_Template_lib_datepicker_range_navigation_select_2_listener($event) { return ctx.dp.onNavigateDateSelect($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, DatepickerRangeDialogComponent_ngb_datepicker_month_4_Template, 1, 1, "ngb-datepicker-month", 3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(5, DatepickerRangeDialogComponent_div_5_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.leftTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("date", ctx.dp.model.firstDate)("months", ctx.dp.model.months)("disabled", ctx.dp.model.disabled)("showSelect", ctx.dp.model.navigation === "select")("prevDisabled", ctx.dp.model.prevDisabled)("nextDisabled", ctx.dp.model.nextDisabled)("selectBoxes", ctx.dp.model.selectBoxes);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dp.state.months);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.rightTemplate);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.NgbDatepickerMonth, DatepickerRangeNavigationComponent], encapsulation: 2, changeDetection: 0 });
DatepickerRangeDialogComponent.propDecorators = {
    dp: [{ type: Input }],
    leftTemplate: [{ type: Input }],
    rightTemplate: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerRangeDialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-datepicker-range-dialog',
                template: "<div *ngIf=\"leftTemplate\">\n    <ng-template [ngTemplateOutlet]=\"leftTemplate\"></ng-template>\n</div>\n<div>\n    <lib-datepicker-range-navigation\n        class=\"d-flex align-items-center\"\n        [date]=\"dp.model.firstDate!\"\n        [months]=\"dp.model.months\"\n        [disabled]=\"dp.model.disabled\"\n        [showSelect]=\"dp.model.navigation === 'select'\"\n        [prevDisabled]=\"dp.model.prevDisabled\"\n        [nextDisabled]=\"dp.model.nextDisabled\"\n        [selectBoxes]=\"dp.model.selectBoxes\"\n        (navigate)=\"dp.onNavigateEvent($event)\"\n        (select)=\"dp.onNavigateDateSelect($event)\">\n    </lib-datepicker-range-navigation>\n    <div class=\"d-flex\">\n        <ngb-datepicker-month *ngFor=\"let month of dp.state.months; let i = index\" [month]=\"month\"></ngb-datepicker-month>\n    </div>\n</div>\n<div *ngIf=\"rightTemplate\">\n    <ng-template [ngTemplateOutlet]=\"rightTemplate\"></ng-template>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { dp: [{
            type: Input
        }], leftTemplate: [{
            type: Input
        }], rightTemplate: [{
            type: Input
        }] }); })();

const SHARED_COMPONENTS = [DatepickerComponent, DatepickerAdapterComponent];
const SHARED_DIRECTIVES = [
    DatepickerLeftRangeContentDirective,
    DatepickerRightRangeContentDirective
];
class DatepickerModule {
}
DatepickerModule.ɵfac = function DatepickerModule_Factory(t) { return new (t || DatepickerModule)(); };
DatepickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DatepickerModule });
DatepickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, NgbModule, FormsModule, IconsModule, ReactiveFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbModule, FormsModule, IconsModule, ReactiveFormsModule],
                declarations: [
                    DatepickerMultiMonthViewComponent,
                    DatepickerRangeNavigationComponent,
                    DatepickerRangeDialogComponent,
                    ...SHARED_COMPONENTS,
                    ...SHARED_DIRECTIVES,
                ],
                exports: [...SHARED_COMPONENTS, ...SHARED_DIRECTIVES]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DatepickerModule, { declarations: function () { return [DatepickerMultiMonthViewComponent, DatepickerRangeNavigationComponent, DatepickerRangeDialogComponent, DatepickerComponent, DatepickerAdapterComponent, DatepickerLeftRangeContentDirective, DatepickerRightRangeContentDirective]; }, imports: function () { return [CommonModule, NgbModule, FormsModule, IconsModule, ReactiveFormsModule]; }, exports: function () { return [DatepickerComponent, DatepickerAdapterComponent, DatepickerLeftRangeContentDirective, DatepickerRightRangeContentDirective]; } }); })();

const bigStar = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path class="star-border" fill-rule="evenodd" clip-rule="evenodd" d="M18.1803 20.7543C17.7621 21.0582 17.2026 21.0822 16.76 20.815L12.4061 18.1872L8.0521 20.815C7.60979 21.082 7.05065 21.0583 6.63254 20.7548C6.21442 20.4514 6.01854 19.9272 6.13524 19.4239L7.28401 14.4694L3.44304 11.1358C3.05302 10.7973 2.90338 10.2583 3.06307 9.76723C3.22276 9.27612 3.6608 8.92822 4.17531 8.88385L9.24304 8.44686L11.2226 3.78335C11.4242 3.30842 11.8901 3 12.4061 3C12.922 3 13.388 3.30842 13.5896 3.78335L15.5691 8.44686L20.6368 8.88385C21.1515 8.92824 21.5897 9.2764 21.7492 9.76778C21.9088 10.2592 21.7587 10.7983 21.3682 11.1366L17.5211 14.4694L18.6765 19.4222C18.794 19.9256 18.5985 20.4504 18.1803 20.7543Z"/>\n' +
    '<path class="star-fill" fill-rule="evenodd" clip-rule="evenodd" d="M18.1803 20.7543C17.7621 21.0582 17.2026 21.0822 16.76 20.815L12.4061 18.1872L8.0521 20.815C7.60979 21.082 7.05065 21.0583 6.63254 20.7548C6.21442 20.4514 6.01854 19.9272 6.13524 19.4239L7.28401 14.4694L3.44304 11.1358C3.05302 10.7973 2.90338 10.2583 3.06307 9.76723C3.22276 9.27612 3.6608 8.92822 4.17531 8.88385L9.24304 8.44686L11.2226 3.78335C11.4242 3.30842 11.8901 3 12.4061 3C12.922 3 13.388 3.30842 13.5896 3.78335L15.5691 8.44686L20.6368 8.88385C21.1516 8.92824 21.5897 9.2764 21.7492 9.76778C21.9088 10.2592 21.7587 10.7983 21.3682 11.1366L17.5211 14.4694L18.6765 19.4222C18.794 19.9256 18.5985 20.4504 18.1803 20.7543ZM14.6879 9.66135L20.5264 10.1648L16.0927 14.0057L17.4244 19.7143L12.4061 16.6854L7.38772 19.7143L8.71133 14.0057L4.28577 10.1648L10.1243 9.66135L12.4061 4.28571L14.6879 9.66135Z"/>\n' +
    '</svg>';
class RatingModalComponent {
    constructor(modal) {
        this.modal = modal;
        this.ratingChanged = new EventEmitter();
        this.max = 5;
        this.bigStar = bigStar;
    }
    get rating() {
        return (this.form.get('rating') || 0);
    }
    ngOnInit() {
        this.initForm();
        this.form.patchValue({
            rating: this.data.rating ? this.data.rating : 0
        });
    }
    saveRating() {
        this.ratingChanged.emit(this.rating.value);
        this.modal.close('Rating Changed');
    }
    initForm() {
        this.form = new FormGroup({
            rating: new FormControl(null)
        });
    }
}
RatingModalComponent.ɵfac = function RatingModalComponent_Factory(t) { return new (t || RatingModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbActiveModal)); };
RatingModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RatingModalComponent, selectors: [["lib-rating-modal"]], inputs: { translatedText: "translatedText" }, outputs: { ratingChanged: "ratingChanged" }, decls: 26, vars: 14, consts: [[1, "modal-header"], ["id", "modal-title", 1, "modal-title", "mt-0"], ["type", "button", "aria-label", "Close button", "aria-describedby", "modal-title", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body", 3, "formGroup"], [1, "d-flex", "flex-column", "border-bottom", "mb-10px"], [1, "row", "no-gutters", "align-items-center", "mb-5px"], ["formControlName", "rating", 1, "rating", 3, "max"], [1, "row", "no-gutters", "align-items-center", "mb-10px"], [1, "text-label", "mb-10px"], ["formControlName", "rating", 3, "editable", "max"], [1, "downloads-label"], [1, "d-flex", "flex-column", "mt-10px"], ["class", "row no-gutters mt-5px align-items-center", 4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", "ngbAutofocus", "", 1, "btn", "btn-primary", 3, "disabled", "click"], ["icon", "star", "class", "brand-star", 4, "ngIf"], ["icon", "star", "class", "empty-star", 4, "ngIf"], ["icon", "star", 1, "brand-star"], ["icon", "star", 1, "empty-star"], [1, "row", "no-gutters", "mt-5px", "align-items-center"], [1, "rating-row-label-left", "mr-5px", "col"], ["type", "primary", 3, "height", "value"], [1, "rating-row-label-right", "ml-2", "col"]], template: function RatingModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "h4", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵlistener("click", function RatingModalComponent_Template_button_click_3_listener() { return ctx.modal.dismiss("Cross click"); });
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5, "\u00D7");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(6, "div", 4)(7, "div", 5)(8, "div", 6)(9, "ngb-rating", 7);
        ɵngcc0.ɵɵtemplate(10, RatingModalComponent_ng_template_10_Template, 2, 2, "ng-template");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(11, "div", 8)(12, "span");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(14, "span", 9);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(16, "lib-rating", 10);
        ɵngcc0.ɵɵelementStart(17, "span", 11);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 12);
        ɵngcc0.ɵɵtemplate(20, RatingModalComponent_div_20_Template, 7, 9, "div", 13);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(21, "div", 14)(22, "button", 15);
        ɵngcc0.ɵɵlistener("click", function RatingModalComponent_Template_button_click_22_listener() { return ctx.modal.dismiss("Cancel click"); });
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "button", 16);
        ɵngcc0.ɵɵlistener("click", function RatingModalComponent_Template_button_click_24_listener() { return ctx.saveRating(); });
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2(" ", (ctx.translatedText == null ? null : ctx.translatedText.RATING_OF) || "Rating of", " ", ctx.templateName, " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("max", ctx.max);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.translatedText == null ? null : ctx.translatedText.WILL_CHANGE) || "You will be able to change it in any time", " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.translatedText == null ? null : ctx.translatedText.OVERALL_RATING) || "Overall Rating", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("editable", false)("max", ctx.max);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2(" ", (ctx.data == null ? null : ctx.data.downloads) || 0, " ", (ctx.translatedText == null ? null : ctx.translatedText.DOWNLOADS) || "downloads", " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.ratingRowsTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.translatedText == null ? null : ctx.translatedText.CANCEL) || "Cancel", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.form.dirty);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.translatedText == null ? null : ctx.translatedText.RATE) || "Rate", " ");
    } }, dependencies: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc5.NgbProgressbar, ɵngcc5.NgbRating, ɵngcc1.NgControlStatus, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc1.FormControlName, ErrorControlDirective, RatingComponent, ɵngcc2.DecimalPipe]; }, styles: [".modal-header[_ngcontent-%COMP%]{color:var(--da-primary-text);font-size:18px}.modal-header[_ngcontent-%COMP%]   .modal-title[_ngcontent-%COMP%]{font-size:14px;line-height:19px}.modal-header[_ngcontent-%COMP%]   button.close[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons);font-size:30px;font-weight:300;line-height:1rem}.modal-body[_ngcontent-%COMP%]{font-size:12px}.modal-body[_ngcontent-%COMP%]   .downloads-label[_ngcontent-%COMP%]{color:#949494;font-size:10px}.modal-body[_ngcontent-%COMP%]   .rating-value[_ngcontent-%COMP%]{font-size:24px;font-weight:600;margin-left:8px}.modal-body[_ngcontent-%COMP%]   .text-label[_ngcontent-%COMP%]{color:var(--da-primary-text);font-weight:600;line-height:15px}.modal-body[_ngcontent-%COMP%]   .rating-row-label-left[_ngcontent-%COMP%]{max-width:34px}.modal-body[_ngcontent-%COMP%]   .rating-row-label-left[_ngcontent-%COMP%], .modal-body[_ngcontent-%COMP%]   .rating-row-label-right[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons);font-size:10px}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:11px;height:28px;line-height:14px;margin-left:1rem;width:78px}.brand-star[_ngcontent-%COMP%], .empty-star[_ngcontent-%COMP%]{font-size:13px;margin-right:3px}  .brand-star svg{fill:var(--da-brand-12)!important;stroke:var(--da-brand-base)!important}  .empty-star svg{stroke:var(--da-disable)!important}"] });
RatingModalComponent.ctorParameters = () => [
    { type: NgbActiveModal }
];
RatingModalComponent.propDecorators = {
    translatedText: [{ type: Input }],
    ratingChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RatingModalComponent, [{
        type: Component,
        args: [{ selector: 'lib-rating-modal', template: "<div class=\"modal-header\">\n    <h4 class=\"modal-title mt-0\" id=\"modal-title\">\n        {{ translatedText?.RATING_OF || 'Rating of' }} {{ templateName }}\n    </h4>\n    <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"Close button\"\n        aria-describedby=\"modal-title\"\n        (click)=\"modal.dismiss('Cross click')\"\n    >\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n\n<div class=\"modal-body\" [formGroup]=\"form\">\n    <div class=\"d-flex flex-column border-bottom mb-10px\">\n        <div class=\"row no-gutters align-items-center mb-5px\">\n            <ngb-rating class=\"rating\" formControlName=\"rating\" [max]=\"max\">\n                <ng-template let-fill=\"fill\">\n                    <fa-icon\n                        *ngIf=\"fill === 100\"\n                        icon=\"star\"\n                        class=\"brand-star\"\n                    ></fa-icon>\n\n                    <fa-icon\n                        *ngIf=\"fill < 100\"\n                        icon=\"star\"\n                        class=\"empty-star\"\n                    ></fa-icon>\n                </ng-template>\n            </ngb-rating>\n        </div>\n        <div class=\"row no-gutters align-items-center mb-10px\">\n            <span>\n                {{ translatedText?.WILL_CHANGE || 'You will be able to change it in any time' }}\n            </span>\n        </div>\n    </div>\n    <span class=\"text-label mb-10px\">\n        {{ translatedText?.OVERALL_RATING || 'Overall Rating' }}\n    </span>\n    <lib-rating\n        [editable]=\"false\"\n        formControlName=\"rating\"\n        [max]=\"max\"\n    ></lib-rating>\n    <span class=\"downloads-label\">\n        {{ data?.downloads || 0 }} {{ translatedText?.DOWNLOADS || 'downloads' }}\n    </span>\n    <div class=\"d-flex flex-column mt-10px\">\n        <div\n            *ngFor=\"let ratingRowItem of ratingRowsTemplate\"\n            class=\"row no-gutters mt-5px align-items-center\"\n        >\n            <span class=\"rating-row-label-left mr-5px col\">\n                {{\n                    ratingRowItem.label +\n                        (ratingRowItem.label !== \"1\" ? \" stars\" : \" star\")\n                }}\n            </span>\n            <ngb-progressbar\n                [style.width]=\"ratingRowItem.width\"\n                [height]=\"ratingRowItem.height\"\n                type=\"primary\"\n                [value]=\"ratingRowItem.value\"\n            ></ngb-progressbar>\n            <span class=\"rating-row-label-right ml-2 col\"\n                >{{ ratingRowItem.value | number: \"1.0-1\" }} %</span\n            >\n        </div>\n    </div>\n</div>\n\n<div class=\"modal-footer\">\n    <button\n        type=\"button\"\n        class=\"btn btn-secondary\"\n        (click)=\"modal.dismiss('Cancel click')\"\n    >\n        {{ translatedText?.CANCEL || 'Cancel' }}\n    </button>\n    <button\n        type=\"button\"\n        ngbAutofocus\n        class=\"btn btn-primary\"\n        [disabled]=\"!form.dirty\"\n        (click)=\"saveRating()\"\n    >\n        {{ translatedText?.RATE || 'Rate' }}\n    </button>\n</div>\n", styles: [".modal-header{color:var(--da-primary-text);font-size:18px}.modal-header .modal-title{font-size:14px;line-height:19px}.modal-header button.close{color:var(--da-secondary-text-and-icons);font-size:30px;font-weight:300;line-height:1rem}.modal-body{font-size:12px}.modal-body .downloads-label{color:#949494;font-size:10px}.modal-body .rating-value{font-size:24px;font-weight:600;margin-left:8px}.modal-body .text-label{color:var(--da-primary-text);font-weight:600;line-height:15px}.modal-body .rating-row-label-left{max-width:34px}.modal-body .rating-row-label-left,.modal-body .rating-row-label-right{color:var(--da-secondary-text-and-icons);font-size:10px}.modal-footer button{font-size:11px;height:28px;line-height:14px;margin-left:1rem;width:78px}.brand-star,.empty-star{font-size:13px;margin-right:3px}::ng-deep .brand-star svg{fill:var(--da-brand-12)!important;stroke:var(--da-brand-base)!important}::ng-deep .empty-star svg{stroke:var(--da-disable)!important}"] }]
    }], function () { return [{ type: ɵngcc5.NgbActiveModal }]; }, { ratingChanged: [{
            type: Output
        }], translatedText: [{
            type: Input
        }] }); })();

class TypedModalRef extends NgbModalRef {
    get componentInstance() {
        return super.componentInstance;
    }
}
class ModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(component, options = {}, inputs = {}) {
        const modalRef = this.modalService.open(component, options);
        for (const prop in inputs) {
            if (inputs.hasOwnProperty(prop)) {
                modalRef.componentInstance[prop] = inputs[prop];
            }
        }
        return modalRef;
    }
    dismissAll() {
        if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll();
        }
    }
    hasOpenModals() {
        return this.modalService.hasOpenModals();
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(ɵngcc5.NgbModal)); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac });
ModalService.ctorParameters = () => [
    { type: NgbModal }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc5.NgbModal }]; }, null); })();

class RatingComponent {
    constructor(modalService) {
        this.modalService = modalService;
        this.ratingChanged = new EventEmitter();
        this.disabled = false;
        this.expanded = false;
        this.max = 5;
        this.editable = false;
        this.tooltipPlacement = 'top';
        this.defaultRating = {
            rate1: 0,
            rate2: 0,
            rate3: 0,
            rate4: 0,
            rate5: 0,
            downloads: 0,
            rating: 0,
            myRating: 0
        };
        this.ratingRowsTemplate = [
            { label: '5', width: '60%', height: '4px', value: 0 },
            { label: '4', width: '60%', height: '4px', value: 0 },
            { label: '3', width: '60%', height: '4px', value: 0 },
            { label: '2', width: '60%', height: '4px', value: 0 },
            { label: '1', width: '60%', height: '4px', value: 0 }
        ];
        this.rating = null;
        this.ratingLoaded = false;
        this.destroy$ = new Subject();
        this.onChange = (_) => { };
        this.onTouched = (_) => { };
    }
    ngOnInit() {
        if (this.expanded) {
            this.getDataForTooltip();
        }
    }
    get numberOfFullStars() {
        return Math.floor(this.value);
    }
    get numberOfEmptyStars() {
        return this.max - Math.floor(this.value);
    }
    get numberOfMyFullStars() {
        return Math.floor(this.myRate);
    }
    get numberOfMyEmptyStars() {
        return this.max - Math.floor(this.myRate);
    }
    get fullStars() {
        return Array(this.numberOfFullStars);
    }
    get emptyStars() {
        return Array(this.numberOfEmptyStars);
    }
    get myFullStars() {
        return Array(this.numberOfMyFullStars);
    }
    get myEmptyStars() {
        return Array(this.numberOfMyEmptyStars);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        this.value = value;
    }
    getDataForTooltip() {
        if (!this.ratingLoaded) {
            this.ratingStatistics.pipe(takeUntil(this.destroy$)).subscribe(rating => {
                const ratesCount = rating.ratesCount ||
                    rating.rate1 +
                        rating.rate2 +
                        rating.rate3 +
                        rating.rate4 +
                        rating.rate5;
                this.rating = Object.assign(rating, {
                    ratesCount: ratesCount ? ratesCount : 0
                });
                if (!this.myRate) {
                    this.myRate = this.rating.myRating;
                }
                this.ratingRowsTemplate = this.fillRowsTemplate(this.ratingRowsTemplate);
                this.ratingLoaded = true;
            }, () => {
                this.rating = this.defaultRating;
                this.ratingLoaded = false;
            });
        }
    }
    rate() {
        var _a;
        const modalRef = this.modalService.open(RatingModalComponent, {
            centered: true,
            backdrop: 'static',
            windowClass: 'rating-modal-container',
        });
        modalRef.componentInstance.translatedText = this.translatedText;
        modalRef.componentInstance.max = this.max;
        modalRef.componentInstance.templateName = (_a = this.templateData) === null || _a === void 0 ? void 0 : _a.name;
        modalRef.componentInstance.data = this.rating;
        modalRef.componentInstance.ratingRowsTemplate = this.ratingRowsTemplate;
        modalRef.componentInstance.ratingChanged
            .pipe(takeUntil(this.destroy$))
            .subscribe((rate) => {
            if (rate) {
                this.ratingChanged.emit(rate);
                this.ratingLoaded = false;
                this.rating = null;
            }
        });
    }
    toggleTooltip(tooltip) {
        if (tooltip.isOpen()) {
            tooltip.close();
        }
        else {
            this.getDataForTooltip();
            tooltip.open();
        }
    }
    calculatePercent(prop) {
        if (this.rating) {
            const rate1 = this.rating.rate1 ? this.rating.rate1 : 0;
            const rate2 = this.rating.rate2 ? this.rating.rate2 : 0;
            const rate3 = this.rating.rate3 ? this.rating.rate3 : 0;
            const rate4 = this.rating.rate4 ? this.rating.rate4 : 0;
            const rate5 = this.rating.rate5 ? this.rating.rate5 : 0;
            const sum = rate1 + rate2 + rate3 + rate4 + rate5;
            // @ts-ignore
            return Math.floor((this.rating[prop] / sum) * 100);
        }
        return 0;
    }
    fillRowsTemplate(rowsTemplate) {
        return rowsTemplate.map((x, index) => {
            const prop = 'rate' + `${5 - index}`;
            const value = this.calculatePercent(prop);
            // @ts-ignore
            return Object.assign(Object.assign({}, x), { value: value });
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
}
RatingComponent.ɵfac = function RatingComponent_Factory(t) { return new (t || RatingComponent)(ɵngcc0.ɵɵdirectiveInject(ModalService)); };
RatingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RatingComponent, selectors: [["lib-rating"]], inputs: { disabled: "disabled", expanded: "expanded", max: "max", editable: "editable", tooltipPlacement: "tooltipPlacement", value: "value", myRate: "myRate", templateData: "templateData", ratingStatistics: "ratingStatistics", translatedText: "translatedText" }, outputs: { ratingChanged: "ratingChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RatingComponent),
                multi: true
            }
        ])], decls: 6, vars: 2, consts: [[1, "rating-content"], ["class", "rating-label-wrapper align-items-center", "triggers", "manual", "tooltipClass", "rating-tooltip", 3, "cursor-pointer", "placement", "ngbTooltip", "click", 4, "ngIf", "ngIfElse"], ["tipContent", ""], ["rateExpanded", ""], ["triggers", "manual", "tooltipClass", "rating-tooltip", 1, "rating-label-wrapper", "align-items-center", 3, "placement", "ngbTooltip", "click"], ["t1", "ngbTooltip"], ["class", "rating-star", 4, "ngIf"], [1, "rating-value", "text-truncate"], [3, "ngClass"], [1, "rating-star"], ["icon", "star", "class", "brand-star", 4, "ngFor", "ngForOf"], ["icon", "star", "class", "empty-star", 4, "ngFor", "ngForOf"], ["icon", "star", 1, "brand-star"], ["icon", "star", 1, "empty-star"], ["icon", "star", "class", "my-rate-star", 4, "ngFor", "ngForOf"], [1, "custom-badge", "warning", "size-s", "text-white", "font-10px"], ["icon", "star", 1, "my-rate-star"], [3, "ngTemplateOutlet"], [4, "ngIf", "ngIfElse"], ["rateButtonTemplate", ""], [1, "row", "no-gutters", "mt-10px"], [1, "btn", "btn-link", "rate-button", 3, "click"], [1, "text-button"], [1, "my-rating"], ["class", "w-100", 4, "ngIf", "ngIfElse"], ["loadingTemplate", ""], [1, "w-100"], [1, "rating-for-tooltip", 3, "editable", "ngModel", "max", "ngModelChange"], [1, "row", "no-gutters", "d-flex", "justify-content-center"], [1, "rates-label"], [1, "downloads-label", "ml-5px"], [1, "rating-by-stars", "d-flex", "flex-column", "mt-16px"], ["class", "row no-gutters mt-5px align-items-center text-nowrap", 4, "ngFor", "ngForOf"], [1, "row", "no-gutters", "mt-5px", "align-items-center", "text-nowrap"], [1, "rating-row-label", "mr-5px", "col"], ["type", "primary", 3, "height", "value"], [1, "rating-row-value", "ml-5px", "col"], [1, "spinner", "d-flex", "justify-content-center", "align-items-center"]], template: function RatingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, RatingComponent_div_1_Template, 8, 11, "div", 1);
        ɵngcc0.ɵɵtemplate(2, RatingComponent_ng_template_2_Template, 5, 3, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, RatingComponent_ng_template_4_Template, 3, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.expanded)("ngIfElse", _r3);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc5.NgbProgressbar, SpinnerComponent, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc5.NgbTooltip, RatingComponent, ɵngcc2.DecimalPipe], styles: [".rating-star[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row}.brand-star[_ngcontent-%COMP%], .empty-star[_ngcontent-%COMP%], .my-rate-star[_ngcontent-%COMP%]{font-size:14px;margin-right:3px}  .brand-star svg{fill:var(--da-brand-12)!important;stroke:var(--da-brand-base)!important}  .empty-star svg{stroke:var(--da-disable)!important}  .my-rate-star svg{fill:var(--da-warning-base-12)!important;stroke:var(--da-warning-base)!important}.custom-badge[_ngcontent-%COMP%]{align-items:center;background-color:var(--da-warning-base);display:flex;height:14px!important;margin:2px 0 0 6px!important;padding:1px 6px}.rating-content[_ngcontent-%COMP%]{display:flex}.rating-content[_ngcontent-%COMP%]   .rating-label-wrapper[_ngcontent-%COMP%]{align-items:center!important;display:flex;flex-direction:row;margin-bottom:6px}.rating-content[_ngcontent-%COMP%]   .rating-label-wrapper[_ngcontent-%COMP%]   .rating-value[_ngcontent-%COMP%]{display:flex;margin:1px 0 0 8px}.rating-content[_ngcontent-%COMP%]   .rating-label-wrapper[_ngcontent-%COMP%]   .rating-value[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px}.rating-content[_ngcontent-%COMP%]   .rating-label-wrapper[_ngcontent-%COMP%]   .rate-button[_ngcontent-%COMP%]{cursor:pointer;margin-left:4px}.rating-content[_ngcontent-%COMP%]   .rating-label-wrapper[_ngcontent-%COMP%]   .rate-button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:11px}.color-gray[_ngcontent-%COMP%]{color:var(--da-disable)!important}.downloads-label[_ngcontent-%COMP%]{color:var(--da-disable);font-size:12px}.rates-label[_ngcontent-%COMP%]{color:var(--da-primary-text);float:left;font-size:12px}.rate-button[_ngcontent-%COMP%]{color:#fff;font-size:11px;margin-top:10px;width:100%}.my-rating[_ngcontent-%COMP%]{align-items:center;background-color:var(--da-brand-base);border:1px solid var(--da-brand-base);border-radius:2px;color:var(--da-white);display:flex;font-size:11px;height:14px;margin-left:5px;padding:0 3px}.rating-row-label[_ngcontent-%COMP%]{color:var(--da-brand-base);font-size:10px;text-align:right}.rating-row-value[_ngcontent-%COMP%]{color:var(--da-primary-text);font-size:10px}  ngb-progressbar{background-color:var(--da-border-and-dividers)!important}  ngb-progressbar .progress-bar{background-color:var(--da-brand-base)!important}  .tooltip-small-rating{margin-left:5px}  .rating-modal-container{left:45%!important;max-width:330px}  .rating-for-tooltip .rating-value{color:var(--da-brand-base)}[_nghost-%COMP%]     .rating-tooltip{opacity:1!important}[_nghost-%COMP%]     .rating-tooltip .tooltip-inner{background:linear-gradient(180deg,#fff 0,#fff 78%,#616161 0);border-radius:2px;box-shadow:2px 4px 10px rgba(0,0,0,.13);font-weight:600!important;min-width:180px}"] });
RatingComponent.ctorParameters = () => [
    { type: ModalService }
];
RatingComponent.propDecorators = {
    ratingChanged: [{ type: Output }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    expanded: [{ type: Input }],
    max: [{ type: Input }],
    editable: [{ type: Input }],
    templateData: [{ type: Input }],
    ratingStatistics: [{ type: Input }],
    myRate: [{ type: Input }],
    tooltipPlacement: [{ type: Input }],
    translatedText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RatingComponent, [{
        type: Component,
        args: [{ selector: 'lib-rating', template: "<div class=\"rating-content\">\n    <div\n        *ngIf=\"!expanded; else rateExpanded\"\n        class=\"rating-label-wrapper align-items-center\"\n        triggers=\"manual\"\n        [class.cursor-pointer]=\"editable\"\n        #t1=\"ngbTooltip\"\n        [placement]=\"tooltipPlacement\"\n        [ngbTooltip]=\"tipContent\"\n        tooltipClass=\"rating-tooltip\"\n        (click)=\"editable && toggleTooltip(t1)\"\n    >\n        <div *ngIf=\"!myRate\" class=\"rating-star\">\n            <fa-icon\n                *ngFor=\"let fullStar of fullStars\"\n                icon=\"star\"\n                class=\"brand-star\"\n            ></fa-icon>\n            <fa-icon\n                *ngFor=\"let emptyStar of emptyStars\"\n                icon=\"star\"\n                class=\"empty-star\"\n            ></fa-icon>\n        </div>\n        <div *ngIf=\"myRate\" class=\"rating-star\">\n            <fa-icon\n                *ngFor=\"let myFullStar of myFullStars\"\n                icon=\"star\"\n                class=\"my-rate-star\"\n            ></fa-icon>\n            <fa-icon\n                *ngFor=\"let myEmptyStar of myEmptyStars\"\n                icon=\"star\"\n                class=\"empty-star\"\n            ></fa-icon>\n            <span class=\"custom-badge warning size-s text-white font-10px\">\n                {{ myRate }}\n            </span>\n        </div>\n        <div class=\"rating-value text-truncate\">\n            <span [ngClass]=\"value !== 0 ? 'color-brand' : 'color-gray'\">{{\n                value | number: \"1.1-2\"\n            }}</span>\n        </div>\n    </div>\n\n    <ng-template #tipContent>\n        <div>\n            <ng-template [ngTemplateOutlet]=\"rateExpanded\"></ng-template>\n            <ng-container *ngIf=\"myRate; else rateButtonTemplate\">\n                <div class=\"row no-gutters mt-10px\">\n                    <button class=\"btn btn-link rate-button\" (click)=\"rate()\">\n                        <span class=\"text-button\">\n                            {{ translatedText?.CHANGE_MY_RATE || 'Change my rating' }}\n                        </span>\n                        <span class=\"my-rating\">{{ myRate }}</span>\n                    </button>\n                </div>\n            </ng-container>\n        </div>\n\n        <ng-template #rateButtonTemplate>\n            <div class=\"row no-gutters mt-10px\">\n                <button class=\"btn btn-link rate-button\" (click)=\"rate()\">\n                    {{ translatedText?.RATE_IT_NOW || 'Rate it now' }}\n                </button>\n            </div>\n        </ng-template>\n    </ng-template>\n</div>\n\n<ng-template #rateExpanded>\n    <div class=\"w-100\" *ngIf=\"ratingLoaded; else loadingTemplate\">\n        <lib-rating\n            class=\"rating-for-tooltip\"\n            [editable]=\"false\"\n            [(ngModel)]=\"rating.rating\"\n            [max]=\"max\"\n        ></lib-rating>\n        <div class=\"row no-gutters d-flex justify-content-center\">\n            <span class=\"rates-label\">\n                {{ rating?.ratesCount }} {{ translatedText?.USER_RATINGS || 'user ratings' }}\n            </span>\n            <span class=\"downloads-label ml-5px\">\n                {{ rating?.downloads }} {{ translatedText?.DOWNLOADS || 'downloads' }}\n            </span>\n        </div>\n        <div class=\"rating-by-stars d-flex flex-column mt-16px\">\n            <div\n                *ngFor=\"let ratingRowItem of ratingRowsTemplate\"\n                class=\"row no-gutters mt-5px align-items-center text-nowrap\"\n            >\n                <span class=\"rating-row-label mr-5px col\">\n                    {{\n                        ratingRowItem.label + \" \" +\n                            (ratingRowItem.label !== \"1\" ? (translatedText?.STARS || \"stars\") : (translatedText?.STAR || \"star\"))\n                    }}\n                </span>\n                <ngb-progressbar\n                    [style.width]=\"ratingRowItem.width\"\n                    [height]=\"ratingRowItem.height\"\n                    type=\"primary\"\n                    [value]=\"ratingRowItem.value\"\n                ></ngb-progressbar>\n                <span class=\"rating-row-value ml-5px col\"\n                    >{{ ratingRowItem.value | number: \"1.0-1\" }} %</span\n                >\n            </div>\n        </div>\n    </div>\n    <ng-template #loadingTemplate>\n        <div class=\"spinner d-flex justify-content-center align-items-center\">\n            <lib-spinner></lib-spinner>\n        </div>\n    </ng-template>\n</ng-template>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RatingComponent),
                        multi: true
                    }
                ], styles: [".rating-star{align-items:center;display:flex;flex-direction:row}.brand-star,.empty-star,.my-rate-star{font-size:14px;margin-right:3px}::ng-deep .brand-star svg{fill:var(--da-brand-12)!important;stroke:var(--da-brand-base)!important}::ng-deep .empty-star svg{stroke:var(--da-disable)!important}::ng-deep .my-rate-star svg{fill:var(--da-warning-base-12)!important;stroke:var(--da-warning-base)!important}.custom-badge{align-items:center;background-color:var(--da-warning-base);display:flex;height:14px!important;margin:2px 0 0 6px!important;padding:1px 6px}.rating-content{display:flex}.rating-content .rating-label-wrapper{align-items:center!important;display:flex;flex-direction:row;margin-bottom:6px}.rating-content .rating-label-wrapper .rating-value{display:flex;margin:1px 0 0 8px}.rating-content .rating-label-wrapper .rating-value span{font-size:14px}.rating-content .rating-label-wrapper .rate-button{cursor:pointer;margin-left:4px}.rating-content .rating-label-wrapper .rate-button span{font-size:11px}.color-gray{color:var(--da-disable)!important}.downloads-label{color:var(--da-disable);font-size:12px}.rates-label{color:var(--da-primary-text);float:left;font-size:12px}.rate-button{color:#fff;font-size:11px;margin-top:10px;width:100%}.my-rating{align-items:center;background-color:var(--da-brand-base);border:1px solid var(--da-brand-base);border-radius:2px;color:var(--da-white);display:flex;font-size:11px;height:14px;margin-left:5px;padding:0 3px}.rating-row-label{color:var(--da-brand-base);font-size:10px;text-align:right}.rating-row-value{color:var(--da-primary-text);font-size:10px}::ng-deep ngb-progressbar{background-color:var(--da-border-and-dividers)!important}::ng-deep ngb-progressbar .progress-bar{background-color:var(--da-brand-base)!important}::ng-deep .tooltip-small-rating{margin-left:5px}::ng-deep .rating-modal-container{left:45%!important;max-width:330px}::ng-deep .rating-for-tooltip .rating-value{color:var(--da-brand-base)}:host ::ng-deep .rating-tooltip{opacity:1!important}:host ::ng-deep .rating-tooltip .tooltip-inner{background:linear-gradient(180deg,#fff 0,#fff 78%,#616161 0);border-radius:2px;box-shadow:2px 4px 10px rgba(0,0,0,.13);font-weight:600!important;min-width:180px}"] }]
    }], function () { return [{ type: ModalService }]; }, { ratingChanged: [{
            type: Output
        }], disabled: [{
            type: Input
        }], expanded: [{
            type: Input
        }], max: [{
            type: Input
        }], editable: [{
            type: Input
        }], tooltipPlacement: [{
            type: Input
        }], value: [{
            type: Input
        }], myRate: [{
            type: Input
        }], templateData: [{
            type: Input
        }], ratingStatistics: [{
            type: Input
        }], translatedText: [{
            type: Input
        }] }); })();

class SafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type, args) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                return this.sanitizer.bypassSecurityTrustHtml(value);
        }
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc8.DomSanitizer, 16)); };
SafeHtmlPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeHtml',
                pure: true
            }]
    }], function () { return [{ type: ɵngcc8.DomSanitizer }]; }, null); })();
class SafeHtmlPipeModule {
}
SafeHtmlPipeModule.ɵfac = function SafeHtmlPipeModule_Factory(t) { return new (t || SafeHtmlPipeModule)(); };
SafeHtmlPipeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SafeHtmlPipeModule });
SafeHtmlPipeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafeHtmlPipeModule, [{
        type: NgModule,
        args: [{
                declarations: [SafeHtmlPipe],
                exports: [SafeHtmlPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SafeHtmlPipeModule, { declarations: [SafeHtmlPipe], exports: [SafeHtmlPipe] }); })();

class TypeaheadComponent extends InputComponent {
    constructor() {
        super(...arguments);
        this.debounceTime = 200;
        this.items = [];
        this.focus$ = new Subject();
        this.search = (text$) => {
            const debouncedText$ = text$.pipe(debounceTime(this.debounceTime), distinctUntilChanged());
            return merge(debouncedText$, this.focus$).pipe(map(term => ((term === ''
                ? this.items
                : (this.items || []).filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)) || []).slice(0, 10)));
        };
    }
    handleFocus(event) {
        this.focus$.next(event.target.value);
    }
    handleSelect(event) {
        this.value = event.item;
        this.onChange(event.item);
    }
}
TypeaheadComponent.ɵfac = /*@__PURE__*/ function () { let ɵTypeaheadComponent_BaseFactory; return function TypeaheadComponent_Factory(t) { return (ɵTypeaheadComponent_BaseFactory || (ɵTypeaheadComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TypeaheadComponent)))(t || TypeaheadComponent); }; }();
TypeaheadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TypeaheadComponent, selectors: [["lib-typeahead"]], viewQuery: function TypeaheadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbTypeahead, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.instance = _t.first);
    } }, hostAttrs: [1, "lib-typeahead"], inputs: { debounceTime: "debounceTime", items: "items" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c3, decls: 5, vars: 19, consts: [["class", "label text-truncate", 3, "disabled", 4, "ngIf"], [1, "position-relative", "input-content"], [3, "ngbTypeahead", "value", "readonly", "checked", "type", "input", "focus", "blur", "keydown", "paste", "selectItem"], ["input", "", "controlContainer", ""], [1, "label", "text-truncate"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"]], template: function TypeaheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TypeaheadComponent_span_0_Template, 4, 4, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("input", function TypeaheadComponent_Template_input_input_2_listener($event) { return ctx.handleInput($event); })("focus", function TypeaheadComponent_Template_input_focus_2_listener($event) { ctx.handleFocus($event); return ctx.toggleReadonly(false); })("blur", function TypeaheadComponent_Template_input_blur_2_listener($event) { ctx.onTouched(); ctx.toggleReadonly(true); return ctx.blur.emit($event); })("keydown", function TypeaheadComponent_Template_input_keydown_2_listener($event) { return ctx.validate("keydown", $event); })("paste", function TypeaheadComponent_Template_input_paste_2_listener($event) { return ctx.validate("paste", $event); })("selectItem", function TypeaheadComponent_Template_input_selectItem_2_listener($event) { return ctx.handleSelect($event); });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("invalid", ctx.hasErrors)("warning", ctx.warning)("with-icon", ctx.icon)("clearable", ctx.clearable)("with-max-length", ctx.maxlength);
        ɵngcc0.ɵɵproperty("ngbTypeahead", ctx.search)("value", ctx.value === undefined || ctx.value === null ? "" : ctx.value)("readonly", ctx.readonly)("checked", ctx.type === "radio" && ctx.checked)("type", ctx.type);
        ɵngcc0.ɵɵattribute("placeholder", ctx.placeholder)("maxlength", ctx.maxlength)("data-test-id", ctx.id);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc5.NgbTypeahead], styles: ["[_nghost-%COMP%]     .dropdown-menu{background:var(--da-cards-and-blocks);border-radius:var(--da-dropdown-border-radius);box-shadow:var(--da-dropdown-box-shadow);top:32px!important;transform:none!important;width:100%}[_nghost-%COMP%]     .dropdown-item{color:var(--da-primary-text);justify-content:flex-start!important;white-space:inherit}[_nghost-%COMP%]     .dropdown-item.active:not(:hover){background:none!important;color:var(--da-primary-text)!important}[_nghost-%COMP%]     .active{color:var(--da-primary-text)!important}  lib-typeahead.size-s .dropdown-menu{top:24px!important}  lib-typeahead.size-l .dropdown-menu{top:48px!important}", _c40] });
TypeaheadComponent.propDecorators = {
    debounceTime: [{ type: Input }],
    items: [{ type: Input }],
    instance: [{ type: ViewChild, args: [NgbTypeahead,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeaheadComponent, [{
        type: Component,
        args: [{ selector: 'lib-typeahead', template: "<span *ngIf=\"label\" class=\"label text-truncate\" [class.disabled]=\"readonly\">\n    {{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n    <ng-content></ng-content>\n</span>\n<div class=\"position-relative input-content\">\n    <input\n        #input\n        #controlContainer\n        [ngbTypeahead]=\"search\"\n        [value]=\"value === undefined || value === null ? '' : value\"\n        [attr.placeholder]=\"placeholder\"\n        [class.invalid]=\"hasErrors\"\n        [class.warning]=\"warning\"\n        [class.with-icon]=\"icon\"\n        [class.clearable]=\"clearable\"\n        [class.with-max-length]=\"maxlength\"\n        [readonly]=\"readonly\"\n        [attr.maxlength]=\"maxlength\"\n        [checked]=\"type === 'radio' && checked\"\n        [type]=\"type\"\n        [attr.data-test-id]=\"id\"\n        (input)=\"handleInput($event)\"\n        (focus)=\"handleFocus($event); toggleReadonly(false);\"\n        (blur)=\"onTouched(); toggleReadonly(true); blur.emit($event);\"\n        (keydown)=\"validate('keydown', $event)\"\n        (paste)=\"validate('paste', $event)\"\n        (selectItem)=\"handleSelect($event)\"\n    />\n</div>\n", host: { class: 'lib-typeahead' }, styles: [":host ::ng-deep .dropdown-menu{background:var(--da-cards-and-blocks);border-radius:var(--da-dropdown-border-radius);box-shadow:var(--da-dropdown-box-shadow);top:32px!important;transform:none!important;width:100%}:host ::ng-deep .dropdown-item{color:var(--da-primary-text);justify-content:flex-start!important;white-space:inherit}:host ::ng-deep .dropdown-item.active:not(:hover){background:none!important;color:var(--da-primary-text)!important}:host ::ng-deep .active{color:var(--da-primary-text)!important}::ng-deep lib-typeahead.size-s .dropdown-menu{top:24px!important}::ng-deep lib-typeahead.size-l .dropdown-menu{top:48px!important}", ".mandatory{color:var(--da-error-base)}.label{color:var(--da-title);font-size:11px;margin-bottom:7px}input{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;color:var(--da-primary-text);width:100%}input::-moz-placeholder{color:var(--da-disable)}input:-ms-input-placeholder{color:var(--da-disable)}input::placeholder{color:var(--da-disable)}input:focus{outline:none}input:focus:not(.invalid):not(:hover):not(:active):not(:-moz-read-only){box-shadow:0 0 0 4px var(--da-brand-20)}input:focus:not(.invalid):not(:hover):not(:active):not(:read-only){box-shadow:0 0 0 4px var(--da-brand-20)}input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):hover{border:1px solid var(--da-brand-base)}input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):hover{border:1px solid var(--da-brand-base)}input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):active,input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):hover{margin:0;width:100%}input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):active,input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):hover{margin:0;width:100%}input:not(:disabled):not(.disabled):not(.invalid):not(:-moz-read-only):active{border:1px solid var(--da-brand-base)}input:not(:disabled):not(.disabled):not(.invalid):not(:read-only):active{border:1px solid var(--da-brand-base)}input.invalid{border:1px solid var(--da-error-base)!important}input.disabled,input:disabled{background:rgba(0,0,0,.04);color:var(--da-disable)}input:-moz-read-only{cursor:default}input.disabled,input:disabled,input:read-only{cursor:default}input.with-icon{padding:15px 28px!important}.icon{color:var(--da-brand-base);left:.5rem;position:absolute;top:.5rem}.password-toggle{cursor:pointer;margin-left:-24px;margin-top:6px}:host.lib-input--left{align-items:center}:host.lib-input--left .input-content{flex-grow:1;margin-left:5px}:host.lib-input--left .label{margin-bottom:0}:host.size-s::ng-deep .clear-btn{top:.25rem!important}:host.size-l::ng-deep .clear-btn{top:1rem!important}:host .clear-btn{background:none!important;border:none!important;color:var(--da-secondary-text-and-icons);padding:0!important;position:absolute;right:.5rem;top:.5rem;width:16px}:host .clear-btn .icon{font-size:16px!important}:host .clear-btn:focus{outline:none!important}.max-length{align-items:center;display:flex;height:100%;top:0}.with-max-length{padding-right:62px}.with-copyable-length{padding-right:40px}.with-copyable-length.with-max-length{padding-right:102px}.clearable{padding-right:28px}.clearable.with-copyable-length:not(.with-max-length){padding-right:68px}.clearable.with-max-length:not(.with-copyable-length){padding-right:90px}.clearable.with-copyable-length.with-max-length{padding-right:130px}"] }]
    }], null, { debounceTime: [{
            type: Input
        }], items: [{
            type: Input
        }], instance: [{
            type: ViewChild,
            args: [NgbTypeahead]
        }] }); })();

function searchTreelikeArray(treelikeArray, value) {
    const searchTree = (array) => {
        let result = null;
        for (let i = 0; result == null && i < array.length; i++) {
            result = searchNode(array[i]);
        }
        return result;
    };
    const searchNode = (item) => {
        var _a;
        if (item.value === value) {
            return item;
        }
        else if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
            return searchTree(item.children);
        }
        return null;
    };
    return searchTree(treelikeArray);
}
class TreelikeDropdownComponent extends BaseFormControl {
    constructor() {
        super(...arguments);
        this.labelPosition = 'top';
        this.clearable = true;
        this.truncate = true;
        this.placeholder = 'Select Option';
        this.notFoundText = 'No items found';
        this.dropdownPosition = 'auto';
        this.appendTo = 'body';
        this.id = 'treelike-select';
        this.withCount = false;
        this.items = [];
        this.currentItems = [];
        this.itemParentMap = new Map();
        this.itemParentsMap = new Map();
        this.virtualScroll = false;
        this.labelRemovable = false;
        this.sizeS = false;
        this.closeOnSelect = false;
        this.disabled = false;
        this.valueChange = new EventEmitter();
        this.change = new EventEmitter();
        this.remove = new EventEmitter();
        this.scroll = new EventEmitter();
        this.close = new EventEmitter();
        this.clear = new EventEmitter();
        this.navigate = new EventEmitter();
        this.parentElements = [];
        this.icons = { facChevronLeft, facChevronRight };
    }
    set setDisable(value) {
        this.setDisabledState(value);
    }
    ngOnChanges(changes) {
        var _a;
        (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.update();
    }
    ngOnInit() {
        super.ngOnInit();
        this.sizeS = this.dropdownEl.nativeElement.parentNode.classList.contains('size-s');
        this.initItemParents();
        this.currentItems = this.items;
        if (this.ngSelect) {
            this.ngSelect.toggleItem = () => { };
        }
    }
    initItemParents() {
        this.items.forEach(item => this.mapItemParent(item, this.items));
        console.log(this.itemParentMap);
        console.log(this.itemParentsMap);
    }
    mapItemParent(item, parents) {
        item.children.forEach(i => {
            this.itemParentMap.set(i.value, item);
            this.itemParentsMap.set(i.value, parents);
            i.icon = this.icons.facChevronLeft;
            this.mapItemParent(i, item.children);
        });
    }
    getOptionLabel(item) {
        return this.withCount && item.count
            ? `${item.label} (${item.count})`
            : item.label;
    }
    getLabel(value) {
        return this.buildLabel(searchTreelikeArray(this.items, value));
    }
    buildLabel(item) {
        return this.itemParentMap.get(item === null || item === void 0 ? void 0 : item.value)
            ? `${this.buildLabel(this.itemParentMap.get(item === null || item === void 0 ? void 0 : item.value))} / ${item.label}`
            : item === null || item === void 0 ? void 0 : item.label;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    addParentsEventListener(ngSelect) {
        this.scrollFn = () => {
            if (ngSelect.isOpen) {
                ngSelect.close();
                this.removeParentsEventListener();
            }
        };
        this.parentElements = [];
        let parentElement = this.dropdownEl.nativeElement.parentElement;
        do {
            this.parentElements.push(parentElement);
            parentElement.addEventListener('scroll', this.scrollFn);
            parentElement = parentElement.parentElement;
        } while (parentElement);
    }
    removeParentsEventListener() {
        this.parentElements.forEach(element => {
            element.removeEventListener('scroll', this.scrollFn);
        });
    }
    onOpen() {
        this.currentItems = this.items;
        this.ngSelect.classes =
            'treelike-dropdown-select ' +
                (this.disabled ? 'treelike-dropdown-select--disabled' : '');
        setTimeout(() => {
            var _a, _b;
            this.perfectScrollbar = new PerfectScrollbar((_b = (_a = this.ngSelect) === null || _a === void 0 ? void 0 : _a.dropdownPanel) === null || _b === void 0 ? void 0 : _b.contentElementRef.nativeElement.parentNode, {
                wheelPropagation: true
            });
            this.addParentsEventListener(this.ngSelect);
        });
    }
    goBackToParens(item) {
        var _a;
        if ((_a = this.itemParentsMap.get(item.value)) === null || _a === void 0 ? void 0 : _a.length) {
            this.currentItems = this.itemParentsMap.get(item.value);
        }
    }
    handleChange(item) {
        var _a;
        if ((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length) {
            this.currentItems = item.children;
        }
        else {
            if (this.truncate) {
                this.handleChangeForTruncate();
            }
            this.value = (item === null || item === void 0 ? void 0 : item.value) || null;
            this.change.emit((item === null || item === void 0 ? void 0 : item.value) || null);
            this.updateModel((item === null || item === void 0 ? void 0 : item.value) || null);
            if (this.ngSelect.isOpen) {
                this.ngSelect.close();
            }
        }
    }
    handleChangeForTruncate() {
        const selectContainer = this.selectControlEl.nativeElement.querySelector('.ng-value-container');
        if (selectContainer) {
            setTimeout(() => {
                if (selectContainer.offsetWidth < selectContainer.scrollWidth) {
                    selectContainer.title = Array.from(selectContainer.children)
                        .slice(1)
                        .map(x => x.textContent)
                        .filter(Boolean)
                        .join(', ');
                }
                else {
                    selectContainer.title = '';
                }
            });
        }
    }
    updateModel(value) {
        if (this.ngControl) {
            this.onChange(value);
            this.onTouched();
        }
        this.valueChange.emit(value);
    }
    handleRemove(value) {
        this.remove.emit(value);
    }
    onScroll() {
        this.scroll.emit();
    }
    onClear() {
        this.clear.emit();
    }
    onClose() {
        var _a;
        this.removeParentsEventListener();
        (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.destroy();
        if (typeof this.validation === 'function') {
            this.validationError = this.validation(this.value);
        }
        this.close.emit(this.value);
    }
    onScrollToEnd(value) {
        this.scroll.emit(value);
    }
    ngOnDestroy() {
        this.removeParentsEventListener();
    }
}
TreelikeDropdownComponent.ɵfac = /*@__PURE__*/ function () { let ɵTreelikeDropdownComponent_BaseFactory; return function TreelikeDropdownComponent_Factory(t) { return (ɵTreelikeDropdownComponent_BaseFactory || (ɵTreelikeDropdownComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TreelikeDropdownComponent)))(t || TreelikeDropdownComponent); }; }();
TreelikeDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TreelikeDropdownComponent, selectors: [["lib-treelike-dropdown"]], viewQuery: function TreelikeDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgSelectComponent, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c41, 7, ElementRef);
        ɵngcc0.ɵɵviewQuery(NgSelectComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectControlEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngSelect = _t.first);
    } }, hostAttrs: [1, "treelike-dropdown"], inputs: { labelPosition: "labelPosition", clearable: "clearable", truncate: "truncate", placeholder: "placeholder", notFoundText: "notFoundText", dropdownPosition: "dropdownPosition", appendTo: "appendTo", id: "id", withCount: "withCount", items: "items", virtualScroll: "virtualScroll", labelRemovable: "labelRemovable", setDisable: "setDisable", width: "width", minWidth: "minWidth", maxWidth: "maxWidth", label: "label", validation: "validation", optionTemplateRef: "optionTemplateRef", labelTemplateRef: "labelTemplateRef" }, outputs: { valueChange: "valueChange", change: "change", remove: "remove", scroll: "scroll", close: "close", clear: "clear", navigate: "navigate" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3, decls: 9, vars: 37, consts: [[3, "class", "disabled", 4, "ngIf"], ["perfect-scrollbar-styles", "", 1, "treelike-dropdown", 3, "ngClass"], ["treelikeDropdown", ""], [1, "treelike-dropdown-select", 3, "ngModel", "items", "bindValue", "bindLabel", "placeholder", "notFoundText", "disabled", "virtualScroll", "multiple", "closeOnSelect", "clearable", "appendTo", "dropdownPosition", "ngModelChange", "open", "change", "remove", "blur", "scroll", "scrollToEnd", "close", "clear"], ["controlContainer", ""], ["ng-option-tmp", ""], ["ng-label-tmp", ""], ["class", "validation-error", 3, "size-s", 4, "ngIf"], [3, "message", 4, "ngIf"], ["class", "mandatory", 4, "ngIf"], [1, "mandatory"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultOptionTemplate", ""], [1, "go-to-parent", 3, "click"], ["class", "font-16px", 3, "icon", 4, "ngIf"], [1, "treelike-option", 3, "click"], [1, "option-label"], [1, "go-to-child"], [1, "font-16px", 3, "icon"], ["defaultLabelTemplate", ""], [1, "value-label"], [1, "validation-error"], ["icon", "facExclamationCircle", 1, "fa"], [3, "message"]], template: function TreelikeDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TreelikeDropdownComponent_span_0_Template, 4, 7, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2)(3, "ng-select", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function TreelikeDropdownComponent_Template_ng_select_ngModelChange_3_listener($event) { return ctx.value = $event; })("open", function TreelikeDropdownComponent_Template_ng_select_open_3_listener() { return ctx.onOpen(); })("change", function TreelikeDropdownComponent_Template_ng_select_change_3_listener($event) { return ctx.handleChange($event); })("remove", function TreelikeDropdownComponent_Template_ng_select_remove_3_listener($event) { return ctx.handleRemove($event); })("blur", function TreelikeDropdownComponent_Template_ng_select_blur_3_listener() { return ctx.onTouched(); })("scroll", function TreelikeDropdownComponent_Template_ng_select_scroll_3_listener($event) { return ctx.onScrollToEnd($event); })("scrollToEnd", function TreelikeDropdownComponent_Template_ng_select_scrollToEnd_3_listener() { return ctx.onScroll(); })("close", function TreelikeDropdownComponent_Template_ng_select_close_3_listener() { return ctx.onClose(); })("clear", function TreelikeDropdownComponent_Template_ng_select_clear_3_listener() { return ctx.onClear(); });
        ɵngcc0.ɵɵtemplate(5, TreelikeDropdownComponent_ng_template_5_Template, 3, 4, "ng-template", 5);
        ɵngcc0.ɵɵtemplate(6, TreelikeDropdownComponent_ng_template_6_Template, 3, 4, "ng-template", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, TreelikeDropdownComponent_div_7_Template, 3, 3, "div", 7);
        ɵngcc0.ɵɵtemplate(8, TreelikeDropdownComponent_lib_app_warning_message_8_Template, 1, 1, "lib-app-warning-message", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction5(31, _c43, ctx.labelPosition === "left", ctx.validationError || ctx.hasErrors, ctx.clearable, ctx.warning, ctx.sizeS));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("min-width", ctx.minWidth, "px")("max-width", ctx.maxWidth, "px")("width", ctx.width, "px")("max-height", ctx.height * 2, "px");
        ɵngcc0.ɵɵclassProp("select--append-to", !!ctx.appendTo)("truncated", ctx.truncate);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("items", ctx.currentItems)("bindValue", "value")("bindLabel", "label")("placeholder", ctx.placeholder)("notFoundText", ctx.notFoundText)("disabled", ctx.disabled)("virtualScroll", ctx.virtualScroll)("multiple", false)("closeOnSelect", ctx.closeOnSelect)("clearable", ctx.clearable)("appendTo", ctx.appendTo)("dropdownPosition", ctx.dropdownPosition);
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null)("data-test-id", ctx.id);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.validationError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.warning);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc7.NgSelectComponent, ɵngcc7.ɵf, ɵngcc7.ɵh, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, WarningMessageComponent, PerfectScrollbarStylesComponent], styles: [".treelike-dropdown-select .ng-option-marked,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled),   .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover{display:flex!important;flex-direction:row!important;padding:0!important}  .treelike-dropdown-select .ng-option-marked .go-to-parent,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled) .go-to-parent,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover .go-to-parent{align-items:center;display:flex;justify-content:flex-start;margin:0 8px 0 0;padding:10px 0 10px 16px;width:32px}  .treelike-dropdown-select .ng-option-marked .treelike-option,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled) .treelike-option,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover .treelike-option{display:flex;flex-direction:row;padding:10px 16px 10px 0;width:100%}  .treelike-dropdown-select .ng-option-marked .treelike-option .go-to-child,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled) .treelike-option .go-to-child,   .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover .treelike-option .go-to-child{align-items:center;display:flex;justify-content:flex-end;margin:0 0 0 8px;width:32px}  .treelike-dropdown-select .ng-dropdown-panel-items fa-icon,   .treelike-dropdown-select .ng-dropdown-panel-items path,   .treelike-dropdown-select .ng-dropdown-panel-items svg,   .treelike-dropdown-select .ng-dropdown-panel fa-icon,   .treelike-dropdown-select .ng-dropdown-panel path,   .treelike-dropdown-select .ng-dropdown-panel svg,   .treelike-dropdown-select .ng-option-marked fa-icon,   .treelike-dropdown-select .ng-option-marked path,   .treelike-dropdown-select .ng-option-marked svg,   .treelike-dropdown-select .ng-option:hover fa-icon,   .treelike-dropdown-select .ng-option:hover path,   .treelike-dropdown-select .ng-option:hover svg,   .treelike-dropdown-select .ng-option fa-icon,   .treelike-dropdown-select .ng-option path,   .treelike-dropdown-select .ng-option svg,   .treelike-dropdown-select .treelike-option fa-icon,   .treelike-dropdown-select .treelike-option path,   .treelike-dropdown-select .treelike-option svg{color:var(--da-brand-base)!important}.size-l[_nghost-%COMP%]     .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important}[_nghost-%COMP%]     .ng-select-disabled .ng-arrow:before{content:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23BDBCBC%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")!important}.label[_ngcontent-%COMP%]{color:var(--da-title);display:block;font-size:11px}.label.label-left[_ngcontent-%COMP%]{line-height:28px;margin-right:7px}.label.label-top[_ngcontent-%COMP%]{margin-bottom:7px}.label.disabled[_ngcontent-%COMP%]{color:var(--da-title)}.label[_ngcontent-%COMP%]   .mandatory[_ngcontent-%COMP%]{color:var(--da-error-base)}.internal-header[_ngcontent-%COMP%]{color:var(--da-title);font-weight:700}.multiple-header[_ngcontent-%COMP%]{font-size:14px;line-height:18px}.multiple-header-border[_ngcontent-%COMP%]{border:4px solid transparent}.multiple-header-btn[_ngcontent-%COMP%]{color:var(--da-brand-base);cursor:pointer;margin:0 -.2rem;padding:0 .25rem}.multiple-header-btn[_ngcontent-%COMP%]:focus{border:4px solid var(--da-brand-20);border-radius:4px}.multiple-header-btn[_ngcontent-%COMP%]:active   .text[_ngcontent-%COMP%], .multiple-header-btn[_ngcontent-%COMP%]:hover   .text[_ngcontent-%COMP%]{-webkit-text-decoration-line:underline;text-decoration-line:underline}.multiple-header-btn[_ngcontent-%COMP%]:not(:last-child):after{-webkit-text-decoration-line:none!important;color:var(--da-title);content:\"/\";margin-left:.25rem;text-decoration-line:none!important}.label-left[_ngcontent-%COMP%], .option-label[_ngcontent-%COMP%]{display:inline-block}.option-label[_ngcontent-%COMP%]{color:var(--da-primary-text)} .ng-dropdown-panel .ng-dropdown-panel-items{width:inherit} .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .option-label{overflow:hidden;text-overflow:ellipsis;width:100%}.option-checkbox[_ngcontent-%COMP%]{float:left}[_nghost-%COMP%]  .treelike-dropdown{cursor:pointer!important}[_nghost-%COMP%]  .treelike-dropdown .treelike-dropdown-select{height:inherit}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container{background:var(--da-cards-and-blocks);cursor:pointer!important}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container *{color:var(--da-primary-text)}[_nghost-%COMP%]  .treelike-dropdown .ng-input>input{cursor:text!important}[_nghost-%COMP%]  .treelike-dropdown .ng-select-opened .ng-arrow-wrapper{transform:rotate(180deg)}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container{border:4px solid var(--da-brand-20);border-radius:4px!important;height:calc(100% + 3px)!important;margin:0 -3px;width:calc(100% + 6px)}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-arrow-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-value{margin-top:-3px!important}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container{border:1px solid var(--da-brand-base)!important;height:100%!important;margin:0!important;width:100%!important}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper{padding-right:--2px}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-arrow-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-value, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-arrow-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-value{margin-top:0!important}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled) .ng-placeholder{color:var(--da-disable)!important}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled):active .ng-select-container, [_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled):hover .ng-select-container{border:1px solid var(--da-brand-base)!important;margin:0!important;width:100%!important}[_nghost-%COMP%]  .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select.ng-select-disabled .ng-input>input{color:var(--da-disable)!important}[_nghost-%COMP%]  .treelike-dropdown.has-validation-error .ng-select-container{border:1px solid var(--da-error-base)!important}[_nghost-%COMP%]  .treelike-dropdown .ng-value-container{display:flex!important;height:inherit;overflow:auto}[_nghost-%COMP%]  .treelike-dropdown .ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border:4px solid var(--da-brand-20);border-radius:4px!important;box-shadow:none;outline:none}[_nghost-%COMP%]  .treelike-dropdown .ng-select-single .ng-select-container{padding-left:8px}[_nghost-%COMP%]  .treelike-dropdown .ng-select-disabled .ng-select-container{background-color:rgba(0,0,0,.04)}[_nghost-%COMP%]  .treelike-dropdown .ng-select-disabled .ng-select-container .ng-placeholder, [_nghost-%COMP%]  .treelike-dropdown .ng-select-disabled .ng-select-container .option-label, [_nghost-%COMP%]  .treelike-dropdown .ng-select-disabled .ng-select-container .value-label{color:var(--da-disable)}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container{border:1px solid var(--da-border-and-dividers);border-radius:4px;height:inherit!important;min-height:auto!important;padding:0 8px 0 0}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container .ng-clear, [_nghost-%COMP%]  .treelike-dropdown .ng-select-container .ng-clear-wrapper:hover .ng-clear{color:var(--da-disable)!important;font-size:16px!important}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container .ng-arrow-wrapper{height:24px;padding:0;width:24px}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow{height:16px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:16px}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;-webkit-mask-size:contain;background:var(--da-brand-base);color:var(--da-brand-base);content:\"\";display:inline-block;height:14px;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;mask-size:contain;width:14px}[_nghost-%COMP%]  .treelike-dropdown .ng-select-container .ng-input{display:none!important;left:-3px!important;top:auto!important}[_nghost-%COMP%]  .treelike-dropdown .ng-dropdown-panel{border:var(--da-dropdown-border);border-radius:var(--da-dropdown-border-radius);box-shadow:var(--da-dropdown-box-shadow)}[_nghost-%COMP%]  .treelike-dropdown .ng-dropdown-panel .ng-option{color:var(--da-primary-text);cursor:pointer;padding:12px 19px;white-space:inherit}[_nghost-%COMP%]  .treelike-dropdown .ng-dropdown-panel .ng-option-selected{background-color:var(--da-cards-and-blocks)}[_nghost-%COMP%]  .treelike-dropdown .ng-dropdown-panel .ng-option-selected.ng-option-marked{color:var(--da-brand-base)}[_nghost-%COMP%]  .treelike-dropdown .ng-dropdown-panel .ng-option-marked{background-color:var(--da-background);color:var(--da-brand-base)}[_nghost-%COMP%]  .treelike-dropdown.label-left{float:right}[_nghost-%COMP%]  .treelike-dropdown .icons{color:var(--da-secondary-text-and-icons);cursor:pointer}[_nghost-%COMP%]  .treelike-dropdown .icons:hover{color:var(--da-secondary-text-and-icons)}[_nghost-%COMP%]  .treelike-dropdown-multiple:not(.has-validation-error) .ng-select-focused:not(:hover):not(:active) .ng-value-container .ng-placeholder{margin-top:-3px}[_nghost-%COMP%]  .treelike-dropdown-multiple .ng-select-container{padding-left:8px}[_nghost-%COMP%]  .treelike-dropdown-multiple .ng-select-container .ng-value-container{display:inline-flex!important;flex-direction:row;height:100%;overflow:hidden;padding-left:0;padding-top:0}[_nghost-%COMP%]  .treelike-dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container{align-items:center;display:inline-flex;flex-direction:row;height:100%;overflow:hidden}[_nghost-%COMP%]  .treelike-dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .perfect-scrollbar{max-height:24px;padding-right:.25rem}[_nghost-%COMP%]  .treelike-dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .ng-value{background-color:var(--da-background);border:none;border-radius:4px;color:var(--da-primary-text);margin-bottom:1px;margin-top:1px;padding:2px 6px}[_nghost-%COMP%]  .treelike-dropdown-multiple .ng-dropdown-panel .ng-option-marked, [_nghost-%COMP%]  .treelike-dropdown-multiple .ng-dropdown-panel .ng-option-marked.ng-option-selected{color:var(--da-primary-text)}[_nghost-%COMP%]  .treelike-dropdown-multiple.multiline .ng-select-container .ng-value-container .multiple-label-container, [_nghost-%COMP%]  .treelike-dropdown-multiple.show-input.multiline .ng-select-container .ng-value-container .multiple-label-container{max-width:100%}[_nghost-%COMP%]  .treelike-dropdown-multiple.show-input .ng-select-container .ng-value-container .multiple-label-container{max-width:60%}[_nghost-%COMP%]  .treelike-dropdown-multiple.show-input .ng-select-container .ng-value-container .ng-input{display:block!important;min-width:30%;padding-bottom:0!important}[_nghost-%COMP%]  .clearable .ng-clear-wrapper{align-items:center;display:flex;justify-content:center}[_nghost-%COMP%]  .searchable .ng-select-container .ng-clear-wrapper{height:20px;width:17px}[_nghost-%COMP%]  .searchable .ng-select-container .ng-clear-wrapper .ng-clear{font-size:18px}[_nghost-%COMP%]  .searchable .ng-select-container .ng-input{display:block!important}[_nghost-%COMP%]  .has-validation-error .ng-select-container{border-color:var(--da-error-base)}.validation-error[_ngcontent-%COMP%]{color:var(--da-error-base);font-size:10px;margin-top:5px;position:absolute}.validation-error[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{cursor:pointer;font-size:14px!important;margin-right:7px}[_nghost-%COMP%]   .truncated[_ngcontent-%COMP%]     .ng-value-container{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[_nghost-%COMP%]   .truncated[_ngcontent-%COMP%]     .ng-value{display:inline}[_nghost-%COMP%]     .ng-select-multiple[disabled] .ng-clear-wrapper, [_nghost-%COMP%]     .ng-select-multiple[disabled] input, [_nghost-%COMP%]     .select--append-to .ng-dropdown-panel{display:none}  .treelike-dropdown-select--disabled .ng-dropdown-header,   .treelike-dropdown-select--disabled .ng-option,   .treelike-dropdown-select--disabled .option-checkbox{display:none!important;pointer-events:none}  .treelike-dropdown-select--disabled.ng-dropdown-panel .ng-dropdown-panel-items .ng-option-marked{background:none!important}  .treelike-dropdown-select--disabled .ng-option-selected{display:flex!important}.selected-counter[_ngcontent-%COMP%]{color:var(--da-brand-base)!important}.selected-counter-disabled[_ngcontent-%COMP%]{color:var(--da-disable)!important}"] });
TreelikeDropdownComponent.propDecorators = {
    width: [{ type: Input }],
    minWidth: [{ type: Input }],
    maxWidth: [{ type: Input }],
    label: [{ type: Input }],
    labelPosition: [{ type: Input }],
    clearable: [{ type: Input }],
    truncate: [{ type: Input }],
    placeholder: [{ type: Input }],
    notFoundText: [{ type: Input }],
    dropdownPosition: [{ type: Input }],
    appendTo: [{ type: Input }],
    validation: [{ type: Input }],
    id: [{ type: Input }],
    withCount: [{ type: Input }],
    items: [{ type: Input }],
    setDisable: [{ type: Input }],
    virtualScroll: [{ type: Input }],
    labelRemovable: [{ type: Input }],
    optionTemplateRef: [{ type: Input }],
    labelTemplateRef: [{ type: Input }],
    selectControlEl: [{ type: ViewChild, args: [NgSelectComponent, { read: ElementRef, static: true },] }],
    dropdownEl: [{ type: ViewChild, args: ['treelikeDropdown', { static: true, read: ElementRef },] }],
    ngSelect: [{ type: ViewChild, args: [NgSelectComponent, { static: true },] }],
    valueChange: [{ type: Output }],
    change: [{ type: Output }],
    remove: [{ type: Output }],
    scroll: [{ type: Output }],
    close: [{ type: Output }],
    clear: [{ type: Output }],
    navigate: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreelikeDropdownComponent, [{
        type: Component,
        args: [{ selector: 'lib-treelike-dropdown', template: "<span\n    *ngIf=\"label\"\n    class=\"label label-{{ labelPosition }}\"\n    [class.disabled]=\"disabled\"\n>\n    {{ label }}\n    <span *ngIf=\"isRequired\" class=\"mandatory\">*</span>\n    <ng-content></ng-content>\n</span>\n<div\n    perfect-scrollbar-styles\n    #treelikeDropdown\n    class=\"treelike-dropdown\"\n    [ngClass]=\"{\n        'label-left': labelPosition === 'left',\n        'has-validation-error': validationError || hasErrors,\n        clearable: clearable,\n        warning: warning,\n        'size-s': sizeS\n    }\"\n>\n    <!--    #controlContainer is necessary for base form control-->\n    <ng-select\n        class=\"treelike-dropdown-select\"\n        #controlContainer\n        [class.select--append-to]=\"!!appendTo\"\n        [attr.disabled]=\"disabled || null\"\n        [style.minWidth.px]=\"minWidth\"\n        [style.maxWidth.px]=\"maxWidth\"\n        [style.width.px]=\"width\"\n        [style.maxHeight.px]=\"height * 2\"\n        [class.truncated]=\"truncate\"\n        [(ngModel)]=\"value\"\n        [items]=\"currentItems\"\n        [bindValue]=\"'value'\"\n        [bindLabel]=\"'label'\"\n        [placeholder]=\"placeholder\"\n        [notFoundText]=\"notFoundText\"\n        [disabled]=\"disabled\"\n        [virtualScroll]=\"virtualScroll\"\n        [multiple]=\"false\"\n        [closeOnSelect]=\"closeOnSelect\"\n        [clearable]=\"clearable\"\n        [appendTo]=\"appendTo\"\n        [dropdownPosition]=\"dropdownPosition\"\n        (open)=\"onOpen()\"\n        (change)=\"handleChange($event)\"\n        (remove)=\"handleRemove($event)\"\n        (blur)=\"onTouched()\"\n        (scroll)=\"onScrollToEnd($event)\"\n        (scrollToEnd)=\"onScroll()\"\n        (close)=\"onClose()\"\n        (clear)=\"onClear()\"\n        [attr.data-test-id]=\"id\"\n    >\n        <ng-template ng-option-tmp let-item=\"item\">\n            <ng-container\n                *ngTemplateOutlet=\"\n                    defaultOptionTemplate;\n                    context: {\n                        item: item\n                    }\n                \"\n            ></ng-container>\n            <ng-template #defaultOptionTemplate>\n                <div\n                    class=\"go-to-parent\"\n                    (click)=\"\n                        currentItems.indexOf(item) === 0 &&\n                        itemParentMap.get(item.value)\n                            ? goBackToParens(item)\n                            : handleChange(item)\n                    \"\n                >\n                    <fa-icon\n                        [icon]=\"item.icon\"\n                        *ngIf=\"\n                            (currentItems.indexOf(item) === 0 &&\n                                itemParentMap.get(item.value)) ||\n                            (!itemParentMap.get(item.value) && item.icon)\n                        \"\n                        class=\"font-16px\"\n                    ></fa-icon>\n                </div>\n                <div class=\"treelike-option\" (click)=\"handleChange(item)\">\n                    <div class=\"option-label\" [class.size-s]=\"sizeS\">\n                        {{ getOptionLabel(item) }}\n                    </div>\n                    <div class=\"go-to-child\">\n                        <fa-icon\n                            [icon]=\"icons.facChevronRight\"\n                            *ngIf=\"item.children?.length\"\n                            class=\"font-16px\"\n                        ></fa-icon>\n                    </div>\n                </div>\n            </ng-template>\n        </ng-template>\n\n        <ng-template ng-label-tmp let-item=\"item\">\n            <ng-container\n                *ngTemplateOutlet=\"\n                    labelTemplateRef || defaultLabelTemplate;\n                    context: {\n                        item: item\n                    }\n                \"\n            ></ng-container>\n\n            <ng-template #defaultLabelTemplate>\n                <span class=\"value-label\" [class.size-s]=\"sizeS\">\n                    {{ getLabel(item.value) }}\n                </span>\n            </ng-template>\n        </ng-template>\n    </ng-select>\n    <div\n        *ngIf=\"validationError\"\n        class=\"validation-error\"\n        [class.size-s]=\"sizeS\"\n    >\n        <fa-icon class=\"fa\" icon=\"facExclamationCircle\"></fa-icon>\n        {{ validationError }}\n    </div>\n\n    <lib-app-warning-message\n        *ngIf=\"warning\"\n        [message]=\"warningMessage\"\n    ></lib-app-warning-message>\n</div>\n", host: { class: 'treelike-dropdown' }, styles: ["::ng-deep .treelike-dropdown-select .ng-option-marked,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled),::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover{display:flex!important;flex-direction:row!important;padding:0!important}::ng-deep .treelike-dropdown-select .ng-option-marked .go-to-parent,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled) .go-to-parent,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover .go-to-parent{align-items:center;display:flex;justify-content:flex-start;margin:0 8px 0 0;padding:10px 0 10px 16px;width:32px}::ng-deep .treelike-dropdown-select .ng-option-marked .treelike-option,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled) .treelike-option,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover .treelike-option{display:flex;flex-direction:row;padding:10px 16px 10px 0;width:100%}::ng-deep .treelike-dropdown-select .ng-option-marked .treelike-option .go-to-child,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled) .treelike-option .go-to-child,::ng-deep .treelike-dropdown-select .ng-option:not(.ng-option-disabled):hover .treelike-option .go-to-child{align-items:center;display:flex;justify-content:flex-end;margin:0 0 0 8px;width:32px}::ng-deep .treelike-dropdown-select .ng-dropdown-panel-items fa-icon,::ng-deep .treelike-dropdown-select .ng-dropdown-panel-items path,::ng-deep .treelike-dropdown-select .ng-dropdown-panel-items svg,::ng-deep .treelike-dropdown-select .ng-dropdown-panel fa-icon,::ng-deep .treelike-dropdown-select .ng-dropdown-panel path,::ng-deep .treelike-dropdown-select .ng-dropdown-panel svg,::ng-deep .treelike-dropdown-select .ng-option-marked fa-icon,::ng-deep .treelike-dropdown-select .ng-option-marked path,::ng-deep .treelike-dropdown-select .ng-option-marked svg,::ng-deep .treelike-dropdown-select .ng-option:hover fa-icon,::ng-deep .treelike-dropdown-select .ng-option:hover path,::ng-deep .treelike-dropdown-select .ng-option:hover svg,::ng-deep .treelike-dropdown-select .ng-option fa-icon,::ng-deep .treelike-dropdown-select .ng-option path,::ng-deep .treelike-dropdown-select .ng-option svg,::ng-deep .treelike-dropdown-select .treelike-option fa-icon,::ng-deep .treelike-dropdown-select .treelike-option path,::ng-deep .treelike-dropdown-select .treelike-option svg{color:var(--da-brand-base)!important}:host.size-l ::ng-deep .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M6 9L12 15L18 9%22 stroke%3D%22%232E73D0%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%!important}:host ::ng-deep .ng-select-disabled .ng-arrow:before{content:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23BDBCBC%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\")!important}.label{color:var(--da-title);display:block;font-size:11px}.label.label-left{line-height:28px;margin-right:7px}.label.label-top{margin-bottom:7px}.label.disabled{color:var(--da-title)}.label .mandatory{color:var(--da-error-base)}.internal-header{color:var(--da-title);font-weight:700}.multiple-header{font-size:14px;line-height:18px}.multiple-header-border{border:4px solid transparent}.multiple-header-btn{color:var(--da-brand-base);cursor:pointer;margin:0 -.2rem;padding:0 .25rem}.multiple-header-btn:focus{border:4px solid var(--da-brand-20);border-radius:4px}.multiple-header-btn:active .text,.multiple-header-btn:hover .text{-webkit-text-decoration-line:underline;text-decoration-line:underline}.multiple-header-btn:not(:last-child):after{-webkit-text-decoration-line:none!important;color:var(--da-title);content:\"/\";margin-left:.25rem;text-decoration-line:none!important}.label-left,.option-label{display:inline-block}.option-label{color:var(--da-primary-text)}::ng-deep.ng-dropdown-panel .ng-dropdown-panel-items{width:inherit}::ng-deep.ng-dropdown-panel .ng-dropdown-panel-items .ng-option .option-label{overflow:hidden;text-overflow:ellipsis;width:100%}.option-checkbox{float:left}:host::ng-deep .treelike-dropdown{cursor:pointer!important}:host::ng-deep .treelike-dropdown .treelike-dropdown-select{height:inherit}:host::ng-deep .treelike-dropdown .ng-select-container{background:var(--da-cards-and-blocks);cursor:pointer!important}:host::ng-deep .treelike-dropdown .ng-select-container *{color:var(--da-primary-text)}:host::ng-deep .treelike-dropdown .ng-input>input{cursor:text!important}:host::ng-deep .treelike-dropdown .ng-select-opened .ng-arrow-wrapper{transform:rotate(180deg)}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container{border:4px solid var(--da-brand-20);border-radius:4px!important;height:calc(100% + 3px)!important;margin:0 -3px;width:calc(100% + 6px)}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-arrow-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-clear-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused .ng-select-container .ng-value{margin-top:-3px!important}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container{border:1px solid var(--da-brand-base)!important;height:100%!important;margin:0!important;width:100%!important}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper{padding-right:--2px}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-arrow-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-clear-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:active .ng-select-container .ng-value,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-arrow-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-clear-wrapper,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled).ng-select-focused:hover .ng-select-container .ng-value{margin-top:0!important}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled) .ng-placeholder{color:var(--da-disable)!important}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled):active .ng-select-container,:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select:not(.ng-select-disabled):hover .ng-select-container{border:1px solid var(--da-brand-base)!important;margin:0!important;width:100%!important}:host::ng-deep .treelike-dropdown:not(.has-validation-error) .treelike-dropdown-select.ng-select-disabled .ng-input>input{color:var(--da-disable)!important}:host::ng-deep .treelike-dropdown.has-validation-error .ng-select-container{border:1px solid var(--da-error-base)!important}:host::ng-deep .treelike-dropdown .ng-value-container{display:flex!important;height:inherit;overflow:auto}:host::ng-deep .treelike-dropdown .ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border:4px solid var(--da-brand-20);border-radius:4px!important;box-shadow:none;outline:none}:host::ng-deep .treelike-dropdown .ng-select-single .ng-select-container{padding-left:8px}:host::ng-deep .treelike-dropdown .ng-select-disabled .ng-select-container{background-color:rgba(0,0,0,.04)}:host::ng-deep .treelike-dropdown .ng-select-disabled .ng-select-container .ng-placeholder,:host::ng-deep .treelike-dropdown .ng-select-disabled .ng-select-container .option-label,:host::ng-deep .treelike-dropdown .ng-select-disabled .ng-select-container .value-label{color:var(--da-disable)}:host::ng-deep .treelike-dropdown .ng-select-container{border:1px solid var(--da-border-and-dividers);border-radius:4px;height:inherit!important;min-height:auto!important;padding:0 8px 0 0}:host::ng-deep .treelike-dropdown .ng-select-container .ng-clear,:host::ng-deep .treelike-dropdown .ng-select-container .ng-clear-wrapper:hover .ng-clear{color:var(--da-disable)!important;font-size:16px!important}:host::ng-deep .treelike-dropdown .ng-select-container .ng-arrow-wrapper{height:24px;padding:0;width:24px}:host::ng-deep .treelike-dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow{height:16px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:16px}:host::ng-deep .treelike-dropdown .ng-select-container .ng-arrow-wrapper .ng-arrow:before{-webkit-mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;-webkit-mask-size:contain;background:var(--da-brand-base);color:var(--da-brand-base);content:\"\";display:inline-block;height:14px;mask:url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cpath d%3D%22M4 6L8 10L12 6%22 stroke%3D%22%23327DE2%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;mask-size:contain;width:14px}:host::ng-deep .treelike-dropdown .ng-select-container .ng-input{display:none!important;left:-3px!important;top:auto!important}:host::ng-deep .treelike-dropdown .ng-dropdown-panel{border:var(--da-dropdown-border);border-radius:var(--da-dropdown-border-radius);box-shadow:var(--da-dropdown-box-shadow)}:host::ng-deep .treelike-dropdown .ng-dropdown-panel .ng-option{color:var(--da-primary-text);cursor:pointer;padding:12px 19px;white-space:inherit}:host::ng-deep .treelike-dropdown .ng-dropdown-panel .ng-option-selected{background-color:var(--da-cards-and-blocks)}:host::ng-deep .treelike-dropdown .ng-dropdown-panel .ng-option-selected.ng-option-marked{color:var(--da-brand-base)}:host::ng-deep .treelike-dropdown .ng-dropdown-panel .ng-option-marked{background-color:var(--da-background);color:var(--da-brand-base)}:host::ng-deep .treelike-dropdown.label-left{float:right}:host::ng-deep .treelike-dropdown .icons{color:var(--da-secondary-text-and-icons);cursor:pointer}:host::ng-deep .treelike-dropdown .icons:hover{color:var(--da-secondary-text-and-icons)}:host::ng-deep .treelike-dropdown-multiple:not(.has-validation-error) .ng-select-focused:not(:hover):not(:active) .ng-value-container .ng-placeholder{margin-top:-3px}:host::ng-deep .treelike-dropdown-multiple .ng-select-container{padding-left:8px}:host::ng-deep .treelike-dropdown-multiple .ng-select-container .ng-value-container{display:inline-flex!important;flex-direction:row;height:100%;overflow:hidden;padding-left:0;padding-top:0}:host::ng-deep .treelike-dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container{align-items:center;display:inline-flex;flex-direction:row;height:100%;overflow:hidden}:host::ng-deep .treelike-dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .perfect-scrollbar{max-height:24px;padding-right:.25rem}:host::ng-deep .treelike-dropdown-multiple .ng-select-container .ng-value-container .multiple-label-container .ng-value{background-color:var(--da-background);border:none;border-radius:4px;color:var(--da-primary-text);margin-bottom:1px;margin-top:1px;padding:2px 6px}:host::ng-deep .treelike-dropdown-multiple .ng-dropdown-panel .ng-option-marked,:host::ng-deep .treelike-dropdown-multiple .ng-dropdown-panel .ng-option-marked.ng-option-selected{color:var(--da-primary-text)}:host::ng-deep .treelike-dropdown-multiple.multiline .ng-select-container .ng-value-container .multiple-label-container,:host::ng-deep .treelike-dropdown-multiple.show-input.multiline .ng-select-container .ng-value-container .multiple-label-container{max-width:100%}:host::ng-deep .treelike-dropdown-multiple.show-input .ng-select-container .ng-value-container .multiple-label-container{max-width:60%}:host::ng-deep .treelike-dropdown-multiple.show-input .ng-select-container .ng-value-container .ng-input{display:block!important;min-width:30%;padding-bottom:0!important}:host::ng-deep .clearable .ng-clear-wrapper{align-items:center;display:flex;justify-content:center}:host::ng-deep .searchable .ng-select-container .ng-clear-wrapper{height:20px;width:17px}:host::ng-deep .searchable .ng-select-container .ng-clear-wrapper .ng-clear{font-size:18px}:host::ng-deep .searchable .ng-select-container .ng-input{display:block!important}:host::ng-deep .has-validation-error .ng-select-container{border-color:var(--da-error-base)}.validation-error{color:var(--da-error-base);font-size:10px;margin-top:5px;position:absolute}.validation-error .fa{cursor:pointer;font-size:14px!important;margin-right:7px}:host .truncated ::ng-deep .ng-value-container{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .truncated ::ng-deep .ng-value{display:inline}:host ::ng-deep .ng-select-multiple[disabled] .ng-clear-wrapper,:host ::ng-deep .ng-select-multiple[disabled] input,:host ::ng-deep .select--append-to .ng-dropdown-panel{display:none}::ng-deep .treelike-dropdown-select--disabled .ng-dropdown-header,::ng-deep .treelike-dropdown-select--disabled .ng-option,::ng-deep .treelike-dropdown-select--disabled .option-checkbox{display:none!important;pointer-events:none}::ng-deep .treelike-dropdown-select--disabled.ng-dropdown-panel .ng-dropdown-panel-items .ng-option-marked{background:none!important}::ng-deep .treelike-dropdown-select--disabled .ng-option-selected{display:flex!important}.selected-counter{color:var(--da-brand-base)!important}.selected-counter-disabled{color:var(--da-disable)!important}"] }]
    }], null, { labelPosition: [{
            type: Input
        }], clearable: [{
            type: Input
        }], truncate: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], notFoundText: [{
            type: Input
        }], dropdownPosition: [{
            type: Input
        }], appendTo: [{
            type: Input
        }], id: [{
            type: Input
        }], withCount: [{
            type: Input
        }], items: [{
            type: Input
        }], virtualScroll: [{
            type: Input
        }], labelRemovable: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], change: [{
            type: Output
        }], remove: [{
            type: Output
        }], scroll: [{
            type: Output
        }], close: [{
            type: Output
        }], clear: [{
            type: Output
        }], navigate: [{
            type: Output
        }], setDisable: [{
            type: Input
        }], width: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], label: [{
            type: Input
        }], validation: [{
            type: Input
        }], optionTemplateRef: [{
            type: Input
        }], labelTemplateRef: [{
            type: Input
        }], selectControlEl: [{
            type: ViewChild,
            args: [NgSelectComponent, { read: ElementRef, static: true }]
        }], dropdownEl: [{
            type: ViewChild,
            args: ['treelikeDropdown', { static: true, read: ElementRef }]
        }], ngSelect: [{
            type: ViewChild,
            args: [NgSelectComponent, { static: true }]
        }] }); })();

class TooltipTruncatedElementDirective {
}
TooltipTruncatedElementDirective.ɵfac = function TooltipTruncatedElementDirective_Factory(t) { return new (t || TooltipTruncatedElementDirective)(); };
TooltipTruncatedElementDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipTruncatedElementDirective, selectors: [["", "libTooltipTruncatedElement", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipTruncatedElementDirective, [{
        type: Directive,
        args: [{
                selector: '[libTooltipTruncatedElement]'
            }]
    }], null, null); })();
class TooltipWhenOverflowDirective {
    constructor(elRef, tooltip, zone) {
        this.elRef = elRef;
        this.tooltip = tooltip;
        this.zone = zone;
        this.textElementSelectorFn = identity;
        this.hoverElementSelectorFn = identity;
        this.overflowEnabled = true;
        this.onMouseEnter = () => {
            this.textElement = this.textElementSelectorFn(this.elRef.nativeElement);
            if (!this.overflowEnabled ||
                (this.tooltip && this.isOverflow() && !this.tooltip.isOpen())) {
                this.zone.run(() => {
                    this.tooltip.open();
                });
            }
        };
        this.onMouseLeave = () => {
            if (!this.overflowEnabled || (this.tooltip && this.tooltip.isOpen())) {
                this.zone.run(() => {
                    this.tooltip.close();
                });
            }
        };
    }
    ngOnInit() {
        this.textElement = this.textElementSelectorFn(this.elRef.nativeElement);
        this.hoverElement = this.hoverElementSelectorFn(this.elRef.nativeElement);
        this.zone.runOutsideAngular(() => {
            this.hoverElement.addEventListener('mouseenter', this.onMouseEnter);
            this.hoverElement.addEventListener('mouseleave', this.onMouseLeave);
        });
    }
    isOverflow() {
        var _a;
        if ((_a = this.truncatedElements) === null || _a === void 0 ? void 0 : _a.length) {
            return this.truncatedElements.some(({ nativeElement }) => elementIsOverflowed(nativeElement));
        }
        return (Array.isArray(this.textElement)
            ? this.textElement
            : [this.textElement]).some(element => elementIsOverflowed(element));
    }
    ngOnDestroy() {
        this.hoverElement.removeEventListener('mouseenter', this.onMouseEnter);
        this.hoverElement.removeEventListener('mouseleave', this.onMouseLeave);
    }
}
TooltipWhenOverflowDirective.ɵfac = function TooltipWhenOverflowDirective_Factory(t) { return new (t || TooltipWhenOverflowDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbTooltip), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TooltipWhenOverflowDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipWhenOverflowDirective, selectors: [["", "libTooltipWhenOverflow", ""]], contentQueries: function TooltipWhenOverflowDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TooltipTruncatedElementDirective, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.truncatedElements = _t);
    } }, inputs: { textElementSelectorFn: "textElementSelectorFn", hoverElementSelectorFn: "hoverElementSelectorFn", overflowEnabled: "overflowEnabled" } });
TooltipWhenOverflowDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgbTooltip },
    { type: NgZone }
];
TooltipWhenOverflowDirective.propDecorators = {
    textElementSelectorFn: [{ type: Input }],
    hoverElementSelectorFn: [{ type: Input }],
    overflowEnabled: [{ type: Input }],
    truncatedElements: [{ type: ContentChildren, args: [TooltipTruncatedElementDirective, {
                    read: ElementRef,
                    descendants: true
                },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipWhenOverflowDirective, [{
        type: Directive,
        args: [{
                selector: '[libTooltipWhenOverflow]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc5.NgbTooltip }, { type: ɵngcc0.NgZone }]; }, { textElementSelectorFn: [{
            type: Input
        }], hoverElementSelectorFn: [{
            type: Input
        }], overflowEnabled: [{
            type: Input
        }], truncatedElements: [{
            type: ContentChildren,
            args: [TooltipTruncatedElementDirective, {
                    read: ElementRef,
                    descendants: true
                }]
        }] }); })();
function elementIsOverflowed({ clientWidth, scrollWidth }) {
    return clientWidth < scrollWidth;
}
class TooltipWhenOverflowModule {
}
TooltipWhenOverflowModule.ɵfac = function TooltipWhenOverflowModule_Factory(t) { return new (t || TooltipWhenOverflowModule)(); };
TooltipWhenOverflowModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TooltipWhenOverflowModule });
TooltipWhenOverflowModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipWhenOverflowModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TooltipTruncatedElementDirective,
                    TooltipWhenOverflowDirective
                ],
                exports: [TooltipTruncatedElementDirective, TooltipWhenOverflowDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipWhenOverflowModule, { declarations: [TooltipTruncatedElementDirective, TooltipWhenOverflowDirective], exports: [TooltipTruncatedElementDirective, TooltipWhenOverflowDirective] }); })();

class TreelikeMenuComponent {
    constructor() {
        this.minWidth = 300;
        this.maxWidth = 300;
        this.minHeight = 0;
        this.maxHeight = 340;
        this.treeItems = [];
        this.openIcon = 'ellipsis';
        this.openIconStyles = {};
        this.returnIcon = facChevronLeft;
        this.nextIcon = facChevronRight;
        this.btnClasses = 'btn-primary';
        this.closeOnClick = false;
        this.closeOnScroll = false;
        this.currentTreeItems = [];
        this.isFirstLevel = true;
        this.parentElements = [];
        this.itemParentsMap = new Map();
    }
    handleItemClick(item, event) {
        if (!item.disabled) {
            if (item.children) {
                this.currentTreeItems = item.children;
                this.isItFirstLevel();
            }
            else if (item.actionHandler) {
                item.actionHandler(item, event);
                if (this.closeOnClick) {
                    this.dropdown.close();
                }
            }
        }
    }
    handleReturnClick(item) {
        if (!this.isFirstLevel) {
            this.currentTreeItems = this.itemParentsMap.get(item);
            this.isItFirstLevel();
        }
    }
    resetDropdown(element, dropdown) {
        this.currentTreeItems = this.treeItems;
        this.isItFirstLevel();
        if (this.closeOnScroll) {
            dropdown.isOpen()
                ? this.addParentsEventListener(element, dropdown)
                : this.removeParentsEventListener();
        }
    }
    addParentsEventListener(element, dropdown) {
        this.scrollFn = () => {
            dropdown.close();
            this.removeParentsEventListener();
        };
        this.parentElements = [];
        let parentElement = element.parentElement;
        do {
            this.parentElements.push(parentElement);
            parentElement.addEventListener('scroll', this.scrollFn);
            parentElement = parentElement.parentElement;
        } while (parentElement);
    }
    removeParentsEventListener() {
        this.parentElements.forEach(element => {
            element.removeEventListener('scroll', this.scrollFn);
        });
    }
    isItFirstLevel() {
        this.isFirstLevel = !this.currentTreeItems.some(group => this.itemParentsMap.get(group));
    }
    mapItemParent(items) {
        items.forEach(group => {
            group.items.forEach(groupItem => {
                if (groupItem.children) {
                    groupItem.children.forEach(groupItemGroups => {
                        this.itemParentsMap.set(groupItemGroups, items);
                    });
                    this.mapItemParent(groupItem.children);
                }
            });
        });
    }
    ngOnChanges(changes) {
        if (changes.treeItems) {
            this.currentTreeItems = this.treeItems;
            this.mapItemParent(this.treeItems);
        }
    }
    ngOnDestroy() {
        this.removeParentsEventListener();
    }
}
TreelikeMenuComponent.ɵfac = function TreelikeMenuComponent_Factory(t) { return new (t || TreelikeMenuComponent)(); };
TreelikeMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TreelikeMenuComponent, selectors: [["lib-treelike-menu"]], viewQuery: function TreelikeMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDropdown, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, inputs: { minWidth: "minWidth", maxWidth: "maxWidth", minHeight: "minHeight", maxHeight: "maxHeight", treeItems: "treeItems", openIcon: "openIcon", openIconStyles: "openIconStyles", returnIcon: "returnIcon", nextIcon: "nextIcon", btnClasses: "btnClasses", closeOnClick: "closeOnClick", closeOnScroll: "closeOnScroll" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 18, consts: [["ngbDropdown", "", "container", "body", "autoClose", "outside", "data-test-id", "menu-dropdown-container", 3, "openChange"], ["element", "", "dropdown", "ngbDropdown"], ["type", "button", "data-test-id", "menu-dropdown-button", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primar", 3, "icon", "ngStyle"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdown-container"], [1, "treelike-menu-scrollbar"], [4, "ngFor", "ngForOf"], ["class", "dropdown-divider", 4, "ngIf"], ["class", "d-flex mr-36px group-name align-items-center", 3, "ml-3", "first-group", "click", 4, "ngIf"], ["type", "button", "ngbDropdownItem", "", "data-test-id", "item", 3, "ngClass", "disabled", "click", 4, "ngFor", "ngForOf"], [1, "dropdown-divider"], [1, "d-flex", "mr-36px", "group-name", "align-items-center", 3, "click"], ["data-test-id", "returnButton", "class", "color-brand px-10px text-nowrap font-16px", 3, "icon", 4, "ngIf"], [1, "d-inline-block", "mt-0", "text-truncate"], ["data-test-id", "returnButton", 1, "color-brand", "px-10px", "text-nowrap", "font-16px", 3, "icon"], ["type", "button", "ngbDropdownItem", "", "data-test-id", "item", 3, "ngClass", "disabled", "click"], [1, "text-truncate", 3, "ngClass"], [4, "ngIf"], ["class", "ml-auto mr-0 color-brand font-16px", 3, "icon", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "mr-2", 3, "icon", 4, "ngIf"], [1, "mr-2", 3, "icon"], [1, "ml-auto", "mr-0", "color-brand", "font-16px", 3, "icon"]], template: function TreelikeMenuComponent_Template(rf, ctx) { if (rf & 1) {
        const _r25 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("openChange", function TreelikeMenuComponent_Template_button_openChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const _r0 = ɵngcc0.ɵɵreference(1); const _r1 = ɵngcc0.ɵɵreference(2); return ɵngcc0.ɵɵresetView(ctx.resetDropdown(_r0, _r1)); });
        ɵngcc0.ɵɵelement(3, "fa-icon", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3)(5, "perfect-scrollbar", 4);
        ɵngcc0.ɵɵtemplate(6, TreelikeMenuComponent_ng_container_6_Template, 5, 5, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("three-dot-btn btn p-0 ", ctx.btnClasses, "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("icon", ctx.openIcon)("ngStyle", ctx.openIconStyles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("min-width", ctx.minWidth, "px")("max-width", ctx.maxWidth, "px")("max-height", ctx.maxHeight, "px")("min-height", ctx.minHeight, "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("max-height", ctx.maxHeight, "px")("min-height", ctx.minHeight, "px");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.currentTreeItems);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgStyle, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc5.NgbDropdown, ɵngcc5.NgbDropdownToggle, ɵngcc5.NgbDropdownMenu, ɵngcc5.NgbDropdownItem, ɵngcc6.PerfectScrollbarComponent], styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.three-dot-btn[_ngcontent-%COMP%]{width:32px}.return-button[_ngcontent-%COMP%]{background-color:var(--da-brand-12);cursor:pointer}.hide-divider[_ngcontent-%COMP%]{border-top:0!important;margin:0}.first-group[_ngcontent-%COMP%]{cursor:default!important}.group-name[_ngcontent-%COMP%]{line-height:16px;padding:.75rem 0}.dropdown-item[_ngcontent-%COMP%]{color:var(--da-primary-text);font-size:12px;line-height:16px;padding-left:0}.dropdown-item.disabled[_ngcontent-%COMP%]{color:var(--da-disable)!important}  .treelike-menu-scrollbar .ps-content{padding:.5rem 0}.dropdown-item[_ngcontent-%COMP%]:active, .return-button[_ngcontent-%COMP%]:active{background:var(--da-brand-20)}"] });
TreelikeMenuComponent.propDecorators = {
    minWidth: [{ type: Input }],
    maxWidth: [{ type: Input }],
    minHeight: [{ type: Input }],
    maxHeight: [{ type: Input }],
    treeItems: [{ type: Input }],
    openIcon: [{ type: Input }],
    openIconStyles: [{ type: Input }],
    returnIcon: [{ type: Input }],
    nextIcon: [{ type: Input }],
    btnClasses: [{ type: Input }],
    closeOnClick: [{ type: Input }],
    closeOnScroll: [{ type: Input }],
    dropdown: [{ type: ViewChild, args: [NgbDropdown,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreelikeMenuComponent, [{
        type: Component,
        args: [{ selector: 'lib-treelike-menu', template: "<button\n    #element\n    ngbDropdown\n    #dropdown=\"ngbDropdown\"\n    container=\"body\"\n    autoClose=\"outside\"\n    class=\"three-dot-btn btn p-0 {{ btnClasses }}\"\n    (openChange)=\"resetDropdown(element, dropdown)\"\n    data-test-id=\"menu-dropdown-container\"\n>\n    <fa-icon\n        [icon]=\"openIcon\"\n        type=\"button\"\n        class=\"btn btn-outline-primar\"\n        [ngStyle]=\"openIconStyles\"\n        data-test-id=\"menu-dropdown-button\"\n        ngbDropdownToggle\n    ></fa-icon>\n    <div\n        ngbDropdownMenu\n        aria-labelledby=\"dropdown-container\"\n        [style.minWidth.px]=\"minWidth\"\n        [style.maxWidth.px]=\"maxWidth\"\n        [style.maxHeight.px]=\"maxHeight\"\n        [style.minHeight.px]=\"minHeight\"\n    >\n        <perfect-scrollbar\n            class=\"treelike-menu-scrollbar\"\n            [style.maxHeight.px]=\"maxHeight\"\n            [style.minHeight.px]=\"minHeight\"\n        >\n            <ng-container\n                *ngFor=\"\n                    let itemGroup of currentTreeItems;\n                    first as isFirstGroup\n                \"\n            >\n                <div *ngIf=\"!isFirstGroup\" class=\"dropdown-divider\"></div>\n                <div [class.return-button]=\"!isFirstLevel && isFirstGroup\">\n                    <div\n                        *ngIf=\"itemGroup.label\"\n                        class=\"d-flex mr-36px group-name align-items-center\"\n                        [class.ml-3]=\"isFirstLevel\"\n                        [class.first-group]=\"isFirstLevel\"\n                        (click)=\"handleReturnClick(itemGroup)\"\n                    >\n                        <fa-icon\n                            *ngIf=\"!isFirstLevel && isFirstGroup\"\n                            [icon]=\"returnIcon\"\n                            data-test-id=\"returnButton\"\n                            class=\"color-brand px-10px text-nowrap font-16px\"\n                        ></fa-icon>\n\n                        <h3\n                            class=\"d-inline-block mt-0 text-truncate\"\n                            [class.ml-4]=\"!isFirstLevel && !isFirstGroup\"\n                        >\n                            {{ itemGroup.label }}\n                        </h3>\n                    </div>\n                </div>\n\n                <div\n                    type=\"button\"\n                    *ngFor=\"let groupItem of itemGroup.items\"\n                    ngbDropdownItem\n                    [ngClass]=\"\n                        groupItem.hidden\n                            ? 'd-none'\n                            : 'd-flex text-left text-start align-items-center'\n                    \"\n                    [disabled]=\"groupItem.disabled\"\n                    (click)=\"handleItemClick(groupItem, $event)\"\n                    data-test-id=\"item\"\n                >\n                    <div\n                        [ngClass]=\"\n                            isFirstGroup && !isFirstLevel\n                                ? 'mx-36px'\n                                : !isFirstLevel\n                                ? 'mx-4'\n                                : 'mx-3'\n                        \"\n                        class=\"text-truncate\"\n                    >\n                        <ng-container *ngIf=\"groupItem.template\">\n                            <ng-template\n                                [ngTemplateOutlet]=\"groupItem.template\"\n                                [ngTemplateOutletContext]=\"{\n                                    $implicit: groupItem\n                                }\"\n                            ></ng-template>\n                        </ng-container>\n                        <ng-container *ngIf=\"!groupItem.template\">\n                            <fa-icon\n                                *ngIf=\"groupItem.icon\"\n                                [icon]=\"groupItem.icon\"\n                                class=\"mr-2\"\n                            ></fa-icon>\n                            {{ groupItem.label }}\n                        </ng-container>\n                    </div>\n                    <fa-icon\n                        *ngIf=\"groupItem.children && !groupItem.disabled\"\n                        [icon]=\"nextIcon\"\n                        class=\"ml-auto mr-0 color-brand font-16px\"\n                    ></fa-icon>\n                </div>\n            </ng-container>\n        </perfect-scrollbar>\n    </div>\n</button>\n", styles: [".dropdown-toggle:after{display:none}.three-dot-btn{width:32px}.return-button{background-color:var(--da-brand-12);cursor:pointer}.hide-divider{border-top:0!important;margin:0}.first-group{cursor:default!important}.group-name{line-height:16px;padding:.75rem 0}.dropdown-item{color:var(--da-primary-text);font-size:12px;line-height:16px;padding-left:0}.dropdown-item.disabled{color:var(--da-disable)!important}::ng-deep .treelike-menu-scrollbar .ps-content{padding:.5rem 0}.dropdown-item:active,.return-button:active{background:var(--da-brand-20)}"] }]
    }], function () { return []; }, { minWidth: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], treeItems: [{
            type: Input
        }], openIcon: [{
            type: Input
        }], openIconStyles: [{
            type: Input
        }], returnIcon: [{
            type: Input
        }], nextIcon: [{
            type: Input
        }], btnClasses: [{
            type: Input
        }], closeOnClick: [{
            type: Input
        }], closeOnScroll: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: [NgbDropdown]
        }] }); })();

const directives = [
    ValidationErrorDirective,
    FormSubmitDirective,
    ErrorControlDirective,
    FormDirtyDirective,
    DropdownAddTagValidatorDirective,
    OutsideClickDirective,
    DropdownHeaderTemplateDirective
];
const components = [
    ValidationErrorsComponent,
    WarningMessageComponent,
    RadioButtonComponent,
    RatingModalComponent,
    PerfectScrollbarStylesComponent
];
const controls = [
    CheckboxComponent,
    DropdownComponent,
    InputComponent,
    TextareaComponent,
    RadioGroupComponent,
    RatingComponent,
    TypeaheadComponent,
    TreelikeDropdownComponent,
    TreelikeMenuComponent
];
const declarables = [...directives, ...components, ...controls];
class LibFormsModule {
}
LibFormsModule.ɵfac = function LibFormsModule_Factory(t) { return new (t || LibFormsModule)(); };
LibFormsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LibFormsModule });
LibFormsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        IconsModule,
        NgSelectModule,
        NgbProgressbarModule,
        NgbRatingModule,
        NgbDropdownModule,
        SpinnerModule,
        SafeHtmlPipeModule,
        FormsModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        NgbTooltipModule,
        NgbTypeaheadModule,
        TooltipWhenOverflowModule, FormsModule,
        ReactiveFormsModule,
        IconsModule, DatepickerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LibFormsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconsModule,
                    NgSelectModule,
                    NgbProgressbarModule,
                    NgbRatingModule,
                    NgbDropdownModule,
                    SpinnerModule,
                    SafeHtmlPipeModule,
                    FormsModule,
                    ReactiveFormsModule,
                    PerfectScrollbarModule,
                    NgbTooltipModule,
                    NgbTypeaheadModule,
                    TooltipWhenOverflowModule
                ],
                declarations: [...declarables, ErrorMessageComponent],
                entryComponents: [ErrorMessageComponent],
                exports: [
                    ...declarables,
                    FormsModule,
                    ReactiveFormsModule,
                    IconsModule,
                    DatepickerModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LibFormsModule, { declarations: function () { return [ValidationErrorDirective, FormSubmitDirective, ErrorControlDirective, FormDirtyDirective, DropdownAddTagValidatorDirective, OutsideClickDirective, DropdownHeaderTemplateDirective, ValidationErrorsComponent, WarningMessageComponent, RadioButtonComponent, RatingModalComponent, PerfectScrollbarStylesComponent, CheckboxComponent, DropdownComponent, InputComponent, TextareaComponent, RadioGroupComponent, RatingComponent, TypeaheadComponent, TreelikeDropdownComponent, TreelikeMenuComponent, ErrorMessageComponent]; }, imports: function () { return [CommonModule,
        IconsModule,
        NgSelectModule,
        NgbProgressbarModule,
        NgbRatingModule,
        NgbDropdownModule, SpinnerModule, SafeHtmlPipeModule, FormsModule,
        ReactiveFormsModule,
        PerfectScrollbarModule,
        NgbTooltipModule,
        NgbTypeaheadModule, TooltipWhenOverflowModule]; }, exports: function () { return [ValidationErrorDirective, FormSubmitDirective, ErrorControlDirective, FormDirtyDirective, DropdownAddTagValidatorDirective, OutsideClickDirective, DropdownHeaderTemplateDirective, ValidationErrorsComponent, WarningMessageComponent, RadioButtonComponent, RatingModalComponent, PerfectScrollbarStylesComponent, CheckboxComponent, DropdownComponent, InputComponent, TextareaComponent, RadioGroupComponent, RatingComponent, TypeaheadComponent, TreelikeDropdownComponent, TreelikeMenuComponent, FormsModule,
        ReactiveFormsModule,
        IconsModule, DatepickerModule]; } }); })();

const ENTER = 'Enter';
class SearchComponent {
    constructor() {
        this.fontSize = 12;
        this.value = '';
        this.disabled = false;
        this.placeholder = 'Search';
        this.id = 'search';
        this.enterPressed = new EventEmitter();
        this.searchText = new EventEmitter();
        this.searchTerm$ = new Subject();
        this.isFocused = false;
        this.search = (text) => text.pipe(debounceTime(200), distinctUntilChanged(), map(term => {
            if (this.onChange) {
                this.onChange(term);
            }
            if (this.onTouch) {
                this.onTouch();
            }
            if (!term.length) {
                this.searchTerm$.next(term);
            }
            return term.length < this.searchTermLength
                ? []
                : this.searchText.emit(term);
        }));
    }
    onKeyUp(event) {
        const { value } = event.target;
        this.searchTerm$.next(value);
        this.writeValue(value);
        if (event.code === ENTER) {
            this.enterPressed.emit();
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    writeValue(obj) {
        this.value = obj;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    setFocusWidthWithHover(isFocus) {
        if (this.isFocused) {
            this.width = isFocus ? this.width + 6 : this.width - 6;
        }
    }
}
SearchComponent.ɵfac = function SearchComponent_Factory(t) { return new (t || SearchComponent)(); };
SearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchComponent, selectors: [["lib-search"]], hostAttrs: [1, "lib-search"], inputs: { fontSize: "fontSize", value: "value", disabled: "disabled", placeholder: "placeholder", id: "id", width: "width", height: "height", align: "align", searchTermLength: "searchTermLength" }, outputs: { enterPressed: "enterPressed", searchText: "searchText" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SearchComponent),
                multi: true
            }
        ])], decls: 4, vars: 15, consts: [[1, "input-group", "search-box", 3, "focusin", "focusout", "mouseover", "mouseout"], [1, "input-group-text"], ["icon", "search", 1, "search-icon"], ["type", "search", 1, "form-control", "border-left-0", "border", "input", 3, "placeholder", "ngbTypeahead", "value", "id", "keyup"]], template: function SearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("focusin", function SearchComponent_Template_div_focusin_0_listener() { return ctx.isFocused = !ctx.isFocused; })("focusout", function SearchComponent_Template_div_focusout_0_listener() { ctx.setFocusWidthWithHover(false); return ctx.isFocused = !ctx.isFocused; })("mouseover", function SearchComponent_Template_div_mouseover_0_listener() { return ctx.setFocusWidthWithHover(false); })("mouseout", function SearchComponent_Template_div_mouseout_0_listener() { return ctx.setFocusWidthWithHover(true); });
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵelement(2, "fa-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "input", 3);
        ɵngcc0.ɵɵlistener("keyup", function SearchComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width + "px !important")("float", ctx.align)("height", ctx.height + "px !important");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px");
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("ngbTypeahead", ctx.search)("value", ctx.value || "")("id", ctx.id);
        ɵngcc0.ɵɵattribute("data-test-id", ctx.id);
    } }, dependencies: [ɵngcc5.NgbTypeahead, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: [".search-box[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks);height:inherit}.search-box[_ngcontent-%COMP%]   .border[_ngcontent-%COMP%], .search-box[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{border-color:var(--da-border-and-dividers)!important}.search-box[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%], .search-box[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks);color:var(--da-primary-text)}.search-box[_ngcontent-%COMP%]   .input-group-text[_ngcontent-%COMP%]{border-bottom-right-radius:0;border-right:none;border-top-right-radius:0;font-size:inherit;height:inherit;line-height:inherit;padding:0 4px 0 10px}.btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:not(:last-child){border-bottom-left-radius:20px;border-top-left-radius:20px;height:1.6rem;padding:0 15px}.btn-group[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]:not(:first-child){border-bottom-right-radius:20px;border-top-right-radius:20px;height:1.6rem;padding:0 15px}.search-icon[_ngcontent-%COMP%]{color:var(--da-brand-base)}.input[_ngcontent-%COMP%]{font-size:inherit;height:inherit;line-height:inherit;padding:0 10px 0 4px}.input[_ngcontent-%COMP%]:active, .input[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0}.input[_ngcontent-%COMP%]::-moz-placeholder{color:#c8c8c8}.input[_ngcontent-%COMP%]:-ms-input-placeholder{color:#c8c8c8}.input[_ngcontent-%COMP%]::placeholder{color:#c8c8c8}.input[_ngcontent-%COMP%]::-webkit-search-cancel-button{cursor:pointer;opacity:.7}.input[_ngcontent-%COMP%]::-webkit-search-cancel-button:hover{opacity:1}.input-group[_ngcontent-%COMP%]{border-radius:4px}.input-group[_ngcontent-%COMP%]:focus-within{border:4px solid var(--da-brand-20);margin:0 -3px;width:calc(100% + 6px)}.input-group[_ngcontent-%COMP%]:active   .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%]:active   .input-group-text[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%]:focus-within   .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%]:focus-within   .input-group-text[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%]:hover   .form-control[_ngcontent-%COMP%], .input-group[_ngcontent-%COMP%]:hover   .input-group-text[_ngcontent-%COMP%]{border:0 transparent!important;height:calc(100% - 2px)!important;margin-top:1px}.input-group[_ngcontent-%COMP%]:active, .input-group[_ngcontent-%COMP%]:hover{border:1px solid var(--da-brand-base)!important;margin:0!important;width:100%!important}"] });
SearchComponent.ctorParameters = () => [];
SearchComponent.propDecorators = {
    width: [{ type: Input }],
    height: [{ type: Input }],
    align: [{ type: Input }],
    fontSize: [{ type: Input }],
    searchTermLength: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    placeholder: [{ type: Input }],
    id: [{ type: Input }],
    enterPressed: [{ type: Output }],
    searchText: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchComponent, [{
        type: Component,
        args: [{ selector: 'lib-search', template: "<div\n    class=\"input-group search-box\"\n    [style.width]=\"width + 'px !important'\"\n    [style.float]=\"align\"\n    [style.height]=\"height + 'px !important'\"\n    (focusin)=\"isFocused = !isFocused\"\n    (focusout)=\"setFocusWidthWithHover(false); isFocused = !isFocused\"\n    (mouseover)=\"setFocusWidthWithHover(false)\"\n    (mouseout)=\"setFocusWidthWithHover(true)\"\n>\n    <span class=\"input-group-text\" [style.height.px]=\"height\">\n        <fa-icon icon=\"search\" class=\"search-icon\"></fa-icon>\n    </span>\n    <input\n        class=\"form-control border-left-0 border input\"\n        type=\"search\"\n        [placeholder]=\"placeholder\"\n        [ngbTypeahead]=\"search\"\n        [value]=\"value || ''\"\n        (keyup)=\"onKeyUp($event)\"\n        [style.height.px]=\"height\"\n        [attr.data-test-id]=\"id\"\n        [id]=\"id\"\n    />\n</div>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SearchComponent),
                        multi: true
                    }
                ], host: { class: 'lib-search' }, styles: [".search-box{background-color:var(--da-cards-and-blocks);height:inherit}.search-box .border,.search-box .input-group-text{border-color:var(--da-border-and-dividers)!important}.search-box .form-control,.search-box .input-group-text{background-color:var(--da-cards-and-blocks);color:var(--da-primary-text)}.search-box .input-group-text{border-bottom-right-radius:0;border-right:none;border-top-right-radius:0;font-size:inherit;height:inherit;line-height:inherit;padding:0 4px 0 10px}.btn-group .btn:not(:last-child){border-bottom-left-radius:20px;border-top-left-radius:20px;height:1.6rem;padding:0 15px}.btn-group>.btn:not(:first-child){border-bottom-right-radius:20px;border-top-right-radius:20px;height:1.6rem;padding:0 15px}.search-icon{color:var(--da-brand-base)}.input{font-size:inherit;height:inherit;line-height:inherit;padding:0 10px 0 4px}.input:active,.input:focus{box-shadow:none;outline:0}.input::-moz-placeholder{color:#c8c8c8}.input:-ms-input-placeholder{color:#c8c8c8}.input::placeholder{color:#c8c8c8}.input::-webkit-search-cancel-button{cursor:pointer;opacity:.7}.input::-webkit-search-cancel-button:hover{opacity:1}.input-group{border-radius:4px}.input-group:focus-within{border:4px solid var(--da-brand-20);margin:0 -3px;width:calc(100% + 6px)}.input-group:active .form-control,.input-group:active .input-group-text,.input-group:focus-within .form-control,.input-group:focus-within .input-group-text,.input-group:hover .form-control,.input-group:hover .input-group-text{border:0 transparent!important;height:calc(100% - 2px)!important;margin-top:1px}.input-group:active,.input-group:hover{border:1px solid var(--da-brand-base)!important;margin:0!important;width:100%!important}"] }]
    }], function () { return []; }, { fontSize: [{
            type: Input
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], id: [{
            type: Input
        }], enterPressed: [{
            type: Output
        }], searchText: [{
            type: Output
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], align: [{
            type: Input
        }], searchTermLength: [{
            type: Input
        }] }); })();

class SearchModule {
}
SearchModule.ɵfac = function SearchModule_Factory(t) { return new (t || SearchModule)(); };
SearchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SearchModule });
SearchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, NgbModule, IconsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchModule, [{
        type: NgModule,
        args: [{
                exports: [SearchComponent],
                declarations: [SearchComponent],
                imports: [CommonModule, NgbModule, IconsModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SearchModule, { declarations: function () { return [SearchComponent]; }, imports: function () { return [CommonModule, NgbModule, IconsModule]; }, exports: function () { return [SearchComponent]; } }); })();

class SidenavHeaderDirective {
    constructor(template) {
        this.template = template;
    }
}
SidenavHeaderDirective.ɵfac = function SidenavHeaderDirective_Factory(t) { return new (t || SidenavHeaderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SidenavHeaderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SidenavHeaderDirective, selectors: [["", "libSidenavHeader", ""]] });
SidenavHeaderDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavHeaderDirective, [{
        type: Directive,
        args: [{
                selector: '[libSidenavHeader]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class SidenavFooterDirective {
    constructor(template) {
        this.template = template;
    }
}
SidenavFooterDirective.ɵfac = function SidenavFooterDirective_Factory(t) { return new (t || SidenavFooterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SidenavFooterDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SidenavFooterDirective, selectors: [["", "libSidenavFooter", ""]] });
SidenavFooterDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavFooterDirective, [{
        type: Directive,
        args: [{
                selector: '[libSidenavFooter]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class SidenavItemPostfixDirective {
    constructor(template) {
        this.template = template;
    }
}
SidenavItemPostfixDirective.ɵfac = function SidenavItemPostfixDirective_Factory(t) { return new (t || SidenavItemPostfixDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SidenavItemPostfixDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SidenavItemPostfixDirective, selectors: [["", "libSidenavItemPostfix", ""]] });
SidenavItemPostfixDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavItemPostfixDirective, [{
        type: Directive,
        args: [{
                selector: '[libSidenavItemPostfix]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class ZoneFreeOperator {
    constructor(zone) {
        this.zone = zone;
    }
    call(observer, source) {
        return this.zone.runOutsideAngular(() => source.subscribe(observer));
    }
}

class HoveredService {
    constructor(documentRef, zone) {
        this.zone = zone;
        this.documentEvents$ = merge(fromEvent(documentRef, 'mousemove'));
    }
    createHovered$(target, inElement = false) {
        return (inElement ? of({}) : fromEvent(target, 'mouseenter')).pipe(switchMap(() => merge(fromEvent(target, 'mouseleave'), this.documentEvents$.pipe(filter((event) => !target.contains(this.getActualTarget(event))), take(1)))
            .pipe(mapTo(false), startWith(true), distinctUntilChanged())
            .lift(new ZoneFreeOperator(this.zone))));
    }
    getActualTarget(event) {
        return event.target;
    }
}
HoveredService.ɵfac = function HoveredService_Factory(t) { return new (t || HoveredService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
HoveredService.ɵprov = ɵɵdefineInjectable({ factory: function HoveredService_Factory() { return new HoveredService(ɵɵinject(DOCUMENT), ɵɵinject(NgZone)); }, token: HoveredService, providedIn: "root" });
HoveredService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HoveredService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.NgZone }]; }, null); })();

class FocusMonitor {
    constructor(zone) {
        this.zone = zone;
    }
    monitor$(target) {
        let skipNextFocusOut = false;
        return merge(fromEvent(window, 'focusout').pipe(filter((event) => {
            const actualTarget = this.getActualTarget(event);
            return (!skipNextFocusOut &&
                this.contains(target, actualTarget) &&
                !this.isNativeFocused(actualTarget) &&
                !this.contains(target, event.relatedTarget));
        }), mapTo(false)), fromEvent(window, 'focusin').pipe(map(event => {
            return this.contains(target, this.getActualTarget(event));
        })), fromEvent(window, 'mousedown').pipe(switchMap(event => {
            const actualTarget = this.getActualTarget(event);
            const targetInZone = this.contains(target, actualTarget);
            const activeElement = this.getNativeFocused(document);
            const focusInZone = this.contains(target, activeElement);
            if (event.defaultPrevented) {
                return of(focusInZone || targetInZone);
            }
            if (focusInZone) {
                skipNextFocusOut = true;
                return fromEvent(window, 'focusout').pipe(take(1), mapTo(targetInZone));
            }
            return of(false);
        })))
            .pipe(tap(v => {
            skipNextFocusOut = false;
        }))
            .lift(new ZoneFreeOperator(this.zone));
    }
    contains(parent, element) {
        return Boolean(element) && parent.contains(element);
    }
    getActualTarget(event) {
        return event.composedPath()[0];
    }
    isNativeFocused(node) {
        return (!!node &&
            !!node.ownerDocument &&
            this.getNativeFocused(node.ownerDocument) === node);
    }
    getNativeFocused(documentRef) {
        if (!documentRef.activeElement ||
            !documentRef.activeElement.shadowRoot) {
            return documentRef.activeElement;
        }
        let element = documentRef.activeElement.shadowRoot.activeElement;
        while (element && element.shadowRoot) {
            element = element.shadowRoot.activeElement;
        }
        return element;
    }
}
FocusMonitor.ɵfac = function FocusMonitor_Factory(t) { return new (t || FocusMonitor)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
FocusMonitor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FocusMonitor, factory: FocusMonitor.ɵfac });
FocusMonitor.ctorParameters = () => [
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FocusMonitor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();

class SidenavComponent {
    constructor(elementRef, hovered, zone, cdr, focusMonitor, sidenavStorageService) {
        this.elementRef = elementRef;
        this.hovered = hovered;
        this.zone = zone;
        this.cdr = cdr;
        this.focusMonitor = focusMonitor;
        this.sidenavStorageService = sidenavStorageService;
        this.mode = null;
        this.expanded = false;
        this.exactLinkActive = true;
        this.disableCollapseMode = false;
        this.expandedChange = new EventEmitter();
        this.modeChange = new EventEmitter();
        this.itemClicked = new EventEmitter();
        this.groupClicked = new EventEmitter();
        this.expandedSubscription = Subscription.EMPTY;
        this.destroyed$ = new Subject();
        this.modePassed = false;
        this.handleMatchMedia = () => {
            if (this.disableCollapseMode) {
                return;
            }
            this.zone.run(() => {
                this.expanded = false;
                this.mode = 'over';
                this.modeChange.emit(this.mode);
                this.cdr.detectChanges();
            });
        };
    }
    ngOnChanges(changes) {
        if (changes.mode && changes.mode.firstChange) {
            this.modePassed = true;
        }
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.disableCollapseMode) {
                this.expanded = true;
                return;
            }
            this.listenWindowSize();
            if (!this.modePassed) {
                this.elementRef.nativeElement.parentElement.style.setProperty('display', 'none', 'important');
                this.sidenavStorageService
                    .getMode()
                    .pipe(takeUntil(this.destroyed$))
                    .subscribe(mode => {
                    if (this.mode !== mode) {
                        this.mode = mode;
                        this.expanded = mode === 'push';
                        this.modeChange.emit(mode);
                        this.cdr.markForCheck();
                    }
                    this.elementRef.nativeElement.parentElement.style.removeProperty('display');
                });
            }
            if (window.innerWidth <= 768) {
                return;
            }
            this.expanded = this.mode === 'push';
        });
    }
    hoverElementSelectorFn(el) {
        return el;
    }
    textElementSelectorFn(el) {
        return el.children.namedItem('text-container');
    }
    handleExpand(value) {
        this.expanded = value;
        this.expandedChange.emit(this.expanded);
        if (!this.expanded) {
            return;
        }
        this.listenExpanded();
    }
    isSidenavItem(item) {
        return item;
    }
    handleSideNavItemClicked(menuItem) {
        this.itemClicked.emit(menuItem);
    }
    handleSideNavItemGroupClicked(menuItem, id, event) {
        var _a;
        if (this.expanded) {
            event.preventDefault();
        }
        this.groupClicked.emit(Object.assign(Object.assign({}, menuItem), { parentId: id }));
        this.changeMenuItemIsExpanded(menuItem);
        const sidenavItems = document.querySelectorAll('[sidenav-parent]');
        const parents = [(_a = menuItem.id) !== null && _a !== void 0 ? _a : menuItem.title];
        const parentIds = [id.toString()];
        for (let i = 0; i < sidenavItems.length; i++) {
            const sidenav = sidenavItems.item(i);
            if (!parents.includes(sidenav.attributes.getNamedItem('sidenav-parent').value)) {
                continue;
            }
            const parentIdAttr = sidenav.attributes.getNamedItem('sidenav-parent-id');
            if (!menuItem.id &&
                parentIdAttr &&
                !parentIds.includes(parentIdAttr.value)) {
                continue;
            }
            parents.push(sidenav.id);
            parentIds.push(parentIdAttr === null || parentIdAttr === void 0 ? void 0 : parentIdAttr.value);
            sidenav.classList.add(menuItem.isCollapsed ? 'd-flex' : 'd-none');
            sidenav.classList.remove(menuItem.isCollapsed ? 'd-none' : 'd-flex');
        }
    }
    handlePinToggle() {
        this.mode = this.mode === 'over' ? 'push' : 'over';
        this.sidenavStorageService.setMode(this.mode);
        this.modeChange.emit(this.mode);
        if (this.mode === 'push') {
            this.expandedSubscription.unsubscribe();
        }
        else {
            this.listenExpanded(false, true);
        }
    }
    changeMenuItemIsExpanded(menuItem, value) {
        if (menuItem.isCollapsed === undefined) {
            menuItem.isCollapsed = true;
        }
        value = value || !menuItem.isCollapsed;
        menuItem.isCollapsed = value;
        menuItem.children.forEach((child) => {
            const sidenavItemGroup = child;
            if (sidenavItemGroup.children) {
                this.changeMenuItemIsExpanded(sidenavItemGroup, value);
            }
        });
    }
    listenExpanded(hasFocus = false, hasHover = false) {
        this.expandedSubscription.unsubscribe();
        const { nativeElement } = this.elementRef;
        this.expandedSubscription = this.expandedSubscription = combineLatest([
            this.focusMonitor.monitor$(nativeElement).pipe(startWith(hasFocus)),
            this.hovered.createHovered$(nativeElement, hasFocus || hasHover)
        ])
            .pipe(map(([focused, hovered]) => {
            return !focused && !hovered;
        }), filter(Boolean), take(1))
            .subscribe((collapsed) => {
            this.zone.run(() => {
                this.handleExpand(!collapsed);
                this.cdr.markForCheck();
            });
        });
    }
    listenWindowSize() {
        this.zone.runOutsideAngular(() => {
            this.windowWidthMedia = window.matchMedia('(max-width: 768px)');
            this.windowWidthMedia.addEventListener('change', this.handleMatchMedia);
        });
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.windowWidthMedia) === null || _a === void 0 ? void 0 : _a.removeEventListener('change', this.handleMatchMedia);
        (_b = this.expandedSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        this.destroyed$.next();
    }
}
SidenavComponent.ɵfac = function SidenavComponent_Factory(t) { return new (t || SidenavComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(HoveredService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(FocusMonitor), ɵngcc0.ɵɵdirectiveInject(SidenavStorageService)); };
SidenavComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SidenavComponent, selectors: [["lib-sidenav"]], contentQueries: function SidenavComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SidenavHeaderDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SidenavFooterDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SidenavItemPostfixDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemPostfixTemplate = _t.first);
    } }, hostAttrs: [1, "lib-sidenav"], hostVars: 6, hostBindings: function SidenavComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("lib-sidenav-over", ctx.mode === "over")("lib-sidenav-push", ctx.mode === "push")("sidenav-expanded", ctx.expanded);
    } }, inputs: { mode: "mode", expanded: "expanded", exactLinkActive: "exactLinkActive", disableCollapseMode: "disableCollapseMode", items: "items", hasScrollbar: "hasScrollbar" }, outputs: { expandedChange: "expandedChange", modeChange: "modeChange", itemClicked: "itemClicked", groupClicked: "groupClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([FocusMonitor]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 2, consts: [["class", "sidenav-scrollbar", 4, "ngIf", "ngIfElse"], ["sidenav", ""], ["menu", ""], ["itemTemplate", ""], [1, "sidenav-scrollbar"], [3, "ngTemplateOutlet"], [1, "d-none"], ["id", "pin", "viewBox", "-2.5 -1 20 20", "fill", "none"], ["d", "M9.5 12.5002V4.50024H12V1.00024H2V4.50024H4.5V12.5002L1 14.5002V16.5002H6.955V22.5002H7.045V16.5002H13V14.5002L9.5 12.5002Z", "stroke", "currentColor", "stroke-linejoin", "round"], ["id", "unpin", "fill", "none", "viewBox", "2 0 19.5 19.5"], ["d", "M9.5 13.5002L6 15.5002V17.5002H11.955V23.5002H12.045V17.5002H15.0225M7 3.3V2.00024H17V5.50024H14.5V11M9.5 6.5V5.50024H8.5M1 1L23 23", "stroke", "currentColor", "stroke-linecap", "round", "stroke-linejoin", "round"], ["id", "expand", "viewBox", "0 0 24 24", "fill", "none"], ["d", "M13 17L18 12L13 7", "stroke", "currentColor", "stroke-linecap", "round", "stroke-linejoin", "round"], ["d", "M6 17L11 12L6 7", "stroke", "currentColor", "stroke-linecap", "round", "stroke-linejoin", "round"], ["class", "px-1 py-2 d-flex cursor-pointer sidenav-item sidenav-item--pin", 3, "click", 4, "ngIf"], ["class", "expand-control cursor-pointer", 3, "click", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "px-1", "py-2", "d-flex", "cursor-pointer", "sidenav-item", "sidenav-item--pin", 3, "click"], ["container", "body", "placement", "right", 1, "btn", "btn-link", "ml-auto", "px-1", "py-1", 3, "ngbTooltip"], ["width", "16", "height", "20"], [1, "expand-control", "cursor-pointer", 3, "click"], ["width", "12", "height", "12", 1, "my-2", "mx-1"], ["href", "#expand"], [4, "ngFor", "ngForOf"], ["class", "border-top my-2", 4, "ngIf"], [3, "item", "level", "menuTemplate", "expanded", "expand"], [1, "border-top", "my-2"], ["libTooltipWhenOverflow", "", "container", "body", "placement", "right", "triggers", "manual", 1, "sidenav-item", "d-flex", "py-xl-3", "py-2", "pr-3", 3, "hoverElementSelectorFn", "textElementSelectorFn", "overflowEnabled", "id", "routerLink", "routerLinkActive", "routerLinkActiveOptions", "ngbTooltip", "tooltipClass", "openDelay", "click"], ["class", "mr-1", 3, "sidenav-item--preview", "icon", "width", "height", 4, "ngIf"], [3, "sidenav-item--preview", 4, "ngIf"], ["id", "text-container", "class", "text-truncate mr-1", 4, "ngIf"], ["class", "ml-auto", 3, "icon", 4, "ngIf"], [1, "mr-1", 3, "icon"], ["id", "text-container", 1, "text-truncate", "mr-1"], [1, "ml-auto", 3, "icon"]], template: function SidenavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SidenavComponent_perfect_scrollbar_0_Template, 2, 1, "perfect-scrollbar", 0);
        ɵngcc0.ɵɵtemplate(1, SidenavComponent_ng_template_1_Template, 13, 8, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, SidenavComponent_ng_template_3_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, SidenavComponent_ng_template_5_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasScrollbar)("ngIfElse", _r1);
    } }, dependencies: function () { return [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc9.RouterLinkWithHref, ɵngcc9.RouterLinkActive, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc5.NgbTooltip, ɵngcc6.PerfectScrollbarComponent, TooltipWhenOverflowDirective, SidenavGroupComponent, ɵngcc2.UpperCasePipe, ɵngcc2.SlicePipe]; }, styles: ["[_nghost-%COMP%]{background:var(--da-cards-and-blocks);box-shadow:0 0 24px rgba(0,0,0,.08);display:flex;flex-direction:column;position:relative;transition:width .3s;width:48px}  .sidenav-expanded-tooltip .tooltip-inner{color:var(--da-primary-text);font-family:Open Sans,sans-serif;font-weight:400}  .sidenav-tooltip .tooltip-inner{background-color:var(--da-brand-base);color:#fff}  .sidenav-tooltip .arrow:before{border-right-color:var(--da-brand-base)}.sidenav-expanded[_nghost-%COMP%], .sidenav-expanded   [_nghost-%COMP%]{min-width:200px;width:200px}.expand-control[_ngcontent-%COMP%]{align-items:center;background-color:var(--da-brand-base);border-radius:0 4px 4px 0;color:#fff;display:flex;height:33px;position:absolute;right:-20px;top:20px}.sidenav-scrollbar[_ngcontent-%COMP%]   .expand-control[_ngcontent-%COMP%]{left:48px;position:fixed;right:auto;top:70px}.sidenav-item[_ngcontent-%COMP%]{color:var(--da-primary-text);height:48px;max-height:48px;position:relative}.sidenav-item--preview[_ngcontent-%COMP%]{font-size:14px;line-height:18px;text-align:center}.sidenav-item--preview[_ngcontent-%COMP%], .sidenav-item[_ngcontent-%COMP%]:focus, .sidenav-item[_ngcontent-%COMP%]:hover{color:var(--da-brand-base)}.sidenav-item--active.sidenav-item--compact[_ngcontent-%COMP%], .sidenav-item--active.sidenav-item-without-children[_ngcontent-%COMP%]{background:var(--da-brand-12);border-right:2px solid var(--da-brand-base)!important;color:var(--da-brand-base);text-decoration:none}.sidenav-item--pin[_ngcontent-%COMP%]{border-top:1px solid var(--da-border-and-dividers);max-height:-webkit-fit-content;max-height:-moz-fit-content;max-height:fit-content}@media (max-width:768px){.sidenav-item--pin[_ngcontent-%COMP%]{display:none}}"], changeDetection: 0 });
SidenavComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: HoveredService },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: FocusMonitor },
    { type: SidenavStorageService }
];
SidenavComponent.propDecorators = {
    mode: [{ type: Input }],
    expanded: [{ type: Input }, { type: HostBinding, args: ['class.sidenav-expanded',] }],
    items: [{ type: Input }],
    hasScrollbar: [{ type: Input }],
    exactLinkActive: [{ type: Input }],
    disableCollapseMode: [{ type: Input }],
    expandedChange: [{ type: Output }],
    modeChange: [{ type: Output }],
    itemClicked: [{ type: Output }],
    groupClicked: [{ type: Output }],
    headerTemplate: [{ type: ContentChild, args: [SidenavHeaderDirective, { static: true },] }],
    footerTemplate: [{ type: ContentChild, args: [SidenavFooterDirective, { static: true },] }],
    itemPostfixTemplate: [{ type: ContentChild, args: [SidenavItemPostfixDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavComponent, [{
        type: Component,
        args: [{ selector: 'lib-sidenav', template: "<perfect-scrollbar *ngIf=\"hasScrollbar; else sidenav\" class=\"sidenav-scrollbar\">\n    <ng-container [ngTemplateOutlet]=\"sidenav\"></ng-container>\n</perfect-scrollbar>\n\n<ng-template #sidenav>\n    <svg class=\"d-none\">\n        <symbol id=\"pin\" viewBox=\"-2.5 -1 20 20\" fill=\"none\">\n            <path\n                d=\"M9.5 12.5002V4.50024H12V1.00024H2V4.50024H4.5V12.5002L1 14.5002V16.5002H6.955V22.5002H7.045V16.5002H13V14.5002L9.5 12.5002Z\"\n                stroke=\"currentColor\"\n                stroke-linejoin=\"round\"\n            />\n        </symbol>\n        <symbol id=\"unpin\" fill=\"none\" viewBox=\"2 0 19.5 19.5\">\n            <path\n                d=\"M9.5 13.5002L6 15.5002V17.5002H11.955V23.5002H12.045V17.5002H15.0225M7 3.3V2.00024H17V5.50024H14.5V11M9.5 6.5V5.50024H8.5M1 1L23 23\"\n                stroke=\"currentColor\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n        </symbol>\n        <symbol id=\"expand\" viewBox=\"0 0 24 24\" fill=\"none\">\n            <path\n                d=\"M13 17L18 12L13 7\"\n                stroke=\"currentColor\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n            <path\n                d=\"M6 17L11 12L6 7\"\n                stroke=\"currentColor\"\n                stroke-linecap=\"round\"\n                stroke-linejoin=\"round\"\n            />\n        </symbol>\n    </svg>\n    <div\n        *ngIf=\"expanded && !disableCollapseMode\"\n        class=\"px-1 py-2 d-flex cursor-pointer sidenav-item sidenav-item--pin\"\n        (click)=\"handlePinToggle()\"\n    >\n        <button\n            [ngbTooltip]=\"(mode !== 'push' ? 'Pin' : 'Unpin') + ' Side Menu'\"\n            container=\"body\"\n            placement=\"right\"\n            class=\"btn btn-link ml-auto px-1 py-1\"\n        >\n            <svg width=\"16\" height=\"20\">\n                <use\n                    [attr.href]=\"'#' + (mode !== 'push' ? 'pin' : 'unpin')\"\n                ></use>\n            </svg>\n        </button>\n    </div>\n    <div\n        *ngIf=\"!expanded\"\n        class=\"expand-control cursor-pointer\"\n        (click)=\"handleExpand(true)\"\n    >\n        <svg class=\"my-2 mx-1\" width=\"12\" height=\"12\">\n            <use href=\"#expand\"></use>\n        </svg>\n    </div>\n    <ng-container *ngIf=\"headerTemplate\">\n        <ng-template\n            [ngTemplateOutlet]=\"headerTemplate.template\"\n            [ngTemplateOutletContext]=\"{ expanded: expanded }\"\n        ></ng-template>\n    </ng-container>\n    <ng-template\n        [ngTemplateOutlet]=\"menu\"\n        [ngTemplateOutletContext]=\"{ $implicit: items, level: 0 }\"\n    ></ng-template>\n    <ng-container *ngIf=\"footerTemplate\">\n        <ng-template\n            [ngTemplateOutlet]=\"footerTemplate.template\"\n            [ngTemplateOutletContext]=\"{ expanded: expanded }\"\n        >\n        </ng-template>\n    </ng-container>\n</ng-template>\n\n<ng-template #menu let-items let-level=\"level\" let-fromFlat=\"fromFlat\">\n    <ng-container *ngFor=\"let item of items; index as index\">\n        <ng-container *ngIf=\"isSidenavItem(item) as menuItem\">\n            <ng-container\n                *ngIf=\"menuItem.routerLink || menuItem.withoutRouterLink\"\n            >\n                <ng-template\n                    [ngTemplateOutlet]=\"itemTemplate\"\n                    [ngTemplateOutletContext]=\"{\n                        $implicit: menuItem,\n                        i: index,\n                        leaf: true,\n                        level: level,\n                        withoutRouterLink: menuItem.withoutRouterLink\n                    }\"\n                ></ng-template>\n            </ng-container>\n\n            <ng-container *ngIf=\"menuItem.children\">\n                <ng-template\n                    [ngTemplateOutlet]=\"itemTemplate\"\n                    [ngTemplateOutletContext]=\"{\n                        $implicit: menuItem,\n                        i: index,\n                        leaf: false,\n                        level: level\n                    }\"\n                ></ng-template>\n            </ng-container>\n\n            <ng-container *ngIf=\"menuItem.items\">\n                <div *ngIf=\"index\" class=\"border-top my-2\"></div>\n\n                <lib-sidenav-group\n                    [item]=\"menuItem\"\n                    [level]=\"level\"\n                    [menuTemplate]=\"menu\"\n                    [expanded]=\"expanded\"\n                    (expand)=\"handleExpand(true)\"\n                ></lib-sidenav-group>\n            </ng-container>\n\n            <ng-container *ngIf=\"menuItem.children && expanded\">\n                <ng-template\n                    [ngTemplateOutlet]=\"menu\"\n                    [ngTemplateOutletContext]=\"{\n                        $implicit: menuItem.children,\n                        level: level + 1\n                    }\"\n                >\n                </ng-template>\n            </ng-container>\n        </ng-container>\n    </ng-container>\n</ng-template>\n\n<ng-template\n    #itemTemplate\n    let-item\n    let-i=\"i\"\n    let-leaf=\"leaf\"\n    let-level=\"level\"\n    let-withoutRouterLink=\"withoutRouterLink\"\n>\n    <ng-container *ngIf=\"isSidenavItem(item) as menuItem\">\n        <a\n            libTooltipWhenOverflow\n            [hoverElementSelectorFn]=\"hoverElementSelectorFn\"\n            [textElementSelectorFn]=\"textElementSelectorFn\"\n            [overflowEnabled]=\"expanded\"\n            [id]=\"menuItem.id ? menuItem.id : menuItem.title\"\n            class=\"sidenav-item d-flex py-xl-3 py-2 pr-3 \"\n            [class.sidenav-item--compact]=\"!expanded\"\n            [class.sidenav-item-without-children]=\"!menuItem.children?.length\"\n            [style.padding-left.px]=\"expanded ? 16 + 24 * (level || 0) : 16\"\n            [attr.sidenav-parent]=\"\n                menuItem.sidenavParent ? menuItem.sidenavParent : null\n            \"\n            [attr.sidenav-parent-id]=\"\n                menuItem.sidenavParentId ? menuItem.sidenavParentId : null\n            \"\n            [routerLink]=\"\n                !withoutRouterLink\n                    ? menuItem.routerLink\n                        ? menuItem.routerLink\n                        : menuItem.children?.length\n                        ? menuItem.children[0].routerLink\n                        : null\n                    : null\n            \"\n            [routerLinkActive]=\"\n                !withoutRouterLink ? 'sidenav-item--active' : ''\n            \"\n            [routerLinkActiveOptions]=\"{ exact: !!exactLinkActive }\"\n            [ngbTooltip]=\"menuItem.title\"\n            [tooltipClass]=\"\n                expanded ? 'sidenav-expanded-tooltip' : 'sidenav-tooltip'\n            \"\n            container=\"body\"\n            [openDelay]=\"200\"\n            placement=\"right\"\n            triggers=\"manual\"\n            (click)=\"\n                leaf\n                    ? handleSideNavItemClicked(menuItem)\n                    : handleSideNavItemGroupClicked(\n                          menuItem,\n                          menuItem.id ? menuItem.id : i,\n                          $event\n                      )\n            \"\n        >\n            <fa-icon\n                [class.sidenav-item--preview]=\"!expanded\"\n                *ngIf=\"menuItem.icon\"\n                [icon]=\"menuItem.icon[0]\"\n                class=\"mr-1\"\n                [style.width.px]=\"menuItem.icon[1][0]\"\n                [style.height.px]=\"menuItem.icon[1][1]\"\n            ></fa-icon>\n\n            <div\n                *ngIf=\"!menuItem.icon && !expanded\"\n                [class.sidenav-item--preview]=\"!expanded\"\n            >\n                {{ $any(menuItem.title | slice: 0:2) | uppercase }}\n            </div>\n\n            <div\n                id=\"text-container\"\n                *ngIf=\"expanded\"\n                class=\"text-truncate mr-1\"\n            >\n                {{ menuItem.title }}\n            </div>\n            <ng-container *ngIf=\"itemPostfixTemplate\">\n                <ng-template\n                    [ngTemplateOutlet]=\"itemPostfixTemplate.template\"\n                    [ngTemplateOutletContext]=\"{\n                        expanded: expanded,\n                        item: menuItem\n                    }\"\n                ></ng-template>\n            </ng-container>\n\n            <fa-icon\n                *ngIf=\"!leaf && expanded && menuItem.children?.length\"\n                class=\"ml-auto\"\n                [icon]=\"\n                    menuItem.isCollapsed === false\n                        ? 'chevron-right'\n                        : 'chevron-down'\n                \"\n            >\n            </fa-icon>\n        </a>\n    </ng-container>\n</ng-template>\n", changeDetection: ChangeDetectionStrategy.OnPush, host: {
                    class: 'lib-sidenav',
                    '[class.lib-sidenav-over]': 'mode === "over"',
                    '[class.lib-sidenav-push]': 'mode === "push"'
                }, providers: [FocusMonitor], styles: [":host{background:var(--da-cards-and-blocks);box-shadow:0 0 24px rgba(0,0,0,.08);display:flex;flex-direction:column;position:relative;transition:width .3s;width:48px}::ng-deep .sidenav-expanded-tooltip .tooltip-inner{color:var(--da-primary-text);font-family:Open Sans,sans-serif;font-weight:400}::ng-deep .sidenav-tooltip .tooltip-inner{background-color:var(--da-brand-base);color:#fff}::ng-deep .sidenav-tooltip .arrow:before{border-right-color:var(--da-brand-base)}:host-context(.sidenav-expanded){min-width:200px;width:200px}.expand-control{align-items:center;background-color:var(--da-brand-base);border-radius:0 4px 4px 0;color:#fff;display:flex;height:33px;position:absolute;right:-20px;top:20px}.sidenav-scrollbar .expand-control{left:48px;position:fixed;right:auto;top:70px}.sidenav-item{color:var(--da-primary-text);height:48px;max-height:48px;position:relative}.sidenav-item--preview{font-size:14px;line-height:18px;text-align:center}.sidenav-item--preview,.sidenav-item:focus,.sidenav-item:hover{color:var(--da-brand-base)}.sidenav-item--active.sidenav-item--compact,.sidenav-item--active.sidenav-item-without-children{background:var(--da-brand-12);border-right:2px solid var(--da-brand-base)!important;color:var(--da-brand-base);text-decoration:none}.sidenav-item--pin{border-top:1px solid var(--da-border-and-dividers);max-height:-webkit-fit-content;max-height:-moz-fit-content;max-height:fit-content}@media (max-width:768px){.sidenav-item--pin{display:none}}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: HoveredService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: FocusMonitor }, { type: SidenavStorageService }]; }, { mode: [{
            type: Input
        }], expanded: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.sidenav-expanded']
        }], exactLinkActive: [{
            type: Input
        }], disableCollapseMode: [{
            type: Input
        }], expandedChange: [{
            type: Output
        }], modeChange: [{
            type: Output
        }], itemClicked: [{
            type: Output
        }], groupClicked: [{
            type: Output
        }], items: [{
            type: Input
        }], hasScrollbar: [{
            type: Input
        }], headerTemplate: [{
            type: ContentChild,
            args: [SidenavHeaderDirective, { static: true }]
        }], footerTemplate: [{
            type: ContentChild,
            args: [SidenavFooterDirective, { static: true }]
        }], itemPostfixTemplate: [{
            type: ContentChild,
            args: [SidenavItemPostfixDirective, { static: true }]
        }] }); })();
class SidenavStorageService {
}
SidenavStorageService.ɵfac = function SidenavStorageService_Factory(t) { return new (t || SidenavStorageService)(); };
SidenavStorageService.ɵprov = ɵɵdefineInjectable({ factory: function SidenavStorageService_Factory() { return new SidenavLocalStorageService(); }, token: SidenavStorageService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
                useClass: forwardRef(() => SidenavLocalStorageService)
            }]
    }], null, null); })();
class SidenavLocalStorageService {
    constructor() {
        this.storageKey = 'kit-sidenav-mode';
    }
    setMode(mode) {
        localStorage.setItem(this.storageKey, mode);
    }
    getMode() {
        return of(localStorage.getItem(this.storageKey) || 'over');
    }
}
SidenavLocalStorageService.ɵfac = function SidenavLocalStorageService_Factory(t) { return new (t || SidenavLocalStorageService)(); };
SidenavLocalStorageService.ɵprov = ɵɵdefineInjectable({ factory: function SidenavLocalStorageService_Factory() { return new SidenavLocalStorageService(); }, token: SidenavLocalStorageService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavLocalStorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SidenavGroupComponent {
    constructor() {
        this.expand = new EventEmitter();
        this.value = '';
        this.subscription = Subscription.EMPTY;
    }
    get filteredItems() {
        var _a;
        return this.filterItems((_a = this.item) === null || _a === void 0 ? void 0 : _a.items, this.value);
    }
    handleSearch(filter) {
        this.value = filter;
    }
    handleSearchClick() {
        this.expand.emit();
        this.subscription.unsubscribe();
        this.subscription = this.searchQuery.changes
            .pipe(take(1), map((search) => search.first), map(elementRef => elementRef.nativeElement), map(searchElement => searchElement.querySelector(`[type='search']`)))
            .subscribe(inputElement => {
            focusNativeElement(inputElement, true);
        });
    }
    // memoize!
    filterItems(items, filter) {
        const getItems = (result, item) => {
            var _a;
            if ((_a = item.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filter.toLowerCase())) {
                result.push(item);
                return result;
            }
            if ('children' in item && item.children) {
                const subItems = item.children.reduce(getItems, []);
                if (subItems.length) {
                    result.push(Object.assign(Object.assign({}, item), { items: subItems }));
                }
            }
            return result;
        };
        return items === null || items === void 0 ? void 0 : items.reduce(getItems, []);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
SidenavGroupComponent.ɵfac = function SidenavGroupComponent_Factory(t) { return new (t || SidenavGroupComponent)(); };
SidenavGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SidenavGroupComponent, selectors: [["lib-sidenav-group"]], viewQuery: function SidenavGroupComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(SearchComponent, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchQuery = _t);
    } }, hostAttrs: [1, "lib-sidenav-group"], inputs: { item: "item", menuTemplate: "menuTemplate", level: "level", expanded: "expanded" }, outputs: { expand: "expand" }, decls: 6, vars: 7, consts: [["class", "mt-0 mb-3 mx-3", 4, "ngIf"], [4, "ngIf"], [1, "flex-1", "sidenav-group-scrollbar", 2, "width", "unset", "max-width", "unset"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["noItemsFound", ""], [1, "mt-0", "mb-3", "mx-3"], ["class", "mb-3 mx-3", 3, "value", "searchText", 4, "ngIf", "ngIfElse"], ["compactSearchTemplate", ""], [1, "mb-3", "mx-3", 3, "value", "searchText"], [1, "cursor-pointer", "sidenav-search-icon", "mb-1", 3, "click"], ["icon", "search"], [1, "text-center", "mt-1", "no-items-text"]], template: function SidenavGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SidenavGroupComponent_h3_0_Template, 2, 1, "h3", 0);
        ɵngcc0.ɵɵtemplate(1, SidenavGroupComponent_ng_container_1_Template, 4, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(2, "perfect-scrollbar", 2);
        ɵngcc0.ɵɵtemplate(3, SidenavGroupComponent_ng_template_3_Template, 0, 0, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, SidenavGroupComponent_ng_template_4_Template, 2, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.expanded && ctx.item.title !== "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.item == null ? null : ctx.item.search);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", (ctx.filteredItems == null ? null : ctx.filteredItems.length) ? ctx.menuTemplate : _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(4, _c49, ctx.filteredItems, ctx.level));
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, SearchComponent, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc6.PerfectScrollbarComponent], styles: ["[_nghost-%COMP%]{display:flex;flex:1;flex-direction:column;overflow:hidden}.sidenav-search-icon[_ngcontent-%COMP%]{align-items:center;align-self:center;background-color:rgba(50,125,226,.12);border:1px solid rgba(50,125,226,.12);border-radius:50%;color:var(--da-brand-base);display:flex;height:32px;justify-content:center;width:32px}.no-items-text[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons);font-style:italic}[_nghost-%COMP%]  .sidenav-group-scrollbar>.ps.ps--active-y>.ps__rail-y{background:none!important;right:6px!important}"], changeDetection: 0 });
SidenavGroupComponent.propDecorators = {
    item: [{ type: Input }],
    menuTemplate: [{ type: Input }],
    level: [{ type: Input }],
    expanded: [{ type: Input }],
    expand: [{ type: Output }],
    searchQuery: [{ type: ViewChildren, args: [SearchComponent, { read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavGroupComponent, [{
        type: Component,
        args: [{ selector: 'lib-sidenav-group', template: "<h3 *ngIf=\"expanded && item.title !== ''\" class=\"mt-0 mb-3 mx-3\">{{ item.title }}</h3>\n\n<ng-container *ngIf=\"item?.search\">\n    <lib-search\n        class=\"mb-3 mx-3\"\n        *ngIf=\"expanded; else compactSearchTemplate\"\n        [value]=\"value\"\n        (searchText)=\"handleSearch($event)\"\n    ></lib-search>\n    <ng-template #compactSearchTemplate>\n        <div\n            class=\"cursor-pointer sidenav-search-icon mb-1\"\n            (click)=\"handleSearchClick()\"\n        >\n            <fa-icon icon=\"search\"></fa-icon>\n        </div>\n    </ng-template>\n</ng-container>\n\n<perfect-scrollbar class=\"flex-1 sidenav-group-scrollbar\" style=\"width: unset; max-width: unset\">\n    <ng-template\n        [ngTemplateOutlet]=\"filteredItems?.length ? menuTemplate : noItemsFound\"\n        [ngTemplateOutletContext]=\"{ $implicit: filteredItems, level: level }\">\n    </ng-template>\n</perfect-scrollbar>\n\n<ng-template #noItemsFound>\n    <div class=\"text-center mt-1 no-items-text\">\n        {{expanded ? 'No items found' : ''}}\n    </div>\n</ng-template>\n", host: { class: 'lib-sidenav-group' }, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:flex;flex:1;flex-direction:column;overflow:hidden}.sidenav-search-icon{align-items:center;align-self:center;background-color:rgba(50,125,226,.12);border:1px solid rgba(50,125,226,.12);border-radius:50%;color:var(--da-brand-base);display:flex;height:32px;justify-content:center;width:32px}.no-items-text{color:var(--da-secondary-text-and-icons);font-style:italic}:host::ng-deep .sidenav-group-scrollbar>.ps.ps--active-y>.ps__rail-y{background:none!important;right:6px!important}"] }]
    }], function () { return []; }, { expand: [{
            type: Output
        }], item: [{
            type: Input
        }], menuTemplate: [{
            type: Input
        }], level: [{
            type: Input
        }], expanded: [{
            type: Input
        }], searchQuery: [{
            type: ViewChildren,
            args: [SearchComponent, { read: ElementRef }]
        }] }); })();

class SidenavContainerComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.leftMargin = 0;
        this.subscription = Subscription.EMPTY;
    }
    set sidenavSetter(sidenav) {
        this.sidenav = sidenav;
        if (!sidenav) {
            return;
        }
        this.subscription.unsubscribe();
        this.subscription = sidenav.modeChange
            .pipe(startWith(sidenav.mode))
            .subscribe(mode => {
            // exp.has been changed (remove setTimeout)
            setTimeout(() => {
                if (mode === 'push' && this.sidenav.expanded) {
                    this.leftMargin = 0;
                }
                else if (mode === 'over') {
                    this.leftMargin = 48;
                }
                this.cdr.markForCheck();
            });
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.subscription = null;
    }
}
SidenavContainerComponent.ɵfac = function SidenavContainerComponent_Factory(t) { return new (t || SidenavContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SidenavContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SidenavContainerComponent, selectors: [["lib-sidenav-container"]], contentQueries: function SidenavContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SidenavComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sidenavSetter = _t.first);
    } }, ngContentSelectors: _c53, decls: 2, vars: 0, template: function SidenavContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c52);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵprojection(1, 1);
    } }, styles: ["[_nghost-%COMP%]{bottom:0;display:flex;left:0;position:absolute;right:0;top:0}[_nghost-%COMP%]     .lib-sidenav{height:100%;z-index:2}[_nghost-%COMP%]     .lib-sidenav-over{position:absolute}[_nghost-%COMP%]     .lib-sidenav-content{flex:1;z-index:1}"], changeDetection: 0 });
SidenavContainerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
SidenavContainerComponent.propDecorators = {
    sidenavSetter: [{ type: ContentChild, args: [SidenavComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavContainerComponent, [{
        type: Component,
        args: [{ selector: 'lib-sidenav-container', template: "<ng-content select=\"lib-sidenav\"></ng-content>\n<ng-content select=\"lib-sidenav-content\"></ng-content>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{bottom:0;display:flex;left:0;position:absolute;right:0;top:0}:host ::ng-deep .lib-sidenav{height:100%;z-index:2}:host ::ng-deep .lib-sidenav-over{position:absolute}:host ::ng-deep .lib-sidenav-content{flex:1;z-index:1}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { sidenavSetter: [{
            type: ContentChild,
            args: [SidenavComponent]
        }] }); })();

class SidenavContentComponent {
    constructor(container) {
        this.container = container;
    }
}
SidenavContentComponent.ɵfac = function SidenavContentComponent_Factory(t) { return new (t || SidenavContentComponent)(ɵngcc0.ɵɵdirectiveInject(SidenavContainerComponent)); };
SidenavContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SidenavContentComponent, selectors: [["lib-sidenav-content"]], hostAttrs: [1, "lib-sidenav-content"], hostVars: 2, hostBindings: function SidenavContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("margin-left", ctx.container.leftMargin, "px");
    } }, ngContentSelectors: _c3, decls: 1, vars: 0, template: function SidenavContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{background:var(--da-background);display:block;height:100%;position:relative;transition-duration:.4s;transition-property:transform,margin-left,margin-right;transition-timing-function:cubic-bezier(.25,.8,.25,1)}"], changeDetection: 0 });
SidenavContentComponent.ctorParameters = () => [
    { type: SidenavContainerComponent }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavContentComponent, [{
        type: Component,
        args: [{ selector: 'lib-sidenav-content', template: '<ng-content></ng-content>', changeDetection: ChangeDetectionStrategy.OnPush, host: {
                    class: 'lib-sidenav-content',
                    '[style.margin-left.px]': 'container.leftMargin'
                }, styles: [":host{background:var(--da-background);display:block;height:100%;position:relative;transition-duration:.4s;transition-property:transform,margin-left,margin-right;transition-timing-function:cubic-bezier(.25,.8,.25,1)}"] }]
    }], function () { return [{ type: SidenavContainerComponent }]; }, null); })();

class SidenavModule {
}
SidenavModule.ɵfac = function SidenavModule_Factory(t) { return new (t || SidenavModule)(); };
SidenavModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SidenavModule });
SidenavModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, SearchModule, RouterModule, IconsModule, NgbTooltipModule, PerfectScrollbarModule, TooltipWhenOverflowModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SidenavModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SidenavComponent,
                    SidenavHeaderDirective,
                    SidenavFooterDirective,
                    SidenavItemPostfixDirective,
                    SidenavGroupComponent,
                    SidenavContainerComponent,
                    SidenavContentComponent,
                ],
                imports: [CommonModule, SearchModule, RouterModule, IconsModule, NgbTooltipModule, PerfectScrollbarModule, TooltipWhenOverflowModule],
                exports: [
                    SidenavComponent,
                    SidenavContainerComponent,
                    SidenavContentComponent,
                    SidenavHeaderDirective,
                    SidenavFooterDirective,
                    SidenavItemPostfixDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SidenavModule, { declarations: function () { return [SidenavComponent, SidenavHeaderDirective, SidenavFooterDirective, SidenavItemPostfixDirective, SidenavGroupComponent, SidenavContainerComponent, SidenavContentComponent]; }, imports: function () { return [CommonModule, SearchModule, RouterModule, IconsModule, NgbTooltipModule, PerfectScrollbarModule, TooltipWhenOverflowModule]; }, exports: function () { return [SidenavComponent, SidenavContainerComponent, SidenavContentComponent, SidenavHeaderDirective, SidenavFooterDirective, SidenavItemPostfixDirective]; } }); })();

class AccordionSecondLevelStylesComponent {
}
AccordionSecondLevelStylesComponent.ɵfac = function AccordionSecondLevelStylesComponent_Factory(t) { return new (t || AccordionSecondLevelStylesComponent)(); };
AccordionSecondLevelStylesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionSecondLevelStylesComponent, selectors: [["ng-component"]], decls: 0, vars: 0, template: function AccordionSecondLevelStylesComponent_Template(rf, ctx) { }, styles: ["ngb-accordion[secondlevel]>.card{border-radius:0;box-shadow:none;margin-bottom:0}[role=tabpanel] .card-body>ngb-accordion[secondlevel]>.card{border-left:0;border-right:0}ngb-accordion[secondlevel]>.card:not(:last-of-type){border-bottom:0!important}ngb-accordion[secondlevel]>.card>.card-header[role=tab]{background-color:var(--da-table-header)}ngb-accordion[secondlevel]>.card>.card-header[role=tab]:hover,ngb-accordion[secondlevel]>.card>.card-header[role=tab]:hover [aria-expanded]:before{color:var(--da-brand-base)}ngb-accordion[secondlevel]>.card.opened-panel>.card-header[role=tab]{background:var(--da-cards-and-blocks);color:var(--da-brand-base)}ngb-accordion[secondlevel]>.card.opened-panel>.card-header[role=tab] [aria-expanded]:before{color:var(--da-brand-base)}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionSecondLevelStylesComponent, [{
        type: Component,
        args: [{ template: '', encapsulation: ViewEncapsulation.None, styles: ["ngb-accordion[secondlevel]>.card{border-radius:0;box-shadow:none;margin-bottom:0}[role=tabpanel] .card-body>ngb-accordion[secondlevel]>.card{border-left:0;border-right:0}ngb-accordion[secondlevel]>.card:not(:last-of-type){border-bottom:0!important}ngb-accordion[secondlevel]>.card>.card-header[role=tab]{background-color:var(--da-table-header)}ngb-accordion[secondlevel]>.card>.card-header[role=tab]:hover,ngb-accordion[secondlevel]>.card>.card-header[role=tab]:hover [aria-expanded]:before{color:var(--da-brand-base)}ngb-accordion[secondlevel]>.card.opened-panel>.card-header[role=tab]{background:var(--da-cards-and-blocks);color:var(--da-brand-base)}ngb-accordion[secondlevel]>.card.opened-panel>.card-header[role=tab] [aria-expanded]:before{color:var(--da-brand-base)}"] }]
    }], null, null); })();

const PANEL_OPENED_CLASS = 'opened-panel';
class DaAccordionService {
    constructor(accordion, elementRef, zone) {
        this.accordion = accordion;
        this.elementRef = elementRef;
        this.destroyed$ = new Subject();
        accordion.panelChange
            .pipe(delay(0), takeUntil(this.destroyed$))
            .lift(new ZoneFreeOperator(zone))
            .subscribe(() => this.updateAccordionHeaderStyles());
    }
    updateAccordionHeaderStyles() {
        this.accordion.panels.forEach(panel => {
            const panelElement = this.elementRef.nativeElement.querySelector(`[id="${panel.id}-header"]`).parentElement;
            panelElement.classList.toggle(PANEL_OPENED_CLASS, panel.isOpen);
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
    }
}
DaAccordionService.ɵfac = function DaAccordionService_Factory(t) { return new (t || DaAccordionService)(ɵngcc0.ɵɵinject(ɵngcc5.NgbAccordion, 1), ɵngcc0.ɵɵinject(ɵngcc0.ElementRef), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
DaAccordionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DaAccordionService, factory: DaAccordionService.ɵfac });
DaAccordionService.ctorParameters = () => [
    { type: NgbAccordion, decorators: [{ type: Host }] },
    { type: ElementRef },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DaAccordionService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc5.NgbAccordion, decorators: [{
                type: Host
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();

class AccordionSecondLevelDirective {
    constructor(accordion, elementRef, resolver, injector, accordionService) {
        this.accordion = accordion;
        this.elementRef = elementRef;
        this.resolver = resolver;
        this.injector = injector;
        this.accordionService = accordionService;
        this.resolver
            .resolveComponentFactory(AccordionSecondLevelStylesComponent)
            .create(this.injector);
    }
    ngAfterViewInit() {
        this.accordionService.updateAccordionHeaderStyles();
    }
}
AccordionSecondLevelDirective.ɵfac = function AccordionSecondLevelDirective_Factory(t) { return new (t || AccordionSecondLevelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbAccordion, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(DaAccordionService)); };
AccordionSecondLevelDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AccordionSecondLevelDirective, selectors: [["ngb-accordion", "secondLevel", ""]], features: [ɵngcc0.ɵɵProvidersFeature([DaAccordionService])] });
AccordionSecondLevelDirective.ctorParameters = () => [
    { type: NgbAccordion, decorators: [{ type: Host }] },
    { type: ElementRef },
    { type: ComponentFactoryResolver },
    { type: Injector },
    { type: DaAccordionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionSecondLevelDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ngb-accordion[secondLevel]',
                providers: [DaAccordionService]
            }]
    }], function () { return [{ type: ɵngcc5.NgbAccordion, decorators: [{
                type: Host
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: DaAccordionService }]; }, null); })();

class AccordionFirstLevelStylesComponent {
}
AccordionFirstLevelStylesComponent.ɵfac = function AccordionFirstLevelStylesComponent_Factory(t) { return new (t || AccordionFirstLevelStylesComponent)(); };
AccordionFirstLevelStylesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionFirstLevelStylesComponent, selectors: [["ng-component"]], decls: 0, vars: 0, template: function AccordionFirstLevelStylesComponent_Template(rf, ctx) { }, styles: ["ngb-accordion[firstlevel]>.card{box-shadow:none;transition-duration:.3s;transition-property:box-shadow;transition-timing-function:ease-in-out}ngb-accordion[firstlevel]>.card:not(.card-disabled):not(.opened-panel):hover{box-shadow:var(--da-fl-accordion-hover-shadow,var(--da-card-hover-box-shadow))}ngb-accordion[firstlevel]>.card.opened-panel{box-shadow:var(--da-card-hover-box-shadow)}"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionFirstLevelStylesComponent, [{
        type: Component,
        args: [{ template: '', encapsulation: ViewEncapsulation.None, styles: ["ngb-accordion[firstlevel]>.card{box-shadow:none;transition-duration:.3s;transition-property:box-shadow;transition-timing-function:ease-in-out}ngb-accordion[firstlevel]>.card:not(.card-disabled):not(.opened-panel):hover{box-shadow:var(--da-fl-accordion-hover-shadow,var(--da-card-hover-box-shadow))}ngb-accordion[firstlevel]>.card.opened-panel{box-shadow:var(--da-card-hover-box-shadow)}"] }]
    }], null, null); })();

class AccordionFirstLevelDirective {
    constructor(resolver, injector, accordionService) {
        this.accordionService = accordionService;
        resolver
            .resolveComponentFactory(AccordionFirstLevelStylesComponent)
            .create(injector);
    }
    ngAfterViewInit() {
        this.accordionService.updateAccordionHeaderStyles();
    }
}
AccordionFirstLevelDirective.ɵfac = function AccordionFirstLevelDirective_Factory(t) { return new (t || AccordionFirstLevelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(DaAccordionService)); };
AccordionFirstLevelDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AccordionFirstLevelDirective, selectors: [["ngb-accordion", "firstLevel", ""]], features: [ɵngcc0.ɵɵProvidersFeature([DaAccordionService])] });
AccordionFirstLevelDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Injector },
    { type: DaAccordionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionFirstLevelDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ngb-accordion[firstLevel]',
                providers: [DaAccordionService]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: DaAccordionService }]; }, null); })();

class AccordionHeaderToggleDirective extends NgbPanelToggle {
    constructor(accordion, panel) {
        super(accordion, panel);
        this.accordion = accordion;
        this.panel = panel;
    }
}
AccordionHeaderToggleDirective.ɵfac = function AccordionHeaderToggleDirective_Factory(t) { return new (t || AccordionHeaderToggleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbAccordion), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbPanel)); };
AccordionHeaderToggleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AccordionHeaderToggleDirective, selectors: [["", "libHeaderToggle", ""]], hostVars: 1, hostBindings: function AccordionHeaderToggleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("disabled", ctx.panel.disabled);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
AccordionHeaderToggleDirective.ctorParameters = () => [
    { type: NgbAccordion },
    { type: NgbPanel }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionHeaderToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[libHeaderToggle]',
                host: {
                    '[disabled]': 'panel.disabled'
                }
            }]
    }], function () { return [{ type: ɵngcc5.NgbAccordion }, { type: ɵngcc5.NgbPanel }]; }, null); })();

class AccordionStylesModule {
}
AccordionStylesModule.ɵfac = function AccordionStylesModule_Factory(t) { return new (t || AccordionStylesModule)(); };
AccordionStylesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AccordionStylesModule });
AccordionStylesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionStylesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AccordionSecondLevelDirective,
                    AccordionSecondLevelStylesComponent,
                    AccordionFirstLevelDirective,
                    AccordionFirstLevelStylesComponent,
                    AccordionHeaderToggleDirective,
                ],
                imports: [CommonModule],
                exports: [
                    AccordionSecondLevelDirective,
                    AccordionFirstLevelDirective,
                    AccordionHeaderToggleDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccordionStylesModule, { declarations: function () { return [AccordionSecondLevelDirective, AccordionSecondLevelStylesComponent, AccordionFirstLevelDirective, AccordionFirstLevelStylesComponent, AccordionHeaderToggleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AccordionSecondLevelDirective, AccordionFirstLevelDirective, AccordionHeaderToggleDirective]; } }); })();

class CopyToClipboardDirective {
    constructor(zone, { nativeElement }) {
        this.copied = new EventEmitter();
        this.destroyed$ = new Subject();
        zone.runOutsideAngular(() => {
            fromEvent(nativeElement, 'click')
                .pipe(switchMap(() => navigator.clipboard.writeText(this.text)), takeUntil(this.destroyed$))
                .subscribe(() => {
                zone.run(() => this.copied.emit());
            });
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
    }
}
CopyToClipboardDirective.ɵfac = function CopyToClipboardDirective_Factory(t) { return new (t || CopyToClipboardDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CopyToClipboardDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CopyToClipboardDirective, selectors: [["", "copyToClipboard", ""]], inputs: { text: ["copyToClipboard", "text"] }, outputs: { copied: "copied" } });
CopyToClipboardDirective.ctorParameters = () => [
    { type: NgZone },
    { type: ElementRef }
];
CopyToClipboardDirective.propDecorators = {
    text: [{ type: Input, args: ['copyToClipboard',] }],
    copied: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CopyToClipboardDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[copyToClipboard]'
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ɵngcc0.ElementRef }]; }, { copied: [{
            type: Output
        }], text: [{
            type: Input,
            args: ['copyToClipboard']
        }] }); })();
class CopyToClipboardModule {
}
CopyToClipboardModule.ɵfac = function CopyToClipboardModule_Factory(t) { return new (t || CopyToClipboardModule)(); };
CopyToClipboardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CopyToClipboardModule });
CopyToClipboardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CopyToClipboardModule, [{
        type: NgModule,
        args: [{
                declarations: [CopyToClipboardDirective],
                imports: [CommonModule],
                exports: [CopyToClipboardDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CopyToClipboardModule, { declarations: function () { return [CopyToClipboardDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CopyToClipboardDirective]; } }); })();

class ScrollDirective {
    constructor(element) {
        this.element = element;
        this.appScrollDisabled = false;
        // tslint:disable-next-line:variable-name
        this._isOnBottom = true;
        this.upCounter = 0;
        this.downCounter = 0;
        this.isOnTop = false;
        this.isScrollingDown = (oldPosition, newPosition) => oldPosition.scrollTop < newPosition.scrollTop;
        this.isScrollToTop = (position) => position.scrollTop === 0;
        this.isScrollToBottom = (position) => position.scrollHeight - position.scrollTop === position.clientHeight;
        this.isScrollingUp = (oldPosition, newPosition) => oldPosition.scrollTop > newPosition.scrollTop;
    }
    get isOnBottom() {
        return this._isOnBottom;
    }
    set isOnBottom(val) {
        this._isOnBottom = val;
    }
    ngAfterViewInit() {
        if (this.appScrollDisabled) {
            return;
        }
        this.scrollEvent = fromEvent(this.element.nativeElement, 'scroll');
        this.wheelEvent = fromEvent(this.element.nativeElement, 'wheel');
        this.scrolledDown = this.scrollEvent
            .pipe(map(e => ({
            scrollHeight: e.target.scrollHeight,
            scrollTop: e.target.scrollTop,
            clientHeight: e.target.clientHeight
        })), pairwise(), filter(([oldPosition, newPosition]) => this.isScrollingDown(oldPosition, newPosition) &&
            this.isScrollToBottom(newPosition)))
            .subscribe(() => {
            if (this.scrollCallback) {
                this.scrollCallback();
            }
            this.isOnBottom = true;
        });
        this.scrollingDown = this.scrollEvent
            .pipe(map(e => ({
            scrollHeight: e.target.scrollHeight,
            scrollTop: e.target.scrollTop,
            clientHeight: e.target.clientHeight
        })), startWith({
            scrollHeight: this.element.nativeElement.scrollHeight,
            scrollTop: this.element.nativeElement.scrollTop,
            clientHeight: this.element.nativeElement.clientHeight
        }), pairwise(), filter(([oldPosition, newPosition]) => this.isScrollingDown(oldPosition, newPosition)))
            .subscribe(() => {
            this.isOnTop = false;
        });
        this.scrollingUp = this.scrollEvent
            .pipe(map(e => ({
            scrollHeight: e.target.scrollHeight,
            scrollTop: e.target.scrollTop,
            clientHeight: e.target.clientHeight
        })), startWith({
            scrollHeight: this.element.nativeElement.scrollHeight,
            scrollTop: this.element.nativeElement.scrollTop,
            clientHeight: this.element.nativeElement.clientHeight
        }), pairwise(), filter(([oldPosition, newPosition]) => this.isScrollingUp(oldPosition, newPosition)))
            .subscribe(() => {
            this.isOnBottom = false;
        });
        this.scrolledUp = this.scrollEvent
            .pipe(map(e => ({
            scrollHeight: e.target.scrollHeight,
            scrollTop: e.target.scrollTop,
            clientHeight: e.target.clientHeight
        })), pairwise(), filter(([, newPosition]) => this.isScrollToTop(newPosition)))
            .subscribe(() => {
            this.upCounter = 0;
            this.isOnTop = true;
        });
        this.wheeledUp = this.wheelEvent.subscribe(event => {
            if (event.deltaY < 0 && this.isOnTop === true && this.checkLog) {
                this.upCounter = this.upCounter + 1;
            }
            if (this.upCounter > 20 &&
                this.isOnTop === true &&
                this.wheelUpCallback) {
                this.wheelUpCallback();
                this.upCounter = 0;
            }
        });
        this.wheeledDown = this.wheelEvent.subscribe(event => {
            if (event.deltaY > 0 && this.isOnBottom) {
                this.downCounter++;
            }
            if (this.downCounter > 20 &&
                this.isOnBottom &&
                this.wheeledDownCallback) {
                this.wheeledDownCallback();
                this.downCounter = 0;
            }
        });
    }
    ngOnDestroy() {
        if (this.scrolledDown) {
            this.scrolledDown.unsubscribe();
        }
    }
}
ScrollDirective.ɵfac = function ScrollDirective_Factory(t) { return new (t || ScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ScrollDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScrollDirective, selectors: [["", "appScroll", ""]], inputs: { appScrollDisabled: "appScrollDisabled", isOnBottom: "isOnBottom", scrollCallback: "scrollCallback", wheelUpCallback: "wheelUpCallback", checkLog: "checkLog", wheeledDownCallback: "wheeledDownCallback" } });
ScrollDirective.ctorParameters = () => [
    { type: ElementRef }
];
ScrollDirective.propDecorators = {
    appScrollDisabled: [{ type: Input }],
    scrollCallback: [{ type: Input }],
    wheelUpCallback: [{ type: Input }],
    checkLog: [{ type: Input }],
    wheeledDownCallback: [{ type: Input }],
    isOnBottom: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[appScroll]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { appScrollDisabled: [{
            type: Input
        }], isOnBottom: [{
            type: Input
        }], scrollCallback: [{
            type: Input
        }], wheelUpCallback: [{
            type: Input
        }], checkLog: [{
            type: Input
        }], wheeledDownCallback: [{
            type: Input
        }] }); })();
class KitScrollModule {
}
KitScrollModule.ɵfac = function KitScrollModule_Factory(t) { return new (t || KitScrollModule)(); };
KitScrollModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: KitScrollModule });
KitScrollModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KitScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [ScrollDirective],
                exports: [ScrollDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(KitScrollModule, { declarations: [ScrollDirective], exports: [ScrollDirective] }); })();

class RowTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
RowTemplateDirective.ɵfac = function RowTemplateDirective_Factory(t) { return new (t || RowTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
RowTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: RowTemplateDirective, selectors: [["ng-template", "rowTemplate", ""]] });
RowTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RowTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[rowTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class HeaderTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
HeaderTemplateDirective.ɵfac = function HeaderTemplateDirective_Factory(t) { return new (t || HeaderTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
HeaderTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HeaderTemplateDirective, selectors: [["ng-template", "headerTemplate", ""]] });
HeaderTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[headerTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class DataGridComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.dataSource = [];
        this.columns = [];
        this.trackByFn = null;
        this.sortOptions = [10, 25, 50];
        this.useHeader = true;
        this.adjustHorizontalScroll = false;
        this.pageSizeContainer = null;
        this.allowDraggingRows = false;
        this.placement = ['bottom', 'top'];
        this.noDataText = 'No data available';
        this.sort = new EventEmitter();
        this.pageChange = new EventEmitter();
        this.rowClick = new EventEmitter();
        this.rowDoubleClick = new EventEmitter();
        this.rowItemDropped = new EventEmitter();
        this.trackByItem = (index, item) => {
            if (this.trackByFn) {
                return this.trackByFn(index, item);
            }
            return item;
        };
    }
    get gridColumns() {
        return this.columns.filter(col => !col.hidden);
    }
    changeSort(fieldName) {
        if (!fieldName) {
            return;
        }
        this.sort.emit(fieldName);
    }
    onPageChange(data) {
        this.pageChange.emit(data);
    }
    handleRowClick(item) {
        this.rowClick.emit(item);
    }
    handleDoubleClick(item) {
        this.rowDoubleClick.emit(item);
    }
    itemGuard(item) {
        return item;
    }
    onResize() {
        this.elRef.nativeElement.classList.add('grid--auto');
        const width = this.elRef.nativeElement.firstElementChild
            .firstElementChild.offsetWidth;
        this.elRef.nativeElement.style.setProperty('--w', `${width}px`);
        const ths = Array.from(this.tableRef.nativeElement.tHead.children.item(0).children);
        ths.forEach((th, i) => {
            this.columns[i].width = th.offsetWidth + 'px';
        });
        this.elRef.nativeElement.classList.remove('grid--auto');
    }
}
DataGridComponent.ɵfac = function DataGridComponent_Factory(t) { return new (t || DataGridComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DataGridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataGridComponent, selectors: [["lib-data-grid"]], contentQueries: function DataGridComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, HeaderTemplateDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, RowTemplateDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rowTemplate = _t.first);
    } }, viewQuery: function DataGridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(ScrollDirective, 5);
        ɵngcc0.ɵɵviewQuery(_c54, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scroll = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tableRef = _t.first);
    } }, inputs: { dataSource: "dataSource", columns: "columns", trackByFn: "trackByFn", sortOptions: "sortOptions", useHeader: "useHeader", adjustHorizontalScroll: "adjustHorizontalScroll", pageSizeContainer: "pageSizeContainer", allowDraggingRows: "allowDraggingRows", placement: "placement", noDataText: "noDataText", pagination: "pagination", pageable: "pageable", bodyHeight: "bodyHeight", sticky: "sticky", scrollCallback: "scrollCallback", wheelUsing: "wheelUsing", wheelUpCallback: "wheelUpCallback", wheeledDownCallback: "wheeledDownCallback", checkLog: "checkLog", usePerfectScrollbar: "usePerfectScrollbar", translatedText: "translatedText" }, outputs: { sort: "sort", pageChange: "pageChange", rowClick: "rowClick", rowDoubleClick: "rowDoubleClick", rowItemDropped: "rowItemDropped" }, decls: 8, vars: 17, consts: [[1, "table-wrapper"], [1, "table", "data-grid", "w-100", "fixed-layout", 3, "libResizeObserverDisable", "libResizeObserver"], ["tableRef", ""], [4, "ngIf"], ["appScroll", "", "perfectScrollbar", "", "cdkDropList", "", 3, "appScrollDisabled", "scrollCallback", "checkLog", "wheelUpCallback", "wheeledDownCallback", "disabled", "cdkDropListData", "cdkDropListDisabled", "cdkDropListDropped"], ["class", "body-row", "cdkDrag", "", 3, "click", "dblclick", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "metaData", "placement", "pageSizeContainer", "sortOptions", "noDataText", "translatedText", "pagerdata", 4, "ngIf"], [4, "ngTemplateOutlet"], ["defaultHeader", ""], [1, "table-border"], [3, "ngClass", "width", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], [1, "column-header"], ["class", "fa sort-icon ml-5px", "icon", "chevron-down", 4, "ngIf"], ["class", "fa sort-icon-active ml-5px", 3, "icon", 4, "ngIf"], ["icon", "chevron-down", 1, "fa", "sort-icon", "ml-5px"], [1, "fa", "sort-icon-active", "ml-5px", 3, "icon"], ["cdkDrag", "", 1, "body-row", 3, "click", "dblclick"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultCell", ""], [3, "width", 4, "ngFor", "ngForOf"], [3, "metaData", "placement", "pageSizeContainer", "sortOptions", "noDataText", "translatedText", "pagerdata"]], template: function DataGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "table", 1, 2);
        ɵngcc0.ɵɵlistener("libResizeObserver", function DataGridComponent_Template_table_libResizeObserver_1_listener() { return ctx.onResize(); });
        ɵngcc0.ɵɵelementStart(3, "thead");
        ɵngcc0.ɵɵtemplate(4, DataGridComponent_ng_container_4_Template, 4, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "tbody", 4);
        ɵngcc0.ɵɵlistener("cdkDropListDropped", function DataGridComponent_Template_tbody_cdkDropListDropped_5_listener($event) { return ctx.rowItemDropped.emit($event); });
        ɵngcc0.ɵɵtemplate(6, DataGridComponent_tr_6_Template, 4, 6, "tr", 5);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(7, DataGridComponent_lib_pagination_7_Template, 1, 6, "lib-pagination", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("sticky", ctx.sticky);
        ɵngcc0.ɵɵproperty("libResizeObserverDisable", !ctx.adjustHorizontalScroll);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useHeader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("max-height", ctx.bodyHeight ? ctx.bodyHeight : "");
        ɵngcc0.ɵɵproperty("appScrollDisabled", !ctx.wheelUsing && !ctx.scrollCallback)("scrollCallback", ctx.scrollCallback)("checkLog", ctx.checkLog)("wheelUpCallback", ctx.wheelUpCallback)("wheeledDownCallback", ctx.wheeledDownCallback)("disabled", !ctx.usePerfectScrollbar)("cdkDropListData", ctx.dataSource)("cdkDropListDisabled", !ctx.allowDraggingRows);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dataSource)("ngForTrackBy", ctx.trackByItem);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pagination);
    } }, dependencies: function () { return [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ResizeObserverDirective, ɵngcc6.PerfectScrollbarDirective, ScrollDirective, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, PaginationComponent, ɵngcc10.CdkDropList, ɵngcc10.CdkDrag]; }, styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;height:100%;width:100%}.table-wrapper[_ngcontent-%COMP%]{height:100%;overflow:auto}.table.fixed-layout[_ngcontent-%COMP%]{table-layout:fixed}.table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:.5rem .75rem;vertical-align:middle}.table.sticky[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;margin:0}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{background:var(--da-table-header-new);border-bottom:1px solid var(--da-border-and-dividers);border-top:1px solid var(--da-border-and-dividers)}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > .table-border[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]{border:0;line-height:16px;padding-bottom:8px}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > .table-border[_ngcontent-%COMP%] > th.sort-field[_ngcontent-%COMP%]{cursor:pointer}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > .table-border[_ngcontent-%COMP%] > th.sort-field[_ngcontent-%COMP%]   .column-header[_ngcontent-%COMP%]{align-items:center;display:flex;white-space:nowrap}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > .table-border[_ngcontent-%COMP%] > th.sort-field[_ngcontent-%COMP%]   .sort-icon[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons);display:block;font-size:16px!important}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > .table-border[_ngcontent-%COMP%] > th.sort-field[_ngcontent-%COMP%]   .sort-icon-active[_ngcontent-%COMP%]{color:var(--da-brand-hover);font-size:16px!important}.table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%] > .table-border[_ngcontent-%COMP%] > th[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:10px;margin-left:3px}.table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]{position:relative}.table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{border-bottom:1px solid var(--da-border-and-dividers)}.table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background:var(--da-blackout)}.table.sticky[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]{display:block;overflow:auto;width:var(--w,100%)}.table.sticky[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .table.sticky[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{display:table;table-layout:fixed;width:var(--w,100%)}.table.sticky[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{width:var(--w,100%)}.table[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar-button{background-repeat:no-repeat;height:0}.table[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar-track{background-color:var(cards-and-blocks)}.table[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar-thumb{-webkit-border-radius:10px;background-color:var(--da-border-and-dividers);background-position:50%;background-repeat:no-repeat;box-shadow:0 1px 1px var(--da-cards-and-blocks) inset}.table[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-resizer{background-repeat:no-repeat;height:0}.table[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar{width:8px}[_nghost-%COMP%]  .data-grid td{border-top:none!important}.scrollable-body[_ngcontent-%COMP%]{overflow-y:hidden}.grid--auto[_nghost-%COMP%]   .table[_ngcontent-%COMP%], .grid--auto[_nghost-%COMP%]   .table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%], .grid--auto[_nghost-%COMP%]   .table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{table-layout:auto}.grid--auto[_nghost-%COMP%]   .table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]{width:auto}.grid--auto[_nghost-%COMP%]   .table[_ngcontent-%COMP%]{table-layout:auto}  .body-row.cdk-drag-preview{background:var(--da-cards-and-blocks);border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box;display:flex}  .body-row.cdk-drag-preview td{align-items:center;display:flex;padding:.5rem .75rem;vertical-align:middle}.cdk-drop-list-dragging[_ngcontent-%COMP%]   .cdk-drag[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}"] });
DataGridComponent.ctorParameters = () => [
    { type: ElementRef }
];
DataGridComponent.propDecorators = {
    dataSource: [{ type: Input }],
    columns: [{ type: Input }],
    pagination: [{ type: Input }],
    pageable: [{ type: Input }],
    bodyHeight: [{ type: Input }],
    sticky: [{ type: Input }],
    scrollCallback: [{ type: Input }],
    wheelUsing: [{ type: Input }],
    wheelUpCallback: [{ type: Input }],
    wheeledDownCallback: [{ type: Input }],
    checkLog: [{ type: Input }],
    trackByFn: [{ type: Input }],
    sortOptions: [{ type: Input }],
    usePerfectScrollbar: [{ type: Input }],
    useHeader: [{ type: Input }],
    adjustHorizontalScroll: [{ type: Input }],
    pageSizeContainer: [{ type: Input }],
    allowDraggingRows: [{ type: Input }],
    placement: [{ type: Input }],
    noDataText: [{ type: Input }],
    translatedText: [{ type: Input }],
    sort: [{ type: Output }],
    pageChange: [{ type: Output }],
    rowClick: [{ type: Output }],
    rowDoubleClick: [{ type: Output }],
    rowItemDropped: [{ type: Output }],
    scroll: [{ type: ViewChild, args: [ScrollDirective,] }],
    tableRef: [{ type: ViewChild, args: ['tableRef',] }],
    headerTemplate: [{ type: ContentChild, args: [HeaderTemplateDirective, { static: true },] }],
    rowTemplate: [{ type: ContentChild, args: [RowTemplateDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataGridComponent, [{
        type: Component,
        args: [{ selector: 'lib-data-grid', template: "<div class=\"table-wrapper\">\n    <table\n        #tableRef\n        class=\"table data-grid w-100 fixed-layout\"\n        [class.sticky]=\"sticky\"\n        [libResizeObserverDisable]=\"!adjustHorizontalScroll\"\n        (libResizeObserver)=\"onResize()\"\n    >\n        <thead>\n            <ng-container *ngIf=\"useHeader\">\n                <ng-container\n                    *ngTemplateOutlet=\"\n                        headerTemplate ? headerTemplate.template : defaultHeader\n                    \"\n                ></ng-container>\n                <ng-template #defaultHeader>\n                    <tr class=\"table-border\">\n                        <th\n                            *ngFor=\"let c of gridColumns\"\n                            [ngClass]=\"{ 'sort-field': c.sortingField }\"\n                            [style.width]=\"c.width\"\n                            (click)=\"changeSort(c.sortingField)\"\n                        >\n                            <span class=\"column-header\"\n                                >{{ c.title }}\n                                <fa-icon\n                                    *ngIf=\"\n                                        c.sortingField &&\n                                        (!pageable ||\n                                            !pageable.sorted(c.sortingField))\n                                    \"\n                                    class=\"fa sort-icon ml-5px\"\n                                    icon=\"chevron-down\"\n                                >\n                                </fa-icon>\n                                <fa-icon\n                                    *ngIf=\"\n                                        pageable &&\n                                        pageable.sorted(c.sortingField) as s\n                                    \"\n                                    icon=\"{{\n                                        s === 'ASC'\n                                            ? 'chevron-up'\n                                            : 'chevron-down'\n                                    }}\"\n                                    class=\"fa sort-icon-active ml-5px\"\n                                >\n                                </fa-icon>\n                            </span>\n                        </th>\n                    </tr>\n                </ng-template>\n            </ng-container>\n        </thead>\n\n        <tbody\n            appScroll\n            [appScrollDisabled]=\"!wheelUsing && !scrollCallback\"\n            [scrollCallback]=\"scrollCallback\"\n            [checkLog]=\"checkLog\"\n            [wheelUpCallback]=\"wheelUpCallback\"\n            [wheeledDownCallback]=\"wheeledDownCallback\"\n            [style.max-height]=\"bodyHeight ? bodyHeight : ''\"\n            perfectScrollbar\n            [disabled]=\"!usePerfectScrollbar\"\n            cdkDropList\n            [cdkDropListData]=\"dataSource\"\n            [cdkDropListDisabled]=\"!allowDraggingRows\"\n            (cdkDropListDropped)=\"rowItemDropped.emit($event)\"\n        >\n            <tr\n                *ngFor=\"\n                    let item of dataSource;\n                    let i = index;\n                    trackBy: trackByItem\n                \"\n                class=\"body-row\"\n                cdkDrag\n                (click)=\"handleRowClick(item)\"\n                (dblclick)=\"handleDoubleClick(item)\"\n            >\n                <ng-container\n                    *ngTemplateOutlet=\"\n                        rowTemplate ? rowTemplate.template : defaultCell;\n                        context: { item: item, items: dataSource, index: i }\n                    \"\n                >\n                </ng-container>\n                <ng-template #defaultCell>\n                    <td *ngFor=\"let c of gridColumns\" [style.width]=\"c.width\">\n                        {{ item[c.field] }}\n                    </td>\n                </ng-template>\n            </tr>\n        </tbody>\n    </table>\n</div>\n\n<lib-pagination\n    *ngIf=\"pagination\"\n    [metaData]=\"pagination\"\n    (pagerdata)=\"onPageChange($event)\"\n    [placement]=\"placement\"\n    [pageSizeContainer]=\"pageSizeContainer\"\n    [sortOptions]=\"sortOptions\"\n    [noDataText]=\"noDataText\"\n    [translatedText]=\"translatedText\"\n></lib-pagination>\n", styles: [":host{display:flex;flex-direction:column;height:100%;width:100%}.table-wrapper{height:100%;overflow:auto}.table.fixed-layout{table-layout:fixed}.table td{padding:.5rem .75rem;vertical-align:middle}.table.sticky{display:flex;flex-direction:column;height:100%;margin:0}.table thead{background:var(--da-table-header-new);border-bottom:1px solid var(--da-border-and-dividers);border-top:1px solid var(--da-border-and-dividers)}.table thead>.table-border>th{border:0;line-height:16px;padding-bottom:8px}.table thead>.table-border>th.sort-field{cursor:pointer}.table thead>.table-border>th.sort-field .column-header{align-items:center;display:flex;white-space:nowrap}.table thead>.table-border>th.sort-field .sort-icon{color:var(--da-secondary-text-and-icons);display:block;font-size:16px!important}.table thead>.table-border>th.sort-field .sort-icon-active{color:var(--da-brand-hover);font-size:16px!important}.table thead>.table-border>th i{font-size:10px;margin-left:3px}.table tbody{position:relative}.table tbody tr{border-bottom:1px solid var(--da-border-and-dividers)}.table tbody tr:hover{background:var(--da-blackout)}.table.sticky tbody{display:block;overflow:auto;width:var(--w,100%)}.table.sticky tbody tr,.table.sticky thead{display:table;table-layout:fixed;width:var(--w,100%)}.table.sticky thead{width:var(--w,100%)}.table ::-webkit-scrollbar-button{background-repeat:no-repeat;height:0}.table ::-webkit-scrollbar-track{background-color:var(cards-and-blocks)}.table ::-webkit-scrollbar-thumb{-webkit-border-radius:10px;background-color:var(--da-border-and-dividers);background-position:50%;background-repeat:no-repeat;box-shadow:0 1px 1px var(--da-cards-and-blocks) inset}.table ::-webkit-resizer{background-repeat:no-repeat;height:0}.table ::-webkit-scrollbar{width:8px}:host::ng-deep .data-grid td{border-top:none!important}.scrollable-body{overflow-y:hidden}:host.grid--auto .table,:host.grid--auto .table tbody tr,:host.grid--auto .table thead{table-layout:auto}:host.grid--auto .table thead{width:auto}:host.grid--auto .table{table-layout:auto}::ng-deep .body-row.cdk-drag-preview{background:var(--da-cards-and-blocks);border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box;display:flex}::ng-deep .body-row.cdk-drag-preview td{align-items:center;display:flex;padding:.5rem .75rem;vertical-align:middle}.cdk-drop-list-dragging .cdk-drag{transition:transform .25s cubic-bezier(0,0,.2,1)}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { dataSource: [{
            type: Input
        }], columns: [{
            type: Input
        }], trackByFn: [{
            type: Input
        }], sortOptions: [{
            type: Input
        }], useHeader: [{
            type: Input
        }], adjustHorizontalScroll: [{
            type: Input
        }], pageSizeContainer: [{
            type: Input
        }], allowDraggingRows: [{
            type: Input
        }], placement: [{
            type: Input
        }], noDataText: [{
            type: Input
        }], sort: [{
            type: Output
        }], pageChange: [{
            type: Output
        }], rowClick: [{
            type: Output
        }], rowDoubleClick: [{
            type: Output
        }], rowItemDropped: [{
            type: Output
        }], pagination: [{
            type: Input
        }], pageable: [{
            type: Input
        }], bodyHeight: [{
            type: Input
        }], sticky: [{
            type: Input
        }], scrollCallback: [{
            type: Input
        }], wheelUsing: [{
            type: Input
        }], wheelUpCallback: [{
            type: Input
        }], wheeledDownCallback: [{
            type: Input
        }], checkLog: [{
            type: Input
        }], usePerfectScrollbar: [{
            type: Input
        }], translatedText: [{
            type: Input
        }], scroll: [{
            type: ViewChild,
            args: [ScrollDirective]
        }], tableRef: [{
            type: ViewChild,
            args: ['tableRef']
        }], headerTemplate: [{
            type: ContentChild,
            args: [HeaderTemplateDirective, { static: true }]
        }], rowTemplate: [{
            type: ContentChild,
            args: [RowTemplateDirective, { static: true }]
        }] }); })();

class ResizeObserverDirective {
    constructor(elRef, zone) {
        this.elRef = elRef;
        this.zone = zone;
        this.libResizeObserverDisable = false;
        this.libResizeObserver = new EventEmitter();
        this.resizeObserverSelectorFn = (host) => host;
    }
    ngOnInit() {
        if (this.libResizeObserverDisable) {
            return;
        }
        this.zone.runOutsideAngular(() => {
            this.observer = new ResizeObserver(() => this.libResizeObserver.emit());
            this.observer.observe(this.resizeObserverSelectorFn(this.elRef.nativeElement));
        });
    }
    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
ResizeObserverDirective.ɵfac = function ResizeObserverDirective_Factory(t) { return new (t || ResizeObserverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ResizeObserverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ResizeObserverDirective, selectors: [["", "libResizeObserver", ""]], inputs: { libResizeObserverDisable: "libResizeObserverDisable", resizeObserverSelectorFn: "resizeObserverSelectorFn" }, outputs: { libResizeObserver: "libResizeObserver" } });
ResizeObserverDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
ResizeObserverDirective.propDecorators = {
    libResizeObserverDisable: [{ type: Input }],
    libResizeObserver: [{ type: Output }],
    resizeObserverSelectorFn: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResizeObserverDirective, [{
        type: Directive,
        args: [{
                selector: '[libResizeObserver]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { libResizeObserverDisable: [{
            type: Input
        }], libResizeObserver: [{
            type: Output
        }], resizeObserverSelectorFn: [{
            type: Input
        }] }); })();
class ResizeObserverModule {
}
ResizeObserverModule.ɵfac = function ResizeObserverModule_Factory(t) { return new (t || ResizeObserverModule)(); };
ResizeObserverModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ResizeObserverModule });
ResizeObserverModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResizeObserverModule, [{
        type: NgModule,
        args: [{
                declarations: [ResizeObserverDirective],
                exports: [ResizeObserverDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ResizeObserverModule, { declarations: [ResizeObserverDirective], exports: [ResizeObserverDirective] }); })();

class PagerService {
    getPager(totalItems, currentPage = 1, pageSize = 10) {
        // calculate total pages
        const totalPages = Math.ceil(totalItems / pageSize);
        // ensure current page isn't out of range
        if (currentPage < 1) {
            currentPage = 1;
        }
        else if (currentPage > totalPages) {
            if (totalPages <= 0) {
                currentPage = 1;
            }
            else {
                currentPage = totalPages;
            }
        }
        let startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        }
        else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            }
            else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            }
            else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }
        // calculate start and end item indexes
        const startIndex = totalItems == 0 ? 0 : (currentPage - 1) * pageSize + 1;
        const endIndex = Math.min((startIndex + (pageSize - 1)), totalItems);
        // create an array of pages to ng-repeat in the pager control
        const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(i => startPage + i);
        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages,
        };
    }
}
PagerService.ɵfac = function PagerService_Factory(t) { return new (t || PagerService)(); };
PagerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PagerService, factory: PagerService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PagerService, [{
        type: Injectable
    }], null, null); })();

const ENTER_KEY = 'Enter';
class PaginationComponent {
    constructor(pagerService) {
        this.pagerService = pagerService;
        this.totalCount = 0;
        this.perPageCount = 10;
        this.jumpValue = '';
        this.sortOptions = [10, 25, 50];
        this.placement = ['bottom', 'top'];
        this.pageSizeContainer = null;
        this.noDataText = 'No data available';
        this.pagerdata = new EventEmitter();
    }
    get isDiscrete() {
        return this.pager.pages.length > 5;
    }
    ngOnChanges() {
        this.totalCount = this.metaData.totalElements;
        this.perPageCount = this.metaData.pageSize;
        this.previousPageCount = this.perPageCount;
        this.setInitialPage(this.metaData.page + 1);
    }
    changeMessage(selectedItem) {
        this.perPageCount = selectedItem;
        if (this.previousPageCount === this.perPageCount) {
            return;
        }
        this.setPage(0);
    }
    setInitialPage(page) {
        this.pager = this.getPager(page);
    }
    setPage(page) {
        const pager = this.getPager(page);
        this.pagerdata.emit(pager);
        this.setInitialPage(page);
    }
    getPager(page) {
        return this.pagerService.getPager(this.totalCount, page, this.perPageCount);
    }
    getVisiblePages() {
        const pages = [];
        const first = this.pager.currentPage < 3 ? 1 : this.pager.currentPage - 1;
        const last = first + 4 < this.pager.totalPages
            ? first + 4
            : this.pager.totalPages;
        for (let i = last - 4; i < last; i++) {
            pages.push(i);
        }
        return pages;
    }
    isEndOfList() {
        return this.pager.totalPages < this.pager.currentPage + 4;
    }
    jump() {
        if (!this.jumpValue) {
            return;
        }
        const val = parseInt(this.jumpValue, 10);
        const page = val > 0 && val <= this.pager.totalPages ? val : 1;
        this.setPage(page);
        this.jumpValue = '';
    }
    onJumpValueChange(e) {
        if (e.key === ENTER_KEY) {
            this.jump();
        }
        else {
            this.jumpValue = e.target.value;
        }
    }
    validateJumpValue(e) {
        return e.charCode >= 48;
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(ɵngcc0.ɵɵdirectiveInject(PagerService)); };
PaginationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["lib-pagination"]], inputs: { sortOptions: "sortOptions", placement: "placement", pageSizeContainer: "pageSizeContainer", noDataText: "noDataText", metaData: "metaData", translatedText: "translatedText" }, outputs: { pagerdata: "pagerdata" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 9, vars: 4, consts: [[1, "col-12", "content-wrapper"], [1, "row", "align-items-center"], [1, "col", "pl-1"], [4, "ngIf"], [1, "col", "text-center", "pl-1", "pr-1", "font-italic", "secondary-text-and-icons"], ["class", "secondary-text-and-icons", 4, "ngIf"], [1, "col", "pr-1", "min-width-fit-content"], ["aria-label", "Page navigation", 4, "ngIf"], [1, "secondary-text-and-icons"], ["ngbDropdown", "", 1, "d-inline-block", 3, "placement", "container"], ["id", "dropdownBasic1", "ngbDropdownToggle", "", 1, "btn", "nav-link", "dropdown-toggle"], ["aria-labelledby", "dropdownBasic1", "ngbDropdownMenu", "", "container", "body", 1, "dropdown-menu", "dropdown-menu-right"], ["class", "dropdown-item", 3, "fontSize", "height", "padding", "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"], ["aria-label", "Page navigation"], ["class", "first", 3, "ngClass", 4, "ngIf"], ["class", "splitter", 3, "ngClass", 4, "ngIf"], [1, "previous", 3, "ngClass"], ["icon", "facArrowLeftRegular", 1, "fa", "cursor-pointer", "font-16px", "color-brand", 3, "click"], ["class", "pagination", 4, "ngIf"], [1, "next", 3, "ngClass"], ["icon", "facArrowRightRegular", 1, "fa", "cursor-pointer", "font-16px", "color-brand", 3, "click"], ["class", "splitter last", 3, "ngClass", 4, "ngIf"], ["class", "last", 3, "ngClass", 4, "ngIf"], [1, "first", 3, "ngClass"], ["icon", "arrow-back", 1, "fa", "cursor-pointer", "font-16px", "color-brand", 3, "click"], [1, "splitter", 3, "ngClass"], [1, "pagination"], [4, "ngFor", "ngForOf"], ["class", "pagination-ellipsis disable", 4, "ngIf"], [3, "ngClass", "click"], [1, "pagination-ellipsis", "disable"], [1, "splitter", "last", 3, "ngClass"], [1, "last", 3, "ngClass"], ["icon", "arrow-forward", 1, "fa", "cursor-pointer", "font-16px", "color-brand", 3, "click"], ["type", "number", "min", "1", 1, "jump-to-input", "size-s", 3, "placeholder", "value", "keypress", "keyup"], [1, "jump-to-button", "active", 3, "click"], [1, "fa", "fa-arrow-right"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, PaginationComponent_div_3_Template, 10, 12, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, PaginationComponent_span_5_Template, 2, 7, "span", 5);
        ɵngcc0.ɵɵtemplate(6, PaginationComponent_span_6_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, PaginationComponent_nav_8_Template, 12, 13, "nav", 7);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalCount > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalCount > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalCount === 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pager.totalPages);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc5.NgbDropdown, ɵngcc5.NgbDropdownToggle, ɵngcc5.NgbDropdownMenu, InputComponent], styles: ["ul[_ngcontent-%COMP%]{margin-bottom:0}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:3px}button[_ngcontent-%COMP%], span[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--da-primary-text);cursor:pointer;padding:4px 8px;text-decoration:none}button.first[_ngcontent-%COMP%], button.last[_ngcontent-%COMP%], button.next[_ngcontent-%COMP%], button.previous[_ngcontent-%COMP%], span.first[_ngcontent-%COMP%], span.last[_ngcontent-%COMP%], span.next[_ngcontent-%COMP%], span.previous[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.first[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.last[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.next[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.previous[_ngcontent-%COMP%]{padding:0}button.disabled[_ngcontent-%COMP%], span.disabled[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.disabled[_ngcontent-%COMP%]{cursor:default!important;opacity:0}button.disabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%], span.disabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.disabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{cursor:default!important}button.disabled[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], span.disabled[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a.disabled[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--da-disable)}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--da-brand-base)}i[_ngcontent-%COMP%]{color:var(--da-primary-text);margin:0 5px;padding:3px}.row[_ngcontent-%COMP%]{margin-top:20px}.active[_ngcontent-%COMP%]{background:var(--da-brand-base);border-radius:4px;color:var(--da-white)!important;text-decoration:none}.splitter[_ngcontent-%COMP%]{border:1px solid var(--da-disable);cursor:default;margin:0 10px;padding:0}.pagination[_ngcontent-%COMP%]{display:inline-flex}nav[_ngcontent-%COMP%]{float:right}.pagination-ellipsis[_ngcontent-%COMP%]{cursor:default;margin:0}.dropdown-menu[_ngcontent-%COMP%]{background-clip:padding-box;background-color:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);color:var(--da-primary-text);font-size:.7rem;list-style:none;min-width:1rem;text-align:left;z-index:1000}.nav-link[_ngcontent-%COMP%]{margin:0 8px}.btn[_ngcontent-%COMP%]{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;background-color:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);display:inline-block;font-size:.7rem!important;font-weight:100;line-height:1.5;padding:.275rem .65rem;text-align:center;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;user-select:none}.btn[_ngcontent-%COMP%]:focus{border-color:var(--da-border-and-dividers)!important}.dropdown-item[_ngcontent-%COMP%]{padding:0 1.25rem!important}.jump-to-input[_ngcontent-%COMP%]{border-radius:4px;display:inline-block!important;width:95px}.jump-to-button[_ngcontent-%COMP%]{border:none;border-radius:0 4px 4px 0;height:24px;margin-left:-26px;padding:2px 8px;position:absolute}.jump-to-button[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--da-white)}.jump-to-button[_ngcontent-%COMP%]:focus{outline:none}@media (max-width:1360px){.col[_ngcontent-%COMP%]{padding:0!important}.last[_ngcontent-%COMP%]{display:none}}"] });
PaginationComponent.ctorParameters = () => [
    { type: PagerService }
];
PaginationComponent.propDecorators = {
    sortOptions: [{ type: Input }],
    metaData: [{ type: Input }],
    placement: [{ type: Input }],
    pageSizeContainer: [{ type: Input }],
    noDataText: [{ type: Input }],
    translatedText: [{ type: Input }],
    pagerdata: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{ selector: 'lib-pagination', template: "<div class=\"col-12 content-wrapper\">\n    <div class=\"row align-items-center\">\n        <div class=\"col pl-1\">\n            <div *ngIf=\"totalCount > 0\">\n                <span class=\"secondary-text-and-icons\">{{\n                    translatedText?.SHOW || \"Show\"\n                }}</span>\n                <div\n                    ngbDropdown\n                    class=\"d-inline-block\"\n                    [placement]=\"placement\"\n                    [container]=\"pageSizeContainer\"\n                >\n                    <button\n                        class=\"btn nav-link dropdown-toggle\"\n                        id=\"dropdownBasic1\"\n                        ngbDropdownToggle\n                        [style.fontSize]=\"'0.7rem !important'\"\n                        [style.height]=\"'25px !important'\"\n                        [style.padding]=\"'0 10px'\"\n                    >\n                        {{ perPageCount }}\n                    </button>\n                    <div\n                        class=\"dropdown-menu dropdown-menu-right\"\n                        aria-labelledby=\"dropdownBasic1\"\n                        ngbDropdownMenu\n                        container=\"body\"\n                    >\n                        <button\n                            *ngFor=\"let option of sortOptions\"\n                            class=\"dropdown-item\"\n                            [style.fontSize]=\"'0.7rem !important'\"\n                            [style.height]=\"'25px !important'\"\n                            [style.padding]=\"'0 12px !important'\"\n                            on-click=\"changeMessage(option)\"\n                        >\n                            {{ option }}\n                        </button>\n                    </div>\n                </div>\n                <span class=\"secondary-text-and-icons\">{{\n                    translatedText?.ENTRIES || \"entries\"\n                }}</span>\n            </div>\n        </div>\n        <div\n            class=\"col text-center pl-1 pr-1 font-italic secondary-text-and-icons\"\n        >\n            <span *ngIf=\"totalCount > 0\" class=\"secondary-text-and-icons\"\n                >{{ translatedText?.SHOWING || \"Showing\" }}\n                {{ pager.startIndex }} {{ translatedText?.TO || \"to\" }}\n                {{ pager.endIndex }} {{ translatedText?.OF || \"of\" }}\n                {{ totalCount }}\n                {{ translatedText?.ENTRIES || \"entries\" }}</span\n            >\n            <span *ngIf=\"totalCount === 0\">{{ noDataText }}</span>\n        </div>\n        <div class=\"col pr-1 min-width-fit-content\">\n            <nav *ngIf=\"pager.totalPages\" aria-label=\"Page navigation\">\n                <span\n                    *ngIf=\"isDiscrete\"\n                    class=\"first\"\n                    [ngClass]=\"{ disabled: pager.currentPage === 1 }\"\n                >\n                    <fa-icon\n                        class=\"fa cursor-pointer font-16px color-brand\"\n                        icon=\"arrow-back\"\n                        (click)=\"setPage(1)\"\n                    ></fa-icon>\n                </span>\n                <span\n                    *ngIf=\"isDiscrete\"\n                    class=\"splitter\"\n                    [ngClass]=\"{ disabled: pager.currentPage === 1 }\"\n                ></span>\n                <span\n                    class=\"previous\"\n                    [ngClass]=\"{ disabled: pager.currentPage === 1 }\"\n                >\n                    <fa-icon\n                        class=\"fa cursor-pointer font-16px color-brand\"\n                        icon=\"facArrowLeftRegular\"\n                        (click)=\"setPage(pager.currentPage - 1)\"\n                    ></fa-icon>\n                </span>\n                <ul *ngIf=\"pager.pages && isDiscrete\" class=\"pagination\">\n                    <li *ngFor=\"let page of getVisiblePages()\">\n                        <a\n                            [ngClass]=\"{ active: pager.currentPage === page }\"\n                            (click)=\"setPage(page)\"\n                            >{{ page }}</a\n                        >\n                    </li>\n                    <li\n                        class=\"pagination-ellipsis disable\"\n                        *ngIf=\"!isEndOfList()\"\n                    >\n                        ...\n                    </li>\n                    <li>\n                        <a\n                            [ngClass]=\"{\n                                active: pager.currentPage === pager.totalPages\n                            }\"\n                            (click)=\"setPage(pager.totalPages)\"\n                        >\n                            {{ pager.totalPages }}\n                        </a>\n                    </li>\n                </ul>\n                <ul *ngIf=\"pager.pages && !isDiscrete\" class=\"pagination\">\n                    <li *ngFor=\"let page of pager.pages\">\n                        <a\n                            [ngClass]=\"{ active: pager.currentPage === page }\"\n                            (click)=\"setPage(page)\"\n                            >{{ page }}</a\n                        >\n                    </li>\n                </ul>\n                <span\n                    class=\"next\"\n                    [ngClass]=\"{\n                        disabled: pager.currentPage === pager.totalPages\n                    }\"\n                >\n                    <fa-icon\n                        class=\"fa cursor-pointer font-16px color-brand\"\n                        icon=\"facArrowRightRegular\"\n                        (click)=\"setPage(pager.currentPage + 1)\"\n                    ></fa-icon>\n                </span>\n                <span\n                    *ngIf=\"isDiscrete\"\n                    class=\"splitter last\"\n                    [ngClass]=\"{\n                        disabled: pager.currentPage === pager.totalPages\n                    }\"\n                ></span>\n                <span\n                    *ngIf=\"isDiscrete\"\n                    class=\"last\"\n                    [ngClass]=\"{\n                        disabled: pager.currentPage === pager.totalPages\n                    }\"\n                >\n                    <fa-icon\n                        class=\"fa cursor-pointer font-16px color-brand\"\n                        icon=\"arrow-forward\"\n                        (click)=\"setPage(pager.totalPages)\"\n                    ></fa-icon>\n                </span>\n                <span *ngIf=\"isDiscrete\">\n                    <lib-input\n                        type=\"number\"\n                        min=\"1\"\n                        class=\"jump-to-input size-s\"\n                        [placeholder]=\"translatedText?.JUMP_TO || 'Jump to ...'\"\n                        [value]=\"jumpValue\"\n                        (keypress)=\"validateJumpValue($event)\"\n                        (keyup)=\"onJumpValueChange($event)\"\n                    >\n                    </lib-input>\n                    <button class=\"jump-to-button active\" (click)=\"jump()\">\n                        <em class=\"fa fa-arrow-right\"></em>\n                    </button>\n                </span>\n            </nav>\n        </div>\n    </div>\n</div>\n", styles: ["ul{margin-bottom:0}ul li{padding:3px}button,span,ul li a{color:var(--da-primary-text);cursor:pointer;padding:4px 8px;text-decoration:none}button.first,button.last,button.next,button.previous,span.first,span.last,span.next,span.previous,ul li a.first,ul li a.last,ul li a.next,ul li a.previous{padding:0}button.disabled,span.disabled,ul li a.disabled{cursor:default!important;opacity:0}button.disabled *,span.disabled *,ul li a.disabled *{cursor:default!important}button.disabled i,span.disabled i,ul li a.disabled i{color:var(--da-disable)}ul li a{color:var(--da-brand-base)}i{color:var(--da-primary-text);margin:0 5px;padding:3px}.row{margin-top:20px}.active{background:var(--da-brand-base);border-radius:4px;color:var(--da-white)!important;text-decoration:none}.splitter{border:1px solid var(--da-disable);cursor:default;margin:0 10px;padding:0}.pagination{display:inline-flex}nav{float:right}.pagination-ellipsis{cursor:default;margin:0}.dropdown-menu{background-clip:padding-box;background-color:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);color:var(--da-primary-text);font-size:.7rem;list-style:none;min-width:1rem;text-align:left;z-index:1000}.nav-link{margin:0 8px}.btn{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;background-color:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);display:inline-block;font-size:.7rem!important;font-weight:100;line-height:1.5;padding:.275rem .65rem;text-align:center;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;user-select:none}.btn:focus{border-color:var(--da-border-and-dividers)!important}.dropdown-item{padding:0 1.25rem!important}.jump-to-input{border-radius:4px;display:inline-block!important;width:95px}.jump-to-button{border:none;border-radius:0 4px 4px 0;height:24px;margin-left:-26px;padding:2px 8px;position:absolute}.jump-to-button i{color:var(--da-white)}.jump-to-button:focus{outline:none}@media (max-width:1360px){.col{padding:0!important}.last{display:none}}"] }]
    }], function () { return [{ type: PagerService }]; }, { sortOptions: [{
            type: Input
        }], placement: [{
            type: Input
        }], pageSizeContainer: [{
            type: Input
        }], noDataText: [{
            type: Input
        }], pagerdata: [{
            type: Output
        }], metaData: [{
            type: Input
        }], translatedText: [{
            type: Input
        }] }); })();
class KitPaginationModule {
}
KitPaginationModule.ɵfac = function KitPaginationModule_Factory(t) { return new (t || KitPaginationModule)(); };
KitPaginationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: KitPaginationModule });
KitPaginationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, IconsModule, NgbModule, LibFormsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KitPaginationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, IconsModule, NgbModule, LibFormsModule],
                declarations: [PaginationComponent],
                exports: [PaginationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(KitPaginationModule, { declarations: function () { return [PaginationComponent]; }, imports: function () { return [CommonModule, IconsModule, NgbModule, LibFormsModule]; }, exports: function () { return [PaginationComponent]; } }); })();

class DataGridModule {
}
DataGridModule.ɵfac = function DataGridModule_Factory(t) { return new (t || DataGridModule)(); };
DataGridModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataGridModule });
DataGridModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        ResizeObserverModule,
        PerfectScrollbarModule,
        KitScrollModule,
        IconsModule,
        KitPaginationModule,
        DragDropModule, DragDropModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataGridModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ResizeObserverModule,
                    PerfectScrollbarModule,
                    KitScrollModule,
                    IconsModule,
                    KitPaginationModule,
                    DragDropModule
                ],
                declarations: [
                    DataGridComponent,
                    RowTemplateDirective,
                    HeaderTemplateDirective
                ],
                exports: [
                    DragDropModule,
                    DataGridComponent,
                    RowTemplateDirective,
                    HeaderTemplateDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataGridModule, { declarations: function () { return [DataGridComponent, RowTemplateDirective, HeaderTemplateDirective]; }, imports: function () { return [CommonModule, ResizeObserverModule, PerfectScrollbarModule, KitScrollModule, IconsModule, KitPaginationModule, DragDropModule]; }, exports: function () { return [DragDropModule, DataGridComponent, RowTemplateDirective, HeaderTemplateDirective]; } }); })();

class ModalConfirmComponent {
    constructor(modal) {
        this.modal = modal;
        this.confirmOk = new EventEmitter();
        this.additionalBtnClicked = new EventEmitter();
        this.cancelBtnClicked = new EventEmitter();
        this.crossClicked = new EventEmitter();
        this.additionalButtonText = '';
        this.confirmButtonText = 'Yes';
        this.closeButtonText = 'No';
        this.showAdditionalButton = false;
        this.showConfirmButton = true;
        this.showCancelButton = true;
        this.confirmButtonWithLoader = false;
        this.confirmButtonLoading = false;
        this.cancelBtnTooltip = '';
        this.cancelBtnDisable = false;
    }
    confirm() {
        this.confirmOk.emit(true);
        if (!this.confirmButtonWithLoader) {
            this.modal.close();
        }
    }
    confirmAdditional() {
        this.additionalBtnClicked.emit(true);
        this.modal.close();
    }
    cancel() {
        this.cancelBtnClicked.emit();
        this.modal.dismiss('cancel click');
    }
}
ModalConfirmComponent.ɵfac = function ModalConfirmComponent_Factory(t) { return new (t || ModalConfirmComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbActiveModal)); };
ModalConfirmComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalConfirmComponent, selectors: [["lib-modal-confirm"]], inputs: { additionalButtonText: "additionalButtonText", confirmButtonText: "confirmButtonText", closeButtonText: "closeButtonText", showAdditionalButton: "showAdditionalButton", showConfirmButton: "showConfirmButton", showCancelButton: "showCancelButton" }, outputs: { confirmOk: "confirmOk", additionalBtnClicked: "additionalBtnClicked", cancelBtnClicked: "cancelBtnClicked", crossClicked: "crossClicked" }, decls: 11, vars: 6, consts: [[1, "modal-header"], ["id", "modal-title", "class", "mt-0", 4, "ngIf"], ["type", "button", "aria-label", "Close button", "aria-describedby", "modal-title", 1, "close", 3, "click"], ["aria-hidden", "true"], [4, "ngIf"], [1, "modal-footer"], [3, "ngbTooltip"], ["type", "button", "class", "btn btn-secondary", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-primary additional-button", 3, "click", 4, "ngIf"], ["type", "button", "ngbAutofocus", "", "class", "btn btn-primary", 3, "btnWithLoader", "click", 4, "ngIf"], ["id", "modal-title", 1, "mt-0"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "modal-body"], ["class", "text-description", 4, "ngIf"], [1, "text-description"], ["icon", "facExclamationCircle", 1, "warning-icon"], [1, "message-with-warning"], ["type", "button", 1, "btn", "btn-secondary", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-primary", "additional-button", 3, "click"], ["type", "button", "ngbAutofocus", "", 1, "btn", "btn-primary", 3, "btnWithLoader", "click"]], template: function ModalConfirmComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ModalConfirmComponent_h2_1_Template, 4, 2, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function ModalConfirmComponent_Template_button_click_2_listener() { return ctx.modal.dismiss("Cross click"); });
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4, "\u00D7");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(5, ModalConfirmComponent_ng_container_5_Template, 5, 3, "ng-container", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, ModalConfirmComponent_button_8_Template, 2, 2, "button", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, ModalConfirmComponent_button_9_Template, 2, 1, "button", 8);
        ɵngcc0.ɵɵtemplate(10, ModalConfirmComponent_button_10_Template, 2, 2, "button", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.title);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message && (ctx.message.content || ctx.message.description || ctx.message.warningMessage));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngbTooltip", ctx.cancelBtnTooltip);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCancelButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAdditionalButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showConfirmButton);
    } }, dependencies: function () { return [ɵngcc2.NgIf, ɵngcc5.NgbTooltip, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ButtonWithLoaderComponent, SafeHtmlPipe]; }, styles: [_c80] });
ModalConfirmComponent.ctorParameters = () => [
    { type: NgbActiveModal }
];
ModalConfirmComponent.propDecorators = {
    confirmOk: [{ type: Output }],
    additionalBtnClicked: [{ type: Output }],
    cancelBtnClicked: [{ type: Output }],
    crossClicked: [{ type: Output }],
    additionalButtonText: [{ type: Input }],
    confirmButtonText: [{ type: Input }],
    closeButtonText: [{ type: Input }],
    showAdditionalButton: [{ type: Input }],
    showConfirmButton: [{ type: Input }],
    showCancelButton: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalConfirmComponent, [{
        type: Component,
        args: [{ selector: 'lib-modal-confirm', template: "<div class=\"modal-header\">\n    <h2 *ngIf=\"message.title\" id=\"modal-title\" class=\"mt-0\">\n        <span\n            *ngIf=\"message.additionalTitleHtml\"\n            [innerHTML]=\"message.additionalTitleHtml | safeHtml: 'html'\"\n        >\n        </span>\n        <span>{{ message.title }}</span>\n    </h2>\n    <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"Close button\"\n        aria-describedby=\"modal-title\"\n        (click)=\"modal.dismiss('Cross click')\"\n    >\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<ng-container\n    *ngIf=\"\n        message &&\n        (message.content || message.description || message.warningMessage)\n    \"\n>\n    <div class=\"modal-body\">\n        <p *ngIf=\"message.content\">{{ message?.content }}</p>\n        <p *ngIf=\"message.description\" class=\"text-description\">\n            {{ message?.description }}\n        </p>\n        <p *ngIf=\"message.warningMessage\">\n            <fa-icon class=\"warning-icon\" icon=\"facExclamationCircle\"></fa-icon>\n            <span class=\"message-with-warning\">\n                {{ message?.warningMessage }}\n            </span>\n        </p>\n    </div>\n</ng-container>\n\n<div class=\"modal-footer\">\n    <div [ngbTooltip]=\"cancelBtnTooltip\">\n        <button\n            *ngIf=\"showCancelButton\"\n            type=\"button\"\n            class=\"btn btn-secondary\"\n            [disabled]=\"cancelBtnDisable\"\n            (click)=\"cancel()\"\n        >\n            {{ closeButtonText }}\n        </button>\n    </div>\n    <button\n        *ngIf=\"showAdditionalButton\"\n        type=\"button\"\n        class=\"btn btn-primary additional-button\"\n        (click)=\"confirmAdditional()\"\n    >\n        {{ additionalButtonText }}\n    </button>\n    <button\n        *ngIf=\"showConfirmButton\"\n        [btnWithLoader]=\"confirmButtonLoading\"\n        type=\"button\"\n        ngbAutofocus\n        class=\"btn btn-primary\"\n        (click)=\"confirm()\"\n    >\n        {{ confirmButtonText }}\n    </button>\n</div>\n", styles: [".modal-header{border:none;color:var(--da-title)}.modal-header button.close{color:var(--da-popup-icon-close-color);font-size:30px;font-weight:300;line-height:1rem}.modal-body{font-size:12px;white-space:pre-line}.modal-body i{color:var(--da-popup-icon-warning-color);font-size:14px;margin:0 4px}.modal-body .text-description{color:#bebebe;font-size:10px}.modal-body .message-with-warning{margin-left:5px}.modal-body .warning-icon{color:var(--da-error-base);font-size:16px!important}.modal-footer{border:none;display:flex}.modal-footer button{font-size:11px;height:28px;line-height:14px;margin-left:1rem}.modal-footer button:not(.additional-button){min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;width:88px}"] }]
    }], function () { return [{ type: ɵngcc5.NgbActiveModal }]; }, { confirmOk: [{
            type: Output
        }], additionalBtnClicked: [{
            type: Output
        }], cancelBtnClicked: [{
            type: Output
        }], crossClicked: [{
            type: Output
        }], additionalButtonText: [{
            type: Input
        }], confirmButtonText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], showAdditionalButton: [{
            type: Input
        }], showConfirmButton: [{
            type: Input
        }], showCancelButton: [{
            type: Input
        }] }); })();

class ModalWarningComponent {
    constructor(modal) {
        this.modal = modal;
        this.confirmOk = new EventEmitter();
        this.cancelBtnClicked = new EventEmitter();
        this.confirmButtonText = 'Yes';
        this.closeButtonText = 'No';
        this.showConfirmButton = true;
        this.showCancelButton = true;
        this.confirmButtonWithLoader = false;
        this.confirmButtonLoading = false;
        this.cancelBtnTooltip = '';
        this.cancelBtnDisable = false;
    }
    checkImageType(value) {
        if (typeof value === 'string') {
            if (new RegExp('^([^/ ]*)?(/[^/ ]*)+/?..+$').test(value)) {
                return 'url';
            }
            else {
                return 'icon';
            }
        }
        else
            return 'icon';
    }
    confirm() {
        this.confirmOk.emit(true);
        if (!this.confirmButtonWithLoader) {
            this.modal.close();
        }
    }
    cancel() {
        this.cancelBtnClicked.emit();
        this.modal.dismiss('cancel click');
    }
}
ModalWarningComponent.ɵfac = function ModalWarningComponent_Factory(t) { return new (t || ModalWarningComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbActiveModal)); };
ModalWarningComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalWarningComponent, selectors: [["lib-modal-warning"]], inputs: { confirmButtonText: "confirmButtonText", closeButtonText: "closeButtonText", showConfirmButton: "showConfirmButton", showCancelButton: "showCancelButton" }, outputs: { confirmOk: "confirmOk", cancelBtnClicked: "cancelBtnClicked" }, decls: 7, vars: 6, consts: [["class", "centered-container mt-40px", 4, "ngIf"], ["ngbAutofocus", "", "class", "centered-container text-center mt-4 mx-40px", "test-id", "title", 3, "mt-40px", 4, "ngIf"], ["class", "text-description text-center body2 secondary-text-and-icons  mx-40px", 4, "ngIf"], ["class", "d-flex centered-container mt-3 mt-16px  mx-40px", 4, "ngIf"], [1, "modal-footer", "centered-container", "mt-40px"], ["type", "button", "class", "btn btn-secondary", "test-id", "cancelButton", 3, "ngbTooltip", "disabled", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-primary", "test-id", "confirmButton", 3, "btnWithLoader", "click", 4, "ngIf"], [1, "centered-container", "mt-40px"], ["test-id", "image-container-with-image", 3, "src", 4, "ngIf"], ["test-id", "image-container-with-icon", "class", "fa-icon", 3, "icon", "color", "fontSize", 4, "ngIf"], ["test-id", "image-container-with-image", 3, "src"], ["test-id", "image-container-with-icon", 1, "fa-icon", 3, "icon"], ["ngbAutofocus", "", "test-id", "title", 1, "centered-container", "text-center", "mt-4", "mx-40px"], [1, "text-description", "text-center", "body2", "secondary-text-and-icons", "mx-40px"], [1, "d-flex", "centered-container", "mt-3", "mt-16px", "mx-40px"], ["class", "mr-16px", 3, "color", "fontSize", "icon", 4, "ngIf"], [1, "body1", "modal-warning-content", "text-left", "m-0"], [1, "mr-16px", 3, "icon"], ["type", "button", "test-id", "cancelButton", 1, "btn", "btn-secondary", 3, "ngbTooltip", "disabled", "click"], ["type", "button", "test-id", "confirmButton", 1, "btn", "btn-primary", 3, "btnWithLoader", "click"]], template: function ModalWarningComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ModalWarningComponent_div_0_Template, 3, 2, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ModalWarningComponent_h2_1_Template, 2, 3, "h2", 1);
        ɵngcc0.ɵɵtemplate(2, ModalWarningComponent_p_2_Template, 2, 1, "p", 2);
        ɵngcc0.ɵɵtemplate(3, ModalWarningComponent_div_3_Template, 4, 2, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ModalWarningComponent_button_5_Template, 2, 3, "button", 5);
        ɵngcc0.ɵɵtemplate(6, ModalWarningComponent_button_6_Template, 2, 2, "button", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.image);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.description);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message && ctx.message.content);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCancelButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showConfirmButton);
    } }, dependencies: function () { return [ɵngcc2.NgIf, ɵngcc5.NgbTooltip, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ButtonWithLoaderComponent]; }, styles: [".modal-header[_ngcontent-%COMP%]{border:none;color:var(--da-title)}.modal-header[_ngcontent-%COMP%]   button.close[_ngcontent-%COMP%]{color:var(--da-popup-icon-close-color);font-size:30px;font-weight:300;line-height:1rem}.modal-body[_ngcontent-%COMP%]{font-size:12px;white-space:pre-line}.modal-body[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--da-popup-icon-warning-color);font-size:14px;margin:0 4px}.modal-body[_ngcontent-%COMP%]   .text-description[_ngcontent-%COMP%]{color:#bebebe;font-size:10px}.modal-body[_ngcontent-%COMP%]   .message-with-warning[_ngcontent-%COMP%]{margin-left:5px}.modal-body[_ngcontent-%COMP%]   .warning-icon[_ngcontent-%COMP%]{color:var(--da-error-base);font-size:16px!important}.modal-footer[_ngcontent-%COMP%]{border:none;display:flex}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:11px;height:28px;line-height:14px;margin-left:1rem}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:not(.additional-button){min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;width:88px}.centered-container[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center}.modal-warning-content[_ngcontent-%COMP%]{color:var(--da-title)!important}"] });
ModalWarningComponent.ctorParameters = () => [
    { type: NgbActiveModal }
];
ModalWarningComponent.propDecorators = {
    confirmOk: [{ type: Output }],
    cancelBtnClicked: [{ type: Output }],
    confirmButtonText: [{ type: Input }],
    closeButtonText: [{ type: Input }],
    showConfirmButton: [{ type: Input }],
    showCancelButton: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalWarningComponent, [{
        type: Component,
        args: [{ selector: 'lib-modal-warning', template: "<div *ngIf=\"message.image\" class=\"centered-container mt-40px\">\n    <img *ngIf=\"checkImageType(message.image) === 'url'\" [src]=\"message.image\" test-id=\"image-container-with-image\" />\n    <fa-icon\n        test-id=\"image-container-with-icon\"\n        *ngIf=\"checkImageType(message.image) === 'icon'\"\n        class=\"fa-icon\"\n        [icon]=\"message.image\"\n        [style.color]=\"message.imageColor\"\n        [style.fontSize]=\"message.imageFontSize\"\n    >\n    </fa-icon>\n</div>\n<h2 *ngIf=\"message.title\" ngbAutofocus class=\"centered-container text-center mt-4 mx-40px\" [class.mt-40px]=\"!message.image\" test-id=\"title\">\n    {{ message.title }}\n</h2>\n<p *ngIf=\"message.description\" class=\"text-description text-center body2 secondary-text-and-icons  mx-40px\">\n    {{ message?.description }}\n</p>\n<div class=\"d-flex centered-container mt-3 mt-16px  mx-40px\" *ngIf=\"message && message.content\">\n    <fa-icon\n        *ngIf=\"message.icon\"\n        [style.color]=\"message.iconColor\"\n        [style.fontSize]=\"message.iconFontSize\"\n        class=\"mr-16px\"\n        [icon]=\"message.icon\"\n    >\n    </fa-icon>\n    <p class=\"body1 modal-warning-content text-left m-0 \">{{ message?.content }}</p>\n</div>\n<div class=\"modal-footer centered-container mt-40px\">\n    <button\n        [ngbTooltip]=\"cancelBtnTooltip\"\n        *ngIf=\"showCancelButton\"\n        type=\"button\"\n        class=\"btn btn-secondary\"\n        [disabled]=\"cancelBtnDisable\"\n        (click)=\"cancel()\"\n        test-id=\"cancelButton\"\n    >\n        {{ closeButtonText }}\n    </button>\n    <button\n        *ngIf=\"showConfirmButton\"\n        [btnWithLoader]=\"confirmButtonLoading\"\n        type=\"button\"\n        class=\"btn btn-primary\"\n        (click)=\"confirm()\"\n        test-id=\"confirmButton\"\n    >\n        {{ confirmButtonText }}\n    </button>\n</div>\n", styles: [".modal-header{border:none;color:var(--da-title)}.modal-header button.close{color:var(--da-popup-icon-close-color);font-size:30px;font-weight:300;line-height:1rem}.modal-body{font-size:12px;white-space:pre-line}.modal-body i{color:var(--da-popup-icon-warning-color);font-size:14px;margin:0 4px}.modal-body .text-description{color:#bebebe;font-size:10px}.modal-body .message-with-warning{margin-left:5px}.modal-body .warning-icon{color:var(--da-error-base);font-size:16px!important}.modal-footer{border:none;display:flex}.modal-footer button{font-size:11px;height:28px;line-height:14px;margin-left:1rem}.modal-footer button:not(.additional-button){min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;width:88px}.centered-container{align-items:center;display:flex;justify-content:center}.modal-warning-content{color:var(--da-title)!important}"] }]
    }], function () { return [{ type: ɵngcc5.NgbActiveModal }]; }, { confirmOk: [{
            type: Output
        }], cancelBtnClicked: [{
            type: Output
        }], confirmButtonText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], showConfirmButton: [{
            type: Input
        }], showCancelButton: [{
            type: Input
        }] }); })();

class StreamWrapperContentDirective {
    constructor(template) {
        this.template = template;
    }
}
StreamWrapperContentDirective.ɵfac = function StreamWrapperContentDirective_Factory(t) { return new (t || StreamWrapperContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
StreamWrapperContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StreamWrapperContentDirective, selectors: [["ng-template", "contentTemplate", ""]] });
StreamWrapperContentDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamWrapperContentDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: 'ng-template[contentTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class StreamWrapperLoaderDirective {
    constructor(template) {
        this.template = template;
    }
}
StreamWrapperLoaderDirective.ɵfac = function StreamWrapperLoaderDirective_Factory(t) { return new (t || StreamWrapperLoaderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
StreamWrapperLoaderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StreamWrapperLoaderDirective, selectors: [["ng-template", "loaderTemplate", ""]] });
StreamWrapperLoaderDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamWrapperLoaderDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: 'ng-template[loaderTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class StreamWrapperComponent {
    constructor() {
        this.cssClass = 'd-flex';
        this.errorCssClass = '';
        this.errorText = 'Something went wrong';
        this.reload$ = new BehaviorSubject(null);
    }
    set dataStream$(obs) {
        this.obsWithReload$ = this.reload$.asObservable().pipe(switchMap(() => {
            return concat(of({ type: 'start' }), obs.pipe(catchError(() => of({ type: 'error' }))));
        }));
    }
    isBoolean(item) {
        return typeof item === 'boolean';
    }
    handleReload() {
        this.reload$.next(null);
    }
}
StreamWrapperComponent.ɵfac = function StreamWrapperComponent_Factory(t) { return new (t || StreamWrapperComponent)(); };
StreamWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StreamWrapperComponent, selectors: [["lib-stream-wrapper"]], contentQueries: function StreamWrapperComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, StreamWrapperContentDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, StreamWrapperLoaderDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.loader = _t.first);
    } }, inputs: { cssClass: "cssClass", errorCssClass: "errorCssClass", errorText: "errorText", dataStream$: "dataStream$" }, decls: 5, vars: 5, consts: [[4, "ngIf"], ["defaultLoader", ""], ["class", "h-100 flex-grow-1 align-items-center justify-content-center", 3, "ngClass", 4, "ngIf"], ["class", "h-100 d-flex justify-content-center align-items-center flex-column", 3, "ngClass", 4, "ngIf"], [1, "h-100", "flex-grow-1", "align-items-center", "justify-content-center", 3, "ngClass"], [4, "ngTemplateOutlet"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "h-100", "d-flex", "justify-content-center", "align-items-center", "flex-column", 3, "ngClass"], [1, "error-text"], [1, "btn", "btn-sm", "btn-primary", "mt-3", 3, "click"]], template: function StreamWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, StreamWrapperComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵpipe(2, "obsWithStatus");
        ɵngcc0.ɵɵtemplate(3, StreamWrapperComponent_ng_template_3_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ɵngcc0.ɵɵpipeBind1(2, 3, ctx.obsWithReload$)));
    } }, dependencies: function () { return [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, SpinnerComponent, ɵngcc2.AsyncPipe, ObsWithStatusPipe]; }, styles: [".error-text[_ngcontent-%COMP%]{color:var(--da-brand-base);font-size:12px}"] });
StreamWrapperComponent.propDecorators = {
    dataStream$: [{ type: Input }],
    cssClass: [{ type: Input }],
    errorCssClass: [{ type: Input }],
    errorText: [{ type: Input }],
    content: [{ type: ContentChild, args: [StreamWrapperContentDirective,] }],
    loader: [{ type: ContentChild, args: [StreamWrapperLoaderDirective, { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StreamWrapperComponent, [{
        type: Component,
        args: [{ selector: 'lib-stream-wrapper', template: "<ng-container *ngIf=\"obsWithReload$ | obsWithStatus | async as dataStream\">\n    <div *ngIf=\"dataStream.loading\" [ngClass]=\"cssClass\" class=\"h-100 flex-grow-1 align-items-center justify-content-center\">\n        <ng-container *ngTemplateOutlet=\"loader ? loader.template : defaultLoader\"></ng-container>\n    </div>\n    <ng-container *ngIf=\"dataStream.value\">\n        <ng-container *ngTemplateOutlet=\"content.template; context: { data: dataStream.value }\"> </ng-container>\n    </ng-container>\n    <div *ngIf=\"dataStream.error\" class=\"h-100 d-flex justify-content-center align-items-center flex-column\" [ngClass]=\"errorCssClass\">\n        <span class=\"error-text\">\n            {{ isBoolean(dataStream.error) ? errorText : dataStream.error || errorText }}\n        </span>\n        <button class=\"btn btn-sm btn-primary mt-3\" (click)=\"handleReload()\">Reload</button>\n    </div>\n</ng-container>\n\n<ng-template #defaultLoader>\n    <lib-spinner></lib-spinner>\n</ng-template>\n", styles: [".error-text{color:var(--da-brand-base);font-size:12px}"] }]
    }], function () { return []; }, { cssClass: [{
            type: Input
        }], errorCssClass: [{
            type: Input
        }], errorText: [{
            type: Input
        }], dataStream$: [{
            type: Input
        }], content: [{
            type: ContentChild,
            args: [StreamWrapperContentDirective]
        }], loader: [{
            type: ContentChild,
            args: [StreamWrapperLoaderDirective, { static: false }]
        }] }); })();

class TriggerComponent {
    constructor() {
        this.followValue = false;
        this.type = 'text';
    }
    get warning() {
        return this.warningMessage;
    }
    registerOnChange(fn) {
        this.onChangeCb = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCb = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    writeValue(value) {
        this.value = value;
    }
    onCheck() {
        if (!this.disabled && !this.followValue) {
            this.value = !this.value;
            if (this.onChangeCb) {
                this.onChangeCb(this.value);
                this.onTouchedCb();
            }
        }
    }
}
TriggerComponent.ɵfac = function TriggerComponent_Factory(t) { return new (t || TriggerComponent)(); };
TriggerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TriggerComponent, selectors: [["trigger"]], hostAttrs: [1, "lib-trigger"], inputs: { followValue: "followValue", type: "type", disabled: "disabled", value: "value", warningMessage: "warningMessage" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TriggerComponent),
                multi: true
            }
        ])], ngContentSelectors: _c3, decls: 10, vars: 9, consts: [[1, "trigger"], [1, "trigger-button", 3, "ngClass", "click"], ["class", "trigger-label-on", 4, "ngIf"], ["icon", "simpleCheck", "class", "d-flex trigger-label-on", 3, "fontSize", 4, "ngIf"], [1, "trigger-button-circle"], ["class", "trigger-label-off", 4, "ngIf"], ["icon", "facDelete", "class", "d-flex trigger-label-off", 3, "fontSize", 4, "ngIf"], [1, "trigger-label"], [3, "message"], [1, "trigger-label-on"], ["icon", "simpleCheck", 1, "d-flex", "trigger-label-on"], [1, "trigger-label-off"], ["icon", "facDelete", 1, "d-flex", "trigger-label-off"]], template: function TriggerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function TriggerComponent_Template_div_click_1_listener() { return ctx.onCheck(); });
        ɵngcc0.ɵɵtemplate(2, TriggerComponent_div_2_Template, 2, 0, "div", 2);
        ɵngcc0.ɵɵtemplate(3, TriggerComponent_fa_icon_3_Template, 1, 2, "fa-icon", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, TriggerComponent_div_5_Template, 2, 0, "div", 5);
        ɵngcc0.ɵɵtemplate(6, TriggerComponent_fa_icon_6_Template, 1, 2, "fa-icon", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(9, "lib-app-warning-message", 8);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c59, ctx.value, ctx.disabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value && ctx.type === "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value && ctx.type === "icon");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.value && ctx.type === "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.value && ctx.type === "icon");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("message", ctx.warningMessage);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, WarningMessageComponent, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: [".trigger[_ngcontent-%COMP%]{align-items:center;display:flex;height:inherit}.trigger-label[_ngcontent-%COMP%]{color:var(--da-primary-text);display:block;height:inherit;margin-left:5px}.trigger-button[_ngcontent-%COMP%]{align-items:center;background:var(--da-toggle-off-background);border-radius:calc(var(--da-trigger-height)/2);cursor:pointer;display:flex;height:var(--da-trigger-height);justify-content:flex-start;min-width:var(--da-trigger-width);position:relative;transition:background .1s linear;width:var(--da-trigger-width)}.trigger-button.checked[_ngcontent-%COMP%]{background:var(--da-brand-base)}.trigger-button.checked[_ngcontent-%COMP%]   .trigger-button-circle[_ngcontent-%COMP%]{background:var(--da-white);left:auto;right:2px}.trigger-button.disabled[_ngcontent-%COMP%]{background:var(--da-toggle-off-background)!important;cursor:auto;pointer-events:none}.trigger-button-circle[_ngcontent-%COMP%]{background:var(--da-toggle-off-circle);border-radius:calc(var(--da-trigger-height)/2 - 3px);height:calc(var(--da-trigger-height) - 6px);left:2px;margin:2px;position:absolute;right:auto;transition:margin .1s linear;width:calc(var(--da-trigger-height) - 6px)}.trigger-label-on[_ngcontent-%COMP%]{color:var(--da-white);margin-left:calc(var(--da-trigger-height)/2 - 3px);margin-right:1px}fa-icon.trigger-label-on[_ngcontent-%COMP%]{position:relative;top:-1px}.trigger-label-off[_ngcontent-%COMP%]{color:var(--da-disable);position:absolute;right:4px}fa-icon.trigger-label-off[_ngcontent-%COMP%]{right:5px;top:.5px}.trigger-label-off[_ngcontent-%COMP%], .trigger-label-on[_ngcontent-%COMP%]{font-size:10px;white-space:nowrap}.size-s[_nghost-%COMP%]   .trigger-label-off[_ngcontent-%COMP%], .size-s[_nghost-%COMP%]   .trigger-label-on[_ngcontent-%COMP%]{font-size:9px}"] });
TriggerComponent.ctorParameters = () => [];
TriggerComponent.propDecorators = {
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    followValue: [{ type: Input }],
    warningMessage: [{ type: Input }],
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TriggerComponent, [{
        type: Component,
        args: [{ selector: 'trigger', template: "<div class=\"trigger\">\n    <div class=\"trigger-button\" [ngClass]=\"{ 'checked': value, 'disabled': disabled }\" (click)=\"onCheck()\">\n        <div *ngIf=\"value && type === 'text'\" class=\"trigger-label-on\">ON</div>\n        <fa-icon *ngIf=\"value && type === 'icon'\" icon=\"simpleCheck\" [style.fontSize.px]=\"14\" class=\"d-flex trigger-label-on\"></fa-icon>\n        <div class=\"trigger-button-circle\"></div>\n        <div *ngIf=\"!value && type === 'text'\" class=\"trigger-label-off\">OFF</div>\n        <fa-icon *ngIf=\"!value && type === 'icon'\" icon=\"facDelete\" [style.fontSize.px]=\"14\" class=\"d-flex trigger-label-off\"></fa-icon>\n    </div>\n    <div class=\"trigger-label\">\n        <ng-content></ng-content>\n    </div>\n</div>\n<lib-app-warning-message [message]=\"warningMessage\"></lib-app-warning-message>\n", providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TriggerComponent),
                        multi: true
                    }
                ], host: { class: 'lib-trigger' }, styles: [".trigger{align-items:center;display:flex;height:inherit}.trigger-label{color:var(--da-primary-text);display:block;height:inherit;margin-left:5px}.trigger-button{align-items:center;background:var(--da-toggle-off-background);border-radius:calc(var(--da-trigger-height)/2);cursor:pointer;display:flex;height:var(--da-trigger-height);justify-content:flex-start;min-width:var(--da-trigger-width);position:relative;transition:background .1s linear;width:var(--da-trigger-width)}.trigger-button.checked{background:var(--da-brand-base)}.trigger-button.checked .trigger-button-circle{background:var(--da-white);left:auto;right:2px}.trigger-button.disabled{background:var(--da-toggle-off-background)!important;cursor:auto;pointer-events:none}.trigger-button-circle{background:var(--da-toggle-off-circle);border-radius:calc(var(--da-trigger-height)/2 - 3px);height:calc(var(--da-trigger-height) - 6px);left:2px;margin:2px;position:absolute;right:auto;transition:margin .1s linear;width:calc(var(--da-trigger-height) - 6px)}.trigger-label-on{color:var(--da-white);margin-left:calc(var(--da-trigger-height)/2 - 3px);margin-right:1px}fa-icon.trigger-label-on{position:relative;top:-1px}.trigger-label-off{color:var(--da-disable);position:absolute;right:4px}fa-icon.trigger-label-off{right:5px;top:.5px}.trigger-label-off,.trigger-label-on{font-size:10px;white-space:nowrap}:host.size-s .trigger-label-off,:host.size-s .trigger-label-on{font-size:9px}"] }]
    }], function () { return []; }, { followValue: [{
            type: Input
        }], type: [{
            type: Input
        }], disabled: [{
            type: Input
        }], value: [{
            type: Input
        }], warningMessage: [{
            type: Input
        }] }); })();

class SideMenuHeaderDirective {
    constructor(template) {
        this.template = template;
    }
}
SideMenuHeaderDirective.ɵfac = function SideMenuHeaderDirective_Factory(t) { return new (t || SideMenuHeaderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SideMenuHeaderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SideMenuHeaderDirective, selectors: [["ng-template", "sideMenuHeaderTemplate", ""]] });
SideMenuHeaderDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideMenuHeaderDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[sideMenuHeaderTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class SideMenuItemDirective {
    constructor(template) {
        this.template = template;
    }
}
SideMenuItemDirective.ɵfac = function SideMenuItemDirective_Factory(t) { return new (t || SideMenuItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SideMenuItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SideMenuItemDirective, selectors: [["ng-template", "sideMenuItemTemplate", ""]] });
SideMenuItemDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideMenuItemDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[sideMenuItemTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class SideMenuChildItemDirective {
    constructor(template) {
        this.template = template;
    }
}
SideMenuChildItemDirective.ɵfac = function SideMenuChildItemDirective_Factory(t) { return new (t || SideMenuChildItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SideMenuChildItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SideMenuChildItemDirective, selectors: [["ng-template", "sideMenuChildItemTemplate", ""]] });
SideMenuChildItemDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideMenuChildItemDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[sideMenuChildItemTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class SideMenuFooterDirective {
    constructor(template) {
        this.template = template;
    }
}
SideMenuFooterDirective.ɵfac = function SideMenuFooterDirective_Factory(t) { return new (t || SideMenuFooterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SideMenuFooterDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SideMenuFooterDirective, selectors: [["ng-template", "sideMenuFooterTemplate", ""]] });
SideMenuFooterDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideMenuFooterDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[sideMenuFooterTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class SideMenuComponent {
    constructor() {
        this.hasSearch = false;
        this.sideMenuClicked = new Subject();
        this.sideSubMenuClicked = new Subject();
        this.activeMenu = {};
        this.hamburgerMenu = false;
    }
    ngOnInit() {
        this.items = this.menuItems;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            var _a;
            this.hamburgerMenu = !((_a = document.getElementsByClassName('side-menu-overlay')[0]) === null || _a === void 0 ? void 0 : _a.children[0]);
        });
    }
    onResize() {
        const els = document.getElementsByClassName('side-menu');
        for (let i = 0; i < els.length; i++) {
            const el = els.item(i);
            el.classList.add(window.innerWidth > 1000 ? 'd-block' : 'd-none');
            el.classList.remove(window.innerWidth <= 1000 ? 'd-block' : 'd-none');
        }
    }
    handleClick(menuItem, menuClicked, event) {
        this.activeMenu = menuItem;
        menuClicked.next(menuItem);
        menuItem.opened = !menuItem.opened;
        event.stopPropagation();
    }
    search(str) {
        this.items = JSON.parse(JSON.stringify(this.menuItems.filter(item => item.title.toLowerCase().includes(str.toLowerCase()) ||
            (item.children &&
                item.children.some(child => child.title
                    .toLowerCase()
                    .includes(str.toLowerCase()))))));
        this.items.forEach(item => {
            if (item.children) {
                item.children = item.children.filter(child => child.title.toLowerCase().includes(str.toLowerCase()));
            }
        });
    }
    handleOverlay(show) {
        if (window.innerWidth > 1000) {
            return;
        }
        const els = document.getElementsByClassName('side-menu');
        for (let i = 0; i < els.length; i++) {
            const el = els.item(i);
            if (show) {
                el.classList.add('d-block', 'w-200');
                el.classList.remove('d-none');
            }
            else {
                el.classList.remove('d-block', 'w-200');
                el.classList.add('d-none');
            }
        }
    }
}
SideMenuComponent.ɵfac = function SideMenuComponent_Factory(t) { return new (t || SideMenuComponent)(); };
SideMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideMenuComponent, selectors: [["lib-side-menu"]], contentQueries: function SideMenuComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SideMenuHeaderDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SideMenuItemDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SideMenuChildItemDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SideMenuFooterDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sideMenuHeaderDirective = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sideMenuItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sideMenuChildItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sideMenuFooterDirective = _t.first);
    } }, hostAttrs: [1, "d-flex"], hostBindings: function SideMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function SideMenuComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { hasSearch: "hasSearch", menuItems: "menuItems" }, outputs: { sideMenuClicked: "sideMenuClicked", sideSubMenuClicked: "sideSubMenuClicked" }, decls: 8, vars: 9, consts: [["class", "side-menu-overlay", 4, "ngIf"], [1, "side-menu", 3, "mouseleave", "mouseenter"], [4, "ngIf"], ["class", "d-block size-s px-2 my-2", 3, "searchText", 4, "ngIf"], ["class", "search-scrollbar", 3, "has-search", "height-unset", 4, "ngIf"], ["menu", ""], [1, "side-menu-overlay"], [1, "hamburger-menu", "cursor-pointer", 3, "click"], [3, "ngTemplateOutlet"], [1, "d-block", "size-s", "px-2", "my-2", 3, "searchText"], [1, "search-scrollbar"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf"], [1, "side-menu-item", "d-flex", 3, "routerLink", "routerLinkActive", "click"], [3, "class", "icon", 4, "ngIf"], ["class", "children-container", 4, "ngIf"], [3, "icon"], [1, "children-container"]], template: function SideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SideMenuComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "aside", 1);
        ɵngcc0.ɵɵlistener("mouseleave", function SideMenuComponent_Template_aside_mouseleave_1_listener() { return ctx.handleOverlay(false); })("mouseenter", function SideMenuComponent_Template_aside_mouseenter_1_listener() { return ctx.handleOverlay(true); });
        ɵngcc0.ɵɵtemplate(2, SideMenuComponent_2_Template, 1, 1, null, 2);
        ɵngcc0.ɵɵtemplate(3, SideMenuComponent_lib_search_3_Template, 1, 0, "lib-search", 3);
        ɵngcc0.ɵɵtemplate(4, SideMenuComponent_perfect_scrollbar_4_Template, 2, 10, "perfect-scrollbar", 4);
        ɵngcc0.ɵɵtemplate(5, SideMenuComponent_5_Template, 1, 1, null, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, SideMenuComponent_ng_template_6_Template, 1, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hamburgerMenu);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("left-40px", ctx.hamburgerMenu)("pt-20px", !ctx.hasSearch);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sideMenuHeaderDirective);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasSearch);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sideMenuItemTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sideMenuFooterDirective);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc6.PerfectScrollbarComponent, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, SearchComponent, ɵngcc9.RouterLink, ɵngcc9.RouterLinkActive], styles: ["@charset \"UTF-8\";[_nghost-%COMP%]{display:block}.side-menu[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks)}.side-menu-overlay[_ngcontent-%COMP%]{display:none;height:inherit;width:50px;z-index:10}.left-40px[_ngcontent-%COMP%]{left:-40px}.hamburger-menu[_ngcontent-%COMP%]{border-radius:0 5px 5px 0;box-shadow:2px 0 8px rgba(0,0,0,.15);font-size:1.25rem;height:40px;margin-top:8px;width:40px}.hamburger-menu[_ngcontent-%COMP%]:before{left:5px;padding-left:5px;position:relative;top:-10px}aside[_ngcontent-%COMP%]{border-bottom:1px solid var(--da-border-and-dividers);border-right:1px solid var(--da-border-and-dividers);flex-shrink:0;height:inherit;overflow:hidden;padding-bottom:20px;top:0;width:200px;z-index:10}.has-search[_ngcontent-%COMP%]{height:calc(100% - 25px)}.side-menu-item[_ngcontent-%COMP%]{border:3px solid transparent;cursor:pointer;display:block;line-height:38px;overflow:hidden;padding:0 5px 0 20px;position:relative;text-overflow:ellipsis}.children-container[_ngcontent-%COMP%] > .side-menu-item[_ngcontent-%COMP%]{padding-left:40px}.children-container[_ngcontent-%COMP%] > .children-container[_ngcontent-%COMP%] > .side-menu-item[_ngcontent-%COMP%]{padding-left:60px!important}.children-container[_ngcontent-%COMP%] > .children-container[_ngcontent-%COMP%] > .children-container[_ngcontent-%COMP%] > .side-menu-item[_ngcontent-%COMP%]{padding-left:80px!important}.side-menu-item[_ngcontent-%COMP%]   .chevron-icon[_ngcontent-%COMP%]{font-size:16px!important;margin-left:auto;margin-right:15px}.side-menu-item[_ngcontent-%COMP%]   .chevron-icon--right[_ngcontent-%COMP%]{font-size:10px!important}.side-menu-item.active[_ngcontent-%COMP%]:not(.side-menu-item-parent){font-weight:600}.side-menu-item.active[_ngcontent-%COMP%]:not(.side-menu-item-parent), .side-menu-item[_ngcontent-%COMP%]:hover{background:var(--da-brand-12);border-color:var(--da-brand-20);color:var(--da-primary-text)}.side-menu-item.active[_ngcontent-%COMP%]:not(.side-menu-item-parent)   .side-menu-item.active[_ngcontent-%COMP%]:before, .side-menu-item[_ngcontent-%COMP%]:hover   .side-menu-item.active[_ngcontent-%COMP%]:before{content:\"\"}.side-menu-item[_ngcontent-%COMP%]:focus{outline:none}.chevron-down[_ngcontent-%COMP%]:after, .chevron-right[_ngcontent-%COMP%]:after{color:var(--da-secondary-text-and-icons);content:\"\uF107\";cursor:pointer;font:normal normal normal 16px/1 FontAwesome,sans-serif}.chevron-right[_ngcontent-%COMP%]:after{content:\"\uF105\"}.height-unset[_ngcontent-%COMP%]{height:unset!important}@media (max-width:1000px){[_nghost-%COMP%]{width:10px!important}.side-menu-overlay[_ngcontent-%COMP%]{display:block}aside[_ngcontent-%COMP%]{display:none;position:relative}}"] });
SideMenuComponent.propDecorators = {
    menuItems: [{ type: Input }],
    hasSearch: [{ type: Input }],
    sideMenuClicked: [{ type: Output }],
    sideSubMenuClicked: [{ type: Output }],
    sideMenuHeaderDirective: [{ type: ContentChild, args: [SideMenuHeaderDirective, { static: true },] }],
    sideMenuItemTemplate: [{ type: ContentChild, args: [SideMenuItemDirective, { static: true },] }],
    sideMenuChildItemTemplate: [{ type: ContentChild, args: [SideMenuChildItemDirective, { static: true },] }],
    sideMenuFooterDirective: [{ type: ContentChild, args: [SideMenuFooterDirective, { static: true },] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideMenuComponent, [{
        type: Component,
        args: [{ selector: 'lib-side-menu', template: "<div *ngIf=\"hamburgerMenu\" class=\"side-menu-overlay\">\n    <div\n        class=\"hamburger-menu cursor-pointer\"\n        (click)=\"handleOverlay(true)\"\n    ></div>\n</div>\n\n<aside\n    class=\"side-menu\"\n    [class.left-40px]=\"hamburgerMenu\"\n    [class.pt-20px]=\"!hasSearch\"\n    (mouseleave)=\"handleOverlay(false)\"\n    (mouseenter)=\"handleOverlay(true)\"\n>\n    <ng-template\n        *ngIf=\"sideMenuHeaderDirective\"\n        [ngTemplateOutlet]=\"sideMenuHeaderDirective.template\"\n    ></ng-template>\n\n    <lib-search\n        *ngIf=\"hasSearch\"\n        class=\"d-block size-s px-2 my-2\"\n        (searchText)=\"search($event)\"\n    ></lib-search>\n\n    <perfect-scrollbar\n        *ngIf=\"sideMenuItemTemplate\"\n        class=\"search-scrollbar\"\n        [class.has-search]=\"hasSearch\"\n        [class.height-unset]=\"sideMenuFooterDirective\"\n    >\n        <ng-template\n            [ngTemplateOutlet]=\"menu\"\n            [ngTemplateOutletContext]=\"{\n                $implicit: items,\n                menuClicked: sideMenuClicked,\n                template: sideMenuItemTemplate.template\n            }\"\n        ></ng-template>\n    </perfect-scrollbar>\n\n    <ng-template\n        *ngIf=\"sideMenuFooterDirective\"\n        [ngTemplateOutlet]=\"sideMenuFooterDirective.template\"\n    ></ng-template>\n</aside>\n\n<ng-template\n    #menu\n    let-menuItems\n    let-menuClicked=\"menuClicked\"\n    let-template=\"template\"\n>\n    <ng-container *ngFor=\"let menuItem of menuItems\">\n        <div\n            class=\"side-menu-item d-flex\"\n            [class.side-menu-item-parent]=\"menuItem.children?.length\"\n            [class.active]=\"\n                !menuItem.children?.length && menuItem === activeMenu\n            \"\n            [routerLink]=\"\n                menuItem.children?.length ? null : menuItem.routerLink\n            \"\n            [routerLinkActive]=\"menuItem.routerLink ? 'active' : ''\"\n            (click)=\"handleClick(menuItem, menuClicked, $event)\"\n        >\n            <ng-template\n                [ngTemplateOutlet]=\"template\"\n                [ngTemplateOutletContext]=\"{ $implicit: menuItem }\"\n            ></ng-template>\n            <fa-icon\n                *ngIf=\"menuItem.children?.length\"\n                class=\"chevron-icon chevron-icon--{{\n                    menuItem.opened ? 'down' : 'right'\n                }}\"\n                icon=\"{{ menuItem.opened ? 'chevron-down' : 'chevron-right' }}\"\n            >\n            </fa-icon>\n        </div>\n\n        <div\n            class=\"children-container\"\n            *ngIf=\"menuItem.opened && menuItem.children?.length\"\n        >\n            <ng-template\n                *ngIf=\"sideMenuChildItemTemplate\"\n                [ngTemplateOutlet]=\"menu\"\n                [ngTemplateOutletContext]=\"{\n                    $implicit: menuItem.children,\n                    menuClicked: sideSubMenuClicked,\n                    template: sideMenuChildItemTemplate.template\n                }\"\n            ></ng-template>\n        </div>\n    </ng-container>\n</ng-template>\n", host: {
                    class: 'd-flex'
                }, styles: ["@charset \"UTF-8\";:host{display:block}.side-menu{background-color:var(--da-cards-and-blocks)}.side-menu-overlay{display:none;height:inherit;width:50px;z-index:10}.left-40px{left:-40px}.hamburger-menu{border-radius:0 5px 5px 0;box-shadow:2px 0 8px rgba(0,0,0,.15);font-size:1.25rem;height:40px;margin-top:8px;width:40px}.hamburger-menu:before{left:5px;padding-left:5px;position:relative;top:-10px}aside{border-bottom:1px solid var(--da-border-and-dividers);border-right:1px solid var(--da-border-and-dividers);flex-shrink:0;height:inherit;overflow:hidden;padding-bottom:20px;top:0;width:200px;z-index:10}.has-search{height:calc(100% - 25px)}.side-menu-item{border:3px solid transparent;cursor:pointer;display:block;line-height:38px;overflow:hidden;padding:0 5px 0 20px;position:relative;text-overflow:ellipsis}.children-container>.side-menu-item{padding-left:40px}.children-container>.children-container>.side-menu-item{padding-left:60px!important}.children-container>.children-container>.children-container>.side-menu-item{padding-left:80px!important}.side-menu-item .chevron-icon{font-size:16px!important;margin-left:auto;margin-right:15px}.side-menu-item .chevron-icon--right{font-size:10px!important}.side-menu-item.active:not(.side-menu-item-parent){font-weight:600}.side-menu-item.active:not(.side-menu-item-parent),.side-menu-item:hover{background:var(--da-brand-12);border-color:var(--da-brand-20);color:var(--da-primary-text)}.side-menu-item.active:not(.side-menu-item-parent) .side-menu-item.active:before,.side-menu-item:hover .side-menu-item.active:before{content:\"\"}.side-menu-item:focus{outline:none}.chevron-down:after,.chevron-right:after{color:var(--da-secondary-text-and-icons);content:\"\uF107\";cursor:pointer;font:normal normal normal 16px/1 FontAwesome,sans-serif}.chevron-right:after{content:\"\uF105\"}.height-unset{height:unset!important}@media (max-width:1000px){:host{width:10px!important}.side-menu-overlay{display:block}aside{display:none;position:relative}}"] }]
    }], function () { return []; }, { hasSearch: [{
            type: Input
        }], sideMenuClicked: [{
            type: Output
        }], sideSubMenuClicked: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], menuItems: [{
            type: Input
        }], sideMenuHeaderDirective: [{
            type: ContentChild,
            args: [SideMenuHeaderDirective, { static: true }]
        }], sideMenuItemTemplate: [{
            type: ContentChild,
            args: [SideMenuItemDirective, { static: true }]
        }], sideMenuChildItemTemplate: [{
            type: ContentChild,
            args: [SideMenuChildItemDirective, { static: true }]
        }], sideMenuFooterDirective: [{
            type: ContentChild,
            args: [SideMenuFooterDirective, { static: true }]
        }] }); })();

class ScrollerComponent {
    constructor(zone) {
        this.zone = zone;
        this.libScrollerSize = 14;
        this.libScrollerDir = 'horizontal';
        this.lisScrollerDisabled = false;
        this.scrollStep = 150;
    }
    shift(start) {
        this.container.nativeElement.scrollBy({
            [this.libScrollerDir === 'horizontal' ? 'left' : 'top']: start,
            behavior: 'smooth'
        });
    }
    ngAfterViewInit() {
        if (this.lisScrollerDisabled) {
            return;
        }
        this.zone.runOutsideAngular(() => {
            this.observer = new ResizeObserver(() => this.adjustButtonsVisibility());
            this.observer.observe(this.container.nativeElement);
            this.container.nativeElement.onscroll = () => this.adjustButtonsVisibility();
        });
        this.adjustButtonsVisibility();
    }
    adjustButtonsVisibility() {
        const el = this.container.nativeElement;
        const firstChild = el.children.length ? el.children[0] : null;
        const overflow = this.libScrollerDir === 'horizontal'
            ? el.scrollWidth - el.offsetWidth
            : el.scrollHeight - el.offsetHeight;
        const isOverflow = overflow > 0;
        this.actions.nativeElement.hidden = !isOverflow;
        if (firstChild) {
            const newScrollStep = this.libScrollerDir === 'horizontal'
                ? firstChild.offsetWidth
                : firstChild.offsetHeight;
            if (newScrollStep > 0) {
                this.scrollStep = newScrollStep;
            }
        }
        el.classList.remove('scroller-container--start', 'scroller-container--end');
        if (!isOverflow) {
            return;
        }
        const start = Math.floor(this.libScrollerDir === 'horizontal' ? el.scrollLeft : el.scrollTop);
        if (start === 0) {
            el.classList.add('scroller-container--start');
        }
        else if (start + 1 >= overflow) {
            el.classList.add('scroller-container--end');
        }
    }
    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
ScrollerComponent.ɵfac = function ScrollerComponent_Factory(t) { return new (t || ScrollerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ScrollerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScrollerComponent, selectors: [["", "libScroller", ""]], viewQuery: function ScrollerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c61, 5);
        ɵngcc0.ɵɵviewQuery(_c62, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.actions = _t.first);
    } }, inputs: { libScrollerSize: "libScrollerSize", libScrollerDir: "libScrollerDir", lisScrollerDisabled: "lisScrollerDisabled" }, attrs: _c63, ngContentSelectors: _c3, decls: 4, vars: 1, consts: [[1, "scroller-container"], ["container", ""], ["class", "scroller-actions", 3, "--size", 4, "ngIf"], [1, "scroller-actions"], ["actions", ""], [1, "position-absolute", "start-arrow"], ["icon", "facArrowUpInCircle", 1, "d-flex", 3, "click"], [1, "position-absolute", "end-arrow"], ["icon", "facArrowDownInCircle", 1, "d-flex", 3, "click"]], template: function ScrollerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ScrollerComponent_div_3_Template, 6, 2, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.lisScrollerDisabled);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: ["[_nghost-%COMP%]{overflow:hidden;position:relative}.scroller-container[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;max-width:inherit;overflow:hidden;width:100%}[libScrollerDir=vertical][_nghost-%COMP%]   .scroller-container[_ngcontent-%COMP%]{flex-direction:column;height:100%;max-height:inherit}.scroller-container--end[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]   .end-arrow[_ngcontent-%COMP%], .scroller-container--start[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]   .start-arrow[_ngcontent-%COMP%]{display:none}.scroller-container[_ngcontent-%COMP%]    >*{flex-shrink:0}.scroller-actions[_ngcontent-%COMP%]{font-size:var(--size)}.end-arrow[_ngcontent-%COMP%], .start-arrow[_ngcontent-%COMP%]{align-items:center;bottom:0;color:var(--da-brand-base);display:flex;font-size:var(--size);justify-content:center;top:0;z-index:1}.end-arrow[_ngcontent-%COMP%]:after, .end-arrow[_ngcontent-%COMP%]:before, .start-arrow[_ngcontent-%COMP%]:after, .start-arrow[_ngcontent-%COMP%]:before{background:var(--da-cards-and-blocks);bottom:0;content:\"\";pointer-events:none;position:absolute;top:0}.start-arrow[_ngcontent-%COMP%]{left:0}.start-arrow[_ngcontent-%COMP%]     svg{transform:rotate(-90deg)}.start-arrow[_ngcontent-%COMP%]:before{left:-.7em;right:.7em}.start-arrow[_ngcontent-%COMP%]:after{background:linear-gradient(90deg,var(--da-cards-and-blocks),transparent 97.78%);left:calc(100% - .7em);right:-.7em}.end-arrow[_ngcontent-%COMP%]{right:0}.end-arrow[_ngcontent-%COMP%]     svg{transform:rotate(-90deg)}.end-arrow[_ngcontent-%COMP%]:before{background:linear-gradient(270deg,var(--da-cards-and-blocks),transparent 97.78%);left:-.7em;right:calc(100% - .7em)}.end-arrow[_ngcontent-%COMP%]:after{left:.7em;right:0}fa-icon[_ngcontent-%COMP%]{align-items:center;cursor:pointer;height:calc(var(--size) + 1.4em);justify-content:center;width:calc(var(--size) + 1.4em)}fa-icon[_ngcontent-%COMP%], fa-icon[_ngcontent-%COMP%]     svg{position:relative;z-index:1}fa-icon[_ngcontent-%COMP%]:before{border-radius:4px;bottom:0;content:\"\";left:0;position:absolute;right:0;top:0}fa-icon[_ngcontent-%COMP%]:hover:before{background:var(--da-brand-base);opacity:.12;z-index:1}[libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%], [libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]:after, [libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]:before, [libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%], [libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]:after, [libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]:before{left:0;right:0}[libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]{bottom:auto;top:0}[libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]:before{bottom:.7em}[libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]:after{background:linear-gradient(180deg,var(--da-cards-and-blocks),transparent 97.78%);top:calc(100% - .7em)}[libScrollerDir=vertical][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]     svg{transform:rotate(0deg)}[libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]{bottom:0;top:auto}[libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]:before{background:linear-gradient(0deg,var(--da-cards-and-blocks),transparent 97.78%);bottom:calc(100% - .7em);top:0}[libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]:after{bottom:0;top:.7em}[libScrollerDir=vertical][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]     svg{transform:rotate(0deg)}"] });
ScrollerComponent.ctorParameters = () => [
    { type: NgZone }
];
ScrollerComponent.propDecorators = {
    libScrollerSize: [{ type: Input }],
    libScrollerDir: [{ type: Input }],
    lisScrollerDisabled: [{ type: Input }],
    container: [{ type: ViewChild, args: ['container',] }],
    actions: [{ type: ViewChild, args: ['actions',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollerComponent, [{
        type: Component,
        args: [{ selector: '[libScroller]', template: `
        <div #container class="scroller-container">
            <ng-content></ng-content>
        </div>
        <div
            *ngIf="!lisScrollerDisabled"
            #actions
            class="scroller-actions"
            [style.--size]="libScrollerSize + 'px'"
        >
            <div class="position-absolute start-arrow">
                <fa-icon
                    icon="facArrowUpInCircle"
                    class="d-flex"
                    (click)="shift(-scrollStep)"
                ></fa-icon>
            </div>
            <div class="position-absolute end-arrow">
                <fa-icon
                    icon="facArrowDownInCircle"
                    class="d-flex"
                    (click)="shift(scrollStep)"
                ></fa-icon>
            </div>
        </div>
    `, styles: [":host{overflow:hidden;position:relative}.scroller-container{display:flex;flex-wrap:nowrap;max-width:inherit;overflow:hidden;width:100%}:host[libScrollerDir=vertical] .scroller-container{flex-direction:column;height:100%;max-height:inherit}.scroller-container--end+div .end-arrow,.scroller-container--start+div .start-arrow{display:none}.scroller-container ::ng-deep>*{flex-shrink:0}.scroller-actions{font-size:var(--size)}.end-arrow,.start-arrow{align-items:center;bottom:0;color:var(--da-brand-base);display:flex;font-size:var(--size);justify-content:center;top:0;z-index:1}.end-arrow:after,.end-arrow:before,.start-arrow:after,.start-arrow:before{background:var(--da-cards-and-blocks);bottom:0;content:\"\";pointer-events:none;position:absolute;top:0}.start-arrow{left:0}.start-arrow ::ng-deep svg{transform:rotate(-90deg)}.start-arrow:before{left:-.7em;right:.7em}.start-arrow:after{background:linear-gradient(90deg,var(--da-cards-and-blocks),transparent 97.78%);left:calc(100% - .7em);right:-.7em}.end-arrow{right:0}.end-arrow ::ng-deep svg{transform:rotate(-90deg)}.end-arrow:before{background:linear-gradient(270deg,var(--da-cards-and-blocks),transparent 97.78%);left:-.7em;right:calc(100% - .7em)}.end-arrow:after{left:.7em;right:0}fa-icon{align-items:center;cursor:pointer;height:calc(var(--size) + 1.4em);justify-content:center;width:calc(var(--size) + 1.4em)}fa-icon,fa-icon ::ng-deep svg{position:relative;z-index:1}fa-icon:before{border-radius:4px;bottom:0;content:\"\";left:0;position:absolute;right:0;top:0}fa-icon:hover:before{background:var(--da-brand-base);opacity:.12;z-index:1}:host[libScrollerDir=vertical] .end-arrow,:host[libScrollerDir=vertical] .end-arrow:after,:host[libScrollerDir=vertical] .end-arrow:before,:host[libScrollerDir=vertical] .start-arrow,:host[libScrollerDir=vertical] .start-arrow:after,:host[libScrollerDir=vertical] .start-arrow:before{left:0;right:0}:host[libScrollerDir=vertical] .start-arrow{bottom:auto;top:0}:host[libScrollerDir=vertical] .start-arrow:before{bottom:.7em}:host[libScrollerDir=vertical] .start-arrow:after{background:linear-gradient(180deg,var(--da-cards-and-blocks),transparent 97.78%);top:calc(100% - .7em)}:host[libScrollerDir=vertical] .start-arrow ::ng-deep svg{transform:rotate(0deg)}:host[libScrollerDir=vertical] .end-arrow{bottom:0;top:auto}:host[libScrollerDir=vertical] .end-arrow:before{background:linear-gradient(0deg,var(--da-cards-and-blocks),transparent 97.78%);bottom:calc(100% - .7em);top:0}:host[libScrollerDir=vertical] .end-arrow:after{bottom:0;top:.7em}:host[libScrollerDir=vertical] .end-arrow ::ng-deep svg{transform:rotate(0deg)}"] }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { libScrollerSize: [{
            type: Input
        }], libScrollerDir: [{
            type: Input
        }], lisScrollerDisabled: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['container']
        }], actions: [{
            type: ViewChild,
            args: ['actions']
        }] }); })();

class TagComponent {
    constructor(elementRef) {
        this.hoverable = false;
        this.removable = false;
        this.remove = new EventEmitter();
        this.isLink = false;
        this.isLink = elementRef.nativeElement instanceof HTMLAnchorElement;
    }
    handleRemove(event) {
        event.preventDefault();
        event.stopPropagation();
        this.remove.emit();
    }
}
TagComponent.ɵfac = function TagComponent_Factory(t) { return new (t || TagComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TagComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TagComponent, selectors: [["lib-tag"], ["a", "libTag", ""]], hostVars: 4, hostBindings: function TagComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hoverable", ctx.isLink)("removable", ctx.removable);
    } }, inputs: { hoverable: "hoverable", removable: "removable", tag: "tag" }, outputs: { remove: "remove" }, ngContentSelectors: _c65, decls: 6, vars: 3, consts: [[1, "tag"], [1, "text", "text-truncate", "body3"], ["class", "body3 ml-1", "icon", "goto", 4, "ngIf"], ["class", "body3 ml-1 cursor-pointer", "icon", "times", 3, "click", 4, "ngIf"], ["icon", "goto", 1, "body3", "ml-1"], ["icon", "times", 1, "body3", "ml-1", "cursor-pointer", 3, "click"]], template: function TagComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c64);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TagComponent_fa_icon_4_Template, 1, 0, "fa-icon", 2);
        ɵngcc0.ɵɵtemplate(5, TagComponent_fa_icon_5_Template, 1, 0, "fa-icon", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.tag, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: ["[_nghost-%COMP%]{background:var(--da-border-and-dividers);border-radius:4px;color:var(--da-secondary-text-and-icons);display:inline-block;outline:none}.hoverable[_nghost-%COMP%]:hover, .removable[_nghost-%COMP%]:hover{color:var(--da-link-hover)}.hoverable[_nghost-%COMP%]:active, .removable[_nghost-%COMP%]:active{color:var(--da-brand-base)}.hoverable[_nghost-%COMP%]:focus, .removable[_nghost-%COMP%]:focus{box-shadow:0 0 0 4px rgba(50,125,226,.2)!important}[disabled][_nghost-%COMP%]{background:var(--da-blackout);color:var(--da-disable);pointer-events:none}[_nghost-%COMP%]   .tag[_ngcontent-%COMP%]{align-items:center;display:flex;padding:1px 4px}"], changeDetection: 0 });
TagComponent.ctorParameters = () => [
    { type: ElementRef }
];
TagComponent.propDecorators = {
    tag: [{ type: Input }],
    hoverable: [{ type: HostBinding, args: ['class.hoverable',] }, { type: Input }],
    removable: [{ type: HostBinding, args: ['class.removable',] }, { type: Input }],
    remove: [{ type: Output }],
    isLink: [{ type: HostBinding, args: ['class.hoverable',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TagComponent, [{
        type: Component,
        args: [{ selector: 'lib-tag, a[libTag]', template: "<div class=\"tag\">\n    <ng-content select=\"[left-content]\"></ng-content>\n    <span class=\"text text-truncate body3\">\n        {{ tag }}\n    </span>\n    <fa-icon *ngIf=\"isLink\" class=\"body3 ml-1\" icon=\"goto\"></fa-icon>\n\n    <fa-icon\n        *ngIf=\"removable\"\n        class=\"body3 ml-1 cursor-pointer\"\n        icon=\"times\"\n        (click)=\"handleRemove($event)\"\n    ></fa-icon>\n</div>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{background:var(--da-border-and-dividers);border-radius:4px;color:var(--da-secondary-text-and-icons);display:inline-block;outline:none}:host.hoverable:hover,:host.removable:hover{color:var(--da-link-hover)}:host.hoverable:active,:host.removable:active{color:var(--da-brand-base)}:host.hoverable:focus,:host.removable:focus{box-shadow:0 0 0 4px rgba(50,125,226,.2)!important}:host[disabled]{background:var(--da-blackout);color:var(--da-disable);pointer-events:none}:host .tag{align-items:center;display:flex;padding:1px 4px}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { hoverable: [{
            type: HostBinding,
            args: ['class.hoverable']
        }, {
            type: Input
        }], removable: [{
            type: HostBinding,
            args: ['class.removable']
        }, {
            type: Input
        }], remove: [{
            type: Output
        }], isLink: [{
            type: HostBinding,
            args: ['class.hoverable']
        }], tag: [{
            type: Input
        }] }); })();

class SortDirective {
    constructor() {
        this.sortChange = new EventEmitter();
        this.direction = null;
    }
    sort(sortable) {
        if (this.active !== sortable.property) {
            this.active = sortable.property;
            this.direction = null;
        }
        this.direction = getNextSortDirection(this.direction);
        this.sortChange.emit({
            direction: this.direction,
            property: this.active
        });
    }
}
SortDirective.ɵfac = function SortDirective_Factory(t) { return new (t || SortDirective)(); };
SortDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SortDirective, selectors: [["", "libSort", ""]], inputs: { direction: "direction", active: "active" }, outputs: { sortChange: "sortChange" } });
SortDirective.propDecorators = {
    sortChange: [{ type: Output }],
    active: [{ type: Input }],
    direction: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortDirective, [{
        type: Directive,
        args: [{
                selector: '[libSort]'
            }]
    }], function () { return []; }, { sortChange: [{
            type: Output
        }], direction: [{
            type: Input
        }], active: [{
            type: Input
        }] }); })();
function getNextSortDirection(direction) {
    const directionCycle = getSortDirectionCycle(direction);
    let nextDirectionCycleIndex = directionCycle.indexOf(direction) + 1;
    if (nextDirectionCycleIndex >= directionCycle.length) {
        nextDirectionCycleIndex = 0;
    }
    return directionCycle[nextDirectionCycleIndex];
}
function getSortDirectionCycle(current) {
    const directions = ['DESC', 'ASC'];
    //
    // if (current === 'ASC') {
    //     directions.reverse();
    // }
    directions.push(null);
    return directions;
}

class SortColumnComponent {
    constructor(sort) {
        this.sort = sort;
        this.direction = null;
    }
    get isSorted() {
        return this.sort.active === this.property && !!this.sort.direction;
    }
    get icon() {
        if (!this.isSorted) {
            return 'sortDesc';
        }
        return this.sort.direction === 'ASC' ? 'sortAsc' : 'sortDesc';
    }
    handleClick() {
        this.sort.sort(this);
    }
}
SortColumnComponent.ɵfac = function SortColumnComponent_Factory(t) { return new (t || SortColumnComponent)(ɵngcc0.ɵɵdirectiveInject(SortDirective)); };
SortColumnComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SortColumnComponent, selectors: [["", "sort-column", ""]], hostVars: 2, hostBindings: function SortColumnComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SortColumnComponent_click_HostBindingHandler() { return ctx.handleClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sort-active", ctx.isSorted);
    } }, inputs: { property: ["sort-column", "property"] }, attrs: _c66, ngContentSelectors: _c3, decls: 3, vars: 1, consts: [[1, "d-flex", "cursor-pointer"], [1, "ml-2", 3, "icon"]], template: function SortColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelement(2, "fa-icon", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("icon", ctx.icon);
    } }, dependencies: [ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: [".sort-active[_nghost-%COMP%]{color:var(--da-brand-base)}"], changeDetection: 0 });
SortColumnComponent.ctorParameters = () => [
    { type: SortDirective }
];
SortColumnComponent.propDecorators = {
    property: [{ type: Input, args: ['sort-column',] }],
    isSorted: [{ type: HostBinding, args: ['class.sort-active',] }],
    handleClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortColumnComponent, [{
        type: Component,
        args: [{ selector: '[sort-column]', template: "<div class=\"d-flex cursor-pointer\">\n    <ng-content></ng-content>\n    <fa-icon class=\"ml-2\" [icon]=\"$any(icon)\"></fa-icon>\n</div>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host.sort-active{color:var(--da-brand-base)}"] }]
    }], function () { return [{ type: SortDirective }]; }, { isSorted: [{
            type: HostBinding,
            args: ['class.sort-active']
        }], handleClick: [{
            type: HostListener,
            args: ['click']
        }], property: [{
            type: Input,
            args: ['sort-column']
        }] }); })();

class InsightCardComponent {
    constructor() {
        this.color = 'primary';
        this.active = false;
        this.loading = false;
        this.disabled = false;
    }
}
InsightCardComponent.ɵfac = function InsightCardComponent_Factory(t) { return new (t || InsightCardComponent)(); };
InsightCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InsightCardComponent, selectors: [["lib-insight-card"]], hostVars: 6, hostBindings: function InsightCardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.color);
        ɵngcc0.ɵɵclassProp("active", ctx.active)("disabled", ctx.disabled);
    } }, inputs: { color: "color", active: "active", loading: "loading", disabled: "disabled", title: "title", value: "value", unit: "unit" }, decls: 5, vars: 3, consts: [[1, "body1"], [1, "mt-2"], [4, "ngIf"], ["class", "title2", 4, "ngIf"], [1, "title2"], ["class", "body1 ml-1", 4, "ngIf"], [1, "body1", "ml-1"], ["type", "white", 1, "d-inline-block"]], template: function InsightCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, InsightCardComponent_ng_container_3_Template, 4, 2, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(4, InsightCardComponent_span_4_Template, 4, 0, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, dependencies: function () { return [ɵngcc2.NgIf, LoaderComponent]; }, styles: ["[_nghost-%COMP%]{border-radius:4px;color:var(--da-white);cursor:pointer;display:inline-block;padding:8px 16px;position:relative}.primary[_nghost-%COMP%]{background:var(--da-brand-base)}.primary.active[_nghost-%COMP%]:before{border-top-color:var(--da-brand-base)}.success[_nghost-%COMP%]{background:var(--da-success-base)}.success.active[_nghost-%COMP%]:before{border-top-color:var(--da-success-base)}.warning[_nghost-%COMP%]{background:var(--da-warning-base)}.warning.active[_nghost-%COMP%]:before{border-top-color:var(--da-warning-base)}.danger[_nghost-%COMP%]{background:var(--da-error-base)}.danger.active[_nghost-%COMP%]:before{border-top-color:var(--da-error-base)}.active[_nghost-%COMP%]{filter:drop-shadow(0 8px 20px rgba(15,38,68,.16))}.active[_nghost-%COMP%]:before{border-left:12px solid transparent;border-right:12px solid transparent;border-top:10px solid;content:\"\";height:0;left:50%;position:absolute;top:100%;transform:translateX(-50%);width:0}.active[_nghost-%COMP%], .disabled[_nghost-%COMP%]{cursor:default}[_nghost-%COMP%]:hover:not(.active):not(.disabled).primary{background:var(--da-brand-hover)}[_nghost-%COMP%]:hover:not(.active):not(.disabled).success{background:var(--da-success-hover)}[_nghost-%COMP%]:hover:not(.active):not(.disabled).warning{background:var(--da-warning-hover)}[_nghost-%COMP%]:hover:not(.active):not(.disabled).danger{background:var(--da-error-hover)}"] });
InsightCardComponent.propDecorators = {
    color: [{ type: HostBinding, args: ['class',] }, { type: Input }],
    active: [{ type: HostBinding, args: ['class.active',] }, { type: Input }],
    loading: [{ type: Input }],
    disabled: [{ type: HostBinding, args: ['class.disabled',] }, { type: Input }],
    title: [{ type: Input }],
    value: [{ type: Input }],
    unit: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InsightCardComponent, [{
        type: Component,
        args: [{ selector: 'lib-insight-card', template: "<div class=\"body1\">{{ title }}</div>\n<div class=\"mt-2\">\n    <ng-container *ngIf=\"!loading\">\n        <span class=\"title2\">\n        {{ value }}\n        </span>\n        <span class=\"body1 ml-1\" *ngIf=\"unit\">{{ unit }}</span>\n    </ng-container>\n\n    <span *ngIf=\"loading\" class=\"title2\">\n        <lib-loader type=\"white\" class=\"d-inline-block\"></lib-loader>\n         <span>&nbsp;</span>\n    </span>\n</div>\n", styles: [":host{border-radius:4px;color:var(--da-white);cursor:pointer;display:inline-block;padding:8px 16px;position:relative}:host.primary{background:var(--da-brand-base)}:host.primary.active:before{border-top-color:var(--da-brand-base)}:host.success{background:var(--da-success-base)}:host.success.active:before{border-top-color:var(--da-success-base)}:host.warning{background:var(--da-warning-base)}:host.warning.active:before{border-top-color:var(--da-warning-base)}:host.danger{background:var(--da-error-base)}:host.danger.active:before{border-top-color:var(--da-error-base)}:host.active{filter:drop-shadow(0 8px 20px rgba(15,38,68,.16))}:host.active:before{border-left:12px solid transparent;border-right:12px solid transparent;border-top:10px solid;content:\"\";height:0;left:50%;position:absolute;top:100%;transform:translateX(-50%);width:0}:host.active,:host.disabled{cursor:default}:host:hover:not(.active):not(.disabled).primary{background:var(--da-brand-hover)}:host:hover:not(.active):not(.disabled).success{background:var(--da-success-hover)}:host:hover:not(.active):not(.disabled).warning{background:var(--da-warning-hover)}:host:hover:not(.active):not(.disabled).danger{background:var(--da-error-hover)}"] }]
    }], function () { return []; }, { color: [{
            type: HostBinding,
            args: ['class']
        }, {
            type: Input
        }], active: [{
            type: HostBinding,
            args: ['class.active']
        }, {
            type: Input
        }], loading: [{
            type: Input
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }, {
            type: Input
        }], title: [{
            type: Input
        }], value: [{
            type: Input
        }], unit: [{
            type: Input
        }] }); })();

class StopClickPropagationDirective {
    constructor(elRef) {
        this.elRef = elRef;
        this.click = new EventEmitter();
        this.clickHandler = (e) => {
            e.stopPropagation();
            this.click.emit(e);
        };
    }
    ngOnInit() {
        this.elRef.nativeElement.addEventListener('click', this.clickHandler, true);
    }
    ngOnDestroy() {
        this.elRef.nativeElement.removeEventListener('click', this.clickHandler, true);
    }
}
StopClickPropagationDirective.ɵfac = function StopClickPropagationDirective_Factory(t) { return new (t || StopClickPropagationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
StopClickPropagationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StopClickPropagationDirective, selectors: [["", "appStopClickPropagation", ""]], outputs: { click: "click" } });
StopClickPropagationDirective.ctorParameters = () => [
    { type: ElementRef }
];
StopClickPropagationDirective.propDecorators = {
    click: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StopClickPropagationDirective, [{
        type: Directive,
        args: [{
                selector: '[appStopClickPropagation]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { click: [{
            type: Output
        }] }); })();

class ResizeDirective {
    constructor(el) {
        this.el = el;
        this.resizedEvent = new EventEmitter();
        this.oldY = 0;
        this.grabber = false;
        this.destroy$ = new Subject();
    }
    onMouseUp() {
        this.grabber = false;
        this.destroy$.next();
    }
    onResize(event) {
        this.grabber = true;
        this.oldY = event.clientY;
        event.preventDefault();
        this.addMouseMoveListener();
    }
    ngOnInit() {
        var _a;
        this.height = parseInt(this.defaultHeight
            ? this.defaultHeight
            : (_a = this.parentItem) === null || _a === void 0 ? void 0 : _a.offsetHeight, 10);
    }
    resizer(offsetY) {
        this.height -= offsetY;
        this.parentItem.style.height = this.height + 'px';
        this.resizedEvent.emit();
    }
    addMouseMoveListener() {
        fromEvent(document, 'mousemove')
            .pipe(takeUntil(this.destroy$))
            .subscribe(this.mouseMoveCallback.bind(this));
    }
    mouseMoveCallback(event) {
        if (!this.grabber) {
            return;
        }
        this.resizer(event.clientY - this.oldY);
        this.oldY = event.clientY;
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
}
ResizeDirective.ɵfac = function ResizeDirective_Factory(t) { return new (t || ResizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ResizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ResizeDirective, selectors: [["", "libResize", ""]], hostBindings: function ResizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseup", function ResizeDirective_mouseup_HostBindingHandler($event) { return ctx.onMouseUp($event); }, false, ɵngcc0.ɵɵresolveDocument)("mousedown", function ResizeDirective_mousedown_HostBindingHandler($event) { return ctx.onResize($event); });
    } }, inputs: { defaultHeight: "defaultHeight", parentItem: "parentItem" }, outputs: { resizedEvent: "resizedEvent" } });
ResizeDirective.ctorParameters = () => [
    { type: ElementRef }
];
ResizeDirective.propDecorators = {
    defaultHeight: [{ type: Input }],
    parentItem: [{ type: Input }],
    resizedEvent: [{ type: Output }],
    onMouseUp: [{ type: HostListener, args: ['document:mouseup', ['$event'],] }],
    onResize: [{ type: HostListener, args: ['mousedown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResizeDirective, [{
        type: Directive,
        args: [{
                selector: '[libResize]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { resizedEvent: [{
            type: Output
        }], onMouseUp: [{
            type: HostListener,
            args: ['document:mouseup', ['$event']]
        }], onResize: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }], defaultHeight: [{
            type: Input
        }], parentItem: [{
            type: Input
        }] }); })();

// tslint:disable-next-line:directive-class-suffix
class NgSelectAdjustPosition {
    constructor(dropdown, ref, cdr, zone) {
        this.dropdown = dropdown;
        this.ref = ref;
        this.cdr = cdr;
        this.zone = zone;
        this.handleWheel = () => {
            if (this.dropdown.ngSelect.isOpen) {
                if (!this.closeByScroll) {
                    this.dropdown.ngSelect['_handleDropdownPosition']();
                }
                else {
                    this.dropdown.ngSelect.close();
                    this.cdr.detectChanges();
                }
            }
        };
    }
    ngOnInit() {
        this.currentItem = this.ref.nativeElement;
        while (this.currentItem) {
            if (this.currentItem.scrollHeight > this.currentItem.clientHeight) {
                this.handleScroll();
                break;
            }
            this.currentItem = this.currentItem.parentNode;
        }
    }
    handleScroll() {
        this.zone.runOutsideAngular(() => {
            this.currentItem.addEventListener('wheel', this.handleWheel);
        });
    }
    ngOnDestroy() {
        if (this.currentItem) {
            this.currentItem.removeEventListener('wheel', this.handleWheel);
        }
    }
}
NgSelectAdjustPosition.ɵfac = function NgSelectAdjustPosition_Factory(t) { return new (t || NgSelectAdjustPosition)(ɵngcc0.ɵɵdirectiveInject(DropdownComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
NgSelectAdjustPosition.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgSelectAdjustPosition, selectors: [["lib-dropdown", "keep-position", ""]], inputs: { closeByScroll: "closeByScroll" } });
NgSelectAdjustPosition.ctorParameters = () => [
    { type: DropdownComponent },
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: NgZone }
];
NgSelectAdjustPosition.propDecorators = {
    closeByScroll: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgSelectAdjustPosition, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'lib-dropdown[keep-position]'
            }]
    }], function () { return [{ type: DropdownComponent }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { closeByScroll: [{
            type: Input
        }] }); })();

class CardHeaderTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
CardHeaderTemplateDirective.ɵfac = function CardHeaderTemplateDirective_Factory(t) { return new (t || CardHeaderTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
CardHeaderTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CardHeaderTemplateDirective, selectors: [["ng-template", "headerTemplate", ""]] });
CardHeaderTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardHeaderTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[headerTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class CardFooterTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
CardFooterTemplateDirective.ɵfac = function CardFooterTemplateDirective_Factory(t) { return new (t || CardFooterTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
CardFooterTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CardFooterTemplateDirective, selectors: [["ng-template", "footerTemplate", ""]] });
CardFooterTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardFooterTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[footerTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class VisibilityDirective {
    constructor({ nativeElement }) {
        this.options = {
            root: document.documentElement
        };
        this.visibilityChanged = new EventEmitter();
        this.observer = new IntersectionObserver((entries) => {
            this.visibilityChanged.emit(entries.pop().isIntersecting);
        }, this.options || {});
        this.observer.observe(nativeElement);
    }
    ngOnDestroy() {
        this.observer.disconnect();
    }
}
VisibilityDirective.ɵfac = function VisibilityDirective_Factory(t) { return new (t || VisibilityDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VisibilityDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VisibilityDirective, selectors: [["", "visibilityChanged", ""]], inputs: { options: "options" }, outputs: { visibilityChanged: "visibilityChanged" } });
VisibilityDirective.ctorParameters = () => [
    { type: ElementRef }
];
VisibilityDirective.propDecorators = {
    options: [{ type: Input }],
    visibilityChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VisibilityDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[visibilityChanged]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { options: [{
            type: Input
        }], visibilityChanged: [{
            type: Output
        }] }); })();

const defaultError = 'Something went wrong';
class ObsWithStatusPipe {
    transform(val) {
        return val.pipe(map((value) => {
            return {
                loading: value.type === 'start',
                error: value.type === 'error' ? defaultError : '',
                value: value.type ? value.value : value,
            };
        }), startWith({ loading: true }), catchError(error => of({ loading: false, error: typeof error === 'string' ? error : defaultError })));
    }
}
ObsWithStatusPipe.ɵfac = function ObsWithStatusPipe_Factory(t) { return new (t || ObsWithStatusPipe)(); };
ObsWithStatusPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "obsWithStatus", type: ObsWithStatusPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ObsWithStatusPipe, [{
        type: Pipe,
        args: [{
                name: 'obsWithStatus'
            }]
    }], null, null); })();

class TopicService {
}

class HttpListenerService extends TopicService {
    constructor(http, environment) {
        super();
        this.http = http;
        this.environment = environment;
        this.subject = new Subject();
    }
    listenTopic(topic, params) {
        return this.subject.pipe(delay(2000), startWith(0), concatMap(() => {
            const full = params.full;
            return this.http
                .get(`${this.environment.dpApiURL}/data-processor/state`, { params: this.plainObjectToHttpParams(params || {}) })
                .pipe(catchError(() => of({ jobDefinitions: [] })), map(state => [full, state]));
        }), tap(() => this.subject.next()));
    }
    plainObjectToHttpParams(obj) {
        return Object.keys(obj).reduce((params, key) => params.append(key, obj[key]), new HttpParams());
    }
}
HttpListenerService.ɵfac = function HttpListenerService_Factory(t) { return new (t || HttpListenerService)(ɵngcc0.ɵɵinject(ɵngcc11.HttpClient), ɵngcc0.ɵɵinject('environment')); };
HttpListenerService.ɵprov = ɵɵdefineInjectable({ factory: function HttpListenerService_Factory() { return new HttpListenerService(ɵɵinject(HttpClient), ɵɵinject("environment")); }, token: HttpListenerService, providedIn: "root" });
HttpListenerService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HttpListenerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc11.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['environment']
            }] }]; }, null); })();

class IfInViewportService {
    constructor() { }
    isInView(elem) {
        return new Promise(resolve => {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        resolve();
                        observer.unobserve(elem);
                    }
                });
            }, { threshold: [0, 0.1, 0.9, 1] });
            observer.observe(elem);
        });
    }
    isInViewObs(elem) {
        return new Observable(subscriber => {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        subscriber.next();
                        observer.unobserve(elem);
                    }
                });
            }, { threshold: [0, 0.1, 0.9, 1] });
            observer.observe(elem);
            return () => observer.unobserve(elem);
        }).pipe(share());
    }
}
IfInViewportService.ɵfac = function IfInViewportService_Factory(t) { return new (t || IfInViewportService)(); };
IfInViewportService.ɵprov = ɵɵdefineInjectable({ factory: function IfInViewportService_Factory() { return new IfInViewportService(); }, token: IfInViewportService, providedIn: "root" });
IfInViewportService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IfInViewportService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PerfectScrollbarService {
    constructor(resolver, injector) {
        this.resolver = resolver;
        this.injector = injector;
    }
    wrap(element) {
        const factory = this.resolver.resolveComponentFactory(PerfectScrollbarComponent);
        return factory.create(this.injector, [[element]]);
    }
}
PerfectScrollbarService.ɵfac = function PerfectScrollbarService_Factory(t) { return new (t || PerfectScrollbarService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
PerfectScrollbarService.ɵprov = ɵɵdefineInjectable({ factory: function PerfectScrollbarService_Factory() { return new PerfectScrollbarService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR)); }, token: PerfectScrollbarService, providedIn: "root" });
PerfectScrollbarService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PerfectScrollbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, null); })();

class UnsavedDataGuard {
    constructor(modalService) {
        this.modalService = modalService;
    }
    canDeactivate(component) {
        const subject = new Subject();
        if (!component || (component && component.canDeactivate())) {
            return true;
        }
        else {
            const warning = component.getWarning();
            const modalRef = this.modalService.open(ModalConfirmComponent, {
                centered: true,
                backdrop: 'static',
            }, {
                message: {
                    title: warning.title,
                    content: warning.message,
                    WarningMessage: warning.warningMessage,
                },
            });
            modalRef.result.then(() => {
                if (component.beforeLeave) {
                    component.beforeLeave();
                }
                subject.next(true);
            }, () => {
                subject.next(false);
            });
            return subject.asObservable();
        }
    }
}
UnsavedDataGuard.ɵfac = function UnsavedDataGuard_Factory(t) { return new (t || UnsavedDataGuard)(ɵngcc0.ɵɵinject(ModalService)); };
UnsavedDataGuard.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UnsavedDataGuard, factory: UnsavedDataGuard.ɵfac });
UnsavedDataGuard.ctorParameters = () => [
    { type: ModalService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UnsavedDataGuard, [{
        type: Injectable
    }], function () { return [{ type: ModalService }]; }, null); })();

class CardComponent {
}
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(); };
CardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CardComponent, selectors: [["lib-card"]], contentQueries: function CardComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CardHeaderTemplateDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, CardFooterTemplateDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
    } }, hostAttrs: [1, "lib-card"], hostVars: 4, hostBindings: function CardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("static-card", ctx.staticCard)("with-shadow", ctx.withShadow);
    } }, inputs: { staticCard: "staticCard", withShadow: "withShadow" }, ngContentSelectors: _c3, decls: 3, vars: 2, consts: [[3, "ngTemplateOutlet", 4, "ngIf"], [3, "ngTemplateOutlet"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CardComponent_ng_container_0_Template, 1, 1, "ng-container", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, CardComponent_ng_container_2_Template, 1, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.footerTemplate);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;display:block;padding:16px}.with-shadow[_nghost-%COMP%]{box-shadow:var(--da-soft-default-shadow)}[_nghost-%COMP%]:not(.static-card):hover{box-shadow:var(--da-card-hover-box-shadow)}[_nghost-%COMP%]:not(.static-card).selected, [_nghost-%COMP%]:not(.static-card):active, [_nghost-%COMP%]:not(.static-card):focus{border:1px solid var(--da-brand-base);box-shadow:none;outline:none}"] });
CardComponent.propDecorators = {
    staticCard: [{ type: HostBinding, args: ['class.static-card',] }, { type: Input }],
    withShadow: [{ type: HostBinding, args: ['class.with-shadow',] }, { type: Input }],
    headerTemplate: [{ type: ContentChild, args: [CardHeaderTemplateDirective, { static: true },] }],
    footerTemplate: [{ type: ContentChild, args: [CardFooterTemplateDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{ selector: 'lib-card', template: "<ng-container\n    *ngIf=\"headerTemplate\"\n    [ngTemplateOutlet]=\"headerTemplate.template\"\n></ng-container>\n\n<ng-content></ng-content>\n\n<ng-container\n    *ngIf=\"footerTemplate\"\n    [ngTemplateOutlet]=\"footerTemplate.template\"\n></ng-container>\n", host: { class: 'lib-card' }, styles: [":host{background:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:4px;display:block;padding:16px}:host.with-shadow{box-shadow:var(--da-soft-default-shadow)}:host:not(.static-card):hover{box-shadow:var(--da-card-hover-box-shadow)}:host:not(.static-card).selected,:host:not(.static-card):active,:host:not(.static-card):focus{border:1px solid var(--da-brand-base);box-shadow:none;outline:none}"] }]
    }], null, { staticCard: [{
            type: HostBinding,
            args: ['class.static-card']
        }, {
            type: Input
        }], withShadow: [{
            type: HostBinding,
            args: ['class.with-shadow']
        }, {
            type: Input
        }], headerTemplate: [{
            type: ContentChild,
            args: [CardHeaderTemplateDirective, { static: true }]
        }], footerTemplate: [{
            type: ContentChild,
            args: [CardFooterTemplateDirective, { static: true }]
        }] }); })();

class LoaderComponent {
    constructor() {
        this.size = '15px';
        this.type = 'brand';
    }
}
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(); };
LoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["lib-loader"]], inputs: { size: "size", type: "type" }, decls: 1, vars: 7, template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("loader ", "type--" + ctx.type, "");
        ɵngcc0.ɵɵstyleProp("width", ctx.size)("height", ctx.size);
    } }, styles: [".loader[_ngcontent-%COMP%], .loader[_ngcontent-%COMP%]:after{border-radius:50%;height:inherit;width:inherit}.loader[_ngcontent-%COMP%]{-webkit-animation:load8 1.1s linear infinite;animation:load8 1.1s linear infinite;border:1px solid var(--da-border-and-dividers);border-left-color:var(--da-brand-base);position:relative;text-indent:-9999em;transform:translateZ(0)}.type--white.loader[_ngcontent-%COMP%]{border-color:var(--da-white);border-left-color:hsla(0,0%,100%,.12)}@-webkit-keyframes load8{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes load8{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}"] });
LoaderComponent.propDecorators = {
    size: [{ type: Input }],
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{ selector: 'lib-loader', template: "<div class=\"loader {{ 'type--' + type }}\" [style.width]=\"size\" [style.height]=\"size\"></div>\n", styles: [".loader,.loader:after{border-radius:50%;height:inherit;width:inherit}.loader{-webkit-animation:load8 1.1s linear infinite;animation:load8 1.1s linear infinite;border:1px solid var(--da-border-and-dividers);border-left-color:var(--da-brand-base);position:relative;text-indent:-9999em;transform:translateZ(0)}.type--white.loader{border-color:var(--da-white);border-left-color:hsla(0,0%,100%,.12)}@-webkit-keyframes load8{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes load8{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}"] }]
    }], function () { return []; }, { size: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class SplitButtonComponent {
    constructor() {
        this.placement = 'bottom-right';
        this.isPrimary = true;
        this.isLink = false;
        this.isIcon = false;
        this.container = null;
        this.itemClick = new EventEmitter();
        this.parentElements = [];
        this.sizeS = false;
        this.sizeL = false;
    }
    ngOnInit() {
        const hostNativeElement = this.containerEl.nativeElement
            .parentNode;
        this.sizeS = hostNativeElement.classList.contains('size-s');
        this.sizeL = hostNativeElement.classList.contains('size-l');
    }
    addParentsEventListener(element, dropdown) {
        this.scrollFn = () => {
            dropdown.close();
            this.removeParentsEventListener();
        };
        this.parentElements = [];
        let parentElement = element.parentElement;
        do {
            this.parentElements.push(parentElement);
            parentElement.addEventListener('scroll', this.scrollFn);
            parentElement = parentElement.parentElement;
        } while (parentElement);
    }
    removeParentsEventListener() {
        this.parentElements.forEach(element => {
            element.removeEventListener('scroll', this.scrollFn);
        });
    }
    handleOpen(element, dropdown) {
        dropdown.isOpen()
            ? this.addParentsEventListener(element, dropdown)
            : this.removeParentsEventListener();
    }
    handleClick(item) {
        if (item.disabled) {
            return;
        }
        this.itemClick.emit(item);
    }
    ngOnDestroy() {
        this.removeParentsEventListener();
    }
}
SplitButtonComponent.ɵfac = function SplitButtonComponent_Factory(t) { return new (t || SplitButtonComponent)(); };
SplitButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SplitButtonComponent, selectors: [["lib-split-button"]], contentQueries: function SplitButtonComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
    } }, viewQuery: function SplitButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c67, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerEl = _t.first);
    } }, inputs: { placement: "placement", isPrimary: "isPrimary", isLink: "isLink", isIcon: "isIcon", container: "container", buttonText: "buttonText", buttonIcon: "buttonIcon", items: "items", disabled: "disabled", dropdownMode: "dropdownMode" }, outputs: { itemClick: "itemClick" }, ngContentSelectors: _c3, decls: 6, vars: 2, consts: [["containerEl", ""], ["class", "btn", 3, "ngClass", "disabled", "click", 4, "ngIf"], ["ngbDropdown", "", "display", "dynamic", 3, "placement", "container", "openChange", 4, "ngIf"], ["defaultItem", ""], [1, "btn", 3, "ngClass", "disabled", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["ngbDropdown", "", "display", "dynamic", 3, "placement", "container", "openChange"], ["element", "", "dropdown", "ngbDropdown"], ["ngbDropdownToggle", "", 1, "btn", 3, "disabled", "ngClass", "click"], ["toggle", ""], ["class", "button-text", 4, "ngIf"], ["class", "fa chevron-icon", 3, "icon", 4, "ngIf"], [1, "fa", "chevron-icon", 3, "icon"], ["ngbDropdownMenu", "", 1, "pt-0", "pb-0", "dropdown-list"], ["class", "cursor-pointer dropdown-item split-button-item body1 pt-2 pb-2 pl-3 pr-3", 3, "disabled", "click", 4, "ngFor", "ngForOf"], [1, "button-text"], [1, "cursor-pointer", "dropdown-item", "split-button-item", "body1", "pt-2", "pb-2", "pl-3", "pr-3", 3, "click"], ["class", "fa mr-5px", 3, "icon", 4, "ngIf"], [1, "fa", "mr-5px", 3, "icon"]], template: function SplitButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵtemplate(2, SplitButtonComponent_button_2_Template, 2, 13, "button", 1);
        ɵngcc0.ɵɵtemplate(3, SplitButtonComponent_div_3_Template, 11, 17, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, SplitButtonComponent_ng_template_4_Template, 2, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.items == null ? null : ctx.items.length) === 1 && !ctx.dropdownMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dropdownMode || (ctx.items == null ? null : ctx.items.length) > 1);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.NgbDropdown, ɵngcc5.NgbDropdownToggle, ɵngcc5.NgbDropdownMenu, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: ["[_nghost-%COMP%]{display:inline-block}.dropdown-menu[_ngcontent-%COMP%]{border-radius:4px;box-shadow:var(--da-dropdown-box-shadow)}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks);color:var(--da-primary-text)}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item.disabled[_ngcontent-%COMP%]:hover, .dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:hover{background-color:var(--da-brand-12)!important}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item.disabled[_ngcontent-%COMP%]{color:var(--da-disable);cursor:default;pointer-events:auto}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:first-child{border-radius:4px 4px 0 0}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:last-child{border-radius:0 0 4px 4px}.dropdown-list[_ngcontent-%COMP%]{margin:0}[x-placement^=top][_ngcontent-%COMP%]{margin-bottom:4px}[x-placement^=bottom][_ngcontent-%COMP%]{margin-top:4px}[x-placement^=left][_ngcontent-%COMP%]{margin-right:4px}[x-placement^=right][_ngcontent-%COMP%]{margin-left:4px}.chevron-icon[_ngcontent-%COMP%]{font-size:14px;margin-left:8px}.chevron-icon-along[_ngcontent-%COMP%]{margin-left:0!important}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none!important}  .split-button-item fa-icon{color:var(--da-brand-base)}  .split-button-item.disabled fa-icon{color:var(--da-disable)}"] });
SplitButtonComponent.propDecorators = {
    placement: [{ type: Input }],
    buttonText: [{ type: Input }],
    buttonIcon: [{ type: Input }],
    items: [{ type: Input }],
    disabled: [{ type: Input }],
    dropdownMode: [{ type: Input }],
    isPrimary: [{ type: Input }],
    isLink: [{ type: Input }],
    isIcon: [{ type: Input }],
    container: [{ type: Input }],
    itemClick: [{ type: Output }],
    itemTemplate: [{ type: ContentChild, args: [TemplateRef, { static: true },] }],
    containerEl: [{ type: ViewChild, args: ['containerEl', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitButtonComponent, [{
        type: Component,
        args: [{ selector: 'lib-split-button', template: "<div #containerEl>\n    <button\n        class=\"btn\"\n        [ngClass]=\"{\n            'btn-primary': isPrimary && !isLink,\n            'btn-secondary': !isPrimary && !isLink,\n            'btn-link py-0': isLink,\n            'size-s': sizeS,\n            'size-l': sizeL\n        }\"\n        *ngIf=\"items?.length === 1 && !dropdownMode\"\n        (click)=\"itemClick.emit(items[0])\"\n        [disabled]=\"items[0].disabled || disabled\"\n    >\n        <ng-container\n            *ngTemplateOutlet=\"\n                itemTemplate || defaultItem;\n                context: { item: items[0], items: items }\n            \"\n        ></ng-container>\n    </button>\n    <div\n        #element\n        #dropdown=\"ngbDropdown\"\n        *ngIf=\"dropdownMode || items?.length > 1\"\n        ngbDropdown\n        [placement]=\"placement\"\n        display=\"dynamic\"\n        (openChange)=\"handleOpen(element, dropdown)\"\n        [container]=\"container\"\n    >\n        <button\n            #toggle\n            ngbDropdownToggle\n            [disabled]=\"!items || !items.length || disabled\"\n            class=\"btn\"\n            [ngClass]=\"{\n                'btn-primary': isPrimary && !isLink,\n                'btn-secondary': !isPrimary && !isLink,\n                'btn-link py-0': isLink,\n                'size-s': sizeS,\n                'size-l': sizeL,\n                'btn-icon': isIcon\n            }\"\n            (click)=\"toggle.blur()\"\n        >\n            <span *ngIf=\"buttonText && !isIcon\" class=\"button-text\">{{ buttonText }}</span>\n            <fa-icon\n                *ngIf=\"buttonIcon && !isIcon\"\n                class=\"fa chevron-icon\"\n                [icon]=\"buttonIcon\"\n            ></fa-icon>\n            <fa-icon\n                class=\"fa chevron-icon\"\n                [class.chevron-icon-along]=\"isIcon\"\n                [icon]=\"isIcon ? buttonIcon : dropdown.isOpen() ? 'chevron-up' : 'chevron-down'\"\n            ></fa-icon>\n        </button>\n        <ul class=\"pt-0 pb-0 dropdown-list\" ngbDropdownMenu>\n            <ng-content></ng-content>\n            <li\n                class=\"cursor-pointer dropdown-item split-button-item body1 pt-2 pb-2 pl-3 pr-3\"\n                *ngFor=\"let item of items\"\n                [class.disabled]=\"!!item.disabled\"\n                (click)=\"handleClick(item)\"\n            >\n                <ng-container\n                    *ngTemplateOutlet=\"\n                        itemTemplate || defaultItem;\n                        context: { item: item, items: items }\n                    \"\n                ></ng-container>\n            </li>\n        </ul>\n    </div>\n</div>\n\n<ng-template #defaultItem let-item=\"item\">\n    <fa-icon *ngIf=\"item.icon\"\n        class=\"fa mr-5px\"\n        [icon]=\"item.icon\"\n    ></fa-icon>\n    {{ item.label }}\n</ng-template>\n", styles: [":host{display:inline-block}.dropdown-menu{border-radius:4px;box-shadow:var(--da-dropdown-box-shadow)}.dropdown-menu .dropdown-item{background-color:var(--da-cards-and-blocks);color:var(--da-primary-text)}.dropdown-menu .dropdown-item.disabled:hover,.dropdown-menu .dropdown-item:hover{background-color:var(--da-brand-12)!important}.dropdown-menu .dropdown-item.disabled{color:var(--da-disable);cursor:default;pointer-events:auto}.dropdown-menu .dropdown-item:first-child{border-radius:4px 4px 0 0}.dropdown-menu .dropdown-item:last-child{border-radius:0 0 4px 4px}.dropdown-list{margin:0}[x-placement^=top]{margin-bottom:4px}[x-placement^=bottom]{margin-top:4px}[x-placement^=left]{margin-right:4px}[x-placement^=right]{margin-left:4px}.chevron-icon{font-size:14px;margin-left:8px}.chevron-icon-along{margin-left:0!important}.dropdown-toggle:after{content:none!important}::ng-deep .split-button-item fa-icon{color:var(--da-brand-base)}::ng-deep .split-button-item.disabled fa-icon{color:var(--da-disable)}"] }]
    }], function () { return []; }, { placement: [{
            type: Input
        }], isPrimary: [{
            type: Input
        }], isLink: [{
            type: Input
        }], isIcon: [{
            type: Input
        }], container: [{
            type: Input
        }], itemClick: [{
            type: Output
        }], buttonText: [{
            type: Input
        }], buttonIcon: [{
            type: Input
        }], items: [{
            type: Input
        }], disabled: [{
            type: Input
        }], dropdownMode: [{
            type: Input
        }], itemTemplate: [{
            type: ContentChild,
            args: [TemplateRef, { static: true }]
        }], containerEl: [{
            type: ViewChild,
            args: ['containerEl', { static: true }]
        }] }); })();

class NavbarMenuSpecialItemsDirective {
    constructor(template) {
        this.template = template;
    }
}
NavbarMenuSpecialItemsDirective.ɵfac = function NavbarMenuSpecialItemsDirective_Factory(t) { return new (t || NavbarMenuSpecialItemsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
NavbarMenuSpecialItemsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NavbarMenuSpecialItemsDirective, selectors: [["ng-template", "navbarSpecialItem", ""]] });
NavbarMenuSpecialItemsDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavbarMenuSpecialItemsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[navbarSpecialItem]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

const DELAY_1S = 1000;
const LOGO_WIDTH = 192;
const CONTEXT_MENU_WIDTH = 200;
class NavbarMenuComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.limitedWidth = LOGO_WIDTH + CONTEXT_MENU_WIDTH;
        this.collapsed$ = new EventEmitter();
        this.collapsed = false;
        this.destroyed$ = new Subject();
    }
    ngAfterViewInit() {
        if (this.menuItems$) {
            this.menuItems$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
                setTimeout(() => {
                    this.checkCollapse();
                }, DELAY_1S);
            });
        }
    }
    ngOnChanges() {
        setTimeout(() => {
            this.checkCollapse();
        }, DELAY_1S);
    }
    onResize() {
        this.checkCollapse();
    }
    checkCollapse() {
        var _a, _b;
        const navBar = (_b = (_a = this.elRef.nativeElement) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('navbar-nav')) === null || _b === void 0 ? void 0 : _b.item(0);
        if (!navBar) {
            return;
        }
        this.collapsed =
            window.innerWidth - navBar.getBoundingClientRect().width <
                this.limitedWidth;
        navBar.style.position = this.collapsed ? 'absolute' : 'static';
        navBar.style.top = this.collapsed ? '-1000px' : '';
        this.collapsed$.next(this.collapsed);
    }
    ngOnDestroy() {
        this.destroyed$.next();
    }
}
NavbarMenuComponent.ɵfac = function NavbarMenuComponent_Factory(t) { return new (t || NavbarMenuComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NavbarMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavbarMenuComponent, selectors: [["lib-navbar-menu"]], contentQueries: function NavbarMenuComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NavbarMenuSpecialItemsDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.navbarMenuSpecialItemsDirective = _t.first);
    } }, hostBindings: function NavbarMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function NavbarMenuComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { limitedWidth: "limitedWidth", menuItems: "menuItems", menuItems$: "menuItems$" }, outputs: { collapsed$: "collapsed$" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 8, vars: 2, consts: [[1, "navbar-nav-scroll", "d-flex"], [4, "ngIf", "ngIfElse"], ["observableDataTemplate", ""], ["itemTemplate", ""], ["collapsedTmpl", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "navbar-nav", "flex-row"], ["class", "nav-item", 3, "id", 4, "ngFor", "ngForOf"], [1, "nav-item", 3, "id"], [4, "ngIf"], ["class", "nav-link", 3, "ngClass", "routerLinkActive", "routerLink", 4, "ngIf"], [1, "nav-link", 3, "ngClass", "routerLinkActive", "routerLink"], [1, "d-flex", "flex-column"], ["class", "row no-gutters justify-content-center align-content-center", 3, "height", 4, "ngIf"], [1, "row", "no-gutters", "font-12px"], [1, "row", "no-gutters", "justify-content-center", "align-content-center"], ["class", "fa-icon font-16px", 3, "icon", 4, "ngIf"], ["class", "header-item-image", 3, "innerHTML", 4, "ngIf"], [1, "fa-icon", "font-16px", 3, "icon"], [1, "header-item-image", 3, "innerHTML"], ["class", "dropdown collapsed-menu", "ngbDropdown", "", "container", "body", "placement", "bottom-left", "display", "dynamic", 4, "ngIf"], ["ngbDropdown", "", "container", "body", "placement", "bottom-left", "display", "dynamic", 1, "dropdown", "collapsed-menu"], ["aria-label", "Hide Sidebar", "id", "collapseDropdown", "ngbDropdownToggle", "", 1, "hamburger-menu", "dropdown-button"], ["aria-labelledby", "navbarAditionDropdown", "ngbDropdownMenu", ""], [4, "ngFor", "ngForOf"], ["class", "dropdown-item collapsed-item cursor-pointer", 3, "routerLink", 4, "ngIf"], [1, "dropdown-item", "collapsed-item", "cursor-pointer", 3, "routerLink"], ["class", "fa-icon pt-1", 3, "height", "icon", 4, "ngIf"], [3, "margin-right", "height", "innerHTML", 4, "ngIf"], [1, "fa-icon", "pt-1", 3, "icon"], [3, "innerHTML"]], template: function NavbarMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NavbarMenuComponent_ng_container_1_Template, 4, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, NavbarMenuComponent_ng_template_2_Template, 2, 3, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, NavbarMenuComponent_ng_template_4_Template, 4, 6, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, NavbarMenuComponent_ng_template_6_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.menuItems)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.NgbDropdown, ɵngcc5.NgbDropdownToggle, ɵngcc5.NgbDropdownMenu, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc9.RouterLinkWithHref, ɵngcc9.RouterLinkActive, ɵngcc2.AsyncPipe, SafeHtmlPipe], styles: ["[_nghost-%COMP%]{margin-bottom:auto;margin-top:auto}.header-item-image[_ngcontent-%COMP%]     svg{height:16px;width:16px}.header-item-image[_ngcontent-%COMP%]     svg path{stroke:var(--da-secondary-text-and-icons)}.fa-icon[_ngcontent-%COMP%]{font-size:14px!important}.navbar-nav-scroll[_ngcontent-%COMP%]{height:50px;margin:auto auto auto 0;overflow:hidden;white-space:nowrap}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]{color:var(--da-primary-text);margin:auto 16px;padding:6px 0}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link.link-without-pic[_ngcontent-%COMP%]{padding:15px 0!important}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%]{margin-right:0!important}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]:hover, .navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]:hover   fa-icon[_ngcontent-%COMP%]{color:var(--da-brand-base)}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]:hover   .header-item-image[_ngcontent-%COMP%]     svg path{stroke:var(--da-brand-base)}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link-with-icon[_ngcontent-%COMP%]{height:60px;padding-top:22px}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link.active[_ngcontent-%COMP%], .navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]:focus{border-bottom:2px solid var(--da-brand-base)!important;color:var(--da-brand-base)}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link.active[_ngcontent-%COMP%]   .fa-icon[_ngcontent-%COMP%], .navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]:focus   .fa-icon[_ngcontent-%COMP%]{color:var(--da-brand-base)}.navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link.active[_ngcontent-%COMP%]   .header-item-image[_ngcontent-%COMP%]     svg path, .navbar-nav-scroll[_ngcontent-%COMP%]   .navbar-nav[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   a.nav-link[_ngcontent-%COMP%]:focus   .header-item-image[_ngcontent-%COMP%]     svg path{stroke:var(--da-brand-base)}.dropdown-toggle[_ngcontent-%COMP%]:empty:after{display:none}.collapsed-menu[_ngcontent-%COMP%]{align-items:center;display:flex}[_nghost-%COMP%]     .dropdown-menu{margin-top:8px}[_nghost-%COMP%]     .dropdown .dropdown-item.collapsed-item{color:var(--da-primary-text);display:flex!important;overflow:hidden}"] });
NavbarMenuComponent.ctorParameters = () => [
    { type: ElementRef }
];
NavbarMenuComponent.propDecorators = {
    menuItems: [{ type: Input }],
    menuItems$: [{ type: Input }],
    limitedWidth: [{ type: Input }],
    navbarMenuSpecialItemsDirective: [{ type: ContentChild, args: [NavbarMenuSpecialItemsDirective, { static: true },] }],
    collapsed$: [{ type: Output }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavbarMenuComponent, [{
        type: Component,
        args: [{ selector: 'lib-navbar-menu', template: "<div class=\"navbar-nav-scroll d-flex\">\n    <ng-container *ngIf=\"menuItems; else observableDataTemplate\">\n        <ng-template\n            [ngTemplateOutlet]=\"collapsedTmpl\"\n            [ngTemplateOutletContext]=\"{ $implicit: menuItems }\"\n        >\n        </ng-template>\n\n        <ul class=\"navbar-nav flex-row\">\n            <li\n                class=\"nav-item\"\n                *ngFor=\"let item of menuItems; let i = index\"\n                id=\"{{ i }}\"\n            >\n                <ng-template\n                    [ngTemplateOutlet]=\"itemTemplate\"\n                    [ngTemplateOutletContext]=\"{ $implicit: item }\"\n                >\n                </ng-template>\n            </li>\n        </ul>\n    </ng-container>\n\n    <ng-template #observableDataTemplate>\n        <ng-container *ngIf=\"menuItems$ | async as items\">\n            <ng-template\n                [ngTemplateOutlet]=\"collapsedTmpl\"\n                [ngTemplateOutletContext]=\"{ $implicit: items }\"\n            >\n            </ng-template>\n\n            <ul class=\"navbar-nav flex-row\">\n                <li\n                    class=\"nav-item\"\n                    *ngFor=\"let item of items; let k = index\"\n                    id=\"{{ k }}\"\n                >\n                    <ng-template\n                        [ngTemplateOutlet]=\"itemTemplate\"\n                        [ngTemplateOutletContext]=\"{ $implicit: item }\"\n                    >\n                    </ng-template>\n                </li>\n            </ul>\n        </ng-container>\n    </ng-template>\n</div>\n\n<ng-template #itemTemplate let-item>\n    <a\n        *ngIf=\"\n            !item.specialItem && (item.active$ ? (item.active$ | async) : true)\n        \"\n        class=\"nav-link\"\n        [ngClass]=\"{'link-without-pic': (!item.image && !item.icon)}\"\n        [routerLinkActive]=\"['active']\"\n        [routerLink]=\"[item.routerLink]\"\n    >\n        <div class=\"d-flex flex-column\">\n            <div *ngIf=\"item.icon || item.image\" class=\"row no-gutters justify-content-center align-content-center\" [style.height.px]=\"18\">\n                <fa-icon\n                    *ngIf=\"item.icon && !item.image\"\n                    class=\"fa-icon font-16px\"\n                    [icon]=\"item.icon\"\n                ></fa-icon>\n                <span\n                    *ngIf=\"item.image && !item.icon\"\n                    class=\"header-item-image\"\n                    [innerHTML]=\"item.image | safeHtml: 'html'\">\n                </span>\n            </div>\n            <div class=\"row no-gutters font-12px\">\n                 <span>\n                    {{ item.label }}\n                 </span>\n            </div>\n        </div>\n    </a>\n    <ng-template\n        *ngIf=\"\n            item.specialItem && (item.active$ ? (item.active$ | async) : true)\n        \"\n        [ngTemplateOutlet]=\"navbarMenuSpecialItemsDirective.template\"\n        [ngTemplateOutletContext]=\"{ $implicit: item }\"\n    ></ng-template>\n</ng-template>\n\n<ng-template #collapsedTmpl let-items>\n    <div\n        *ngIf=\"collapsed\"\n        class=\"dropdown collapsed-menu\"\n        ngbDropdown\n        container=\"body\"\n        placement=\"bottom-left\"\n        display=\"dynamic\"\n    >\n        <a\n            class=\"hamburger-menu dropdown-button\"\n            aria-label=\"Hide Sidebar\"\n            id=\"collapseDropdown\"\n            ngbDropdownToggle\n        ></a>\n        <div aria-labelledby=\"navbarAditionDropdown\" ngbDropdownMenu>\n            <ng-container *ngFor=\"let menu of items\">\n                <a\n                    *ngIf=\"\n                        !menu.specialItem &&\n                        (menu.active$ ? (menu.active$ | async) : true)\n                    \"\n                    [routerLink]=\"menu.routerLink\"\n                    class=\"dropdown-item collapsed-item cursor-pointer\"\n                >\n                    <fa-icon\n                        *ngIf=\"menu.icon\"\n                        class=\"fa-icon pt-1\"\n                        [style.height.px]=\"16\"\n                        [icon]=\"menu.icon\"\n                    ></fa-icon>\n                    <span\n                        *ngIf=\"menu.image && !menu.icon\"\n                        [style.margin-right.px]=\"12\"\n                        [style.height.px]=\"16\"\n                        [innerHTML]=\"menu.image | safeHtml: 'html'\"\n                    >\n                    </span>\n                    <div>\n                        {{ menu.label }}\n                    </div>\n                </a>\n                <ng-template\n                    *ngIf=\"\n                        menu.specialItem &&\n                        (menu.active$ ? (menu.active$ | async) : true)\n                    \"\n                    [ngTemplateOutlet]=\"\n                        navbarMenuSpecialItemsDirective.template\n                    \"\n                    [ngTemplateOutletContext]=\"{ $implicit: menu }\"\n                ></ng-template>\n            </ng-container>\n        </div>\n    </div>\n</ng-template>\n", styles: [":host{margin-bottom:auto;margin-top:auto}.header-item-image ::ng-deep svg{height:16px;width:16px}.header-item-image ::ng-deep svg path{stroke:var(--da-secondary-text-and-icons)}.fa-icon{font-size:14px!important}.navbar-nav-scroll{height:50px;margin:auto auto auto 0;overflow:hidden;white-space:nowrap}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link{color:var(--da-primary-text);margin:auto 16px;padding:6px 0}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link.link-without-pic{padding:15px 0!important}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link fa-icon{margin-right:0!important}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link:hover,.navbar-nav-scroll .navbar-nav .nav-item a.nav-link:hover fa-icon{color:var(--da-brand-base)}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link:hover .header-item-image ::ng-deep svg path{stroke:var(--da-brand-base)}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link-with-icon{height:60px;padding-top:22px}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link.active,.navbar-nav-scroll .navbar-nav .nav-item a.nav-link:focus{border-bottom:2px solid var(--da-brand-base)!important;color:var(--da-brand-base)}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link.active .fa-icon,.navbar-nav-scroll .navbar-nav .nav-item a.nav-link:focus .fa-icon{color:var(--da-brand-base)}.navbar-nav-scroll .navbar-nav .nav-item a.nav-link.active .header-item-image ::ng-deep svg path,.navbar-nav-scroll .navbar-nav .nav-item a.nav-link:focus .header-item-image ::ng-deep svg path{stroke:var(--da-brand-base)}.dropdown-toggle:empty:after{display:none}.collapsed-menu{align-items:center;display:flex}:host ::ng-deep .dropdown-menu{margin-top:8px}:host ::ng-deep .dropdown .dropdown-item.collapsed-item{color:var(--da-primary-text);display:flex!important;overflow:hidden}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { limitedWidth: [{
            type: Input
        }], collapsed$: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], menuItems: [{
            type: Input
        }], menuItems$: [{
            type: Input
        }], navbarMenuSpecialItemsDirective: [{
            type: ContentChild,
            args: [NavbarMenuSpecialItemsDirective, { static: true }]
        }] }); })();

class ContextButtonDirective {
    constructor(template) {
        this.template = template;
    }
}
ContextButtonDirective.ɵfac = function ContextButtonDirective_Factory(t) { return new (t || ContextButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ContextButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ContextButtonDirective, selectors: [["ng-template", "buttonTemplate", ""]] });
ContextButtonDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContextButtonDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[buttonTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class ContextSpecialItemsDirective {
    constructor(template) {
        this.template = template;
    }
}
ContextSpecialItemsDirective.ɵfac = function ContextSpecialItemsDirective_Factory(t) { return new (t || ContextSpecialItemsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ContextSpecialItemsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ContextSpecialItemsDirective, selectors: [["ng-template", "specialItems", ""]] });
ContextSpecialItemsDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContextSpecialItemsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[specialItems]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class ContextMenuComponent {
    constructor() {
        this.placement = 'bottom-right';
        this.itemClicked = new EventEmitter();
        this.isOpened = false;
    }
}
ContextMenuComponent.ɵfac = function ContextMenuComponent_Factory(t) { return new (t || ContextMenuComponent)(); };
ContextMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ContextMenuComponent, selectors: [["lib-context-menu"]], contentQueries: function ContextMenuComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ContextButtonDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ContextSpecialItemsDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contextSpecialItemsTemplate = _t.first);
    } }, inputs: { placement: "placement", menuItems: "menuItems" }, outputs: { itemClicked: "itemClicked" }, decls: 7, vars: 7, consts: [["ngbDropdown", "", "container", "body", "display", "dynamic", 1, "dropdown", "context-menu", "default-size", 3, "placement", "openChange"], ["id", "navbarAditionDropdown", "ngbDropdownToggle", "", 1, "dropdown-button", "cursor-pointer"], [3, "ngTemplateOutlet", 4, "ngIf"], [1, "fa-icon", "chevron-icon", 3, "icon"], ["aria-labelledby", "navbarAditionDropdown", "ngbDropdownMenu", ""], ["class", "dropdown-item cursor-pointer", 3, "href", "routerLink", "click", 4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet"], [1, "dropdown-item", "cursor-pointer", 3, "href", "routerLink", "click"], ["class", "fa-icon", 3, "icon", 4, "ngIf"], [1, "item-text"], [1, "fa-icon", 3, "icon"]], template: function ContextMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("openChange", function ContextMenuComponent_Template_button_openChange_0_listener($event) { return ctx.isOpened = $event; });
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵtemplate(2, ContextMenuComponent_ng_container_2_Template, 1, 1, "ng-container", 2);
        ɵngcc0.ɵɵelement(3, "fa-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ContextMenuComponent_a_5_Template, 4, 4, "a", 5);
        ɵngcc0.ɵɵtemplate(6, ContextMenuComponent_ng_container_6_Template, 1, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("placement", ctx.placement);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("active", ctx.isOpened);
        ɵngcc0.ɵɵproperty("icon", ctx.isOpened ? "chevron-up" : "chevron-down");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menuItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contextSpecialItemsTemplate);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.NgbDropdown, ɵngcc5.NgbDropdownToggle, ɵngcc5.NgbDropdownMenu, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ɵngcc9.RouterLinkWithHref], styles: ["[_nghost-%COMP%]{margin-bottom:auto;margin-top:auto;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}[_nghost-%COMP%]   button[_ngcontent-%COMP%]{background:transparent;border:none;border-radius:4px;padding:0 2px!important}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:active, [_nghost-%COMP%]   button[_ngcontent-%COMP%]:focus, [_nghost-%COMP%]   button[_ngcontent-%COMP%]:hover{box-shadow:none!important;outline:none}[_nghost-%COMP%]   button[_ngcontent-%COMP%]:active     *, [_nghost-%COMP%]   button[_ngcontent-%COMP%]:focus     *, [_nghost-%COMP%]   button[_ngcontent-%COMP%]:hover     *{color:var(--da-brand-base)}.dropdown-button[_ngcontent-%COMP%]{align-items:center;display:flex;flex-wrap:nowrap}.dropdown-button[_ngcontent-%COMP%]   .chevron-icon[_ngcontent-%COMP%]{font-size:16px!important}.dropdown-button[_ngcontent-%COMP%]   .chevron-icon.active[_ngcontent-%COMP%]{color:var(--da-brand-base)}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.dropdown-item[_ngcontent-%COMP%]{align-items:center;display:flex;font-size:11px}.dropdown-item[_ngcontent-%COMP%]   .fa-icon[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center}.context-menu[_ngcontent-%COMP%]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.fa-icon[_ngcontent-%COMP%]:last-child{margin-right:0!important}"] });
ContextMenuComponent.propDecorators = {
    menuItems: [{ type: Input }],
    placement: [{ type: Input }],
    itemClicked: [{ type: Output }],
    buttonTemplate: [{ type: ContentChild, args: [ContextButtonDirective, { static: true },] }],
    contextSpecialItemsTemplate: [{ type: ContentChild, args: [ContextSpecialItemsDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContextMenuComponent, [{
        type: Component,
        args: [{ selector: 'lib-context-menu', template: "<button\n    class=\"dropdown context-menu default-size\"\n    ngbDropdown\n    container=\"body\"\n    [placement]=\"placement\"\n    display=\"dynamic\"\n    (openChange)=\"isOpened = $event\"\n>\n    <a\n        class=\"dropdown-button cursor-pointer\"\n        id=\"navbarAditionDropdown\"\n        ngbDropdownToggle\n    >\n        <ng-container\n            *ngIf=\"buttonTemplate\"\n            [ngTemplateOutlet]=\"buttonTemplate.template\"\n        ></ng-container>\n        <fa-icon\n            class=\"fa-icon chevron-icon\"\n            [class.active]=\"isOpened\"\n            [icon]=\"isOpened ? 'chevron-up' : 'chevron-down'\"\n        ></fa-icon>\n    </a>\n    <div aria-labelledby=\"navbarAditionDropdown\" ngbDropdownMenu>\n        <a\n            *ngFor=\"let menu of menuItems\"\n            [href]=\"menu.link ? menu.link : null\"\n            [routerLink]=\"menu.routerLink ? menu.routerLink : null\"\n            class=\"dropdown-item cursor-pointer\"\n            (click)=\"itemClicked.emit(menu)\"\n        >\n            <fa-icon\n                *ngIf=\"menu.icon\"\n                class=\"fa-icon\"\n                [icon]=\"menu.icon\"\n            ></fa-icon>\n            <div class=\"item-text\">\n                {{ menu.name }}\n            </div>\n        </a>\n        <ng-container\n            *ngIf=\"contextSpecialItemsTemplate\"\n            [ngTemplateOutlet]=\"contextSpecialItemsTemplate.template\"\n        >\n        </ng-container>\n    </div>\n</button>\n", styles: [":host{margin-bottom:auto;margin-top:auto;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}:host button{background:transparent;border:none;border-radius:4px;padding:0 2px!important}:host button:active,:host button:focus,:host button:hover{box-shadow:none!important;outline:none}:host button:active ::ng-deep *,:host button:focus ::ng-deep *,:host button:hover ::ng-deep *{color:var(--da-brand-base)}.dropdown-button{align-items:center;display:flex;flex-wrap:nowrap}.dropdown-button .chevron-icon{font-size:16px!important}.dropdown-button .chevron-icon.active{color:var(--da-brand-base)}.dropdown-toggle:after{content:none}.dropdown-item{align-items:center;display:flex;font-size:11px}.dropdown-item .fa-icon{align-items:center;display:flex;justify-content:center}.context-menu{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.fa-icon:last-child{margin-right:0!important}"] }]
    }], function () { return []; }, { placement: [{
            type: Input
        }], itemClicked: [{
            type: Output
        }], menuItems: [{
            type: Input
        }], buttonTemplate: [{
            type: ContentChild,
            args: [ContextButtonDirective, { static: true }]
        }], contextSpecialItemsTemplate: [{
            type: ContentChild,
            args: [ContextSpecialItemsDirective, { static: true }]
        }] }); })();

class ButtonWithLoaderComponent {
    constructor() {
        this.loading = false;
        this.loadingText = 'Loading...';
    }
}
ButtonWithLoaderComponent.ɵfac = function ButtonWithLoaderComponent_Factory(t) { return new (t || ButtonWithLoaderComponent)(); };
ButtonWithLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonWithLoaderComponent, selectors: [["button", "btnWithLoader", ""]], contentQueries: function ButtonWithLoaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.loaderTemplate = _t.first);
    } }, inputs: { loading: ["btnWithLoader", "loading"], loadingText: "loadingText" }, attrs: _c74, ngContentSelectors: _c3, decls: 2, vars: 1, consts: [[4, "ngIf"], [3, "ngIf", "ngIfElse", "ngTemplateOutlet"], ["defaultLoadingTemplate", ""], ["class", "spinner-border text-light mr-2", "role", "status", 4, "ngIf"], ["role", "status", 1, "spinner-border", "text-light", "mr-2"], [1, "sr-only"]], template: function ButtonWithLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, ButtonWithLoaderComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
        ɵngcc0.ɵɵprojection(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], styles: ["@-webkit-keyframes spinner-border{to{transform:rotate(1turn)}}@keyframes spinner-border{to{transform:rotate(1turn)}}.spinner-border[_ngcontent-%COMP%]{-webkit-animation:spinner-border .75s linear infinite;animation:spinner-border .75s linear infinite;border:.25em solid;border-radius:50%;border-right:.25em solid transparent;display:inline-block;height:1rem;vertical-align:text-bottom;width:1rem}@media (max-width:1920px){.spinner-border[_ngcontent-%COMP%]{height:.8rem;width:.8rem}}"] });
ButtonWithLoaderComponent.propDecorators = {
    loading: [{ type: Input, args: ['btnWithLoader',] }],
    loadingText: [{ type: Input }],
    loaderTemplate: [{ type: ContentChild, args: [TemplateRef,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonWithLoaderComponent, [{
        type: Component,
        args: [{ selector: 'button[btnWithLoader]', template: "<ng-container *ngIf=\"loading\">\n    <ng-template\n        [ngIf]=\"loaderTemplate\"\n        [ngIfElse]=\"defaultLoadingTemplate\"\n        [ngTemplateOutlet]=\"loaderTemplate\"\n    ></ng-template>\n\n    <ng-template #defaultLoadingTemplate>\n        <div\n            *ngIf=\"loading\"\n            class=\"spinner-border text-light mr-2\"\n            role=\"status\"\n        >\n            <span class=\"sr-only\">{{ loadingText }}</span>\n        </div>\n    </ng-template>\n</ng-container>\n\n<ng-content></ng-content>\n", styles: ["@-webkit-keyframes spinner-border{to{transform:rotate(1turn)}}@keyframes spinner-border{to{transform:rotate(1turn)}}.spinner-border{-webkit-animation:spinner-border .75s linear infinite;animation:spinner-border .75s linear infinite;border:.25em solid;border-radius:50%;border-right:.25em solid transparent;display:inline-block;height:1rem;vertical-align:text-bottom;width:1rem}@media (max-width:1920px){.spinner-border{height:.8rem;width:.8rem}}"] }]
    }], function () { return []; }, { loading: [{
            type: Input,
            args: ['btnWithLoader']
        }], loadingText: [{
            type: Input
        }], loaderTemplate: [{
            type: ContentChild,
            args: [TemplateRef]
        }] }); })();

class NavItemDirective {
    constructor(template) {
        this.template = template;
        this.props = {};
    }
}
NavItemDirective.ɵfac = function NavItemDirective_Factory(t) { return new (t || NavItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
NavItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NavItemDirective, selectors: [["ng-template", "navItem", ""]], inputs: { navItemName: "navItemName", navItemId: "navItemId", navItemLink: "navItemLink", navItemHeaderTemplate: "navItemHeaderTemplate", navItemContextMenuItems: "navItemContextMenuItems" } });
NavItemDirective.ctorParameters = () => [
    { type: TemplateRef }
];
NavItemDirective.propDecorators = {
    navItemName: [{ type: Input }],
    navItemId: [{ type: Input }],
    navItemLink: [{ type: Input }],
    navItemHeaderTemplate: [{ type: Input }],
    navItemContextMenuItems: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavItemDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[navItem]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { navItemName: [{
            type: Input
        }], navItemId: [{
            type: Input
        }], navItemLink: [{
            type: Input
        }], navItemHeaderTemplate: [{
            type: Input
        }], navItemContextMenuItems: [{
            type: Input
        }] }); })();

class NavComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.hiddenItems = [];
        this.tabSetWidth = 0;
        this.level = 1;
        this.defaultTabSetPadding = false;
        this.useHorizontalScroll = false;
        this.navChange = new EventEmitter();
        this.navItemClick = new EventEmitter();
    }
    onResize() {
        if (this.useHorizontalScroll) {
            return;
        }
        let tabsWidth = 0;
        const items = this.navItems.toArray();
        this.resetItems();
        this.tabSetWidth =
            this.tabSetElementRef.nativeElement.offsetWidth -
                (this.level === 1 && !this.defaultTabSetPadding ? 80 : 30);
        this.tabSet.links.forEach((link, i) => {
            tabsWidth +=
                link.elRef.nativeElement.offsetWidth +
                    (this.level < 2 ? 30 : 0);
            if (tabsWidth > this.tabSetWidth) {
                items[i].hidden = true;
                this.hiddenItems.push({
                    id: link.navItem.id,
                    name: items[i].navItemName,
                    routerLink: items[i].navItemLink
                });
            }
        });
        this.cdr.detectChanges();
    }
    ngAfterViewChecked() {
        if (this.tabSetWidth < 1) {
            this.onResize();
        }
    }
    resetItems() {
        this.hiddenItems = [];
        this.navItems.forEach(item => (item.hidden = false));
        this.cdr.detectChanges();
    }
    selectById(id) {
        this.tabSet.select(id);
    }
    onNavChange(e) {
        this.navChange.emit(e);
    }
    onNavItemClick(item) {
        this.navItemClick.emit(item);
    }
}
NavComponent.ɵfac = function NavComponent_Factory(t) { return new (t || NavComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NavComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavComponent, selectors: [["lib-nav"]], contentQueries: function NavComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c75, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NavItemDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabHeaderTmpl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.navItems = _t);
    } }, viewQuery: function NavComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbNav, 5);
        ɵngcc0.ɵɵviewQuery(_c76, 5);
        ɵngcc0.ɵɵviewQuery(_c61, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabSet = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabSetElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, hostBindings: function NavComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function NavComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { level: "level", defaultTabSetPadding: "defaultTabSetPadding", useHorizontalScroll: "useHorizontalScroll", activeId: "activeId", destroyOnHide: "destroyOnHide" }, outputs: { navChange: "navChange", navItemClick: "navItemClick" }, ngContentSelectors: _c3, decls: 9, vars: 9, consts: [["tabSet", ""], ["ngbNav", "", "libScroller", "", 1, "nav", "nav-tabs", "justify-content-start", 3, "lisScrollerDisabled", "activeId", "destroyOnHide", "navChange"], ["horizontalNav", "ngbNav"], [3, "ngbNavItem", 4, "ngFor", "ngForOf"], [1, "context-menu", 3, "hidden"], ["specialItems", ""], [3, "ngbNavOutlet"], [3, "ngbNavItem"], [4, "ngIf"], ["ngbNavLink", "", 4, "ngIf"], ["ngbNavContent", ""], ["tabTitleTmpl", ""], ["ngbNavLink", "", 3, "click", 4, "ngIf"], ["ngbNavLink", "", "routerLinkActive", "", 3, "routerLink", "active", "click", 4, "ngIf"], ["class", "context-menu mr-30px", 3, "placement", "menuItems", "itemClicked", "click", 4, "ngIf"], ["ngbNavLink", "", 3, "click"], [3, "ngTemplateOutlet"], ["ngbNavLink", "", "routerLinkActive", "", 3, "routerLink", "click"], ["rla", "routerLinkActive"], [1, "context-menu", "mr-30px", 3, "placement", "menuItems", "itemClicked", "click"], ["buttonTemplate", ""], [1, "nav-tem", "nav-link", "mr-0"], ["ngbNavLink", ""], [4, "ngTemplateOutlet"], [4, "ngIf", "ngIfElse"], ["defaultHeaderTmpl", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "dropdown-item cursor-pointer font-12px", 3, "routerLink", "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", "cursor-pointer", "font-12px", 3, "routerLink", "click"]], template: function NavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0)(2, "nav", 1, 2);
        ɵngcc0.ɵɵlistener("navChange", function NavComponent_Template_nav_navChange_2_listener($event) { return ctx.onNavChange($event); });
        ɵngcc0.ɵɵtemplate(4, NavComponent_ng_container_4_Template, 6, 3, "ng-container", 3);
        ɵngcc0.ɵɵelementStart(5, "lib-context-menu", 4);
        ɵngcc0.ɵɵtemplate(6, NavComponent_ng_template_6_Template, 1, 1, "ng-template", 5);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(7, "div", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵclassMapInterpolate1("nav-tab-set blue-tab level-", ctx.level, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("lisScrollerDisabled", !ctx.useHorizontalScroll)("activeId", ctx.activeId)("destroyOnHide", ctx.destroyOnHide === undefined ? true : ctx.destroyOnHide);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.navItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.hiddenItems.length);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngbNavOutlet", _r1);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc5.NgbNavContent, ɵngcc5.NgbNav, ɵngcc5.NgbNavItem, ɵngcc5.NgbNavLink, ɵngcc5.NgbNavOutlet, ɵngcc9.RouterLink, ɵngcc9.RouterLinkWithHref, ɵngcc9.RouterLinkActive, ScrollerComponent, ContextMenuComponent, ContextButtonDirective, ContextSpecialItemsDirective], styles: [".nav-tab-set[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{border-bottom:1px solid var(--da-border-and-dividers);font-size:14px;padding:15px 0}.nav-tab-set[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:last-child{margin-right:0}.nav-tab-set[_ngcontent-%COMP%]   .tab-content[_ngcontent-%COMP%]{padding:24px}.nav-tab-set[_ngcontent-%COMP%]   .more-menu[_ngcontent-%COMP%]{font-size:16px;line-height:45px}.nav-tab-set.level-0.blue-tab[_ngcontent-%COMP%]{background:var(--da-background)}.nav-tab-set.level-0[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]{box-shadow:0 4px 8px -4px rgba(15,38,68,.16);padding:0 24px}.nav-tab-set.level-0[_ngcontent-%COMP%]   .tab-content[_ngcontent-%COMP%]{background:transparent}[_nghost-%COMP%]  .nav-tab-set.level-0 .tab-pane{background-color:var(--da-cards-and-blocks);border-radius:4px;box-shadow:0 4px 8px rgba(15,38,68,.16);padding:24px}[_nghost-%COMP%]  .nav-tab-set.level-1 .tab-pane, [_nghost-%COMP%]  .nav-tab-set.level-2 .tab-pane{box-shadow:none}.nav-tab-set.level-1[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]{box-shadow:none;padding:0 24px}.nav-tab-set.level-1[_ngcontent-%COMP%]   .tab-content[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks)}.nav-tab-set.level-2[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]{border-bottom:none;box-shadow:none;padding:0}.nav-tab-set.level-2[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background-color:var(--da-background);border:1px solid var(--da-border-and-dividers);border-left:none;border-radius:4px 4px 0 0;color:var(--da-secondary-text-and-icons);margin-right:0;padding:10px 16px}.nav-tab-set.level-2[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks);border-bottom:1px solid var(--da-border-and-dividers)!important;color:var(--da-brand-base)}.nav-tab-set.level-2[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:focus{border-color:var(--da-border-and-dividers)!important}.nav-tab-set.level-2[_ngcontent-%COMP%]   .nav-tabs[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]:first-child{border-left:1px solid var(--da-border-and-dividers)}.nav-tab-set.level-2[_ngcontent-%COMP%]   .tab-content[_ngcontent-%COMP%]{background-color:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:0 4px 4px 4px}.nav-tab-set.level-2[_ngcontent-%COMP%]   .more-menu[_ngcontent-%COMP%]{margin-left:30px}[_nghost-%COMP%]     .nav-tab-set .context-menu .chevron-icon{margin-left:10px;margin-right:0}[_nghost-%COMP%]   .context-menu[_ngcontent-%COMP%]     button{padding:0!important}[_nghost-%COMP%]   .context-menu[_ngcontent-%COMP%]     button .nav-link{border:none}"] });
NavComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
NavComponent.propDecorators = {
    level: [{ type: Input }],
    activeId: [{ type: Input }],
    destroyOnHide: [{ type: Input }],
    defaultTabSetPadding: [{ type: Input }],
    useHorizontalScroll: [{ type: Input }],
    navChange: [{ type: Output }],
    navItemClick: [{ type: Output }],
    tabSet: [{ type: ViewChild, args: [NgbNav,] }],
    tabSetElementRef: [{ type: ViewChild, args: ['tabSet', { static: false },] }],
    container: [{ type: ViewChild, args: ['container', { read: ElementRef },] }],
    navItems: [{ type: ContentChildren, args: [NavItemDirective,] }],
    tabHeaderTmpl: [{ type: ContentChild, args: ['tabHeaderTmpl',] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavComponent, [{
        type: Component,
        args: [{ selector: 'lib-nav', template: "<div #tabSet class=\"nav-tab-set blue-tab level-{{ level }}\">\n    <nav\n        #horizontalNav=\"ngbNav\"\n        ngbNav\n        libScroller\n        [lisScrollerDisabled]=\"!useHorizontalScroll\"\n        class=\"nav nav-tabs justify-content-start\"\n        [activeId]=\"activeId\"\n        [destroyOnHide]=\"destroyOnHide === undefined ? true : destroyOnHide\"\n        (navChange)=\"onNavChange($event)\"\n    >\n        <ng-container\n            *ngFor=\"let navItem of navItems\"\n            [ngbNavItem]=\"navItem.navItemId\"\n        >\n            <ng-container\n                *ngIf=\"!navItem.hidden && !navItem.navItemHeaderTemplate\"\n            >\n                <a\n                    *ngIf=\"\n                        !navItem.navItemLink && !navItem.navItemContextMenuItems\n                    \"\n                    ngbNavLink\n                    (click)=\"onNavItemClick(navItem)\"\n                >\n                    <ng-template\n                        [ngTemplateOutlet]=\"tabTitleTmpl\"\n                    ></ng-template>\n                </a>\n\n                <a\n                    *ngIf=\"navItem.navItemLink\"\n                    ngbNavLink\n                    routerLinkActive\n                    #rla=\"routerLinkActive\"\n                    [routerLink]=\"navItem.navItemLink\"\n                    [class.active]=\"rla.isActive\"\n                    (click)=\"onNavItemClick(navItem)\"\n                >\n                    <ng-template\n                        [ngTemplateOutlet]=\"tabTitleTmpl\"\n                    ></ng-template>\n                </a>\n\n                <lib-context-menu\n                    *ngIf=\"\n                        !navItem.navItemLink && navItem.navItemContextMenuItems\n                    \"\n                    class=\"context-menu mr-30px\"\n                    [placement]=\"'bottom-left'\"\n                    [menuItems]=\"navItem.navItemContextMenuItems\"\n                    (itemClicked)=\"onNavItemClick($event)\"\n                    (click)=\"onNavItemClick(navItem)\"\n                >\n                    <ng-template buttonTemplate>\n                        <span class=\"nav-tem nav-link mr-0\">\n                            {{ navItem.navItemName }}\n                        </span>\n                    </ng-template>\n                </lib-context-menu>\n            </ng-container>\n\n            <a *ngIf=\"navItem.navItemHeaderTemplate\" ngbNavLink>\n                <ng-container\n                    *ngTemplateOutlet=\"navItem.navItemHeaderTemplate\"\n                ></ng-container>\n            </a>\n            <ng-template ngbNavContent>\n                <ng-container\n                    *ngTemplateOutlet=\"navItem.template\"\n                ></ng-container>\n            </ng-template>\n            <ng-template #tabTitleTmpl>\n                <ng-container *ngIf=\"tabHeaderTmpl; else defaultHeaderTmpl\">\n                    <ng-template\n                        [ngTemplateOutlet]=\"tabHeaderTmpl\"\n                        [ngTemplateOutletContext]=\"{ $implicit: navItem }\"\n                    ></ng-template>\n                </ng-container>\n                <ng-template #defaultHeaderTmpl>{{\n                    navItem.navItemName\n                }}</ng-template>\n            </ng-template>\n        </ng-container>\n        <lib-context-menu class=\"context-menu\" [hidden]=\"!hiddenItems.length\">\n            <ng-template specialItems>\n                <span\n                    *ngFor=\"let item of hiddenItems\"\n                    class=\"dropdown-item cursor-pointer font-12px\"\n                    [routerLink]=\"item.routerLink\"\n                    (click)=\"selectById(item.id)\"\n                >\n                    {{ item.name }}\n                </span>\n            </ng-template>\n        </lib-context-menu>\n    </nav>\n    <div [ngbNavOutlet]=\"horizontalNav\"></div>\n    <ng-content></ng-content>\n</div>\n", styles: [".nav-tab-set .nav-link{border-bottom:1px solid var(--da-border-and-dividers);font-size:14px;padding:15px 0}.nav-tab-set .nav-link:last-child{margin-right:0}.nav-tab-set .tab-content{padding:24px}.nav-tab-set .more-menu{font-size:16px;line-height:45px}.nav-tab-set.level-0.blue-tab{background:var(--da-background)}.nav-tab-set.level-0 .nav-tabs{box-shadow:0 4px 8px -4px rgba(15,38,68,.16);padding:0 24px}.nav-tab-set.level-0 .tab-content{background:transparent}:host::ng-deep .nav-tab-set.level-0 .tab-pane{background-color:var(--da-cards-and-blocks);border-radius:4px;box-shadow:0 4px 8px rgba(15,38,68,.16);padding:24px}:host::ng-deep .nav-tab-set.level-1 .tab-pane,:host::ng-deep .nav-tab-set.level-2 .tab-pane{box-shadow:none}.nav-tab-set.level-1 .nav-tabs{box-shadow:none;padding:0 24px}.nav-tab-set.level-1 .tab-content{background-color:var(--da-cards-and-blocks)}.nav-tab-set.level-2 .nav-tabs{border-bottom:none;box-shadow:none;padding:0}.nav-tab-set.level-2 .nav-tabs .nav-link{background-color:var(--da-background);border:1px solid var(--da-border-and-dividers);border-left:none;border-radius:4px 4px 0 0;color:var(--da-secondary-text-and-icons);margin-right:0;padding:10px 16px}.nav-tab-set.level-2 .nav-tabs .nav-link.active{background-color:var(--da-cards-and-blocks);border-bottom:1px solid var(--da-border-and-dividers)!important;color:var(--da-brand-base)}.nav-tab-set.level-2 .nav-tabs .nav-link:focus{border-color:var(--da-border-and-dividers)!important}.nav-tab-set.level-2 .nav-tabs .nav-link:first-child{border-left:1px solid var(--da-border-and-dividers)}.nav-tab-set.level-2 .tab-content{background-color:var(--da-cards-and-blocks);border:1px solid var(--da-border-and-dividers);border-radius:0 4px 4px 4px}.nav-tab-set.level-2 .more-menu{margin-left:30px}:host ::ng-deep .nav-tab-set .context-menu .chevron-icon{margin-left:10px;margin-right:0}:host .context-menu ::ng-deep button{padding:0!important}:host .context-menu ::ng-deep button .nav-link{border:none}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { level: [{
            type: Input
        }], defaultTabSetPadding: [{
            type: Input
        }], useHorizontalScroll: [{
            type: Input
        }], navChange: [{
            type: Output
        }], navItemClick: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], activeId: [{
            type: Input
        }], destroyOnHide: [{
            type: Input
        }], tabSet: [{
            type: ViewChild,
            args: [NgbNav]
        }], tabSetElementRef: [{
            type: ViewChild,
            args: ['tabSet', { static: false }]
        }], container: [{
            type: ViewChild,
            args: ['container', { read: ElementRef }]
        }], navItems: [{
            type: ContentChildren,
            args: [NavItemDirective]
        }], tabHeaderTmpl: [{
            type: ContentChild,
            args: ['tabHeaderTmpl']
        }] }); })();

class LetDirective {
    constructor(viewContainer, templateRef) {
        viewContainer.createEmbeddedView(templateRef, new LetDirectiveContext(this));
    }
    static ngTemplateContextGuard(dir, ctx) {
        return true;
    }
}
LetDirective.ɵfac = function LetDirective_Factory(t) { return new (t || LetDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
LetDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LetDirective, selectors: [["", "libLet", ""]], inputs: { context: ["libLet", "context"] } });
LetDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef }
];
LetDirective.propDecorators = {
    context: [{ type: Input, args: ['libLet',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LetDirective, [{
        type: Directive,
        args: [{
                selector: '[libLet]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }]; }, { context: [{
            type: Input,
            args: ['libLet']
        }] }); })();
class LetDirectiveContext {
    constructor(dir) {
        this.dir = dir;
    }
    get $implicit() {
        return this.dir.context;
    }
    get libLet() {
        return this.dir.context;
    }
}

var Direction;
(function (Direction) {
    Direction["UP"] = "up";
    Direction["DOWN"] = "down";
    Direction["NONE"] = "none";
})(Direction || (Direction = {}));
class StopScrollPropagationDirective {
    constructor(elementRef, zone) {
        this.handleEvent = (event) => {
            if (!this.isTrappingEvent(event)) {
                return;
            }
            event.stopPropagation();
            if (this.eventShouldBePrevented(event)) {
                event.preventDefault();
            }
        };
        this.element = elementRef.nativeElement;
        this.zone = zone;
    }
    static getDirectionFromKeyboardEvent(event) {
        switch (event.key) {
            case ' ':
                return event.shiftKey ? Direction.UP : Direction.DOWN;
            case 'ArrowUp':
            case 'Home':
            case 'PageUp':
                return Direction.UP;
            case 'ArrowDown':
            case 'End':
            case 'PageDown':
                return Direction.DOWN;
            default:
                return Direction.NONE;
        }
    }
    static getDirectionFromWheelEvent(event) {
        const delta = event.deltaY || event.detail;
        return delta <= 0 ? Direction.UP : Direction.DOWN;
    }
    static getDirectionFromEvent(event) {
        if (event instanceof WheelEvent) {
            return StopScrollPropagationDirective.getDirectionFromWheelEvent(event);
        }
        else {
            return StopScrollPropagationDirective.getDirectionFromKeyboardEvent(event);
        }
    }
    static isFormElement(element) {
        return (element.tagName === 'TEXTAREA' ||
            element.tagName === 'INPUT' ||
            element.tagName === 'SELECT');
    }
    static isScrollableElement(element) {
        if (getComputedStyle(element).overflowY === 'hidden') {
            return false;
        }
        return element.scrollHeight !== element.clientHeight;
    }
    static isScrolledToTheBottom(element) {
        return element.clientHeight + element.scrollTop >= element.scrollHeight;
    }
    static isScrolledToTheTop(element) {
        return !element.scrollTop;
    }
    static isScrolledInMaxDirection(element, direction) {
        return ((direction === Direction.UP &&
            StopScrollPropagationDirective.isScrolledToTheTop(element)) ||
            (direction === Direction.DOWN &&
                StopScrollPropagationDirective.isScrolledToTheBottom(element)));
    }
    static normalizeInputAsBoolean(value) {
        return value === '' || !!value;
    }
    ngOnChanges(changes) {
        this.stopScrollPropagation = StopScrollPropagationDirective.normalizeInputAsBoolean(this.stopScrollPropagation);
        this.stopKeyScroll = StopScrollPropagationDirective.normalizeInputAsBoolean(this.stopKeyScroll);
        if ('stopKeyScroll' in changes) {
            if (this.stopKeyScroll) {
                this.element.tabIndex = -1; // Focus without tab-based navigation.
            }
            else {
                this.element.removeAttribute('tabIndex');
            }
        }
    }
    ngOnInit() {
        this.zone.runOutsideAngular(() => {
            this.element.addEventListener('wheel', this.handleEvent, false);
            this.element.addEventListener('keydown', this.handleEvent, false);
        });
    }
    eventShouldBePrevented(event) {
        let target = event.target;
        const direction = StopScrollPropagationDirective.getDirectionFromEvent(event);
        while (target !== this.element) {
            if (StopScrollPropagationDirective.isScrollableElement(target) &&
                !StopScrollPropagationDirective.isScrolledInMaxDirection(target, direction)) {
                return false;
            }
            target = target.parentNode;
        }
        return StopScrollPropagationDirective.isScrolledInMaxDirection(target, direction);
    }
    isTrappingEvent(event) {
        if (!this.stopScrollPropagation) {
            return false;
        }
        if (event instanceof KeyboardEvent) {
            if (!this.stopKeyScroll) {
                return false;
            }
            const target = event.target;
            if (event instanceof KeyboardEvent &&
                StopScrollPropagationDirective.isFormElement(target)) {
                return false;
            }
            if (StopScrollPropagationDirective.getDirectionFromKeyboardEvent(event) ===
                Direction.NONE) {
                return false;
            }
        }
        return true;
    }
    ngOnDestroy() {
        this.element.removeEventListener('wheel', this.handleEvent, false);
        this.element.removeEventListener('keydown', this.handleEvent, false);
    }
}
StopScrollPropagationDirective.ɵfac = function StopScrollPropagationDirective_Factory(t) { return new (t || StopScrollPropagationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
StopScrollPropagationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StopScrollPropagationDirective, selectors: [["", "stopScrollPropagation", ""]], inputs: { stopScrollPropagation: "stopScrollPropagation", stopKeyScroll: "stopKeyScroll" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
StopScrollPropagationDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StopScrollPropagationDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[stopScrollPropagation]',
                inputs: ['stopScrollPropagation', 'stopKeyScroll']
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();

class ToastrFooterTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ToastrFooterTemplateDirective.ɵfac = function ToastrFooterTemplateDirective_Factory(t) { return new (t || ToastrFooterTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ToastrFooterTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ToastrFooterTemplateDirective, selectors: [["ng-template", "footerTemplate", ""]] });
ToastrFooterTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrFooterTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[footerTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class ToastrBodyTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
ToastrBodyTemplateDirective.ɵfac = function ToastrBodyTemplateDirective_Factory(t) { return new (t || ToastrBodyTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ToastrBodyTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ToastrBodyTemplateDirective, selectors: [["ng-template", "bodyTemplate", ""]] });
ToastrBodyTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrBodyTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[bodyTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class ToastrComponent {
    constructor() {
        this.closeButtonText = 'Close';
        this.showIcon = true;
        this.closeButton = true;
    }
    get class() {
        return 'toastr-' + this.toastType;
    }
    get messageIcon() {
        return this.getTypeOrIcon(true);
    }
    get toastType() {
        return this.getTypeOrIcon();
    }
    get isNotification() {
        return this.getTypeOrIcon() === 'notification';
    }
    onClose() {
        this.onCloseFunction.call(this);
    }
    getMessage() {
        try {
            return JSON.parse(this.message).message;
        }
        catch (e) {
            return this.message;
        }
    }
    getTypeOrIcon(getIcon) {
        if (!this.toastrType) {
            return;
        }
        switch (true) {
            case this.toastrType.toLowerCase().includes('error'):
                return getIcon ? 'facExclamationCircle' : 'error';
            case this.toastrType.toLowerCase().includes('info'):
                return getIcon ? 'facExclamationCircle' : 'info';
            case this.toastrType.toLowerCase().includes('success'):
                return getIcon ? 'check' : 'success';
            case this.toastrType.toLowerCase().includes('warning'):
                return getIcon ? 'exclamationTriangle' : 'warning';
            case this.toastrType.toLowerCase().includes('notification'):
                return getIcon ? 'facExclamationCircle' : 'notification';
        }
    }
}
ToastrComponent.ɵfac = function ToastrComponent_Factory(t) { return new (t || ToastrComponent)(); };
ToastrComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToastrComponent, selectors: [["lib-toastr"]], contentQueries: function ToastrComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ToastrFooterTemplateDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, ToastrBodyTemplateDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bodyTemplate = _t.first);
    } }, hostAttrs: [1, "toastr", "m-0"], hostVars: 2, hostBindings: function ToastrComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { closeButtonText: "closeButtonText", showIcon: "showIcon", closeButton: "closeButton", toastrType: "toastrType", message: "message", title: "title", htmlBodyContent: "htmlBodyContent", addDefaultFooter: "addDefaultFooter", onCloseFunction: "onCloseFunction" }, decls: 14, vars: 5, consts: [["class", "close toastr-close-button", "aria-label", "Close", "tabindex", "-1", 3, "click", 4, "ngIf"], ["class", "toastr-icon", 3, "ngClass", 4, "ngIf"], [1, "toastr-content"], ["class", "toastr-title", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet"], ["htmlBody", ""], ["defaultBody", ""], ["customFooter", ""], ["defaultFooter", ""], ["aria-label", "Close", "tabindex", "-1", 1, "close", "toastr-close-button", 3, "click"], ["aria-hidden", "true"], [1, "toastr-icon", 3, "ngClass"], [3, "icon"], [1, "toastr-title", 3, "ngClass"], ["aria-live", "polite", 1, "toastr-message", 3, "innerHTML"], ["aria-live", "polite", 1, "toastr-message"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "float-right"], ["type", "button", 1, "btn", "btn-link", "size-s", 3, "click"]], template: function ToastrComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ToastrComponent_button_0_Template, 3, 0, "button", 0);
        ɵngcc0.ɵɵtemplate(1, ToastrComponent_div_1_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ToastrComponent_div_3_Template, 2, 5, "div", 3);
        ɵngcc0.ɵɵtemplate(4, ToastrComponent_ng_container_4_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵelementContainer(5, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, ToastrComponent_ng_template_6_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, ToastrComponent_ng_template_8_Template, 3, 3, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, ToastrComponent_ng_template_10_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, ToastrComponent_ng_template_12_Template, 3, 1, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r8 = ɵngcc0.ɵɵreference(11);
        const _r10 = ɵngcc0.ɵɵreference(13);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closeButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showIcon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.addDefaultFooter ? _r10 : _r8);
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: [".toast-container{pointer-events:all}.toastr{background-color:var(--da-cards-and-blocks);border-radius:3px 3px 3px 3px;box-shadow:var(--da-card-hover-box-shadow);color:var(--da-primary-text);display:flex!important;margin:0 0 6px;min-height:78px;overflow:hidden;position:relative;width:400px}.toastr-icon{align-items:center;display:flex;font-family:FontAwesome,sans-serif;font-size:24px;justify-content:center;min-height:78px;width:78px}.toastr-icon-error{background-color:rgba(251,78,78,.12)}.toastr-icon-success{background-color:rgba(46,204,113,.12)}.toastr-icon-info,.toastr-icon-notification{background-color:rgba(50,125,226,.12)}.toastr-icon-warning{background-color:rgba(255,188,31,.12)}.toastr-content{flex:1;height:100%;max-width:322px;min-height:78px;padding:16px 32px 16px 16px;word-wrap:break-word}.toastr-close-button{background:transparent;border:0;color:var(--da-secondary-text);cursor:pointer;display:block;font-size:30px;font-weight:300;line-height:12px;padding:0;position:absolute;right:13px;top:18px}.toastr-title{font-size:14px;margin-bottom:4px}.toastr-title-notification{color:var(--da-title)!important}.toastr-message{font-size:12px}.toastr-info .toastr-icon,.toastr-info .toastr-title,.toastr-notification .toastr-icon,.toastr-notification .toastr-title{color:var(--da-brand-base)}.toastr-info .toast-icon svg,.toastr-notification .toast-icon svg{transform:rotate(180deg)}.toastr-success .toastr-icon,.toastr-success .toastr-title{color:var(--da-success-base)}.toastr-warning .toastr-icon,.toastr-warning .toastr-title{color:var(--da-warning-base)}.toastr-error .toastr-icon,.toastr-error .toastr-title{color:var(--da-error-base)}@media (max-width:560px){.toastr{width:290px}}"], encapsulation: 2, data: { animation: [
            trigger('flyInOut', [
                state('inactive', style({
                    display: 'none',
                    opacity: 0
                })),
                state('active', style({})),
                state('removed', style({ opacity: 0 })),
                transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
                transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
            ])
        ] } });
ToastrComponent.propDecorators = {
    toastrType: [{ type: Input }],
    message: [{ type: Input }],
    title: [{ type: Input }],
    closeButtonText: [{ type: Input }],
    showIcon: [{ type: Input }],
    htmlBodyContent: [{ type: Input }],
    addDefaultFooter: [{ type: Input }],
    closeButton: [{ type: Input }],
    onCloseFunction: [{ type: Input }],
    footerTemplate: [{ type: ContentChild, args: [ToastrFooterTemplateDirective, { static: true },] }],
    bodyTemplate: [{ type: ContentChild, args: [ToastrBodyTemplateDirective, { static: true },] }],
    class: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrComponent, [{
        type: Component,
        args: [{ selector: 'lib-toastr', template: "<button *ngIf=\"closeButton\" (click)=\"onClose()\" class=\"close toastr-close-button\" aria-label=\"Close\"\n        tabindex=\"-1\">\n    <span aria-hidden=\"true\">&times;</span>\n</button>\n<div *ngIf=\"showIcon\" class=\"toastr-icon\" [ngClass]=\"'toastr-icon-' + toastType\">\n    <fa-icon icon=\"{{messageIcon}}\"></fa-icon>\n</div>\n<div class=\"toastr-content\">\n    <div *ngIf=\"title\" class=\"toastr-title\" [ngClass]=\"{'toastr-title-notification': isNotification}\" [attr.aria-label]=\"title\">\n        {{ title }}\n    </div>\n\n    <ng-container *ngIf=\"message\">\n        <ng-container [ngTemplateOutlet]=\"htmlBodyContent ? htmlBody : defaultBody\"></ng-container>\n    </ng-container>\n\n    <ng-container [ngTemplateOutlet]=\"addDefaultFooter ? defaultFooter : customFooter\"></ng-container>\n</div>\n\n<ng-template #htmlBody>\n    <div aria-live=\"polite\"\n         class=\"toastr-message\"\n         [innerHTML]=\"getMessage()\"\n    ></div>\n</ng-template>\n\n<ng-template #defaultBody>\n    <div aria-live=\"polite\"\n         class=\"toastr-message\"\n         [attr.aria-label]=\"message\"\n    >\n        {{getMessage()}}\n        <ng-container *ngIf=\"bodyTemplate\"\n                      [ngTemplateOutlet]=\"bodyTemplate.template\"\n                      [ngTemplateOutletContext]=\"{$implicit: message}\"\n        ></ng-container>\n    </div>\n</ng-template>\n\n<ng-template #customFooter>\n    <ng-container *ngIf=\"footerTemplate\"\n                  [ngTemplateOutlet]=\"footerTemplate.template\"\n                  [ngTemplateOutletContext]=\"{$implicit: message}\"\n    ></ng-container>\n</ng-template>\n\n<ng-template #defaultFooter>\n    <div class=\"float-right\">\n        <button type=\"button\" class=\"btn btn-link size-s\" (click)=\"onClose()\">{{ closeButtonText }}</button>\n    </div>\n</ng-template>\n", animations: [
                    trigger('flyInOut', [
                        state('inactive', style({
                            display: 'none',
                            opacity: 0
                        })),
                        state('active', style({})),
                        state('removed', style({ opacity: 0 })),
                        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
                        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
                    ])
                ], host: {
                    class: 'toastr m-0'
                }, encapsulation: ViewEncapsulation.None, styles: [".toast-container{pointer-events:all}.toastr{background-color:var(--da-cards-and-blocks);border-radius:3px 3px 3px 3px;box-shadow:var(--da-card-hover-box-shadow);color:var(--da-primary-text);display:flex!important;margin:0 0 6px;min-height:78px;overflow:hidden;position:relative;width:400px}.toastr-icon{align-items:center;display:flex;font-family:FontAwesome,sans-serif;font-size:24px;justify-content:center;min-height:78px;width:78px}.toastr-icon-error{background-color:rgba(251,78,78,.12)}.toastr-icon-success{background-color:rgba(46,204,113,.12)}.toastr-icon-info,.toastr-icon-notification{background-color:rgba(50,125,226,.12)}.toastr-icon-warning{background-color:rgba(255,188,31,.12)}.toastr-content{flex:1;height:100%;max-width:322px;min-height:78px;padding:16px 32px 16px 16px;word-wrap:break-word}.toastr-close-button{background:transparent;border:0;color:var(--da-secondary-text);cursor:pointer;display:block;font-size:30px;font-weight:300;line-height:12px;padding:0;position:absolute;right:13px;top:18px}.toastr-title{font-size:14px;margin-bottom:4px}.toastr-title-notification{color:var(--da-title)!important}.toastr-message{font-size:12px}.toastr-info .toastr-icon,.toastr-info .toastr-title,.toastr-notification .toastr-icon,.toastr-notification .toastr-title{color:var(--da-brand-base)}.toastr-info .toast-icon svg,.toastr-notification .toast-icon svg{transform:rotate(180deg)}.toastr-success .toastr-icon,.toastr-success .toastr-title{color:var(--da-success-base)}.toastr-warning .toastr-icon,.toastr-warning .toastr-title{color:var(--da-warning-base)}.toastr-error .toastr-icon,.toastr-error .toastr-title{color:var(--da-error-base)}@media (max-width:560px){.toastr{width:290px}}"] }]
    }], function () { return []; }, { closeButtonText: [{
            type: Input
        }], showIcon: [{
            type: Input
        }], closeButton: [{
            type: Input
        }], class: [{
            type: HostBinding,
            args: ['class']
        }], toastrType: [{
            type: Input
        }], message: [{
            type: Input
        }], title: [{
            type: Input
        }], htmlBodyContent: [{
            type: Input
        }], addDefaultFooter: [{
            type: Input
        }], onCloseFunction: [{
            type: Input
        }], footerTemplate: [{
            type: ContentChild,
            args: [ToastrFooterTemplateDirective, { static: true }]
        }], bodyTemplate: [{
            type: ContentChild,
            args: [ToastrBodyTemplateDirective, { static: true }]
        }] }); })();

class CardExpandedTemplateDirective {
    constructor(template) {
        this.template = template;
        this.isShown = true;
    }
}
CardExpandedTemplateDirective.ɵfac = function CardExpandedTemplateDirective_Factory(t) { return new (t || CardExpandedTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
CardExpandedTemplateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CardExpandedTemplateDirective, selectors: [["ng-template", "cardExpandedTemplate", ""]], inputs: { isShown: "isShown", expandedLabel: "expandedLabel" } });
CardExpandedTemplateDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardExpandedTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'ng-template[cardExpandedTemplate]',
                inputs: ['isShown', 'expandedLabel']
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

class CardWithStatusComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.statusMapper = {};
        this.expanded = false;
    }
    get statusValue() {
        const status = this.status.value.toLowerCase();
        if (status === 'default') {
            return 'default';
        }
        return this.statusMapper[this.status.value.toLowerCase()];
    }
}
CardWithStatusComponent.ɵfac = function CardWithStatusComponent_Factory(t) { return new (t || CardWithStatusComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CardWithStatusComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CardWithStatusComponent, selectors: [["lib-card-with-status"]], contentQueries: function CardWithStatusComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CardExpandedTemplateDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cardExpandedTemplate = _t.first);
    } }, inputs: { statusMapper: "statusMapper", status: "status" }, ngContentSelectors: _c3, decls: 8, vars: 11, consts: [[1, "card-wrapper", "flex-1"], ["class", "mr-2 status-icon", 3, "icon", 4, "ngIf"], [1, "d-flex", "justify-content-between"], [4, "ngIf"], [1, "mr-2", "status-icon", 3, "icon"], [1, "divider", "mt-4"], [1, "expand-collapse", 3, "click"], ["icon", "open", 1, "expand-collapse--icon", "mr-1"], [3, "ngTemplateOutlet"]], template: function CardWithStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0)(2, "div");
        ɵngcc0.ɵɵtemplate(3, CardWithStatusComponent_fa_icon_3_Template, 1, 1, "fa-icon", 1);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, CardWithStatusComponent_ng_container_7_Template, 7, 7, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("status-dot status-dot--", ctx.statusValue, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("max-width-fit-content status-container status-container--", ctx.statusValue, " mb-2");
        ɵngcc0.ɵɵclassProp("status-container--padding", ctx.statusValue !== "default");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.status.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.status.label, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardExpandedTemplate && ctx.cardExpandedTemplate.isShown);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective], styles: ["[_nghost-%COMP%]{background:var(--da-cards-and-blocks);display:flex;margin-bottom:.5rem;position:relative;width:100%}[_nghost-%COMP%]:before{background:var(--da-border-and-dividers);bottom:0;content:\" \";height:calc(100% + 1rem);left:4px;position:absolute;top:0;width:2px}.card-wrapper[_ngcontent-%COMP%]{border-radius:4px;box-shadow:var(--da-card-hover-box-shadow);font-size:12px;line-height:16px;margin-left:35px;min-width:775px;padding:20px}.card-wrapper--description[_ngcontent-%COMP%]{color:var(--da-title)}.card-wrapper--time[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons)}.status-dot[_ngcontent-%COMP%]{border:1px solid var(--da-cards-and-blocks);border-radius:50%;height:10px;left:0;position:absolute;top:57px;width:10px}.status-dot--approved[_ngcontent-%COMP%]{background-color:var(--da-success-base)}.status-dot--waiting[_ngcontent-%COMP%]{background-color:var(--da-warning-base)}.status-dot--rejected[_ngcontent-%COMP%]{background-color:var(--da-error-base)}.status-dot--to-do[_ngcontent-%COMP%]{background-color:var(--da-blue-base)}.status-container[_ngcontent-%COMP%]{align-items:center;border-radius:9px;display:flex;font-size:10px;line-height:13px;padding:0;text-align:center}.status-container[_ngcontent-%COMP%], .status-container[_ngcontent-%COMP%]   .status-icon[_ngcontent-%COMP%]{color:var(--da-secondary-text-and-icons)}.status-container--padding[_ngcontent-%COMP%]{padding:2px 6px}.status-container--approved[_ngcontent-%COMP%]{background-color:var(--da-success-base)}.status-container--waiting[_ngcontent-%COMP%]{background-color:var(--da-warning-base)}.status-container--rejected[_ngcontent-%COMP%]{background-color:var(--da-error-base)}.status-container--to-do[_ngcontent-%COMP%]{background-color:var(--da-blue-base)}.status-container--approved[_ngcontent-%COMP%], .status-container--approved[_ngcontent-%COMP%]   .status-icon[_ngcontent-%COMP%], .status-container--rejected[_ngcontent-%COMP%], .status-container--rejected[_ngcontent-%COMP%]   .status-icon[_ngcontent-%COMP%], .status-container--to-do[_ngcontent-%COMP%], .status-container--to-do[_ngcontent-%COMP%]   .status-icon[_ngcontent-%COMP%], .status-container--waiting[_ngcontent-%COMP%], .status-container--waiting[_ngcontent-%COMP%]   .status-icon[_ngcontent-%COMP%]{color:#fff}.divider[_ngcontent-%COMP%]{height:1px;margin-left:-20px;margin-right:-20px;position:relative}.divider.border-bottom[_ngcontent-%COMP%]{border-bottom:1px solid var(--da-border-and-dividers)!important}.divider[_ngcontent-%COMP%]   .expand-collapse[_ngcontent-%COMP%]{align-items:center;background-color:var(--da-cards-and-blocks);color:var(--da-brand-base);cursor:pointer;display:flex;font-size:12px;left:15px;line-height:16px;padding:0 5px;position:absolute;top:-8px}.divider[_ngcontent-%COMP%]   .expand-collapse--icon[_ngcontent-%COMP%]{color:var(--da-brand-base);transform:rotate(-90deg)}.divider[_ngcontent-%COMP%]   .expand-collapse--icon.expanded[_ngcontent-%COMP%]{transform:rotate(90deg)}"], data: { animation: [
            trigger('expand', [
                state('collapsed, void', style({ height: '0px', opacity: '0', marginTop: '16px' })),
                state('expanded', style({ height: '*', opacity: '1', marginTop: '20px' })),
                transition('expanded <=> collapsed, void => collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
            ])
        ] } });
CardWithStatusComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CardWithStatusComponent.propDecorators = {
    status: [{ type: Input }],
    statusMapper: [{ type: Input }],
    cardExpandedTemplate: [{ type: ContentChild, args: [CardExpandedTemplateDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardWithStatusComponent, [{
        type: Component,
        args: [{ selector: 'lib-card-with-status', template: "<div class=\"status-dot status-dot--{{ statusValue }}\"></div>\n\n<div class=\"card-wrapper flex-1\">\n    <div\n        class=\"max-width-fit-content status-container status-container--{{\n            statusValue\n        }} mb-2\"\n        [class.status-container--padding]=\"statusValue !== 'default'\"\n    >\n        <fa-icon\n            *ngIf=\"status.icon\"\n            class=\"mr-2 status-icon\"\n            [icon]=\"status.icon\"\n        ></fa-icon\n        >{{ status.label }}\n    </div>\n\n    <div class=\"d-flex justify-content-between\">\n        <ng-content></ng-content>\n    </div>\n\n    <ng-container *ngIf=\"cardExpandedTemplate && cardExpandedTemplate.isShown\">\n        <div class=\"divider mt-4\" [class.border-bottom]=\"!!expanded\">\n            <div class=\"expand-collapse\" (click)=\"expanded = !expanded\">\n                <fa-icon\n                    class=\"expand-collapse--icon mr-1\"\n                    icon=\"open\"\n                    [class.expanded]=\"!!expanded\"\n                ></fa-icon>\n                {{ cardExpandedTemplate.expandedLabel }}\n            </div>\n        </div>\n\n        <div [@expand]=\"!!expanded ? 'expanded' : 'collapsed'\">\n            <ng-container [ngTemplateOutlet]=\"cardExpandedTemplate.template\">\n            </ng-container>\n        </div>\n    </ng-container>\n</div>\n", animations: [
                    trigger('expand', [
                        state('collapsed, void', style({ height: '0px', opacity: '0', marginTop: '16px' })),
                        state('expanded', style({ height: '*', opacity: '1', marginTop: '20px' })),
                        transition('expanded <=> collapsed, void => collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
                    ])
                ], styles: [":host{background:var(--da-cards-and-blocks);display:flex;margin-bottom:.5rem;position:relative;width:100%}:host:before{background:var(--da-border-and-dividers);bottom:0;content:\" \";height:calc(100% + 1rem);left:4px;position:absolute;top:0;width:2px}.card-wrapper{border-radius:4px;box-shadow:var(--da-card-hover-box-shadow);font-size:12px;line-height:16px;margin-left:35px;min-width:775px;padding:20px}.card-wrapper--description{color:var(--da-title)}.card-wrapper--time{color:var(--da-secondary-text-and-icons)}.status-dot{border:1px solid var(--da-cards-and-blocks);border-radius:50%;height:10px;left:0;position:absolute;top:57px;width:10px}.status-dot--approved{background-color:var(--da-success-base)}.status-dot--waiting{background-color:var(--da-warning-base)}.status-dot--rejected{background-color:var(--da-error-base)}.status-dot--to-do{background-color:var(--da-blue-base)}.status-container{align-items:center;border-radius:9px;display:flex;font-size:10px;line-height:13px;padding:0;text-align:center}.status-container,.status-container .status-icon{color:var(--da-secondary-text-and-icons)}.status-container--padding{padding:2px 6px}.status-container--approved{background-color:var(--da-success-base)}.status-container--waiting{background-color:var(--da-warning-base)}.status-container--rejected{background-color:var(--da-error-base)}.status-container--to-do{background-color:var(--da-blue-base)}.status-container--approved,.status-container--approved .status-icon,.status-container--rejected,.status-container--rejected .status-icon,.status-container--to-do,.status-container--to-do .status-icon,.status-container--waiting,.status-container--waiting .status-icon{color:#fff}.divider{height:1px;margin-left:-20px;margin-right:-20px;position:relative}.divider.border-bottom{border-bottom:1px solid var(--da-border-and-dividers)!important}.divider .expand-collapse{align-items:center;background-color:var(--da-cards-and-blocks);color:var(--da-brand-base);cursor:pointer;display:flex;font-size:12px;left:15px;line-height:16px;padding:0 5px;position:absolute;top:-8px}.divider .expand-collapse--icon{color:var(--da-brand-base);transform:rotate(-90deg)}.divider .expand-collapse--icon.expanded{transform:rotate(90deg)}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { statusMapper: [{
            type: Input
        }], status: [{
            type: Input
        }], cardExpandedTemplate: [{
            type: ContentChild,
            args: [CardExpandedTemplateDirective, { static: true }]
        }] }); })();

class SlideSelectorComponent {
    constructor() {
        this.selectedTab = new EventEmitter();
        this.viewSelector = 0;
    }
    ngOnInit() {
        this.itemsVm = this.normalizeWidths(this.items || []);
    }
    changeView(index) {
        this.viewSelector = index;
        let leftPosition = 0;
        for (let i = 0; i < index && i < this.itemsVm.length; ++i) {
            leftPosition += this.itemsVm[i].widthPercent;
        }
        this.currentLeftPosition = leftPosition;
        this.selectedTab.emit(this.viewSelector);
    }
    normalizeWidths(items) {
        let widthUndefCount = 0;
        const widthSum = items.reduce((acc, curr) => {
            if (!curr.widthPercent) {
                ++widthUndefCount;
            }
            return acc + (curr.widthPercent || 0);
        }, 0);
        const rest = 100 - widthSum;
        const normalizeCoeff = widthSum / 100;
        const normalize = normalizeCoeff > 1;
        let leftPosition = 0;
        return items.map(item => {
            const result = Object.assign(Object.assign({}, item), { widthPercent: !normalize
                    ? item.widthPercent
                        ? item.widthPercent
                        : rest / widthUndefCount
                    : (item.widthPercent || 0) / normalizeCoeff, leftPositionPercent: leftPosition });
            leftPosition += result.widthPercent;
            return result;
        });
    }
}
SlideSelectorComponent.ɵfac = function SlideSelectorComponent_Factory(t) { return new (t || SlideSelectorComponent)(); };
SlideSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SlideSelectorComponent, selectors: [["lib-slide-selector"]], inputs: { items: "items" }, outputs: { selectedTab: "selectedTab" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "text-truncate", "container", "body", 3, "switch-active-item", "ngbTooltip", "ngStyle", "click", 4, "ngFor", "ngForOf"], [1, "slider", 3, "ngStyle"], ["container", "body", 1, "text-truncate", 3, "ngbTooltip", "ngStyle", "click"]], template: function SlideSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SlideSelectorComponent_nav_0_Template, 3, 5, "nav", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemsVm == null ? null : ctx.itemsVm.length);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgStyle, ɵngcc5.NgbTooltip], styles: ["nav[_ngcontent-%COMP%]{background-color:var(--da-blackout);border:1px solid var(--da-brand-base);border-radius:4px;font-size:1em;height:28px;width:100%}nav[_ngcontent-%COMP%], nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{position:relative}nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--da-brand-base);cursor:pointer;display:inline-block;font-size:12px;height:100%;line-height:26px;text-align:center;text-decoration:none;transition:all .5s ease 0s;z-index:1}.switch-active-item[_ngcontent-%COMP%]{color:#fff!important}nav[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%]{background-color:var(--da-brand-base);border-radius:4px;height:calc(100% + 2px);margin-left:-1px;position:absolute;top:-1px;transition:all .5s ease 0s;z-index:0}"] });
SlideSelectorComponent.ctorParameters = () => [];
SlideSelectorComponent.propDecorators = {
    items: [{ type: Input }],
    selectedTab: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlideSelectorComponent, [{
        type: Component,
        args: [{ selector: 'lib-slide-selector', template: "<nav *ngIf=\"itemsVm?.length\">\n    <a\n        *ngFor=\"let item of itemsVm; let i = index\"\n        [class.switch-active-item]=\"viewSelector === i\"\n        class=\"text-truncate\"\n        [ngbTooltip]=\"item.title\"\n        container=\"body\"\n        [ngStyle]=\"{ width: item.widthPercent + '%' }\"\n        (click)=\"changeView(i)\"\n    >\n        {{ item.title }}\n    </a>\n    <div\n        class=\"slider\"\n        [ngStyle]=\"{\n            width:\n                'calc(' + itemsVm[viewSelector].widthPercent + '%' + ' + 2px)',\n            left: itemsVm[viewSelector].leftPositionPercent + '%'\n        }\"\n    ></div>\n</nav>\n", styles: ["nav{background-color:var(--da-blackout);border:1px solid var(--da-brand-base);border-radius:4px;font-size:1em;height:28px;width:100%}nav,nav a{position:relative}nav a{color:var(--da-brand-base);cursor:pointer;display:inline-block;font-size:12px;height:100%;line-height:26px;text-align:center;text-decoration:none;transition:all .5s ease 0s;z-index:1}.switch-active-item{color:#fff!important}nav .slider{background-color:var(--da-brand-base);border-radius:4px;height:calc(100% + 2px);margin-left:-1px;position:absolute;top:-1px;transition:all .5s ease 0s;z-index:0}"] }]
    }], function () { return []; }, { selectedTab: [{
            type: Output
        }], items: [{
            type: Input
        }] }); })();

class ModalWithOptionsComponent {
    constructor(modal) {
        this.modal = modal;
        this.confirmOk = new EventEmitter();
        this.cancelBtnClicked = new EventEmitter();
        this.selectedRadioButton = 0;
        this.confirmButtonText = 'Confirm';
        this.closeButtonText = 'Close';
        this.showConfirmButton = true;
        this.showCancelButton = true;
        this.confirmButtonWithLoader = false;
        this.confirmButtonLoading = false;
    }
    confirm() {
        this.confirmOk.emit(true);
        if (!this.confirmButtonWithLoader) {
            this.modal.close();
        }
    }
    cancel() {
        this.cancelBtnClicked.emit();
        this.modal.dismiss('cancel click');
    }
    switchRadioButton(index) {
        this.selectedRadioButton = index;
    }
}
ModalWithOptionsComponent.ɵfac = function ModalWithOptionsComponent_Factory(t) { return new (t || ModalWithOptionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbActiveModal)); };
ModalWithOptionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalWithOptionsComponent, selectors: [["lib-modal-with-options"]], inputs: { confirmButtonText: "confirmButtonText", closeButtonText: "closeButtonText" }, outputs: { confirmOk: "confirmOk", cancelBtnClicked: "cancelBtnClicked" }, decls: 12, vars: 5, consts: [[1, "modal-header"], ["id", "modal-title", "class", "mt-0", 4, "ngIf"], ["type", "button", "aria-label", "Close button", "aria-describedby", "modal-title", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [4, "ngIf"], [1, "d-flex", "flex-column"], [3, "mb-16px", 4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", "ngbAutofocus", "", "class", "btn btn-secondary", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-primary", 3, "btnWithLoader", "disabled", "click", 4, "ngIf"], ["id", "modal-title", 1, "mt-0"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], ["class", "text-description", 4, "ngIf"], [1, "text-description"], ["icon", "facExclamationCircle", 1, "warning-icon"], [1, "message-with-warning"], ["id", "radio-button-1", 1, "size-s", "d-block", "mb-3", 3, "checked", "label", "click"], ["type", "button", "ngbAutofocus", "", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", 1, "btn", "btn-primary", 3, "btnWithLoader", "disabled", "click"]], template: function ModalWithOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ModalWithOptionsComponent_h2_1_Template, 4, 2, "h2", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function ModalWithOptionsComponent_Template_button_click_2_listener() { return ctx.modal.dismiss("Cross click"); });
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4, "\u00D7");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, ModalWithOptionsComponent_ng_container_6_Template, 4, 3, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, ModalWithOptionsComponent_div_8_Template, 2, 4, "div", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, ModalWithOptionsComponent_button_10_Template, 2, 1, "button", 9);
        ɵngcc0.ɵɵtemplate(11, ModalWithOptionsComponent_button_11_Template, 2, 3, "button", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message.title);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.radios);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCancelButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showConfirmButton);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, RadioButtonComponent, ɵngcc3.FaIconComponent, ɵngcc4.FaCustomIconDirective, ButtonWithLoaderComponent, SafeHtmlPipe], styles: [_c80] });
ModalWithOptionsComponent.ctorParameters = () => [
    { type: NgbActiveModal }
];
ModalWithOptionsComponent.propDecorators = {
    confirmOk: [{ type: Output }],
    cancelBtnClicked: [{ type: Output }],
    confirmButtonText: [{ type: Input }],
    closeButtonText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalWithOptionsComponent, [{
        type: Component,
        args: [{ selector: 'lib-modal-with-options', template: "<div class=\"modal-header\">\n    <h2 *ngIf=\"message.title\" id=\"modal-title\" class=\"mt-0\">\n        <span\n            *ngIf=\"message.additionalTitleHtml\"\n            [innerHTML]=\"message.additionalTitleHtml | safeHtml: 'html'\"\n        >\n        </span>\n        <span>{{ message.title }}</span>\n    </h2>\n    <button\n        type=\"button\"\n        class=\"close\"\n        aria-label=\"Close button\"\n        aria-describedby=\"modal-title\"\n        (click)=\"modal.dismiss('Cross click')\"\n    >\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n\n<div class=\"modal-body\">\n    <ng-container *ngIf=\"message\">\n        <p *ngIf=\"message.content\">{{ message.content }}</p>\n        <p *ngIf=\"message.description\" class=\"text-description\">\n            {{ message.description }}\n        </p>\n        <p *ngIf=\"message.warningMessage\">\n            <fa-icon class=\"warning-icon\" icon=\"facExclamationCircle\"></fa-icon>\n            <span class=\"message-with-warning\">\n                {{ message.warningMessage }}\n            </span>\n        </p>\n    </ng-container>\n\n    <div class=\"d-flex flex-column\">\n        <div\n            *ngFor=\"let radio of radios; let i = index; let last = last\"\n            [class.mb-16px]=\"!last\"\n        >\n            <lib-radio-button\n                id=\"radio-button-1\"\n                class=\"size-s d-block mb-3\"\n                [checked]=\"selectedRadioButton == i\"\n                [label]=\"radio.buttonText\"\n                (click)=\"switchRadioButton(i)\"\n            ></lib-radio-button>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal-footer\">\n    <button\n        *ngIf=\"showCancelButton\"\n        type=\"button\"\n        ngbAutofocus\n        class=\"btn btn-secondary\"\n        (click)=\"cancel()\"\n    >\n        {{ closeButtonText }}\n    </button>\n    <button\n        *ngIf=\"showConfirmButton\"\n        [btnWithLoader]=\"confirmButtonLoading\"\n        [disabled]=\"selectedRadioButton === null\"\n        type=\"button\"\n        class=\"btn btn-primary\"\n        (click)=\"confirm()\"\n    >\n        {{ confirmButtonText }}\n    </button>\n</div>\n", styles: [".modal-header{border:none;color:var(--da-title)}.modal-header button.close{color:var(--da-popup-icon-close-color);font-size:30px;font-weight:300;line-height:1rem}.modal-body{font-size:12px;white-space:pre-line}.modal-body i{color:var(--da-popup-icon-warning-color);font-size:14px;margin:0 4px}.modal-body .text-description{color:#bebebe;font-size:10px}.modal-body .message-with-warning{margin-left:5px}.modal-body .warning-icon{color:var(--da-error-base);font-size:16px!important}.modal-footer{border:none;display:flex}.modal-footer button{font-size:11px;height:28px;line-height:14px;margin-left:1rem}.modal-footer button:not(.additional-button){min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;white-space:nowrap;width:88px}"] }]
    }], function () { return [{ type: ɵngcc5.NgbActiveModal }]; }, { confirmOk: [{
            type: Output
        }], cancelBtnClicked: [{
            type: Output
        }], confirmButtonText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }] }); })();

class BreadcrumbItem {
    constructor() {
        this.template = null;
    }
    get url() {
        return null;
    }
    get fake() {
        return false;
    }
}
BreadcrumbItem.ɵfac = function BreadcrumbItem_Factory(t) { return new (t || BreadcrumbItem)(); };
BreadcrumbItem.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BreadcrumbItem });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbItem, [{
        type: Directive
    }], function () { return []; }, null); })();
class BreadcrumbItemDirective extends BreadcrumbItem {
    constructor(template) {
        super();
        this.template = template;
        this.breadcrumbClick = new EventEmitter();
    }
    get fake() {
        return !this.breadcrumbClick.observers.length;
    }
}
BreadcrumbItemDirective.ɵfac = function BreadcrumbItemDirective_Factory(t) { return new (t || BreadcrumbItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
BreadcrumbItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BreadcrumbItemDirective, selectors: [["ng-template", "libBreadcrumb", "", 3, "link", ""]], inputs: { active: "active" }, outputs: { breadcrumbClick: "breadcrumbClick" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: BreadcrumbItem, useExisting: BreadcrumbItemDirective }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
BreadcrumbItemDirective.ctorParameters = () => [
    { type: TemplateRef }
];
BreadcrumbItemDirective.propDecorators = {
    active: [{ type: Input }],
    breadcrumbClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbItemDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[libBreadcrumb]:not([link])',
                providers: [
                    { provide: BreadcrumbItem, useExisting: BreadcrumbItemDirective }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { breadcrumbClick: [{
            type: Output
        }], active: [{
            type: Input
        }] }); })();
class BreadcrumbLinkDirective extends BreadcrumbItem {
    constructor(template) {
        super();
        this.template = template;
    }
}
BreadcrumbLinkDirective.ɵfac = function BreadcrumbLinkDirective_Factory(t) { return new (t || BreadcrumbLinkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
BreadcrumbLinkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BreadcrumbLinkDirective, selectors: [["ng-template", "libBreadcrumb", "", "link", ""]], inputs: { link: "link" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: BreadcrumbItem, useExisting: BreadcrumbLinkDirective }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
BreadcrumbLinkDirective.ctorParameters = () => [
    { type: TemplateRef }
];
BreadcrumbLinkDirective.propDecorators = {
    link: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbLinkDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[libBreadcrumb][link]',
                providers: [
                    { provide: BreadcrumbItem, useExisting: BreadcrumbLinkDirective }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { link: [{
            type: Input
        }] }); })();
class BreadcrumbComponent {
    constructor() {
        this.mode = 'arrow';
    }
    get isBootstrap() {
        return this.mode === 'bootstrap';
    }
    getUrl(item) {
        return item instanceof BreadcrumbLinkDirective ? item.link : null;
    }
    isActive(rla, item) {
        return item instanceof BreadcrumbItemDirective
            ? item.active
            : rla.isActive;
    }
}
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(); };
BreadcrumbComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["lib-breadcrumb"]], contentQueries: function BreadcrumbComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BreadcrumbItem, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostVars: 3, hostBindings: function BreadcrumbComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("breadcrumb-mode", ctx.mode);
        ɵngcc0.ɵɵclassProp("breadcrumb", ctx.isBootstrap);
    } }, inputs: { mode: "mode" }, decls: 2, vars: 2, consts: [["class", "d-none", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "d-none"], ["id", "start-arrow", "viewBox", "0 0 9 24", "fill", "transparent"], ["d", "M0 24V0C0.217794 0 0.421177 0.108847 0.541987 0.290063L7.97881 11.4453C8.20275 11.7812 8.20275 12.2188 7.97881 12.5547L0.541987 23.7099C0.421177 23.8912 0.217794 24 0 24Z", "fill", "currentColor"], ["id", "end-arrow", "viewBox", "0 0 9 24", "fill", "transparent"], ["d", "M7.99999 12L1.03645 1.5547C0.593416 0.890145 1.06981 0 1.8685 0H7.99999L7.99999 12L7.99999 24H1.8685C1.06981 24 0.593416 23.1099 1.03645 22.4453L7.99999 12Z", "fill", "currentColor"], ["class", "breadcrumb-arrow-item", "routerLinkActive", "", 3, "breadcrumb-arrow-item-first", "fake", "routerLink", "active", "click", 4, "ngIf", "ngIfElse"], ["bootstrapTmpl", ""], ["routerLinkActive", "", 1, "breadcrumb-arrow-item", 3, "routerLink", "click"], ["rla", "routerLinkActive"], ["class", "end-arrow", "width", "9", "height", "24", 4, "ngIf"], [1, "content"], [4, "ngTemplateOutlet"], ["width", "9", "height", "24", 1, "start-arrow"], ["href", "#start-arrow"], ["width", "9", "height", "24", 1, "end-arrow"], ["transform", "translate(1)", "href", "#end-arrow"], ["routerLinkActive", "", 1, "breadcrumb-item", 3, "routerLink", "click"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BreadcrumbComponent__svg_svg_0_Template, 5, 0, "svg", 0);
        ɵngcc0.ɵɵtemplate(1, BreadcrumbComponent_ng_container_1_Template, 5, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode === "arrow");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc9.RouterLinkWithHref, ɵngcc9.RouterLinkActive], styles: ["[_nghost-%COMP%]{height:24px}[breadcrumb-mode=arrow][_nghost-%COMP%]{display:flex}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item{--breadcrumb-background:var(--da-brand-12);display:flex;margin-right:2px;position:relative}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item-first .content{border-radius:4px 0 0 4px;padding-left:8px!important}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item .content{align-items:center;background-color:var(--breadcrumb-background);color:var(--da-brand-base);display:flex;font-size:10px;justify-content:center;line-height:14px;padding:0 4px}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item:active, [breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item:focus{--breadcrumb-background:var(--da-brand-20)}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item.active{--breadcrumb-background:var(--da-brand-base)}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item.active .content{color:var(--da-table-header)}[breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item:focus, [breadcrumb-mode=arrow][_nghost-%COMP%]     .breadcrumb-arrow-item:hover{text-decoration:underline}[breadcrumb-mode=arrow][_nghost-%COMP%]   .end-arrow[_ngcontent-%COMP%]{color:var(--breadcrumb-background);left:-9px;position:absolute;top:0}[breadcrumb-mode=arrow][_nghost-%COMP%]   .start-arrow[_ngcontent-%COMP%]{color:var(--breadcrumb-background)}[breadcrumb-mode=bootstrap][_nghost-%COMP%]{height:unset;margin-bottom:0}[_nghost-%COMP%]   .fake[_ngcontent-%COMP%], [_nghost-%COMP%]   a.active[_ngcontent-%COMP%]{pointer-events:none}"], changeDetection: 0 });
BreadcrumbComponent.propDecorators = {
    mode: [{ type: Input }, { type: HostBinding, args: ['attr.breadcrumb-mode',] }],
    isBootstrap: [{ type: HostBinding, args: ['class.breadcrumb',] }],
    items: [{ type: ContentChildren, args: [BreadcrumbItem,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{ selector: 'lib-breadcrumb', template: "<svg *ngIf=\"mode === 'arrow'\" class=\"d-none\">\n    <symbol id=\"start-arrow\" viewBox=\"0 0 9 24\" fill=\"transparent\">\n        <path\n            d=\"M0 24V0C0.217794 0 0.421177 0.108847 0.541987 0.290063L7.97881 11.4453C8.20275 11.7812 8.20275 12.2188 7.97881 12.5547L0.541987 23.7099C0.421177 23.8912 0.217794 24 0 24Z\"\n            fill=\"currentColor\"\n        />\n    </symbol>\n    <symbol id=\"end-arrow\" viewBox=\"0 0 9 24\" fill=\"transparent\">\n        <path\n            d=\"M7.99999 12L1.03645 1.5547C0.593416 0.890145 1.06981 0 1.8685 0H7.99999L7.99999 12L7.99999 24H1.8685C1.06981 24 0.593416 23.1099 1.03645 22.4453L7.99999 12Z\"\n            fill=\"currentColor\"\n        />\n    </symbol>\n</svg>\n<ng-container *ngFor=\"let item of items; first as first\">\n    <ng-container>\n        <a\n            *ngIf=\"mode === 'arrow'; else bootstrapTmpl\"\n            class=\"breadcrumb-arrow-item\"\n            [class.breadcrumb-arrow-item-first]=\"first\"\n            [class.fake]=\"item.fake\"\n            routerLinkActive\n            #rla=\"routerLinkActive\"\n            [attr.tabindex]=\"isActive(rla, item) ? -1 : undefined\"\n            [routerLink]=\"getUrl(item)\"\n            [class.active]=\"isActive(rla, item)\"\n            (click)=\"item.breadcrumbClick?.emit($event)\"\n        >\n            <svg class=\"end-arrow\" *ngIf=\"!first\" width=\"9\" height=\"24\">\n                <use transform=\"translate(1)\" href=\"#end-arrow\"></use>\n            </svg>\n            <span class=\"content\">\n                <ng-container *ngTemplateOutlet=\"item.template\"></ng-container>\n            </span>\n            <svg class=\"start-arrow\" width=\"9\" height=\"24\">\n                <use href=\"#start-arrow\"></use>\n            </svg>\n        </a>\n\n        <ng-template #bootstrapTmpl>\n            <a\n                class=\"breadcrumb-item\"\n                routerLinkActive\n                #rla=\"routerLinkActive\"\n                [routerLink]=\"getUrl(item)\"\n                [attr.tabindex]=\"isActive(rla, item) ? -1 : undefined\"\n                [class.active]=\"isActive(rla, item)\"\n                [class.fake]=\"item.fake\"\n                (click)=\"item.breadcrumbClick?.emit($event)\"\n            >\n                <ng-container *ngTemplateOutlet=\"item.template\"></ng-container>\n            </a>\n        </ng-template>\n    </ng-container>\n</ng-container>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{height:24px}:host[breadcrumb-mode=arrow]{display:flex}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item{--breadcrumb-background:var(--da-brand-12);display:flex;margin-right:2px;position:relative}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item-first .content{border-radius:4px 0 0 4px;padding-left:8px!important}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item .content{align-items:center;background-color:var(--breadcrumb-background);color:var(--da-brand-base);display:flex;font-size:10px;justify-content:center;line-height:14px;padding:0 4px}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item:active,:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item:focus{--breadcrumb-background:var(--da-brand-20)}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item.active{--breadcrumb-background:var(--da-brand-base)}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item.active .content{color:var(--da-table-header)}:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item:focus,:host[breadcrumb-mode=arrow] ::ng-deep .breadcrumb-arrow-item:hover{text-decoration:underline}:host[breadcrumb-mode=arrow] .end-arrow{color:var(--breadcrumb-background);left:-9px;position:absolute;top:0}:host[breadcrumb-mode=arrow] .start-arrow{color:var(--breadcrumb-background)}:host[breadcrumb-mode=bootstrap]{height:unset;margin-bottom:0}:host .fake,:host a.active{pointer-events:none}"] }]
    }], function () { return []; }, { mode: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.breadcrumb-mode']
        }], isBootstrap: [{
            type: HostBinding,
            args: ['class.breadcrumb']
        }], items: [{
            type: ContentChildren,
            args: [BreadcrumbItem]
        }] }); })();

class KitBreadcrumbModule {
}
KitBreadcrumbModule.ɵfac = function KitBreadcrumbModule_Factory(t) { return new (t || KitBreadcrumbModule)(); };
KitBreadcrumbModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: KitBreadcrumbModule });
KitBreadcrumbModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(KitBreadcrumbModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                declarations: [
                    BreadcrumbComponent,
                    BreadcrumbItemDirective,
                    BreadcrumbLinkDirective
                ],
                exports: [
                    BreadcrumbComponent,
                    BreadcrumbItemDirective,
                    BreadcrumbLinkDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(KitBreadcrumbModule, { declarations: function () { return [BreadcrumbComponent, BreadcrumbItemDirective, BreadcrumbLinkDirective]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [BreadcrumbComponent, BreadcrumbItemDirective, BreadcrumbLinkDirective]; } }); })();

const START_FROM_ANGLE = 270;
const CIRCLE_RADIUS = 2;
const CIRCLE_COUNT = 8;
const ANGLE = 360 / CIRCLE_COUNT;
const OPACITY_VALUES = Array.from({ length: CIRCLE_COUNT }).fill(0.12);
class WaitingLoaderComponent {
    constructor() {
        this.loaderRadius = 12;
    }
    ngOnInit() {
        const toRadian = (degree) => (degree * Math.PI) / 180;
        this.circles = Array.from({ length: CIRCLE_COUNT }, (_, idx) => {
            const currentAngle = toRadian(START_FROM_ANGLE + idx * ANGLE);
            const currentOpacityValues = [...OPACITY_VALUES];
            currentOpacityValues[idx] = 1;
            const ro = this.loaderRadius - CIRCLE_RADIUS * 2;
            return {
                transform: `translate(${Math.cos(currentAngle) * ro},${Math.sin(currentAngle) * ro})`,
                values: currentOpacityValues.join(';')
            };
        });
    }
}
WaitingLoaderComponent.ɵfac = function WaitingLoaderComponent_Factory(t) { return new (t || WaitingLoaderComponent)(); };
WaitingLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: WaitingLoaderComponent, selectors: [["lib-waiting-loader"]], decls: 3, vars: 3, consts: [[4, "ngFor", "ngForOf"], ["cx", "0", "cy", "0", "r", "2", "fill", "currentColor"], ["attributeName", "fill-opacity", "dur", "1s", "repeatCount", "indefinite", "begin", "0s", "calcMode", "discrete"]], template: function WaitingLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg")(1, "g");
        ɵngcc0.ɵɵtemplate(2, WaitingLoaderComponent__svg_g_2_Template, 3, 3, "g", 0);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("viewBox", "0 0 " + ctx.loaderRadius * 2 + " " + ctx.loaderRadius * 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("transform", "translate(" + ctx.loaderRadius + "," + ctx.loaderRadius + ")");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.circles);
    } }, dependencies: [ɵngcc2.NgForOf], styles: ["[_nghost-%COMP%]{color:var(--da-brand-base);display:block}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WaitingLoaderComponent, [{
        type: Component,
        args: [{ selector: 'lib-waiting-loader', template: "<svg [attr.viewBox]=\"'0 0 ' + loaderRadius * 2 + ' ' + loaderRadius * 2\">\n    <g\n        [attr.transform]=\"\n            'translate(' + loaderRadius + ',' + loaderRadius + ')'\n        \"\n    >\n        <g\n            *ngFor=\"let circle of circles; first as first\"\n            [attr.transform]=\"circle.transform\"\n        >\n            <circle\n                cx=\"0\"\n                cy=\"0\"\n                r=\"2\"\n                fill=\"currentColor\"\n                [attr.fill-opacity]=\"first ? 1 : 0\"\n            >\n                <animate\n                    attributeName=\"fill-opacity\"\n                    dur=\"1s\"\n                    repeatCount=\"indefinite\"\n                    begin=\"0s\"\n                    calcMode=\"discrete\"\n                    [attr.values]=\"circle.values\"\n                ></animate>\n            </circle>\n        </g>\n    </g>\n</svg>\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{color:var(--da-brand-base);display:block}"] }]
    }], function () { return []; }, null); })();

class TruncatePipe {
    transform(value, limit = 25, completeWords = false, ellipsis = '...') {
        if (completeWords) {
            limit = value.substr(0, limit).lastIndexOf(' ');
        }
        return value.length > limit ? value.substr(0, limit) + ellipsis : value;
    }
}
TruncatePipe.ɵfac = function TruncatePipe_Factory(t) { return new (t || TruncatePipe)(); };
TruncatePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "truncate", type: TruncatePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TruncatePipe, [{
        type: Pipe,
        args: [{
                name: 'truncate'
            }]
    }], null, null); })();

//#region external modules
const modules = [
    CommonModule,
    NgbModule,
    NgSelectModule,
    PerfectScrollbarModule,
    LibFormsModule,
    SearchModule,
    SidenavModule,
    KitBreadcrumbModule,
    AccordionStylesModule,
    SpinnerModule,
    SafeHtmlPipeModule,
    CopyToClipboardModule,
    DataGridModule,
    ResizeObserverModule,
    KitScrollModule,
    KitPaginationModule,
    TooltipWhenOverflowModule,
];
const components$1 = [
    CardComponent,
    LoaderComponent,
    ModalConfirmComponent,
    ModalWithOptionsComponent,
    ModalWarningComponent,
    NavComponent,
    ScrollerComponent,
    SideMenuComponent,
    SplitButtonComponent,
    StreamWrapperComponent,
    TriggerComponent,
    SideMenuComponent,
    NavbarMenuComponent,
    ContextMenuComponent,
    ButtonWithLoaderComponent,
    ToastrComponent,
    CardWithStatusComponent,
    SlideSelectorComponent,
    TagComponent,
    SortDirective,
    SortColumnComponent,
    WaitingLoaderComponent,
    InsightCardComponent,
];
const directives$1 = [
    ContextButtonDirective,
    ContextSpecialItemsDirective,
    CardHeaderTemplateDirective,
    SideMenuItemDirective,
    SideMenuChildItemDirective,
    SideMenuHeaderDirective,
    SideMenuFooterDirective,
    CardFooterTemplateDirective,
    StopClickPropagationDirective,
    StreamWrapperContentDirective,
    StreamWrapperLoaderDirective,
    ResizeDirective,
    NgSelectAdjustPosition,
    NavbarMenuSpecialItemsDirective,
    NavItemDirective,
    LetDirective,
    StopScrollPropagationDirective,
    ToastrFooterTemplateDirective,
    ToastrBodyTemplateDirective,
    CardExpandedTemplateDirective,
    VisibilityDirective,
];
const pipes = [ObsWithStatusPipe, TruncatePipe];
const providers = [
    ModalService,
    HttpListenerService,
    IfInViewportService,
    PerfectScrollbarService,
    UnsavedDataGuard,
    HoveredService
];
class UiKitModule {
}
UiKitModule.ɵfac = function UiKitModule_Factory(t) { return new (t || UiKitModule)(); };
UiKitModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UiKitModule });
UiKitModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [...providers], imports: [modules, RouterModule, CommonModule,
        NgbModule,
        NgSelectModule,
        PerfectScrollbarModule, LibFormsModule, SearchModule, SidenavModule, KitBreadcrumbModule, AccordionStylesModule, SpinnerModule, SafeHtmlPipeModule, CopyToClipboardModule, DataGridModule, ResizeObserverModule, KitScrollModule, KitPaginationModule, TooltipWhenOverflowModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiKitModule, [{
        type: NgModule,
        args: [{
                declarations: [...components$1, ...pipes, ...directives$1],
                imports: [...modules, RouterModule],
                entryComponents: [],
                exports: [...modules, ...components$1, ...pipes, ...directives$1],
                providers: [...providers]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UiKitModule, { declarations: function () { return [CardComponent, LoaderComponent, ModalConfirmComponent, ModalWithOptionsComponent, ModalWarningComponent, NavComponent, ScrollerComponent, SideMenuComponent, SplitButtonComponent, StreamWrapperComponent, TriggerComponent, SideMenuComponent, NavbarMenuComponent, ContextMenuComponent, ButtonWithLoaderComponent, ToastrComponent, CardWithStatusComponent, SlideSelectorComponent, TagComponent, SortDirective, SortColumnComponent, WaitingLoaderComponent, InsightCardComponent, ObsWithStatusPipe, TruncatePipe, ContextButtonDirective, ContextSpecialItemsDirective, CardHeaderTemplateDirective, SideMenuItemDirective, SideMenuChildItemDirective, SideMenuHeaderDirective, SideMenuFooterDirective, CardFooterTemplateDirective, StopClickPropagationDirective, StreamWrapperContentDirective, StreamWrapperLoaderDirective, ResizeDirective, NgSelectAdjustPosition, NavbarMenuSpecialItemsDirective, NavItemDirective, LetDirective, StopScrollPropagationDirective, ToastrFooterTemplateDirective, ToastrBodyTemplateDirective, CardExpandedTemplateDirective, VisibilityDirective]; }, imports: function () { return [CommonModule,
        NgbModule,
        NgSelectModule,
        PerfectScrollbarModule, LibFormsModule, SearchModule, SidenavModule, KitBreadcrumbModule, AccordionStylesModule, SpinnerModule, SafeHtmlPipeModule, CopyToClipboardModule, DataGridModule, ResizeObserverModule, KitScrollModule, KitPaginationModule, TooltipWhenOverflowModule, RouterModule]; }, exports: function () { return [CommonModule,
        NgbModule,
        NgSelectModule,
        PerfectScrollbarModule, LibFormsModule, SearchModule, SidenavModule, KitBreadcrumbModule, AccordionStylesModule, SpinnerModule, SafeHtmlPipeModule, CopyToClipboardModule, DataGridModule, ResizeObserverModule, KitScrollModule, KitPaginationModule, TooltipWhenOverflowModule, CardComponent, LoaderComponent, ModalConfirmComponent, ModalWithOptionsComponent, ModalWarningComponent, NavComponent, ScrollerComponent, SideMenuComponent, SplitButtonComponent, StreamWrapperComponent, TriggerComponent, SideMenuComponent, NavbarMenuComponent, ContextMenuComponent, ButtonWithLoaderComponent, ToastrComponent, CardWithStatusComponent, SlideSelectorComponent, TagComponent, SortDirective, SortColumnComponent, WaitingLoaderComponent, InsightCardComponent, ObsWithStatusPipe, TruncatePipe, ContextButtonDirective, ContextSpecialItemsDirective, CardHeaderTemplateDirective, SideMenuItemDirective, SideMenuChildItemDirective, SideMenuHeaderDirective, SideMenuFooterDirective, CardFooterTemplateDirective, StopClickPropagationDirective, StreamWrapperContentDirective, StreamWrapperLoaderDirective, ResizeDirective, NgSelectAdjustPosition, NavbarMenuSpecialItemsDirective, NavItemDirective, LetDirective, StopScrollPropagationDirective, ToastrFooterTemplateDirective, ToastrBodyTemplateDirective, CardExpandedTemplateDirective, VisibilityDirective]; } }); })();

class Store extends BehaviorSubject {
    constructor(initialState) {
        super(initialState);
    }
    get state() {
        return this.value;
    }
    dispatch(fn) {
        this.next(fn(this.value));
    }
    setState(partialState) {
        const nextState = Object.assign(Object.assign({}, this.value), partialState);
        this.next(nextState);
    }
    select(fn) {
        return this.pipe(map(fn), distinctUntilChanged());
    }
    selectSync(fn) {
        return fn(this.value);
    }
}

class StateHistory {
    constructor(store, options = { bufferSize: 10 }) {
        this.store = store;
        this.options = options;
        this.history = {
            past: [],
            present: null,
            future: []
        };
        this.subscription = Subscription.EMPTY;
        /** Allow skipping an update from outside */
        this.skip = false;
        this.enable();
    }
    ignoreNext() {
        this.skip = true;
    }
    get hasPast() {
        return !!this.history.past.length;
    }
    get hasFuture() {
        return !!this.history.future.length;
    }
    enable() {
        this.history.present = this.store.value;
        this.subscription = this.store
            .pipe(pairwise())
            .subscribe(([past, present]) => {
            if (this.skipUpdate) {
                return;
            }
            if (this.skip) {
                this.skip = false;
                return;
            }
            if (this.history.past.length === this.options.bufferSize) {
                this.history.past = this.history.past.slice(1);
            }
            this.history.past = [...this.history.past, past];
            this.history.present = present;
            this.history.future = [];
        });
    }
    undo() {
        if (!this.hasPast) {
            return;
        }
        const { past, present } = this.history;
        const previous = past[past.length - 1];
        this.history.past = past.slice(0, past.length - 1);
        this.history.present = previous;
        this.history.future = [present, ...this.history.future];
        this.update();
    }
    redo() {
        if (!this.hasFuture) {
            return;
        }
        const { past, present } = this.history;
        const next = this.history.future[0];
        const newFuture = this.history.future.slice(1);
        this.history.past = [...past, present];
        this.history.present = next;
        this.history.future = newFuture;
        this.update();
    }
    update() {
        this.skipUpdate = true;
        this.store.next(this.history.present);
        this.skipUpdate = false;
    }
    destroy() {
        this.subscription.unsubscribe();
    }
}

class Pagination {
    static of(source) {
        let result = new Pagination();
        result.page = source.number;
        result.totalPages = source.totalPages;
        result.totalElements = source.totalElements;
        result.pageSize = source.size;
        result.first = source.number === 0;
        result.last = source.number + 1 >= source.totalPages;
        return result;
    }
}

/**
 * pageable request with paging and sorting support
 */
// @dynamic
class Pageable {
    constructor(page, size, orders) {
        /**
         * sorting parameters
         */
        this.orders = [];
        this.page = page;
        this.size = size;
        this.orders = orders;
    }
    static page(page, size) {
        return new Pageable(page, size, []);
    }
    static pageAndSort(direction, properties, page, size) {
        return new Pageable(page, size, properties.map(prop => new SortOrder(direction, prop)));
    }
    add(params) {
        params = params
            .set('page', this.page.toString())
            .set('size', this.size.toString());
        if (this.orders) {
            this.orders.forEach((order, idx) => {
                const value = order.property +
                    ',' +
                    order.direction +
                    (order.ignoreCase ? ',ignore' : '');
                if (idx === 0) {
                    params = params.set('sort', value);
                }
                else {
                    params = params.append('sort', value);
                }
            });
        }
        return params;
    }
    create() {
        return this.add(new HttpParams());
    }
    update(data) {
        this.page = data.currentPage - 1;
        this.size = data.pageSize;
    }
    setFirst() {
        this.page = 0;
    }
    sortOneField(property) {
        const order = this.orders
            ? this.orders.find(x => x.property === property)
            : null;
        if (order) {
            if (order.direction === 'DESC') {
                this.orders = this.orders.filter(item => item !== order);
            }
            else {
                order.direction = 'DESC';
            }
        }
        else {
            this.orders = [{ property: property, direction: 'ASC' }];
        }
    }
    addSortField(property) {
        const order = this.orders
            ? this.orders.find(x => x.property === property)
            : null;
        if (order) {
            if (order.direction === 'ASC') {
                order.direction = 'DESC';
            }
            else {
                this.orders = this.orders.filter(x => x.property !== property);
            }
        }
        else {
            this.orders = [
                ...(this.orders || []),
                { property, direction: 'ASC' }
            ];
        }
    }
    sorted(property) {
        const order = this.orders
            ? this.orders.find(x => x.property === property)
            : null;
        return order ? order.direction : null;
    }
}
class SortOrder {
    constructor(direction, property, ignoreCase) {
        this.ignoreCase = false;
        this.direction = direction;
        this.property = property;
        this.ignoreCase = ignoreCase;
    }
}

var RbacStaticType;
(function (RbacStaticType) {
    /**
     * object or action
     * objId format: object:name
     */
    RbacStaticType["OBJECT"] = "OBJECT";
    /**
     * HTTP endpoint rights
     * objId format: endpoint:name
     */
    RbacStaticType["ENDPOINT"] = "ENDPOINT";
    /**
     * LOCATION rights
     * objId format: location:matching
     */
    RbacStaticType["LOCATION"] = "LOCATION";
})(RbacStaticType || (RbacStaticType = {}));

const CARD_STATUS_COLORS = {
    approved: 'var(--da-success-base)',
    waiting: 'var(--da-warning-base)',
    rejected: 'var(--da-error-base)',
    'to-do': 'var(--da-blue-base)',
    default: ''
};

class ResizeObserverService {
    constructor(zone) {
        this.zone = zone;
    }
    observe$({ nativeElement }, dueTime = 300) {
        return new Observable(subscriber => {
            let observer;
            observer = new ResizeObserver(entries => {
                this.zone.run(() => {
                    subscriber.next(entries);
                });
            });
            observer.observe(nativeElement);
            return () => {
                observer.disconnect();
            };
        })
            .pipe(debounceTime(dueTime), share())
            .lift(new ZoneFreeOperator(this.zone));
    }
}
ResizeObserverService.ɵfac = function ResizeObserverService_Factory(t) { return new (t || ResizeObserverService)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
ResizeObserverService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResizeObserverService, factory: ResizeObserverService.ɵfac });
ResizeObserverService.ctorParameters = () => [
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResizeObserverService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();

function removeError(control, errorKey, markTouched = false) {
    if ((control === null || control === void 0 ? void 0 : control.errors) && control.errors[errorKey]) {
        delete control.errors[errorKey];
        if (markTouched) {
            control.markAsTouched();
        }
        if (Object.keys(control.errors).length === 0) {
            control.setErrors(undefined);
        }
        else {
            control.setErrors(control.errors);
        }
    }
}
function appendError(control, errorKey, errorValue = true, markTouched = false) {
    if (markTouched) {
        control.markAsTouched();
    }
    if (!control) {
        return;
    }
    if (!control.errors) {
        control.setErrors({ [errorKey]: errorValue });
    }
    else {
        control.errors[errorKey] = errorValue;
        control.setErrors(control.errors);
    }
}
function getAllErrors(control, path) {
    let errors = [];
    Object.keys(control.controls).forEach(key => {
        const childControl = control.controls[key];
        if (childControl instanceof FormGroup ||
            childControl instanceof FormArray) {
            errors = [...errors, ...getAllErrors(childControl, [...path, key])];
        }
        const controlErrors = childControl.errors;
        if (controlErrors) {
            Object.keys(controlErrors).forEach(errorKey => {
                errors.push({
                    control: childControl,
                    controlName: key,
                    errorName: errorKey,
                    errorValue: controlErrors[errorKey],
                    errorPath: [...path, key]
                });
            });
        }
    });
    return errors;
}
function validateFormAndDisplayErrors(form) {
    Object.keys(form.controls).forEach(controlName => {
        const control = form.get(controlName);
        if (control instanceof FormGroup ||
            (control instanceof FormArray && control.controls)) {
            validateFormAndDisplayErrors(control);
        }
        else {
            control.setErrors(control.errors);
            control.markAsTouched();
            control.markAsDirty();
            control.updateValueAndValidity();
        }
    });
}
function ArrayByFieldDuplication(formGroup, arrayKey, fieldKey, errorKey, markTouched = true) {
    const controlsArray = formGroup.get(arrayKey);
    if (controlsArray) {
        const group = controlsArray.controls.reduce((acc, cur) => {
            const value = cur.value[fieldKey];
            if (value) {
                acc[value] = (acc[value] || []).concat(cur.get(fieldKey));
            }
            return acc;
        }, {});
        for (const prop in group) {
            if (group[prop].length > 1) {
                group[prop].forEach(control => {
                    appendError(control, errorKey, true, markTouched);
                });
            }
            else {
                removeError(group[prop][0], errorKey, markTouched);
            }
        }
        return Object.values(group).reduce((acc, g) => acc && g.length === 1, true);
    }
    return true;
}
function showServerValidationErrors(form, response) {
    const errors = response.error.errors || [];
    errors.forEach((error) => {
        const field = error.field.split('.');
        const control = form.controls[field[field.length - 1]];
        if (control && control.value === error.rejectedValue) {
            control.setErrors({ customText: error.defaultMessage });
            control.markAsTouched();
        }
        else {
            Object.keys(form.controls).forEach(controlName => {
                const formControl = form.controls[controlName];
                if (!formControl.controls) {
                    return;
                }
                showServerValidationErrors(formControl, new HttpErrorResponse({
                    error: { errors: [error] }
                }));
            });
        }
    });
}
function uniqueField(values, ignoreValue) {
    return function (control) {
        return values[control.value] && control.value !== ignoreValue
            ? { unique: true }
            : null;
    };
}
function notEqualValue(value, customTextFn = null) {
    return (control) => (control.value || '') === value
        ? { notEqual: { value: control.value, customTextFn } }
        : null;
}
function notEqualValues(values, customTextFn = null) {
    return (control) => values.includes(control.value || '')
        ? { notEqual: { value: control.value, customTextFn } }
        : null;
}
function notEmptyString() {
    const emptyOrWhiteSpacePattern = new RegExp(/^$|^\s*$/);
    return (control) => emptyOrWhiteSpacePattern.test(control.value)
        ? { required: { value: control.value } }
        : null;
}
function noLeadingTrailingSpaces(controlLabel) {
    return control => typeof control.value === 'string' &&
        (control.value.startsWith(' ') || control.value.endsWith(' '))
        ? { leadingTrailingSpaces: { value: control.value, controlLabel } }
        : null;
}
function debounceValidator(validatorFn, debounceTime = 200) {
    return control => timer(debounceTime).pipe(switchMap(() => validatorFn(control)));
}

function subscriptionWatcher(callback) {
    return (source) => {
        return new Observable((observer) => {
            const innerSubscription = source.subscribe(observer);
            callback(1);
            return () => {
                innerSubscription.unsubscribe();
                callback(-1);
            };
        });
    };
}

/*
 * Public API Surface of kit
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ArrayByFieldDuplication, BaseFormControl, ButtonWithLoaderComponent, CARD_STATUS_COLORS, CardComponent, CardExpandedTemplateDirective, CardFooterTemplateDirective, CardHeaderTemplateDirective, CardWithStatusComponent, CheckboxComponent, ContextButtonDirective, ContextMenuComponent, ContextSpecialItemsDirective, CopyToClipboardDirective, CopyToClipboardModule, DataGridComponent, DateTimeModel, DatepickerAdapterComponent, DatepickerComponent, DatepickerLeftRangeContentDirective, DatepickerModule, DatepickerMultiMonthViewComponent, DatepickerRightRangeContentDirective, DropdownAddTagValidatorDirective, DropdownComponent, DropdownHeaderTemplateDirective, ErrorControlDirective, ErrorMessageComponent, FORM_ERRORS, FocusMonitor, FormDirtyDirective, FormSubmitDirective, HeaderTemplateDirective, HoveredService, HttpListenerService, IfInViewportService, InputComponent, InsightCardComponent, KitPaginationModule, KitScrollModule, LetDirective, LetDirectiveContext, LibFormsModule, LoaderComponent, ModalConfirmComponent, ModalService, ModalWarningComponent, ModalWithOptionsComponent, NavComponent, NavItemDirective, NavbarMenuComponent, NavbarMenuSpecialItemsDirective, NgSelectAdjustPosition, ObsWithStatusPipe, OutsideClickDirective, Pageable, PagerService, Pagination, PaginationComponent, PerfectScrollbarService, PerfectScrollbarStylesComponent, ProgressSpinnerComponent, RadioButtonComponent, RadioGroupComponent, RatingModalComponent, RbacStaticType, ResizeDirective, ResizeObserverService, RowTemplateDirective, SafeHtmlPipe, SafeHtmlPipeModule, ScrollDirective, SearchComponent, SearchModule, SideMenuChildItemDirective, SideMenuComponent, SideMenuFooterDirective, SideMenuHeaderDirective, SideMenuItemDirective, SidenavComponent, SidenavContainerComponent, SidenavContentComponent, SidenavFooterDirective, SidenavGroupComponent, SidenavHeaderDirective, SidenavItemPostfixDirective, SidenavLocalStorageService, SidenavModule, SidenavStorageService, SlideSelectorComponent, SortColumnComponent, SortDirective, SortOrder, SpinnerComponent, SplitButtonComponent, StateHistory, StopClickPropagationDirective, StopScrollPropagationDirective, Store, StreamWrapperComponent, StreamWrapperContentDirective, StreamWrapperLoaderDirective, TextareaComponent, ToastrBodyTemplateDirective, ToastrComponent, ToastrFooterTemplateDirective, TooltipTruncatedElementDirective, TooltipWhenOverflowDirective, TooltipWhenOverflowModule, TopicService, TreelikeDropdownComponent, TriggerComponent, TypeaheadComponent, TypedModalRef, UiKitModule, UnsavedDataGuard, ValidationErrorDirective, ValidationErrorsComponent, VisibilityDirective, WarningMessageComponent, ZoneFreeOperator, appendError, capitalizeLabel, coerceBooleanProperty, collectAllParentRouteParams, debounceValidator, defaultErrors, focusNativeElement, generateUUID, getAllErrors, isDefined, isErrorState, liftToObsWithStatus, lightOrDark, loadFile, noLeadingTrailingSpaces, notEmptyString, notEqualValue, notEqualValues, observeProperty, onVisible, polling, readFileToObject, removeError, searchTreelikeArray, showServerValidationErrors, sortObjectArrayByKey, subscriptionWatcher, toDropDownItem, toDropDownItemCapitalizedLabel, toDropDownItemFromIPluginService, toHttpParams, toJSONBlob, uniqueField, validateFormAndDisplayErrors, writeContents, ɵ0, ɵ1, ɵ10, ɵ11, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ScrollerComponent as ɵa, TagComponent as ɵb, ResizeObserverModule as ɵba, SortDirective as ɵc, SortColumnComponent as ɵd, WaitingLoaderComponent as ɵe, TruncatePipe as ɵf, SpinnerModule as ɵg, RatingComponent as ɵh, TreelikeMenuComponent as ɵi, DatepickerRangeNavigationComponent as ɵj, DatepickerRangeDialogComponent as ɵk, KitBreadcrumbModule as ɵl, BreadcrumbItem as ɵm, BreadcrumbItemDirective as ɵn, BreadcrumbLinkDirective as ɵo, BreadcrumbComponent as ɵp, AccordionStylesModule as ɵq, AccordionSecondLevelDirective as ɵr, DaAccordionService as ɵs, AccordionSecondLevelStylesComponent as ɵt, AccordionFirstLevelDirective as ɵu, AccordionFirstLevelStylesComponent as ɵv, AccordionHeaderToggleDirective as ɵw, CopyToClipboardModule as ɵx, DataGridModule as ɵy, ResizeObserverDirective as ɵz };

